/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export type DtoV1EnumUrlaFormVersion = 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumDocumentGenerationProvider = 1 | 2;

/** @format int32 */
export type DtoV1EnumClosingType = 1 | 2 | 3 | 4;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsWaiveEscrowOption = 1 | 2 | 3 | 4;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsTaxAnswerSource = 0 | 1 | 2 | 3;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsRefiPurposeType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsPurposeType =
  | 0
  | 1
  | 2
  | 3
  | 6
  | 9
  | 10
  | 11
  | 12;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsPropertyType =
  | 0
  | 22
  | 23
  | 25
  | 26
  | 27
  | 28
  | 30
  | 31
  | 32
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57
  | 99999;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsOccupancyType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsLoanStatus =
  | 2
  | 4
  | 5
  | 6
  | 8
  | 15
  | 16
  | 22
  | 23
  | 30
  | 31
  | 33
  | 34
  | 35
  | 41
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 56
  | 57
  | 58
  | 60
  | 61
  | 62
  | 64
  | 65
  | 66
  | 68
  | 70
  | 71
  | 73
  | 74
  | 75
  | 78
  | 79
  | 81
  | 82
  | 83
  | 84
  | 85
  | 87
  | 88
  | 89
  | 91
  | 92
  | 93
  | 94
  | 95
  | 96
  | 98;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsLoanPurposeType =
  | 1
  | 2
  | 3
  | 6
  | 9
  | 10
  | 11
  | 12;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsLoanProductType = 1 | 2 | 3 | 4;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsLoanCommentSubCategory =
  | 1
  | 2
  | 41
  | 51
  | 55
  | 74
  | 2000005
  | 2000008
  | 2000086
  | 2000150
  | 2000173
  | 2000176
  | 2000241
  | 2000248
  | 2000490
  | 2000500
  | 2000501
  | 2000502
  | 2000510;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsEscrowedOnProperty = 1 | 2 | 3 | 4;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsDerogatoryTermSource = 0 | 1;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsAusUnderwritingMethod = 1 | 2 | 3;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsAttachedPropertyType =
  | 0
  | 1
  | 2
  | 99
  | -1;

/** @format int32 */
export type UWMCLibraryCommonDomainEnumsAnswerSource = 0 | 1 | 2 | 3 | 4;

/** @format int32 */
export type ModelsEnumTransactionExtractionStatus = 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type ModelsEnumTracType = 0 | 1 | 2 | 3;

/** @format int32 */
export type ModelsEnumRuleResultStatus = 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type ModelsEnumQuestionSubContext = 11 | 12 | 21 | 22 | 31 | 32;

/** @format int32 */
export type ModelsEnumQuestionContext = 1 | 2 | 3;

/** @format int32 */
export type ModelsEnumPurposeType = 0 | 1 | 2 | 3 | 6 | 9 | 10 | 11 | 12;

/** @format int32 */
export type ModelsEnumOccupancyType = 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type ModelsEnumLoanProductType = 1 | 2 | 3 | 4;

/** @format int32 */
export type ModelsEnumIconType = 0 | 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type ModelsEnumGrantAssetAutomationStatus = 0 | 1 | 2 | 3;

/** @format int32 */
export type ModelsEnumDocumentExtractionStatus = 0 | 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type ModelsEnumConfidenceLevel = 0 | 1 | 2;

/** @format int32 */
export type ModelsEnumCitizenshipType = 0 | 1 | 2 | 3;

/** @format int32 */
export type ModelsEnumAssetTransactionType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11;

/** @format int32 */
export type ModelsEnumAssetTransactionSource = 1 | 2 | 3 | 4;

/** @format int32 */
export type ModelsEnumAssetTransactionAction = 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type ModelsEnumAssetConditionGroup = 1 | 2 | 3;

/** @format int32 */
export type DtoV1VADebtResolution = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1VACreditReportType = 1 | 2;

/** @format int32 */
export type DtoV1UnderwritingSummariesLiabilityLienPosition =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6;

/** @format int32 */
export type DtoV1UnderwritingSummariesLiabilityLiabilitySummaryType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16;

/** @format int32 */
export type DtoV1QueueEnumStatusReasonType = 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type DtoV1QueueEnumQueueType = 4 | 6 | 14 | 64;

/** @format int32 */
export type DtoV1PropertyTaxTaxesPaidFlag = 0 | 1;

/** @format int32 */
export type DtoV1PropertyInformationEnumsTitleSummaryWorkflow =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6;

/** @format int32 */
export type DtoV1PropertyInformationEnumsCustomerChangeAction = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1PropertyInformationEnumsAnswerSource = 0 | 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1IncomeRentalIncomeRentalPropertyTypeEnum = 1 | 2 | 3;

export type DtoV1IncomeCalculationFieldType =
  | "Currency"
  | "Integer"
  | "Decimal"
  | "Text"
  | "Date"
  | "Radio"
  | "Percentage"
  | "Checkbox";

/** @format int32 */
export type DtoV1IncomeAlertStatus = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1FhaOverviewHudVaLoanPurpose =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13;

/** @format int32 */
export type DtoV1FhaOverviewHudSectionOfAct = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

/** @format int32 */
export type DtoV1EnumWageBonusType = 0 | 1;

/** @format int32 */
export type DtoV1EnumValidationResultRuleSubCategory =
  | 1
  | 3
  | 5
  | 6
  | 7
  | 8
  | 9
  | 12
  | 20
  | 21
  | 22;

/** @format int32 */
export type DtoV1EnumValidationResultRuleResultStatus = 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumValidationResultRuleReferenceType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 17
  | 18
  | 21
  | 22
  | 23;

/** @format int32 */
export type DtoV1EnumValidationResultRuleCategory = 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type DtoV1EnumValidationResultQuestionDisplayType = 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumValidationResultConditionCategory =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24;

/** @format int32 */
export type DtoV1EnumValidationResultCSID = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/** @format int32 */
export type DtoV1EnumValidationResultAlertStyle = 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type DtoV1EnumUnderwritingMethod = 1 | 2;

/** @format int32 */
export type DtoV1EnumUlddPropertyReviewLevel = 0 | 1 | 3;

/** @format int32 */
export type DtoV1EnumTransactionExtractionStatus = 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type DtoV1EnumTracType = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumTaxPaymentTypes =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10;

/** @format int32 */
export type DtoV1EnumResolutionType = 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumRequestReferenceType = 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumPurposeType = 0 | 1 | 2 | 3 | 6 | 9 | 10 | 11 | 12;

/** @format int32 */
export type DtoV1EnumPropertyType =
  | 0
  | 22
  | 23
  | 25
  | 26
  | 27
  | 28
  | 30
  | 31
  | 32
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57;

/** @format int32 */
export type DtoV1EnumPropertyStatus = 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type DtoV1EnumPropertyReviewLevel = 15 | 16 | 17 | 27;

/** @format int32 */
export type DtoV1EnumPropertyInformationContext = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type DtoV1EnumPrepaidAlertType = 0 | 1;

/** @format int32 */
export type DtoV1EnumPaySchedule =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11;

/** @format int32 */
export type DtoV1EnumOwnershipStatus = 0 | 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumOwnerOfMortgage = 1 | 2 | 3 | -1;

/** @format int32 */
export type DtoV1EnumOriginalSectionAct = 0 | 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type DtoV1EnumOriginalMortgageType = 0 | 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type DtoV1EnumOriginalMortgagePurpose = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumOriginalMortgageDescription =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9;

/** @format int32 */
export type DtoV1EnumOccupancyType = 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type DtoV1EnumMatchType = 1 | 2 | 3 | 4 | 5 | 6;

/** @format int32 */
export type DtoV1EnumMaritalStatusType = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumMannerPowerOfAttorneyHeldType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16;

/** @format int32 */
export type DtoV1EnumLoanPurposeType = 0 | 1 | 2 | 3 | 6 | 9 | 10 | 11 | 12;

/** @format int32 */
export type DtoV1EnumLoanProductType = 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumLegalSpouseRightsType = 0 | 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumInvestorCollateralProgramIdentifier =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 6
  | 7;

/** @format int32 */
export type DtoV1EnumIncomeValidationDocumentType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 16
  | 17
  | 19
  | 20
  | 21;

/** @format int32 */
export type DtoV1EnumIncomeType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43;

/** @format int32 */
export type DtoV1EnumIncomeSummaryMessageType = 0 | 1;

export type DtoV1EnumIncomeCalculatorType =
  | "SocialSecurity"
  | "Pension"
  | "InterestDividends"
  | "Rental"
  | "IraDistributions"
  | "ScheduleC"
  | "Partnership"
  | "SoleProprietorship"
  | "Corporation"
  | "PayStub"
  | "Voe"
  | "CapitalGains1040"
  | "W2"
  | "LeaveAndEarningsStatement"
  | "VaBenefitLetterForBenefitIncome"
  | "VaCoeForBenefitIncome"
  | "BankStatementForBenefitIncome";

/** @format int32 */
export type DtoV1EnumIconType = 0 | 1 | 2 | 3 | 4 | 5;

/** @format int32 */
export type DtoV1EnumExclusionReason =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12;

export type DtoV1EnumExcludeAccountFromSumReason =
  | "None"
  | "UnableToExclude"
  | "Medical"
  | "IdentityTheft"
  | "DisputeResolved"
  | "Duplicate";

/** @format int32 */
export type DtoV1EnumEntityType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 25
  | 27
  | 28
  | 29;

/** @format int32 */
export type DtoV1EnumEmploymentType = 0 | 1 | 2;

/** @format int32 */
export type DtoV1EnumDtiFlag = 0 | 1;

/** @format int32 */
export type DtoV1EnumDocumentType =
  | 17812
  | 17817
  | 17836
  | 17838
  | 17854
  | 17860
  | 17865
  | 17866
  | 17872
  | 17876
  | 17886
  | 17888
  | 17905
  | 17912
  | 18047
  | 18394
  | 18401
  | 18614
  | 18788
  | 18854
  | 18888
  | 20018
  | 20046
  | 20057
  | 20670
  | 20677
  | 20688
  | 20691
  | 20701
  | 20703
  | 20711
  | 20720
  | 20722
  | 20723
  | 20731
  | 20732
  | 20744
  | 20826
  | 20851
  | 20890
  | -2
  | -1;

/** @format int32 */
export type DtoV1EnumDeductionAction = 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumCreditBureau = 1 | 2 | 3;

export type DtoV1EnumContactCategoryType =
  | "SeniorUnderwriter"
  | "AccountExecutive"
  | "UnderwriterII"
  | "UnderwritingTeam"
  | "VVOE"
  | "ProjectAssistant"
  | "CollateralUnderwriter";

/** @format int32 */
export type DtoV1EnumConfidenceLevel = 0 | 1 | 2;

/** @format int32 */
export type DtoV1EnumCitizenshipType = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumCalculationScenarioType =
  | 100
  | 200
  | 300
  | 400
  | 500
  | 600
  | 900
  | 1000
  | 1100
  | 1800;

/** @format int32 */
export type DtoV1EnumBusinessChannel = 0 | 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumBorrowerDeclarationsTitleType = 0 | 1 | 2 | 3 | 4;

/** @format int32 */
export type DtoV1EnumBorrowerDeclarationsOwnershipPropertyType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5;

/** @format int32 */
export type DtoV1EnumBorrowerDeclarationsDuExpForeclosureType = 0 | 4;

/** @format int32 */
export type DtoV1EnumBorrowerDeclarationsDuExpDelinquencyType = 0 | 1;

/** @format int32 */
export type DtoV1EnumBorrowerDeclarationsDuExpBankruptcyType = 0 | 1;

/** @format int32 */
export type DtoV1EnumBoltAuditPage =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 56
  | 57
  | 58
  | 59
  | 60
  | 61
  | 62
  | 63
  | 64
  | 65
  | 66
  | 67
  | 68
  | 69
  | 70
  | 71
  | 72
  | 73
  | 74
  | 75
  | 76
  | 77
  | 78
  | 79
  | 80
  | 81
  | 82
  | 83
  | 84
  | 85
  | 86
  | 87
  | 88
  | 89
  | 90
  | 91
  | 92
  | 93
  | 94
  | 95
  | 96
  | 97
  | 98
  | 99
  | 100
  | 101
  | 102
  | 103
  | 104
  | 105
  | 106
  | 107;

/** @format int32 */
export type DtoV1EnumAnnualQualifyingAmountCalcMethod = 0 | 1 | 2 | 3;

/** @format int32 */
export type DtoV1EnumAdditionalReferenceType = 1;

/** @format int32 */
export type DtoV1BoltAuditAuditComponentType = 1 | 2 | 3 | 4;

export type DtoV1AppraisalProductColor =
  | "Blue"
  | "Green"
  | "Yellow"
  | "Pink"
  | "White"
  | "Teal"
  | "Silver"
  | "Purple"
  | "Orange";

/** @format int32 */
export type DtoV1AppraisalAppraisalConclusionType = 0 | 1 | 2 | 3;

export interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Record<string, string[]> | null;
  [key: string]: any;
}

export type MicrosoftAspNetCoreMvcIActionResult = object;

export interface MicrosoftAspNetCoreMvcProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export type NewtonsoftJsonLinqJToken = any;

export interface KeyValuePairSystemInt32SystemString {
  /** @format int32 */
  key?: number;
  value?: string | null;
}

export interface KeyValuePairSystemStringICollectionDtoV1BoltAuditEntityFieldResponse {
  key?: string | null;
  value?: DtoV1BoltAuditEntityFieldResponse[] | null;
}

export interface KeyValuePairSystemStringICollectionDtoV1BoltAuditFieldAudit {
  key?: string | null;
  value?: DtoV1BoltAuditFieldAudit[] | null;
}

export interface KeyValuePairSystemStringICollectionDtoV1BoltAuditIncomeReconciliationFieldAudit {
  key?: string | null;
  value?: DtoV1BoltAuditIncomeReconciliationFieldAudit[] | null;
}

export interface KeyValuePairSystemStringSystemString {
  key?: string | null;
  value?: string | null;
}

export interface DtoContact {
  /** @format int32 */
  contactId?: number;
  /** @format int32 */
  entityId?: number;
  fullName?: string | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoGetMultipackResponse {
  currentLoan?: DtoMultipackLoan | null;
  multipackLoans?: DtoMultipackLoan[] | null;
  seniorUnderwriterContactOptions?: DtoContact[] | null;
  underwriterIIContactOptions?: DtoContact[] | null;
  queueComment?: string | null;
}

export interface DtoIdentitiesAddressIdentifier {
  /** @format int32 */
  addressLdId?: number;
  /** @format int32 */
  addressId?: number;
}

export interface DtoIdentitiesAusRequestIdentifier {
  /** @format int32 */
  requestLdId?: number;
  requestId?: string | null;
}

export interface DtoIdentitiesBorrowerIdentifier {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
}

export interface DtoIdentitiesCustomerIdentifier {
  /** @format int32 */
  obfuscatedLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
}

export interface DtoIdentitiesIncomeIdentifier {
  /** @format int32 */
  obfuscatedLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  employerId?: number;
  /** @format int32 */
  sequenceNumber?: number;
}

export interface DtoIdentitiesLiabilityIdentifier {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  obfuscatedLenderDatabaseId?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  obfuscatedLoanRecordId?: number;
  /** @format int32 */
  debtLenderDatabaseId?: number;
  /** @format int32 */
  debtId?: number;
}

export interface DtoIdentitiesMailingAddressIdentifier {
  /** @format int32 */
  mailingAddressLdId?: number;
  /** @format int32 */
  mailingAddressId?: number;
}

export interface DtoIdentitiesObfuscatedLoanIdentifier {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  obfuscatedLenderDatabaseId?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  obfuscatedLoanRecordId?: number;
}

export interface DtoIdentitiesRequestIdentifier {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  requestLdId?: number;
  requestId?: string | null;
}

export interface DtoLoanInformationDates {
  /** @format date-time */
  fileImportedDate?: string | null;
  /** @format date-time */
  boltEnteredDate?: string | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  /** @format date-time */
  loanApplicationDate?: string | null;
  /** @format date-time */
  underwritingSubmittedDate?: string | null;
  /** @format date-time */
  disbursementDate?: string | null;
  /** @format date-time */
  firstPaymentDate?: string | null;
  /** @format date-time */
  zapEnteredDate?: string | null;
  /** @format date-time */
  cannotCloseBeforeDate?: string | null;
  /** @format date-time */
  actualClosingDate?: string | null;
  /** @format date-time */
  caseNumberDate?: string | null;
  /** @format date-time */
  creditReportExpirationDate?: string | null;
}

export interface DtoMultipackLoan {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  loanNumber?: string | null;
  loanStatus?: string | null;
  loanPurpose?: string | null;
  propertyAddress?: DtoV1Address | null;
  borrowers?: DtoV1BorrowerName[] | null;
  product?: string | null;
  seniorUnderwriter?: DtoContact | null;
  underwriter?: DtoContact | null;
  /** @format date-time */
  updatedAt?: string;
  occupancyType?: string | null;
  originatingLenderId?: string | null;
  isCurrentLoan?: boolean;
}

export interface DtoObfuscatedLoanIdentifierRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoPropertyType {
  /** @format int32 */
  propertyTypeId?: number;
  propertyTypeAlias?: string | null;
  propertyTypeDescription?: string | null;
}

export interface DtoServerDrivenUIAnswerRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  customerRecordId?: number | null;
  ruleCategory: DtoV1EnumValidationResultRuleCategory;
  ruleSubCategory: DtoV1EnumValidationResultRuleSubCategory;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  ruleId: number;
  ruleReferences?: Record<string, string | null>;
  answers: Record<string, NewtonsoftJsonLinqJToken>;
}

export interface DtoServerDrivenUIRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  customerRecordId?: number | null;
  ruleCategory: DtoV1EnumValidationResultRuleCategory;
  ruleSubCategory: DtoV1EnumValidationResultRuleSubCategory;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  ruleId: number;
  ruleReferences?: Record<string, string | null>;
}

export interface DtoV1AIResponse {
  answer?: string | null;
  detailedAnswer?: string | null;
  /** @format double */
  confidence?: number;
  confidenceLevel?: DtoV1EnumConfidenceLevel;
  iconType?: DtoV1EnumIconType | null;
  snippets?: DtoV1Snippet[] | null;
}

export interface DtoV1AUSAUSRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  runDestinyCalcs?: boolean;
}

export interface DtoV1AUSAusDetails {
  positiveRentalPaymentIndicator?: boolean | null;
  positiveRentalPaymentText?: string | null;
  desktopUnderwriterDetails?: DtoV1AUSDesktopUnderwriterDetails | null;
  loanProductAdvisorDetails?: DtoV1AUSLoanProductAdvisorDetails | null;
  borrowerCreditReferences?: DtoV1AUSBorrowerCreditReference[] | null;
}

export interface DtoV1AUSAusDocumentRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  requestIdentifier?: DtoIdentitiesAusRequestIdentifier | null;
  ausMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  /** @format date-time */
  requestDateTime?: string;
  requestStatus?: boolean | null;
}

export interface DtoV1AUSAusDocumentResponse {
  documentBase64?: string | null;
  documentType?: string | null;
  underwritingMethod?: string | null;
  requestIdentifier?: DtoIdentitiesAusRequestIdentifier | null;
  requestPath?: string | null;
}

export interface DtoV1AUSAusRequestHistoryData {
  requestMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  requestIdentifier?: DtoIdentitiesAusRequestIdentifier | null;
  /** @format date-time */
  requestDate?: string | null;
  requestShortDate?: string | null;
  requestTime?: string | null;
  requestUser?: string | null;
  requestStatus?: string | null;
  recommendation?: string | null;
}

export interface DtoV1AUSAusResponse {
  isSuccessful?: boolean;
}

export interface DtoV1AUSBorrowerCreditReference {
  borrowerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  creditReference?: string | null;
}

export interface DtoV1AUSCustomerCreditReference {
  customerIdentifier?: DtoIdentitiesBorrowerIdentifier | null;
  creditReference?: string | null;
}

export interface DtoV1AUSDesktopUnderwriterCreditCompany {
  /** @format int32 */
  companyId?: number;
  name?: string | null;
  creditCompany?: string | null;
  description?: string | null;
  username?: string | null;
  password?: string | null;
  brokerCredentialsInd?: boolean;
}

export interface DtoV1AUSDesktopUnderwriterDetails {
  creditCompanies?: DtoV1AUSDesktopUnderwriterCreditCompany[] | null;
  loanAssociationDetails?: DtoV1AUSDesktopUnderwriterLoanAssociation | null;
  brokerAssociatedCreditCompanies?:
    | DtoV1AUSDesktopUnderwriterCreditCompany[]
    | null;
  hasDesktopUnderwriterData?: boolean;
}

export interface DtoV1AUSDesktopUnderwriterLoanAssociation {
  creditCompany?: string | null;
  companyId?: string | null;
  username?: string | null;
  password?: string | null;
  brokerCredentialsInd?: boolean;
}

export interface DtoV1AUSFreOffering {
  freOfferingId?: string | null;
  displayText?: string | null;
  description?: string | null;
}

export interface DtoV1AUSGetAUSRecommendationResponse {
  ausRecommendation?: string | null;
  underwritingMethod?: string | null;
  requestId?: string | null;
  partialAusUrl?: string | null;
  /** @format date-time */
  requestDate?: string | null;
}

export interface DtoV1AUSGetAusDetailsResponse {
  ausDetails?: DtoV1AUSAusDetails | null;
  lastAusRunDetails?: DtoV1AUSAusRequestHistoryData | null;
  lastAusMethodDetails?: DtoV1AUSLastAusMethodDetails | null;
}

export interface DtoV1AUSGetAusRequestHistoryResponse {
  duRequests?: DtoV1AUSAusRequestHistoryData[] | null;
  lpaRequests?: DtoV1AUSAusRequestHistoryData[] | null;
}

export interface DtoV1AUSLastAusMethodDetails {
  desktopUnderwriterDetails?: DtoV1AUSAusRequestHistoryData | null;
  loanProductAdvisorDetails?: DtoV1AUSAusRequestHistoryData | null;
}

export interface DtoV1AUSLoanProductAdvisorCreditCompany {
  /** @format int32 */
  creditCompanyRecordId?: number;
  companyName?: string | null;
}

export interface DtoV1AUSLoanProductAdvisorDetails {
  creditCompanies?: DtoV1AUSLoanProductAdvisorCreditCompany[] | null;
  loanAssociationDetails?: DtoV1AUSLoanProductAdvisorLoanAssociation | null;
  freOfferingDetails?: DtoV1AUSFreOffering[] | null;
  hasLoanProductAdvisorData?: boolean;
}

export interface DtoV1AUSLoanProductAdvisorLoanAssociation {
  /** @format int32 */
  originalCreditEntityId?: number;
  /** @format int32 */
  creditCompanyRecordId?: number;
  branchNumber?: string | null;
  freOfferingId?: string | null;
}

export interface DtoV1AUSRunAusWithReissueRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  reIssueIndicator?: boolean;
  ausMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  desktopUnderwriterDetails?: DtoV1AUSDesktopUnderwriterLoanAssociation | null;
  loanProductAdvisorDetails?: DtoV1AUSLoanProductAdvisorLoanAssociation | null;
  customerCreditReferences?: DtoV1AUSCustomerCreditReference[] | null;
}

export interface DtoV1AUSUpdatePositiveRentalHistoryPaymentRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  positiveRentalHistoryValue?: boolean;
}

export interface DtoV1ActionBarIconResponse {
  counterOffer?: DtoV1ActionBarIconStatus | null;
  invalidProduct?: DtoV1ActionBarIconStatus | null;
  autoCofC?: DtoV1ActionBarIconStatus | null;
  piti?: DtoV1ActionBarIconStatus | null;
}

export interface DtoV1ActionBarIconStatus {
  iconColor?: boolean | null;
  showIcon?: boolean;
}

export interface DtoV1AdditionalDataItem {
  ruleReferenceValue?: string | null;
  ruleReferenceType?: string | null;
  ruleReferenceLenderDatabaseID?: string | null;
}

export interface DtoV1AdditionalResolutionTextAnswer {
  /** @format int32 */
  addResolutionTextID?: number;
  additionalResolutionText?: string | null;
  /** @format int32 */
  additionalResolutionActionID?: number | null;
  additionalResolutionActionName?: string | null;
}

export interface DtoV1Address {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  wholeAddressString?: string | null;
}

export interface DtoV1AddressExtended {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  wholeAddressString?: string | null;
  addressLine2?: string | null;
  country?: string | null;
  unitNumber?: string | null;
  /** @format int32 */
  unitTypeId?: number | null;
  unitTypeOther?: string | null;
}

export interface DtoV1Answer {
  answerText?: string | null;
  resolutionText?: string | null;
  nextQuestionIds?: number[] | null;
  /** @format int32 */
  processEndMessageActionId?: number | null;
  processEndMessageActionName?: string | null;
  additionalResolutionTextAnswers?:
    | DtoV1AdditionalResolutionTextAnswer[]
    | null;
  processEndMessageActionDesc?: string | null;
  /** @format int32 */
  answerGroupSeq?: number;
  fieldType?: string | null;
  /** @format int32 */
  questionAnswerID?: number;
  dtlAnswer?: string | null;
}

export interface DtoV1AppraisalAirportZone {
  specialAirportHazardZoneType?: string | null;
}

export interface DtoV1AppraisalAppraisalAssignmentData {
  /** @format int32 */
  appraisedValue?: number | null;
  /** @format int32 */
  siteEstimatedValueAmount?: number | null;
  assignmentReason?: string | null;
  governmentAgency?: string | null;
  /** @format date */
  appraisalReportEffectiveDate?: string | null;
  appraisalStatus?: DtoV1AppraisalAppraisalConclusionType | null;
  appraisalManagementCompany?: string | null;
  lenderClient?: string | null;
  primaryAppraiserLicenseNumber?: string | null;
  primaryAppraiserName?: string | null;
}

export interface DtoV1AppraisalAppraisalCarStorage {
  type?: string | null;
  attachmentType?: string | null;
}

export interface DtoV1AppraisalAppraisalCommonData {
  borrowerNames?: string[] | null;
  currentOwnersOfPublicRecord?: string[] | null;
  sellerNames?: string[] | null;
  assessorParcelNumber?: string | null;
  /** @format int32 */
  numberOfParcels?: number | null;
}

export interface DtoV1AppraisalAppraisalComparable {
  /** @format decimal */
  levelCount?: number | null;
  /** @format decimal */
  propertyOrdinalNumber?: number;
  comparableWeight?: string | null;
  propertyRightsAppraised?: string | null;
  constructionMethod?: string | null;
  sameBuilderAsSubject?: boolean | null;
  sameProjectAsSubject?: boolean | null;
  /** @format decimal */
  accessoryDwellingUnitTotalCount?: number | null;
  zoningComplianceType?: string | null;
  /** @format decimal */
  structureLivingUnitCount?: number | null;
  manufacturedHomeWidth?: string | null;
  hasSolar?: boolean;
  /** @format int32 */
  energyEfficientAndGreenAdjustmentAmount?: number | null;
  listingInformations?: DtoV1AppraisalAppraisalListingInformation[] | null;
  salesHistories?: DtoV1AppraisalAppraisalSalesHistory[] | null;
}

export interface DtoV1AppraisalAppraisalConditionData {
  apparentDamages?: DtoV1AppraisalAppraisalPropertyDefect[] | null;
}

export interface DtoV1AppraisalAppraisalData {
  appraisalDocuments?: DtoV1PropertyInformationDocument[] | null;
  hasAppraisalInvoice?: boolean;
  appraisalMatchData?: DtoV1AppraisalAppraisalMatchData[] | null;
  questionAnswerData?: DtoV1QuestionsQuestion[] | null;
  appraisedValueOptions?: DtoV1AppraisalAppraisedValueOption[] | null;
  /** @format int32 */
  appraisalCount?: number;
  /** @format int32 */
  reconciledAppraisalXmlId?: number | null;
  reconciliationDamages?: DtoV1AppraisalReconciliationDamage[] | null;
  reconciliationComparison?: DtoV1AppraisalReconciliationComparison | null;
  systemValues?: DtoV1AppraisalAppraisalSystemValues | null;
  uniformAppraisalDataset?: DtoV1AppraisalAppraisalUadData | null;
  amcCompanies?: DtoV1AppraisalAppraisalManagementCompanyOption[] | null;
  matchedAppraiser?: DtoV1AppraisalAppraiserSearchResult | null;
  selfSufficiency?: DtoV1AppraisalAppraisalSelfSufficiency | null;
}

export interface DtoV1AppraisalAppraisalDwellingExteriorData {
  structureIdentifier?: string | null;
  improvementLabel?: string | null;
  defectsExistIndicator?: boolean;
  photos?: DtoV1AppraisalAppraisalImageData[] | null;
  structureComponents?: DtoV1AppraisalStructureComponent[] | null;
}

export interface DtoV1AppraisalAppraisalEnergyData {
  renewableEnergyComponents?:
    | DtoV1AppraisalAppraisalRenewableEnergyComponent[]
    | null;
}

export interface DtoV1AppraisalAppraisalHazardZone {
  hazardZoneType?: string | null;
  lavaFlowZoneCode?: string | null;
}

export interface DtoV1AppraisalAppraisalImageData {
  /** @format int32 */
  imageCategoryType?: number | null;
  imageCaptionCommentDescription?: string | null;
}

export interface DtoV1AppraisalAppraisalListingInformation {
  listingIdentifier?: string | null;
  listingStatusType?: string | null;
}

export interface DtoV1AppraisalAppraisalManagementCompanyOption {
  /** @format int32 */
  entityId?: number;
  name?: string | null;
}

export interface DtoV1AppraisalAppraisalManufacturedHomeData {
  manufacturerName?: string | null;
  serialNumber?: string | null;
  hudLabelNumber?: string | null;
  manufacturedHomeWidthType?: string | null;
  /** @format int32 */
  aboveGradeFinishedArea?: number | null;
  manufacturedHomeHUDCertificateLabelIndicator?: boolean | null;
  manufacturedHomeHUDDataPlateAttachedIndicator?: boolean | null;
  manufacturedHomeHitchWheelsAxlesRemovedIndicator?: boolean | null;
  manufacturedHomeMovedAfterOriginalInstallationIndicator?: boolean | null;
  /** @format date-time */
  manufactureDate?: string | null;
}

export interface DtoV1AppraisalAppraisalMarketData {
  marketSupplyTrendType?: string | null;
  marketingTimeType?: string | null;
}

export interface DtoV1AppraisalAppraisalMatchData {
  name?: string | null;
  systemDisplayValue?: string | null;
  appraisalDisplayValue?: string | null;
  canHide?: boolean | null;
}

export interface DtoV1AppraisalAppraisalOutbuilding {
  type?: string | null;
  typeOtherDescription?: string | null;
  defectsExistIndicator?: boolean;
  damages?: DtoV1AppraisalAppraisalPropertyDefect[] | null;
}

export interface DtoV1AppraisalAppraisalOutbuildingData {
  items?: DtoV1AppraisalAppraisalOutbuilding[] | null;
}

export interface DtoV1AppraisalAppraisalPhotoReviewItem {
  key?: string | null;
  label?: string | null;
}

export interface DtoV1AppraisalAppraisalProjectData {
  /** @format int32 */
  monthlyHOADues?: number | null;
  developerOrSponsorInControl?: boolean | null;
  unitsCommonAreasAmenitiesComplete?: boolean | null;
  recentlyConverted?: boolean | null;
}

export interface DtoV1AppraisalAppraisalPropertyCharacteristics {
  pudIndicator?: boolean | null;
  propertyInProjectIndicator?: boolean | null;
  /** @format decimal */
  livingUnitExcludingADUCount?: number | null;
  landOwnedInCommonIndicator?: boolean | null;
  constructionMethodTypes?: string[] | null;
  overallConditionRatingCode?: string | null;
  interiorConditionRatingCode?: string | null;
  exteriorConditionRatingCode?: string | null;
  overallQualityRatingCode?: string | null;
  interiorQualityRatingCode?: string | null;
  exteriorQualityRatingCode?: string | null;
}

export interface DtoV1AppraisalAppraisalPropertyDefect {
  feature?: string | null;
  location?: string | null;
  affectsStructuralIntegrityOrSafety?: boolean;
  description?: string | null;
  recommendedAction?: string | null;
  section?: string | null;
}

export interface DtoV1AppraisalAppraisalRenewableEnergyComponent {
  componentType?: string | null;
  componentTypeOtherDescription?: string | null;
  ownershipType?: string | null;
  ownershipTypeOtherDescription?: string | null;
  financedIndicator?: boolean;
}

export interface DtoV1AppraisalAppraisalRoomData {
  roomType?: string | null;
  roomTypeOtherDescription?: string | null;
  photos?: DtoV1AppraisalAppraisalImageData[] | null;
}

export interface DtoV1AppraisalAppraisalSalesData {
  /** @format int32 */
  salesContractAmount?: number | null;
  /** @format date-time */
  salesContractDate?: string | null;
  /** @format int32 */
  totalSalesConcessionAmount?: number | null;
  /** @format int32 */
  rentalIncome?: number | null;
}

export interface DtoV1AppraisalAppraisalSalesHistory {
  /** @format date-time */
  ownershipTransferDate?: string | null;
  ownershipTransferTransactionType?: string | null;
}

export interface DtoV1AppraisalAppraisalSelfSufficiency {
  /** @format int32 */
  totalMonthlyMarketRentAmount?: number | null;
  /** @format decimal */
  maximumPitiaAmount?: number | null;
  /** @format decimal */
  currentPitiaAmount?: number | null;
  isMet?: boolean | null;
}

export interface DtoV1AppraisalAppraisalSiteData {
  zoningComplianceType?: string | null;
  propertyMixedUsageIndicator?: boolean | null;
  propertyPrimarilyResidentialUseIndicator?: boolean | null;
  /** @format decimal */
  residentialUsePercent?: number | null;
  nonResidentialUseTypes?: string[] | null;
  nativeAmericanLandsIndicator?: boolean | null;
  communityLandTrustIndicator?: boolean | null;
  siteUtilities?: DtoV1AppraisalAppraisalSiteUtility[] | null;
  hazardZones?: DtoV1AppraisalAppraisalHazardZone[] | null;
  siteInfluences?: DtoV1AppraisalSiteInfluence[] | null;
  zoningPermitRebuildToCurrentDensityIndicator?: boolean | null;
  publicSewerUtilityAvailableNotConnectedIndicator?: boolean | null;
  publicWaterUtilityAvailableNotConnectedIndicator?: boolean | null;
}

export interface DtoV1AppraisalAppraisalSiteUtility {
  utilityType?: string | null;
  ownershipType?: string | null;
  siteUtilityServices?: DtoV1AppraisalSiteUtilityService[] | null;
}

export interface DtoV1AppraisalAppraisalSubjectPropertyAmenitiesData {
  photos?: DtoV1AppraisalAppraisalImageData[] | null;
}

export interface DtoV1AppraisalAppraisalSubjectPropertyData {
  /** @format decimal */
  levelCount?: number | null;
  property?: DtoV1AppraisalAppraisalPropertyCharacteristics | null;
  propertyType?: DtoV1AppraisalAppraisalPropertyCharacteristics | null;
  propertyAttachmentType?: string | null;
  propertyRightsAppraised?: string | null;
  occupancyType?: string | null;
  isNewConstruction?: boolean | null;
  /** @format int32 */
  yearBuilt?: number | null;
  /** @format decimal */
  unitCount?: number | null;
  /** @format decimal */
  accessoryDwellingUnitTotalCount?: number | null;
  requiresAduNotRentableReview?: boolean;
  requiresOccupancyReview?: boolean;
  /** @format int32 */
  aboveGradeFinishedArea?: number | null;
  /** @format decimal */
  structureLivingUnitCount?: number | null;
  manufacturedHomeWidth?: string | null;
  structureDesign?: string | null;
  constructionMethods?: string[] | null;
  homeownerResponsibleForExteriorMaintenance?: boolean | null;
  encumbrances?: DtoV1AppraisalEncumbrance[] | null;
  constructionStatus?: string | null;
  isInteriorAccessOnly?: boolean;
}

export interface DtoV1AppraisalAppraisalSystemValues {
  propertyAddressLine1?: string | null;
  propertyAddressLine2?: string | null;
  propertyCity?: string | null;
  propertyState?: string | null;
  propertyZipCode?: string | null;
  fipsCountyCode?: string | null;
  unitNo?: string | null;
  county?: string | null;
  buildingStatus?: string | null;
  /** @format int32 */
  propertyValueFormType?: number | null;
  productAlias?: string | null;
  isJumbo?: boolean | null;
  isFHA?: boolean | null;
  isVA?: boolean | null;
  isUSDA?: boolean | null;
  isHeloc?: boolean | null;
  isNationwide?: boolean | null;
  /** @format int32 */
  loanTypeId?: number | null;
  productDescription?: string | null;
  isOneTimeCloseProduct?: boolean;
  isLakeviewProduct?: boolean;
  isJumboProduct?: boolean;
  isDoctorProduct?: boolean;
  productColor?: DtoV1AppraisalProductColor | null;
  isBankStatement?: boolean;
  inactiveFlag?: boolean | null;
  agencyCaseNumber?: string | null;
  /** @format int32 */
  productId?: number | null;
  closingParcelId?: string | null;
  propertyParcelId?: string | null;
  /** @format int32 */
  occupancyTypeId?: number | null;
  occupancyBucket?: string | null;
  /** @format int32 */
  propertyTypeId?: number | null;
  /** @format double */
  monthlyHOADues?: number | null;
  isFeeSimple?: string | null;
  isLeasehold?: string | null;
  isLeasedFee?: string | null;
  /** @format int32 */
  numberOfPayments?: number | null;
  /** @format int32 */
  paymentsPerYear?: number | null;
  /** @format int32 */
  loanPurposeTypeId?: number | null;
  /** @format double */
  refinanceAmountOfExistingLiens?: number | null;
  /** @format double */
  refinanceCostOfImprovements?: number | null;
  /** @format double */
  refinanceOriginalCost?: number | null;
  refinancePurpose?: string | null;
  /** @format int32 */
  refinanceYearAcquired?: number | null;
  refinanceImprovementsMade?: string | null;
  refinanceImprovementsToBeMade?: string | null;
  refinanceImprovementDescription?: string | null;
  /** @format double */
  refinanceOriginalValue?: number | null;
  refinanceLandContractConversionFlag?: boolean | null;
  /** @format int32 */
  businessChannelId?: number | null;
  /** @format double */
  purchasePrice?: number | null;
  /** @format date-time */
  salesContractDate?: string | null;
  /** @format double */
  sellerConcessions?: number | null;
  /** @format decimal */
  allowableMaxSellersConcessions?: number | null;
  deskReviewRequiredFlag?: string | null;
  fieldReviewRequiredFlag?: string | null;
  appraisalManagementCompany?: string | null;
  borrower1FirstName?: string | null;
  borrower1MiddleName?: string | null;
  borrower1LastName?: string | null;
  borrower1Suffix?: string | null;
  borrower2FirstName?: string | null;
  borrower2MiddleName?: string | null;
  borrower2LastName?: string | null;
  borrower2Suffix?: string | null;
  seller1FirstName?: string | null;
  seller1MiddleName?: string | null;
  seller1LastName?: string | null;
  seller2FirstName?: string | null;
  seller2MiddleName?: string | null;
  seller2LastName?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  hudLabelNumber?: string | null;
  make?: string | null;
  /** @format int32 */
  attachmentTypeId?: number | null;
  isNewConstruction?: boolean | null;
  /** @format int32 */
  numberOfUnits?: number | null;
  /** @format int32 */
  manufacturedStructType?: number | null;
  /** @format int32 */
  yearBuilt?: number | null;
  /** @format double */
  appraisedValue?: number | null;
  /** @format double */
  rentalIncome?: number | null;
  /** @format int32 */
  widthInFeet?: number | null;
  /** @format int32 */
  lengthInFeet?: number | null;
  /** @format date-time */
  fhaCaseNumberDate?: string | null;
  /** @format date-time */
  underwritingSubmittedDate?: string | null;
  underwritingMethod?: string | null;
  earlyCDAppraisalIndicator?: boolean | null;
  /** @format int32 */
  loanStatusId?: number | null;
  /** @format date-time */
  actualClosingDate?: string | null;
  correspondentLenderName?: string | null;
  isTitleUploaded?: boolean;
  hasMasterInsurancePolicy?: boolean;
  hasPropertyInsurancePolicy?: boolean;
  isCondoOrAttachedPud?: boolean;
  isInvestorFlex?: boolean;
}

export interface DtoV1AppraisalAppraisalUadData {
  /** @format int32 */
  appraisalXmlId?: number;
  common?: DtoV1AppraisalAppraisalCommonData | null;
  assignmentInformation?: DtoV1AppraisalAppraisalAssignmentData | null;
  subjectProperty?: DtoV1AppraisalAppraisalSubjectPropertyData | null;
  sales?: DtoV1AppraisalAppraisalSalesData | null;
  salesComparables?: DtoV1AppraisalAppraisalComparable[] | null;
  site?: DtoV1AppraisalAppraisalSiteData | null;
  market?: DtoV1AppraisalAppraisalMarketData | null;
  condition?: DtoV1AppraisalAppraisalConditionData | null;
  vehicleStorage?: DtoV1AppraisalAppraisalVehicleStorageData | null;
  outbuilding?: DtoV1AppraisalAppraisalOutbuildingData | null;
  unitInteriors?: DtoV1AppraisalAppraisalUnitInteriorData[] | null;
  projectInformation?: DtoV1AppraisalAppraisalProjectData | null;
  manufacturedHome?: DtoV1AppraisalAppraisalManufacturedHomeData | null;
  energy?: DtoV1AppraisalAppraisalEnergyData | null;
  subjectPropertyAmenities?: DtoV1AppraisalAppraisalSubjectPropertyAmenitiesData | null;
  dwellingExteriors?: DtoV1AppraisalAppraisalDwellingExteriorData[] | null;
}

export interface DtoV1AppraisalAppraisalUnitInteriorData {
  unitIdentifier?: string | null;
  floorIdentifier?: string | null;
  isAccessoryDwellingUnit?: boolean;
  isAccessoryDwellingUnitLegallyRentable?: boolean;
  /** @format decimal */
  bedroomCount?: number;
  /** @format decimal */
  fullBathroomCount?: number;
  /** @format decimal */
  halfBathroomCount?: number;
  /** @format decimal */
  surfaceArea?: number | null;
  rooms?: DtoV1AppraisalAppraisalRoomData[] | null;
  photoReview?: DtoV1AppraisalAppraisalPhotoReviewItem[] | null;
  occupancyType?: string | null;
}

export interface DtoV1AppraisalAppraisalVehicleStorageData {
  carStorages?: DtoV1AppraisalAppraisalCarStorage[] | null;
  photos?: DtoV1AppraisalAppraisalImageData[] | null;
}

export interface DtoV1AppraisalAppraisedValueOption {
  /** @format int32 */
  appraisalXmlId?: number;
  /** @format int32 */
  appraisedValue?: number;
  /** @format date */
  effectiveDate?: string | null;
  appraiserLicenseNumber?: string | null;
}

export interface DtoV1AppraisalAppraiserSearchResult {
  /** @format int32 */
  entityId?: number;
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  contactId?: number;
  /** @format int32 */
  contactLenderDatabaseId?: number;
  appraiserName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  suffix?: string | null;
  companyName?: string | null;
  licenseNumber?: string | null;
  /** @format date-time */
  licenseExpirationDate?: string | null;
  licensedState?: string | null;
  source?: string | null;
}

export interface DtoV1AppraisalConditionCovenantRestriction {
  type?: string | null;
}

export interface DtoV1AppraisalEmailQcApprovalsRequest {
  appraiserName?: string | null;
  appraiserLicenseNumber?: string | null;
}

export interface DtoV1AppraisalEmailQcApprovalsResponse {
  emailSent?: boolean;
  /** @format date-time */
  sentAtUtc?: string;
  statusMessage?: string | null;
}

export interface DtoV1AppraisalEncumbrance {
  restrictions?: DtoV1AppraisalConditionCovenantRestriction[] | null;
}

export interface DtoV1AppraisalFoundation {
  foundationStyles?: DtoV1AppraisalFoundationStyle[] | null;
}

export interface DtoV1AppraisalFoundationStyle {
  accessibleForObservationIndicator?: boolean | null;
  foundationType?: string | null;
  visualObservationCompletedIndicator?: boolean | null;
}

export interface DtoV1AppraisalReconciliationComparison {
  appraisals?: DtoV1AppraisalReconciliationComparisonAppraisal[] | null;
  discrepancies?: DtoV1AppraisalReconciliationComparisonDiscrepancy[] | null;
}

export interface DtoV1AppraisalReconciliationComparisonAppraisal {
  /** @format int32 */
  ordinal?: number;
  appraiserLicenseNumber?: string | null;
  appraiserName?: string | null;
  /** @format int32 */
  appraisalXmlId?: number;
  /** @format date */
  effectiveDate?: string | null;
}

export interface DtoV1AppraisalReconciliationComparisonDiscrepancy {
  key?: string | null;
  label?: string | null;
  questionName?: string | null;
  values?: DtoV1AppraisalReconciliationComparisonValue[] | null;
  correctAppraiserLicenseNumber?: string | null;
}

export interface DtoV1AppraisalReconciliationComparisonValue {
  /** @format int32 */
  ordinal?: number;
  appraiserLicenseNumber?: string | null;
  displayValue?: string | null;
}

export interface DtoV1AppraisalReconciliationDamage {
  name?: string | null;
  /** @format int32 */
  appraisalXmlId?: number;
  /** @format date */
  appraisalEffectiveDate?: string | null;
  section?: string | null;
  feature?: string | null;
  location?: string | null;
  description?: string | null;
  recommendedAction?: string | null;
  underwriterAction?: string | null;
}

export interface DtoV1AppraisalSaveAppraisalRequest {
  appraiserLicenseNumber?: string | null;
  questions?: DtoV1QuestionsQuestion[] | null;
  questionsToDelete?: string[] | null;
  deleteAppraisalOnSave?: boolean;
}

export interface DtoV1AppraisalSaveSubmissionSummaryReportDataRequest {
  questions?: DtoV1QuestionsQuestion[] | null;
  questionsToDelete?: string[] | null;
}

export interface DtoV1AppraisalSiteInfluence {
  airportZones?: DtoV1AppraisalAirportZone[] | null;
}

export interface DtoV1AppraisalSiteUtilityService {
  electricitySourceType?: string | null;
  waterSourceType?: string | null;
  waterWellType?: string | null;
}

export interface DtoV1AppraisalSsrGseResult {
  investor?: string | null;
  riskScore?: string | null;
  /** @format date-time */
  lastReceivedDateTime?: string | null;
  documentFileStatus?: string | null;
  messages?: DtoV1AppraisalSsrMessage[] | null;
}

export interface DtoV1AppraisalSsrMessage {
  messageId?: string | null;
  message?: string | null;
  severity?: string | null;
}

export interface DtoV1AppraisalStructureComponent {
  foundations?: DtoV1AppraisalFoundation[] | null;
  structureComponentDetail?: DtoV1AppraisalStructureComponentDetail | null;
}

export interface DtoV1AppraisalStructureComponentDetail {
  improvementComponentConditionStatusType?: string | null;
  improvementComponentType?: string | null;
}

export interface DtoV1AppraisalSubmissionSummaryReport {
  fileIdentifier?: string | null;
  hasFindings?: boolean;
  results?: DtoV1AppraisalSsrGseResult[] | null;
  documents?: DtoV1PropertyInformationDocument[] | null;
  questionAnswerData?: DtoV1QuestionsQuestion[] | null;
}

export interface DtoV1AssetsAppraisalWaiverData {
  investCollateralProgIdent?: DtoV1EnumInvestorCollateralProgramIdentifier;
  propertyReviewLevel?: DtoV1EnumPropertyReviewLevel;
  ulddPropertyReviewLevel?: DtoV1EnumUlddPropertyReviewLevel;
  additionalProperties?: Record<string, any> | null;
}

export interface DtoV1AssetsAssetBorrower {
  name?: string | null;
  /** @format int32 */
  customerId?: number;
  isPrimaryBorrower?: boolean;
}

export interface DtoV1AssetsAssetRecordIdentifier {
  /** @format int32 */
  assetDatabaseId?: number;
  /** @format int32 */
  assetRecordId?: number;
}

export interface DtoV1AssetsAssetTransactionDeleteStatus {
  /** @format int64 */
  documentAssetTransactionId?: number;
  isReconciliationDeleted?: boolean;
}

export interface DtoV1AssetsAssetsFeatureFlags {
  eligibilityForBusinessAsset?: boolean;
  eligibilityForAssetReconciliation?: boolean;
  eligibilityForGiftAsset?: boolean;
  eligibilityForEmd?: boolean;
  eligibilityForEmdGiftWorkflow?: boolean;
  eligibilityForNewRetirementWorkFlow?: boolean;
  eligibilityForGiftPurchaseAssets?: boolean;
  eligibilityForGiftRefinanceAssets?: boolean;
  eligibilityForGiftOfEquityAssets?: boolean;
  eligibilityForAssetNetProceedsWorkFlow?: boolean;
  eligibilityForAssetCashDepositWorkFlow?: boolean;
  assetFeatureFlags?: Record<string, boolean> | null;
}

export interface DtoV1AssetsBatchAssetRecordIdentifier {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  assetRecords?: DtoV1AssetsAssetRecordIdentifier[] | null;
}

export interface DtoV1AssetsDeleteAssetRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  assetRecordIdentifier?: DtoV1AssetsAssetRecordIdentifier | null;
}

export interface DtoV1AssetsReconcileAccountTransfersRequest {
  /** @format int32 */
  userId?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  transferAssociations?: DtoV1AssetsTransferAssociation[] | null;
  userResponses?: Record<string, Record<string, Record<string, any>>> | null;
}

export interface DtoV1AssetsReconcileAssetRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  assetsToBackOut?: DtoV1AssetsAssetRecordIdentifier[] | null;
  assetsToRestore?: DtoV1AssetsAssetRecordIdentifier[] | null;
  assetTransactionsToBackOut?: DtoV1AssetsAssetTransactionDeleteStatus[] | null;
  assetTransactionsToRestore?: DtoV1AssetsAssetTransactionDeleteStatus[] | null;
  assetsToAssociate?: DtoV1AssetsReconciliationAssetAssociationModel[] | null;
  assetsToDisassociate?:
    | DtoV1AssetsReconciliationAssetAssociationModel[]
    | null;
  suggestedAssets?: DtoV1AssetsAssetRecordIdentifier[] | null;
  suggestedTransactionIds?: number[] | null;
}

export interface DtoV1AssetsReconciliationAssetAssociationModel {
  assetRecordIdentifier?: DtoV1AssetsAssetRecordIdentifier | null;
  parentAssetRecordIdentifier?: DtoV1AssetsAssetRecordIdentifier | null;
}

export interface DtoV1AssetsSaveDepositSourceInformationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  userId?: number;
  assetRecordIdentifier?: DtoV1AssetsAssetRecordIdentifier | null;
  transactionResponses?: Record<string, Record<string, string>> | null;
}

export interface DtoV1AssetsSourceDropdownOptions {
  /** @format int32 */
  assetLdId?: number | null;
  /** @format int32 */
  assetId?: number | null;
  assetType?: string | null;
  displayName?: string | null;
}

export interface DtoV1AssetsTransferAssociation {
  /** @format int32 */
  transferAssociationID?: number | null;
  /** @format int32 */
  receivingAccountAssetID?: number;
  /** @format int32 */
  sourceAccountAssetID?: number | null;
  /** @format date-time */
  transactionDate?: string | null;
  /** @format decimal */
  transactionBalance?: number;
  /** @format decimal */
  remainingBalance?: number;
  description?: string | null;
  isCurrentlyDeducted?: boolean;
  /** @format int64 */
  documentID?: number | null;
  /** @format int64 */
  transactionID?: number | null;
  extractedTransactionID?: string | null;
  boundingBoxes?: DtoV1BoundingBox[] | null;
  iconType?: DtoV1EnumIconType;
}

export interface DtoV1AssetsTransferReconciliationDisplayData {
  tableData?: DtoV1AssetsTransferTableRow[] | null;
  excludedTableData?: DtoV1AssetsTransferAssociation[] | null;
  assetTransferTransactions?: Record<
    string,
    DtoV1AssetsTransferAssociation[] | null
  >;
  accountDropdownOptions?: DtoV1AssetsSourceDropdownOptions[] | null;
  documentOptions?: DtoV1DocumentSelection[] | null;
  transferStatusResponse?: Record<
    string,
    Record<string, DtoV1AssetsTransferStatusResponse>
  > | null;
}

export interface DtoV1AssetsTransferStatusResponse {
  transactionExtractionStatus?: DtoV1EnumTransactionExtractionStatus;
  userResponses?: Record<string, any> | null;
  hasMissingTransactions?: boolean;
  startDate?: string | null;
  endDate?: string | null;
}

export interface DtoV1AssetsTransferTableRow {
  bankName?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number;
  statementEndDate?: string | null;
  /** @format int32 */
  assetId?: number;
}

export interface DtoV1AssetsUpdateAdditionalReservesRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format decimal */
  additionalReserves?: number;
  productType?: DtoV1EnumLoanProductType;
  reservesComment?: string | null;
}

export interface DtoV1BoltApprovalBoltApprovalData {
  loanConditionData?: DtoV1BoltApprovalLoanConditionData | null;
  loanInfo?: DtoV1BoltApprovalHeaderLoanSummary | null;
  complianceFooter?: string | null;
}

export interface DtoV1BoltApprovalHeaderLoanSummary {
  /** @format int32 */
  loanNumber?: number;
  borrowers?: DtoV1BorrowerData[] | null;
  interviewer?: DtoV1BoltApprovalInterviewer | null;
  propertyAddress?: DtoV1Address | null;
  /** @format decimal */
  totalLoanAmount?: number;
  /** @format decimal */
  salesPrice?: number;
}

export interface DtoV1BoltApprovalIntegraLoanCondition {
  /** @format int32 */
  csid?: number;
  condName?: string | null;
  /** @format date-time */
  dateCompleted?: string | null;
  /** @format date-time */
  dateFirstEntered?: string | null;
  /** @format int32 */
  categoryID?: number;
  /** @format int32 */
  lcOrder?: number;
  approvedFlag?: string | null;
  /** @format int32 */
  condID?: number;
  printCondition?: string | null;
  condEnum?: string | null;
  state?: string | null;
  /** @format int32 */
  sourceID?: number;
  condAlias?: string | null;
}

export interface DtoV1BoltApprovalInterviewer {
  brokerId?: string | null;
  entityName?: string | null;
  fullName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  nmlsNumber?: string | null;
}

export interface DtoV1BoltApprovalLoanConditionData {
  preapprovalLoanConditions?: DtoV1BoltApprovalIntegraLoanCondition[] | null;
}

export interface DtoV1BoltAuditAssetAuditRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  /** @format int32 */
  assetId: number;
  /** @format int32 */
  assetTypeId?: number;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1BoltAuditBoltAuditEntity {
  entityDisplayName?: string | null;
  deletedByDisplayName?: string | null;
  entityFields?:
    | KeyValuePairSystemStringICollectionDtoV1BoltAuditEntityFieldResponse[]
    | null;
}

export interface DtoV1BoltAuditBoltAuditRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  page: DtoV1EnumBoltAuditPage;
  entityReferenceAssociations?:
    | DtoV1BoltAuditEntityReferenceAssociation[]
    | null;
}

export interface DtoV1BoltAuditBoltAuditResponse {
  entitiesAudit?: DtoV1BoltAuditEntityAudit[] | null;
}

export interface DtoV1BoltAuditBoltAuditSummaryScreenResponse {
  activeEntities?: DtoV1BoltAuditBoltAuditEntity[] | null;
  deletedEntities?: DtoV1BoltAuditBoltAuditEntity[] | null;
  reserveEntities?: DtoV1BoltAuditBoltAuditEntity[] | null;
}

export interface DtoV1BoltAuditBorrower1003AuditPageResponse {
  borrowerDeclarationsAuditData?:
    | DtoV1BoltAuditBorrower1003BoltAuditResponse[]
    | null;
  borrowerAuditData?: DtoV1BoltAuditBorrower1003BoltAuditResponse[] | null;
  borrowerResidencyHistoryAuditData?:
    | DtoV1BoltAuditBorrower1003BoltAuditResponse[]
    | null;
}

export interface DtoV1BoltAuditBorrower1003BoltAuditResponse {
  /** @format int32 */
  customerRecordId?: number;
  borrowerName?: string | null;
  entitiesAudit?: DtoV1BoltAuditBorrower1003EntityAudit[] | null;
}

export interface DtoV1BoltAuditBorrower1003EntityAudit {
  entityType?: DtoV1EnumEntityType;
  sectionTitle?: string | null;
  fieldsAudit?:
    | KeyValuePairSystemStringICollectionDtoV1BoltAuditFieldAudit[]
    | null;
  entityReferences?: DtoV1BoltAuditEntityReferenceAssociation | null;
}

export interface DtoV1BoltAuditEntityAudit {
  entityType?: DtoV1EnumEntityType;
  sectionTitle?: string | null;
  fieldsAudit?:
    | KeyValuePairSystemStringICollectionDtoV1BoltAuditFieldAudit[]
    | null;
}

export interface DtoV1BoltAuditEntityFieldResponse {
  fieldValue?: string[] | null;
  userName?: string | null;
  /** @format date-time */
  modifiedDateTime?: string;
}

export interface DtoV1BoltAuditEntityReferenceAssociation {
  entity?: DtoV1EnumEntityType;
  references?: Record<string, string | null>;
}

export interface DtoV1BoltAuditFieldAudit {
  fieldValue?: string | null;
  /** @format date-time */
  modifiedDateTime?: string;
  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userName?: string | null;
  /** @format int32 */
  fiscalYear?: number;
  source?: string | null;
}

export interface DtoV1BoltAuditFieldAuditHeader {
  type?: string | null;
  fields?: KeyValuePairSystemStringICollectionDtoV1BoltAuditFieldAudit[] | null;
  children?: DtoV1BoltAuditFieldAuditHeader[] | null;
  loanAction?: string | null;
}

export interface DtoV1BoltAuditIAuditComponent {
  componentType?: DtoV1BoltAuditAuditComponentType;
}

export interface DtoV1BoltAuditIncomeCalculateAuditRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number | null;
}

export interface DtoV1BoltAuditIncomeReconFieldAuditHeader {
  type?: string | null;
  fields?:
    | KeyValuePairSystemStringICollectionDtoV1BoltAuditIncomeReconciliationFieldAudit[]
    | null;
  children?: DtoV1BoltAuditIncomeReconFieldAuditHeader[] | null;
}

export interface DtoV1BoltAuditIncomeReconSectionedBoltAuditResponse {
  entity?: DtoV1BoltAuditIncomeReconSectionedEntityAudit[] | null;
}

export interface DtoV1BoltAuditIncomeReconSectionedEntityAudit {
  entityType?: DtoV1EnumEntityType;
  title?: string | null;
  auditSections?: DtoV1BoltAuditIncomeReconFieldAuditHeader[] | null;
}

export interface DtoV1BoltAuditIncomeReconciliationFieldAudit {
  fieldValue?: string | null;
  /** @format date-time */
  modifiedDateTime?: string;
  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userName?: string | null;
  /** @format int32 */
  fiscalYear?: number;
  source?: string | null;
  amount?: string | null;
  excluded?: string | null;
}

export interface DtoV1BoltAuditSectionedAuditPage {
  pageTitle?: string | null;
  pageDescription?: string | null;
  category?: string | null;
  sections?: DtoV1BoltAuditIAuditComponent[] | null;
  entity?: DtoV1BoltAuditSectionedEntityAudit[] | null;
}

export interface DtoV1BoltAuditSectionedBoltAuditResponse {
  entity?: DtoV1BoltAuditSectionedEntityAudit[] | null;
}

export interface DtoV1BoltAuditSectionedEntityAudit {
  entityType?: DtoV1EnumEntityType;
  title?: string | null;
  auditSections?: DtoV1BoltAuditFieldAuditHeader[] | null;
}

export interface DtoV1BoltAuditValidateDocumentAuditRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1BoltHistoryBoltAuditHistory {
  /** @format int32 */
  questionID?: number;
  /** @format int32 */
  questionAnswerID?: number | null;
  questionDesc?: string | null;
  questionDetailDesc?: string | null;
  answer?: string | null;
  operation?: string | null;
  /** @format int32 */
  modifiedUserID?: number;
  /** @format date-time */
  modifiedDateTime?: string;
  /** @format int32 */
  loanRecordID?: number;
  /** @format int32 */
  ruleID?: number;
  /** @format int32 */
  ruleReferenceTypeID?: number;
  ruleReferenceValue?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  liabilityAdded?: string | null;
  fullName?: string | null;
  userName?: string | null;
}

export interface DtoV1BoltHistoryBoltAuditHistoryRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  auditHistoryTypes?: number[] | null;
  ruleReferenceIdentifiers?:
    | DtoV2ValidationResultRuleReferenceIdentifier[]
    | null;
}

export interface DtoV1BoltHistoryBoltAuditHistoryResponse {
  response?: DtoV1BoltHistoryBoltAuditHistory[] | null;
}

export interface DtoV1BoltResponseDtoV1Borrower1003BorrowerFirstTimeHomeBuyerScreenDataDtoV1Borrower1003BorrowerFirstTimeHomeBuyerInitialFormValues {
  screenData?: DtoV1Borrower1003BorrowerFirstTimeHomeBuyerScreenData | null;
  initialFormValues?: DtoV1Borrower1003BorrowerFirstTimeHomeBuyerInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1Borrower1003BorrowerHousingCounselingScreenDataDtoV1Borrower1003BorrowerHousingCounselingInitialFormValues {
  screenData?: DtoV1Borrower1003BorrowerHousingCounselingScreenData | null;
  initialFormValues?: DtoV1Borrower1003BorrowerHousingCounselingInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1ClassifyDocumentsClassifyDocumentsScreenDataDtoV1ClassifyDocumentsClassifyDocumentsInitialFormValues {
  screenData?: DtoV1ClassifyDocumentsClassifyDocumentsScreenData | null;
  initialFormValues?: DtoV1ClassifyDocumentsClassifyDocumentsInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1CreditValidationGetMortgageHistoryScreenDataIDictionarySystemStringSystemObject {
  screenData?: DtoV1CreditValidationGetMortgageHistoryScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltResponseDtoV1CreditValidationMortgageHistoryScreenDataDtoV1CreditValidationMortgageHistoryInitialFormValues {
  screenData?: DtoV1CreditValidationMortgageHistoryScreenData | null;
  initialFormValues?: DtoV1CreditValidationMortgageHistoryInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1EmploymentIncomeSmartCalculationScreenDataDtoV1EmploymentIncomeSmartCalculationInitialFormValues {
  screenData?: DtoV1EmploymentIncomeSmartCalculationScreenData | null;
  initialFormValues?: DtoV1EmploymentIncomeSmartCalculationInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1EmploymentIncomeValidationScreenDataDtoV1EmploymentIncomeValidationInitialFormValues {
  screenData?: DtoV1EmploymentIncomeValidationScreenData | null;
  initialFormValues?: DtoV1EmploymentIncomeValidationInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1IncomeIncomeSummaryIncomeSummaryDocumentTreeDtoV1IncomeIncomeSummaryIncomeSummaryFhaChildSupportQuestionsAndAnswers {
  screenData?: DtoV1IncomeIncomeSummaryIncomeSummaryDocumentTree | null;
  initialFormValues?: DtoV1IncomeIncomeSummaryIncomeSummaryFhaChildSupportQuestionsAndAnswers | null;
}

export interface DtoV1BoltResponseDtoV1IncomeNoDocumentsProvidedScreenDataIDictionarySystemStringSystemString {
  screenData?: DtoV1IncomeNoDocumentsProvidedScreenData | null;
  initialFormValues?: Record<string, string | null>;
}

export interface DtoV1BoltResponseDtoV1IncomePreviousEmploymentPreviousEmploymentScreenDataDtoV1IncomePreviousEmploymentPreviousEmploymentInitialFormValues {
  screenData?: DtoV1IncomePreviousEmploymentPreviousEmploymentScreenData | null;
  initialFormValues?: DtoV1IncomePreviousEmploymentPreviousEmploymentInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1IncomeCalculatorYmlGetCalculationsScreenDataDtoV1IncomeCalculatorYmlGetCalculationsInitialFormValues {
  screenData?: DtoV1IncomeCalculatorYmlGetCalculationsScreenData | null;
  initialFormValues?: DtoV1IncomeCalculatorYmlGetCalculationsInitialFormValues | null;
}

export interface DtoV1BoltResponseDtoV1KnowYourLoanScreenDataDictionarySystemStringSystemString {
  screenData?: DtoV1KnowYourLoanScreenData | null;
  initialFormValues?: Record<string, string | null>;
}

export interface DtoV1BoltResponseDtoV1PropertyInformationPropertyInformationScreenDataIDictionarySystemStringSystemObject {
  screenData?: DtoV1PropertyInformationPropertyInformationScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltResponseDtoV1PropertyInformationTitleSummaryScreenDataIDictionarySystemStringSystemObject {
  screenData?: DtoV1PropertyInformationTitleSummaryScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltResponseDtoV1PropertyInsuranceGetInsurancePolicyScreenDataIDictionarySystemStringSystemObject {
  screenData?: DtoV1PropertyInsuranceGetInsurancePolicyScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltResponseDtoV1UnderWriterGetUWDateTrackingDataResponseDtoV1UnderWriterGetUWDateTrackingDataResponse {
  screenData?: DtoV1UnderWriterGetUWDateTrackingDataResponse | null;
  initialFormValues?: DtoV1UnderWriterGetUWDateTrackingDataResponse | null;
}

export interface DtoV1BoltResponseModelsAssetsAssetAccountScreenDataModelsAssetsAssetAccountInitialFormValues {
  screenData?: ModelsAssetsAssetAccountScreenData | null;
  initialFormValues?: ModelsAssetsAssetAccountInitialFormValues | null;
}

export interface DtoV1BoltResponseModelsAssetsDepositoryAccountReviewScreenDataDictionarySystemStringSystemObject {
  screenData?: ModelsAssetsDepositoryAccountReviewScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltResponseModelsAssetsDepositoryAccountScreenDataDictionarySystemStringSystemObject {
  screenData?: ModelsAssetsDepositoryAccountScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltResponseModelsAssetsDepositoryStatementScreenDataDictionarySystemStringSystemObject {
  screenData?: ModelsAssetsDepositoryStatementScreenData | null;
  initialFormValues?: Record<string, any> | null;
}

export interface DtoV1BoltStatusBoltStatusRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1BoltStatusBoltStatusResponse {
  completionStatusIND?: boolean | null;
  isLoanZapped?: boolean | null;
  isTestLoan?: boolean | null;
  userCanImpersonate?: boolean;
}

export interface DtoV1Borrower {
  /** @format int32 */
  lenderdatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  socialSecurityNumber?: string | null;
  /** @format int32 */
  borrowerPosition?: number;
  isPrimaryBorrower?: boolean;
  /** @format date-time */
  dateOfBirth?: string | null;
  citizenship?: DtoV1EnumCitizenshipType | null;
  borrowerAddressHistory?: DtoV1Address[] | null;
}

export interface DtoV1Borrower1003BorrowerAlias {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  /** @format int32 */
  age?: number | null;
  /** @format int32 */
  sequenceNumber?: number;
}

export interface DtoV1Borrower1003BorrowerDeclarations {
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /** @format decimal */
  amountOfUndisclosedMoney?: number | null;
  anyConveyanceOnPropertyInLieuOfForeclosure?: boolean | null;
  anyOutstandingJudgements?: boolean | null;
  anyPersonalFinancialLiabilityInLawsuit?: boolean | null;
  anyPropertyForeclosedInLastSevenYears?: boolean | null;
  anyUndisclosedMoneyBeingBorrowed?: boolean | null;
  applyingForNewCreditCard?: boolean | null;
  applyingForAMortgageOnAnotherProperty?: boolean | null;
  declaredBankruptcyInLastSevenYears?: boolean | null;
  isCosignerOnOtherDebt?: boolean | null;
  isDelinquentOrDefaultOnFederalDebt?: boolean | null;
  isFamilyRelationOrBusinessAffiliation?: boolean | null;
  isPrimaryResidence?: boolean | null;
  isPropertySubjectToAlien?: boolean | null;
  ownershipInterestInLastThreeYears?: boolean | null;
  ownershipPropertyType?: DtoV1EnumBorrowerDeclarationsOwnershipPropertyType | null;
  titleType?: DtoV1EnumBorrowerDeclarationsTitleType | null;
  hudApprovedCounselingFlag?: boolean | null;
  duExplanationForeclosure?: DtoV1EnumBorrowerDeclarationsDuExpForeclosureType | null;
  duExplanationDelinquency?: DtoV1EnumBorrowerDeclarationsDuExpDelinquencyType | null;
  duExplanationBankruptcy?: DtoV1EnumBorrowerDeclarationsDuExpBankruptcyType | null;
  bankruptcyChapter7?: boolean | null;
  bankruptcyChapter11?: boolean | null;
  bankruptcyChapter12?: boolean | null;
  bankruptcyChapter13?: boolean | null;
  anyPropertyPreForeclosureInLastSevenYears?: boolean | null;
  firstTimeHomeBuyer?: boolean | null;
}

export interface DtoV1Borrower1003BorrowerDropdownOptions {
  borrowerPosition: DtoV1Option[] | null;
  maritalStatus: DtoV1Option[] | null;
  legalSpouse: DtoV1Option[] | null;
  ownershipStatus: DtoV1Option[] | null;
  citizenship: DtoV1Option[] | null;
  ownershipPropertyType: DtoV1Option[] | null;
  titleType: DtoV1Option[] | null;
  duExplanationForeclosure: DtoV1Option[] | null;
  duExplanationDelinquency: DtoV1Option[] | null;
  duExplanationBankruptcy: DtoV1Option[] | null;
  mannerPowerOfAttorneyHeld: DtoV1Option[] | null;
}

export interface DtoV1Borrower1003BorrowerFirstTimeHomeBuyerAnswers {
  customerIdentifier: DtoIdentitiesBorrowerIdentifier | null;
  isPrimaryBorrower: boolean;
  hasAtLeastOneBorrowerCompletedHomeownerEducation: string | null;
  typeOfHomeOwnershipTraining?: string | null;
  hudApprovedIndicatior?: string | null;
  homeownerEducationAgencyId?: string | null;
  homeownerEducationAgencyName?: string | null;
  /** @format int32 */
  homeownerEducationFlag?: number | null;
  homeownerEducationFormat?: string | null;
  homeownerEducationCompletionDate?: string | null;
  /** @format int32 */
  houseCounselEducationFlag?: number | null;
  houseCounselEducationFormat?: string | null;
  houseCounselEducationAgencyId?: string | null;
  houseCounselEducationAgencyName?: string | null;
  houseCounselEducationCompletionDate?: string | null;
}

export interface DtoV1Borrower1003BorrowerFirstTimeHomeBuyerInitialFormValues {
  customerIdentifier: DtoIdentitiesBorrowerIdentifier | null;
  isPrimaryBorrower: boolean;
  hasAtLeastOneBorrowerCompletedHomeownerEducation: string | null;
  typeOfHomeOwnershipTraining?: string | null;
  hudApprovedIndicatior?: string | null;
  homeownerEducationAgencyId?: string | null;
  homeownerEducationAgencyName?: string | null;
  /** @format int32 */
  homeownerEducationFlag?: number | null;
  homeownerEducationFormat?: string | null;
  homeownerEducationCompletionDate?: string | null;
  /** @format int32 */
  houseCounselEducationFlag?: number | null;
  houseCounselEducationFormat?: string | null;
  houseCounselEducationAgencyId?: string | null;
  houseCounselEducationAgencyName?: string | null;
  houseCounselEducationCompletionDate?: string | null;
  homeownershipTrainingCompleted?: boolean;
}

export interface DtoV1Borrower1003BorrowerFirstTimeHomeBuyerScreenData {
  borrowerFirstTimeHomeBuyerAnswers?:
    | DtoV1Borrower1003BorrowerFirstTimeHomeBuyerAnswers[]
    | null;
}

export interface DtoV1Borrower1003BorrowerHousingCounselingInitialFormValues {
  borrowerIdentifier?: DtoIdentitiesBorrowerIdentifier | null;
  isPrimaryBorrower: boolean;
  hasAtLeastOneBorrowerCompletedHomeownerEducation: string | null;
  /** @format int32 */
  houseCounselEducationFlag?: number | null;
  houseCounselEducationFormat?: string | null;
  houseCounselEducationAgencyId?: string | null;
  houseCounselEducationCompletionDate?: string | null;
  homeownershipTrainingCompleted?: boolean | null;
}

export interface DtoV1Borrower1003BorrowerHousingCounselingScreenData {
  borrowerFirstTimeHomeBuyerAnswers?:
    | DtoV1Borrower1003HousingCounselingData[]
    | null;
}

export interface DtoV1Borrower1003BorrowerMailingAddress {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  wholeAddressString?: string | null;
  mailingAddressIdentifier?: DtoIdentitiesMailingAddressIdentifier | null;
  sameAsPrimary?: boolean;
  country?: string | null;
}

export interface DtoV1Borrower1003BorrowerSummaryAddress {
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  borrowerAddress?: DtoV1BorrowerAddress | null;
  country?: string | null;
  /** @format int32 */
  yearsAtResidence?: number;
  /** @format int32 */
  monthsAtResidence?: number;
  /** @format decimal */
  rentAmount?: number;
  ownershipStatus?: DtoV1EnumOwnershipStatus | null;
  formattedAddressString?: string | null;
}

export interface DtoV1Borrower1003BorrowerSummaryData {
  /** @format int32 */
  lenderdatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  socialSecurityNumber?: string | null;
  /** @format int32 */
  borrowerPosition?: number;
  isPrimaryBorrower?: boolean;
  /** @format date-time */
  dateOfBirth?: string | null;
  citizenship?: DtoV1EnumCitizenshipType | null;
  /** @format int32 */
  age?: number;
  /** @format int32 */
  yearsInSchool?: number;
  maritalStatus?: DtoV1EnumMaritalStatusType;
  /** @format int32 */
  numberOfDependents?: number;
  agesOfDependents?: string | null;
  /** @format int32 */
  numberOfFamilyMembers?: number | null;
  cellPhone?: string | null;
  homePhone?: string | null;
  businessPhone?: string | null;
  businessExtension?: string | null;
  emailAddress?: string | null;
  caivrsNumber?: string | null;
  joinedBorrower?: DtoV1LoanInfoBorrowerInfo | null;
  joinedBorrowerDropdownOptions?: DtoV1Option[] | null;
  borrowerAddressHistory?: DtoV1Borrower1003BorrowerSummaryAddress[] | null;
  borrowerAliases?: DtoV1Borrower1003BorrowerAlias[] | null;
  residenceHistoryDetails?: DtoV1Borrower1003ResidenceHistoryDetails | null;
  borrowerDeclarations?: DtoV1Borrower1003BorrowerDeclarations | null;
  powerOfAttorney?: boolean;
  signer?: string | null;
  legalSpouseRightsFlag?: boolean;
  legalSpouseRightsType?: DtoV1EnumLegalSpouseRightsType | null;
  legalSpouseRightsOthDesc?: string | null;
  legalSpouseRightsState?: string | null;
  mannerPowerOfAttorneyHeld?: DtoV1EnumMannerPowerOfAttorneyHeldType | null;
  isVeteran?: boolean | null;
  primaryResidenceAddress?: string | null;
  primaryAddressSelectionOptions?:
    | DtoV1Borrower1003BorrowerSummaryAddress[]
    | null;
}

export interface DtoV1Borrower1003DeleteBorrowerRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  borrowerToDelete?: DtoIdentitiesBorrowerIdentifier | null;
}

export interface DtoV1Borrower1003GetBorrowerSummaryDataResponse {
  borrowers?: DtoV1Borrower1003BorrowerSummaryData[] | null;
  dropdownOptions?: DtoV1Borrower1003BorrowerDropdownOptions | null;
  borrowerPositionOptions?: number[] | null;
  hasWritePermission?: boolean;
  isFHA?: boolean;
  isVA?: boolean;
  underwritingMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  isAuditHistoryEnabled?: boolean;
  isPrimaryAddressSelectionEnabled?: boolean;
}

export interface DtoV1Borrower1003GetCitizenshipRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1Borrower1003GetCitizenshipResponse {
  results?: DtoV1RuleResult[] | null;
}

export interface DtoV1Borrower1003GetFirstTimeHomeBuyerRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1Borrower1003GetFirstTimeHomeBuyerResponse {
  results?: DtoV1RuleResult[] | null;
  borrowers?: DtoV1Borrower[] | null;
}

export interface DtoV1Borrower1003GetNonOccupyingCoBorrowersRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1Borrower1003GetNonOccupyingCoBorrowersResponse {
  guid?: string | null;
  nonOccupyingCoBorrowerNames?: string[] | null;
  /** @format decimal */
  ltv?: number | null;
  isCoBorrowerFHADefinedFamilyMember?: string | null;
  isSellerFHADefinedFamilyMember?: string | null;
  isIndicationSellerIsFamilyMember?: string | null;
  twoToFourUnitSubjectPropertyRedAlert?: boolean;
  nonOccupyingCoBorrowerIncomeGreaterThanZeroRedAlert?: boolean;
  showNonOccupyingCoBorrowerQuestions?: boolean;
  newNonOccupyingCoBorrowerWorkflow?: boolean;
  nonOccupyingSellerNames?: string[] | null;
  showNonOccupyingSellerNames?: boolean;
}

export interface DtoV1Borrower1003GetSubjectPropertyOccupancyRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1Borrower1003HousingCounselingData {
  borrowerIdentifier?: DtoIdentitiesBorrowerIdentifier | null;
  isPrimaryBorrower: boolean;
  hasAtLeastOneBorrowerCompletedHomeownerEducation: string | null;
  /** @format int32 */
  houseCounselEducationFlag?: number | null;
  houseCounselEducationFormat?: string | null;
  houseCounselEducationAgencyId?: string | null;
  houseCounselEducationCompletionDate?: string | null;
}

export interface DtoV1Borrower1003ResidenceHistoryDetails {
  borrowerResidenceHistory?: DtoV1Borrower1003BorrowerSummaryAddress[] | null;
  borrowerAssociatedAddresses?:
    | DtoV1Borrower1003BorrowerSummaryAddress[]
    | null;
  currentResidences?: DtoV1Borrower1003BorrowerSummaryAddress[] | null;
  previousResidences?: DtoV1Borrower1003BorrowerSummaryAddress[] | null;
  mailingAddress?: DtoV1Borrower1003BorrowerMailingAddress | null;
}

export interface DtoV1Borrower1003SaveBorrowerFirstTimeHomeBuyerHousingCounselingRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  screenData?: DtoV1Borrower1003BorrowerHousingCounselingScreenData | null;
}

export interface DtoV1Borrower1003SaveBorrowerFirstTimeHomeBuyerRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  screenData?: DtoV1Borrower1003BorrowerFirstTimeHomeBuyerScreenData | null;
}

export interface DtoV1Borrower1003SaveCitizenshipRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  saveQuestionAnswersRequest?: DtoV1SaveQuestionAnswersRequest | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
}

export interface DtoV1Borrower1003SaveFirstTimeHomeBuyerRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  saveQuestionAnswersRequest?: DtoV1SaveQuestionAnswersRequest | null;
}

export interface DtoV1Borrower1003SaveNonOccupyingCoBorrowersRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  guid?: string | null;
  isCoBorrowerFHADefinedFamilyMember?: string | null;
  isSellerFHADefinedFamilyMember?: string | null;
  isIndicationSellerIsFamilyMember?: string | null;
}

export interface DtoV1Borrower1003SaveSubjectPropertyOccupancyRequest {
  guid?: string | null;
  fhaCashOut12MonthOccupancy?: string | null;
  fhaCashOutInheritanceOccupancy?: string | null;
  fhaCashOutRentalInheritanceOccupancy?: string | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1Borrower1003SubjectPropertyOccupancyDto {
  guid?: string | null;
  fhaCashOut12MonthOccupancy?: string | null;
  fhaCashOutInheritanceOccupancy?: string | null;
  fhaCashOutRentalInheritanceOccupancy?: string | null;
}

export interface DtoV1Borrower1003UpdateBorrowerDeclarationsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  borrowerDeclarations?: DtoV1Borrower1003BorrowerDeclarations | null;
}

export interface DtoV1Borrower1003UpdateBorrowerResidenceInformationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  borrowerIdentifier?: DtoIdentitiesBorrowerIdentifier | null;
  residenceHistoryDetails?: DtoV1Borrower1003ResidenceHistoryDetails | null;
  shouldTriggerUwaiEntityMatching?: boolean;
}

export interface DtoV1Borrower1003UpdateBorrowerSummaryRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  borrower?: DtoV1Borrower1003BorrowerSummaryData | null;
  shouldTriggerUwaiEntityMatching?: boolean;
}

export interface DtoV1BorrowerAddress {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  wholeAddressString?: string | null;
  primaryResidence?: boolean;
  addressType?: string | null;
}

export interface DtoV1BorrowerData {
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  address?: string | null;
  isPrimaryBorrower?: boolean;
  /** @format int32 */
  age?: number | null;
  socialSecurityNumber?: string | null;
  maritalStatus?: string | null;
  isVeteran?: boolean;
}

export interface DtoV1BorrowerName {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  /** @format int32 */
  age?: number | null;
}

export interface DtoV1BoundingBox {
  /** @format int32 */
  pageNumber?: number;
  /** @format double */
  x1?: number;
  /** @format double */
  y1?: number;
  /** @format double */
  x2?: number;
  /** @format double */
  y2?: number;
  /** @format double */
  x3?: number;
  /** @format double */
  y3?: number;
  /** @format double */
  x4?: number;
  /** @format double */
  y4?: number;
}

export interface DtoV1CaptureEventFieldDifference {
  field?: string | null;
  originalValue?: string | null;
  currentValue?: string | null;
}

export interface DtoV1CheckpointRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  eventTypeId?: number;
}

export interface DtoV1ClassifyDocumentsBorrowerLenderDatabaseIdentifier {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
}

export interface DtoV1ClassifyDocumentsCategoryValues {
  tableData?: Record<string, DtoV1ClassifyDocumentsTableRow> | null;
}

export interface DtoV1ClassifyDocumentsClassifyDocumentsInitialFormValues {
  quickMatch?: Record<string, DtoV1ClassifyDocumentsCategoryValues> | null;
}

export interface DtoV1ClassifyDocumentsClassifyDocumentsScreenData {
  header?: string | null;
  title?: string | null;
  quickMatchCategory?: DtoV1ClassifyDocumentsDocumentCategoryDetails[] | null;
}

export interface DtoV1ClassifyDocumentsDocumentCategoryDetails {
  categoryUwActionTypeId?: string | null;
  categoryName?: string | null;
  categoryStatus?: string | null;
  categoryDescription?: string | null;
  tableData?: DtoV1ClassifyDocumentsTableDetails[] | null;
}

export interface DtoV1ClassifyDocumentsDocumentTypeUpdateInput {
  /**
   * @format int64
   * @min 1
   */
  documentId?: number;
  /**
   * @format int32
   * @min -1
   * @max 2147483647
   */
  documentTypeId?: number;
}

export interface DtoV1ClassifyDocumentsDocumentTypesAndCategories {
  /** @format int32 */
  documentCategoryId?: number;
  documentCategory?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  documentClassification?: string | null;
  isDefaultNA?: boolean;
  dropDownOptions?: DtoV2ClassifyDocumentsDropDownOption[] | null;
}

export interface DtoV1ClassifyDocumentsExtractedItem {
  /** @format int32 */
  itemId?: number;
  itemValue?: string | null;
}

export interface DtoV1ClassifyDocumentsGetDocumentAssociationsRequest {
  /** @format int64 */
  documentId?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1ClassifyDocumentsGetDocumentAssociationsResponse {
  /** @format int64 */
  documentId?: number;
  borrowers?: DtoV1ClassifyDocumentsBorrowerLenderDatabaseIdentifier[] | null;
  assets?: DtoV1DocumentAssociationGetAssetDocumentAssociation[] | null;
  incomes?: DtoV1DocumentAssociationGetIncomeDocumentAssociation[] | null;
  liabilities?:
    | DtoV1DocumentAssociationGetLiabilityDocumentAssociation[]
    | null;
  properties?: DtoV1DocumentAssociationGetPropertyDocumentAssociation[] | null;
}

export interface DtoV1ClassifyDocumentsGetDocumentTypesAndCategoriesResponse {
  documentTypesAndCategories?:
    | DtoV1ClassifyDocumentsDocumentTypesAndCategories[]
    | null;
}

export interface DtoV1ClassifyDocumentsHideDocumentRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int64 */
  documentId?: number;
  /** @format int64 */
  documentTypeId?: number;
}

export interface DtoV1ClassifyDocumentsQuickMatchDocDetails {
  documentTypeId?: string | null;
  documentName?: string | null;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1ClassifyDocumentsSelectOptions {
  placeholder?: string | null;
  options?: DtoV1Option[] | null;
}

export interface DtoV1ClassifyDocumentsTableDetails {
  rowId?: string | null;
  documentType?: DtoV1ClassifyDocumentsQuickMatchDocDetails | null;
  extractedDocData?: DtoV1ClassifyDocumentsExtractedItem[] | null;
  selectOptions?: DtoV1ClassifyDocumentsSelectOptions | null;
}

export interface DtoV1ClassifyDocumentsTableRow {
  associationOptions?: string[] | null;
}

export interface DtoV1ClassifyDocumentsUpdateDocumentClassificationRequest {
  /**
   * @format int64
   * @min 0
   * @max 2147483647
   */
  receivedMailItemId?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  documentTypeUpdateInput?: DtoV1ClassifyDocumentsDocumentTypeUpdateInput | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoV1ClassifyDocumentsUpdateDocumentClassificationResponse {
  success?: boolean;
  message?: string | null;
  updatedClassificationDocumentData?: DtoV1ClassifyDocumentsUpdatedClassificationDocumentData | null;
}

export interface DtoV1ClassifyDocumentsUpdatedClassificationDocumentData {
  documentTypeId?: string | null;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1ClassifyDocumentsUploadBoltApprovalLetterRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  base64?: string | null;
}

export interface DtoV1CommentSaveQueueCommentRequest {
  /** @minItems 1 */
  obfuscatedLoanIdentifiers: DtoIdentitiesObfuscatedLoanIdentifier[] | null;
  /** @maxLength 255 */
  queueComment: string | null;
}

export interface DtoV1Condition {
  conditionText?: string | null;
  state?: string | null;
  csid?: string | null;
  condEnum?: string | null;
  conditionType?: string | null;
  references?: DtoV1AdditionalDataItem[] | null;
}

export interface DtoV1ContactContact {
  firstName?: string | null;
  lastName?: string | null;
  /** @format int32 */
  entityLenderDatabaseID?: number;
  /** @format int32 */
  entityID?: number;
  /** @format int32 */
  contactLenderDatabaseID?: number;
  /** @format int32 */
  contactID?: number;
  /** @format int32 */
  userID?: number;
}

export interface DtoV1ContactContactOptions {
  contactCategoryID?: DtoV1EnumContactCategoryType;
  options?: DtoV1ContactContact[] | null;
  currentContact?: DtoV1ContactContact | null;
}

export interface DtoV1ContactGetLoanContactsAndQueueCommentResponse {
  contactOptions?: DtoV1ContactContactOptions[] | null;
  queueComment?: string | null;
}

export interface DtoV1ContactSaveContact {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  entityId?: number | null;
  /** @format int32 */
  contactId?: number | null;
  type: DtoV1EnumContactCategoryType;
}

export interface DtoV1ContactSaveInternalLoanContactsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  contacts?: DtoV1ContactSaveContact[] | null;
  /** @format int32 */
  userID?: number;
}

export interface DtoV1ContactSaveLoanContactsAndQueueCommentRequest {
  contacts?: DtoV1ContactSaveContact[] | null;
  /** @format int32 */
  userID?: number;
  queueCommentData?: DtoV1CommentSaveQueueCommentRequest | null;
}

export interface DtoV1CounterOfferCounterOfferModalResponse {
  counterOfferModalValues?: DtoV1CounterOfferCounterOfferModalValues[] | null;
  isValidCounterOffer?: boolean | null;
}

export interface DtoV1CounterOfferCounterOfferModalValues {
  fieldName?: string | null;
  currentValue?: string | null;
  originalValue?: string | null;
  previousValue?: string | null;
}

export interface DtoV1CounterOfferSaveCounterOfferRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  isCounterOffer?: boolean | null;
}

export interface DtoV1CreditCreditReportDocumentResponse {
  requestIdentifier?: DtoIdentitiesRequestIdentifier | null;
  underwritingMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  creditReportLinks?: DtoV1CreditCreditReportLink[] | null;
  documentType?: string | null;
}

export interface DtoV1CreditCreditReportLink {
  customerIdentifiers?: DtoIdentitiesCustomerIdentifier[] | null;
  borrowerFirstName?: string | null;
  borrowerMiddleInitial?: string | null;
  borrowerLastName?: string | null;
  creditReportUri?: string | null;
  displayName?: string | null;
}

export interface DtoV1CreditValidationBankruptcyItem {
  statusDate?: string | null;
  bankruptcyType?: string | null;
  status?: string | null;
  bankruptcyOutsideWaitingPeriodQuestion?: DtoV1ValidationResultQuestion | null;
  hasDocumentationBeenProvidedQuestion?: DtoV1ValidationResultQuestion | null;
}

export interface DtoV1CreditValidationBankruptcyScreenData {
  bankruptcies?: DtoV1CreditValidationBankruptcyItem[] | null;
}

export interface DtoV1CreditValidationBorrower {
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  borrowerPosition?: number;
  firstName?: string | null;
  lastName?: string | null;
  socialSecurityNumber?: string | null;
  creditBureauDetails?:
    | DtoV1CreditValidationCreditBureauBorrowerDetails[]
    | null;
}

export interface DtoV1CreditValidationCollectionsScreenData {
  tradelines?: DtoV1CreditValidationTradeline[] | null;
  derogatoryKeywordData?: DtoV1CreditValidationDerogatoryKeywordEntry[] | null;
  tradelineActions?: Record<
    string,
    DtoV1ValidationResultQuestionUserResponse
  > | null;
  collectionQuestion?: DtoV1ValidationResultQuestion | null;
}

export interface DtoV1CreditValidationCreditBureauBorrowerDetails {
  socialSecurityNumber?: string | null;
  /** @format int32 */
  score?: number | null;
  alerts?: DtoV1CreditValidationCreditReportAlert[] | null;
  creditBureau?: DtoV1EnumCreditBureau;
}

export interface DtoV1CreditValidationCreditReportAlert {
  /** @format int32 */
  alertId?: number;
  /** @format int32 */
  creditReportAlertId?: number | null;
  /** @format int32 */
  sequenceNumber?: number;
  description?: string | null;
}

export interface DtoV1CreditValidationCreditReportDocument {
  documentBase64?: string | null;
  underwritingMethod?: string | null;
}

export interface DtoV1CreditValidationDerogatoryAccount {
  creditorName?: string | null;
  accountNumber?: string | null;
  derogatoryTermDetails?: DtoV1CreditValidationUnifiedDerogatoryTerm[] | null;
  /** @format decimal */
  unpaidBalance?: number;
  latePaymentsSymbol?: string | null;
  accountType?: string | null;
  excludeAccountFromSumReason?: DtoV1EnumExcludeAccountFromSumReason | null;
  policeReportProvided?: boolean | null;
}

export interface DtoV1CreditValidationDerogatoryDisputesScreenData {
  disputedAccounts?: DtoV1CreditValidationDerogatoryAccount[] | null;
}

export interface DtoV1CreditValidationDerogatoryEventsDataResponse {
  derogatoryTermsScreenData?: DtoV1CreditValidationDerogatoryTermsScreenData | null;
  derogatoryDisputesScreenData?: DtoV1CreditValidationDerogatoryDisputesScreenData | null;
  collectionsScreenData?: DtoV1CreditValidationCollectionsScreenData | null;
  bankruptcyScreenData?: DtoV1CreditValidationBankruptcyScreenData | null;
  judgmentScreenData?: DtoV1CreditValidationJudgmentScreenData | null;
  foreclosureScreenData?: DtoV1CreditValidationForeclosureItem[] | null;
  taxLienScreenData?: DtoV1CreditValidationTaxLienItem[] | null;
}

export interface DtoV1CreditValidationDerogatoryKeywordEntry {
  /** @format int32 */
  loanDerogatoryKeywordID?: number;
  creditorName?: string | null;
  keyword?: string | null;
  accountNumber?: string | null;
  validMatchInd?: boolean | null;
  comment?: string | null;
}

export interface DtoV1CreditValidationDerogatoryTermsScreenData {
  derogatoryKeywordsQuestion?: DtoV1ValidationResultQuestion | null;
  potentialDerogatoryAccounts?:
    | DtoV1CreditValidationPotentialDerogatoryAccount[]
    | null;
}

export interface DtoV1CreditValidationForeclosureItem {
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format float */
  balance?: number;
  dateOpened?: string | null;
  status?: string | null;
  outsideThreeYearQuestion?: DtoV1ValidationResultQuestion | null;
  documentsQuestion?: DtoV1ValidationResultQuestion | null;
}

export interface DtoV1CreditValidationGetCreditValidationDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1CreditValidationGetCreditValidationDataResponse {
  borrowers?: DtoV1CreditValidationBorrower[] | null;
  inquiries?: DtoV1CreditValidationInquiry[] | null;
  liabilities?: DtoV1CreditValidationLiability[] | null;
  tradelines?: DtoV1CreditValidationTradeline[] | null;
  publicRecords?: DtoV1CreditValidationPublicRecord[] | null;
  derogatoryKeywordData?: DtoV1CreditValidationDerogatoryKeywordEntry[] | null;
  /** @format int64 */
  creditInquiryLetterId?: number;
}

export interface DtoV1CreditValidationGetMortgageHistoryScreenData {
  realEstateLiabilities?: DtoV1CreditValidationRealEstateLiability[] | null;
  resultQuestionAnswerMetadata?: Record<string, number> | null;
  multipleFhaMortgageExceptionEnabled?: boolean;
  mortgagePaymentHistoryQuestionEnabled?: boolean;
  mortgageHistoryREOQuestionEnabled?: boolean;
}

export interface DtoV1CreditValidationInquiry {
  /** @format int32 */
  inquiryId?: number;
  inquirerName?: string | null;
  inquiryDate?: string | null;
}

export interface DtoV1CreditValidationInternalTradeline {
  /** @format int64 */
  internalTradelineId?: number;
  ausMethodSID?: string | null;
  referenceNumber?: string | null;
  /** @format int32 */
  tradelineId?: number;
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format double */
  payment?: number | null;
  /** @format double */
  balance?: number | null;
  /** @format date-time */
  dateLastActivity?: string | null;
  /** @format date-time */
  dateAccountOpened?: string | null;
  /** @format int32 */
  numberOfLates?: number;
}

export interface DtoV1CreditValidationJudgmentItem {
  statusDate?: string | null;
  status?: string | null;
  hasDocumentationBeenProvidedQuestion?: DtoV1ValidationResultQuestion | null;
}

export interface DtoV1CreditValidationJudgmentScreenData {
  judgments?: DtoV1CreditValidationJudgmentItem[] | null;
}

export interface DtoV1CreditValidationLiability {
  /** @format int32 */
  debtId?: number | null;
  /** @format int32 */
  debtLenderdatabaseId?: number | null;
  liabilityType?: string | null;
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format int32 */
  originalTermRemaining?: number;
  lienPosition?: string | null;
  /** @format decimal */
  payment?: number;
  /** @format decimal */
  balance?: number;
  excludePayment?: boolean;
  payoffRequired?: boolean;
  exclusionReason?: string | null;
  associatedRealEstate?: DtoV1RealEstateOwnedRealEstateOwned | null;
  /** @format int64 */
  matchedTradelineId?: number | null;
  matchType?: DtoV1EnumMatchType | null;
  showMortgageSeasoningQuestion?: boolean | null;
}

export interface DtoV1CreditValidationMortgageHistoryInitialFormValues {
  loanLevelQuestionAnswers?: Record<string, string | null>;
  liabilityQuestionAnswers?: Record<string, Record<string, string>> | null;
}

export interface DtoV1CreditValidationMortgageHistoryLiability {
  /** @format int32 */
  debtId?: number;
  /** @format decimal */
  payment?: number;
  /** @format decimal */
  balance?: number;
  isReportingMortgage?: boolean;
  isReoReportedOnCredit?: boolean;
  isSubjectProperty?: boolean | null;
  liabilityType?: string | null;
  lienPosition?: string | null;
  creditorName?: string | null;
  /** @format int32 */
  creditReportLatePayments?: number | null;
  /** @format date-time */
  dateAccountOpened?: string | null;
  propertyAddress?: DtoV1Address | null;
  ruleResult?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1CreditValidationMortgageHistoryScreenData {
  loanPurposeType?: UWMCLibraryCommonDomainEnumsLoanPurposeType | null;
  refiPurpose?: string | null;
  loanProductType?: UWMCLibraryCommonDomainEnumsLoanProductType | null;
  caseNumberDate?: string | null;
  submitToUwDate?: string | null;
  fileImportDate?: string | null;
  disbursementDate?: string | null;
  estimatedClosingDate?: string | null;
  actualClosingDate?: string | null;
  firstPaymentDate?: string | null;
  ruleResult?: DtoV1ValidationResultRuleResult[] | null;
  liabilityData?: DtoV1CreditValidationMortgageHistoryLiability[] | null;
  isFHAPartialClaimEnabled?: boolean;
}

export interface DtoV1CreditValidationPotentialDerogatoryAccount {
  creditorName?: string | null;
  accountNumber?: string | null;
  derogatoryTerms?: string[] | null;
  accountType?: string | null;
  latePaymentsSymbol?: string | null;
  accountStatus?: string | null;
  /** @format decimal */
  balance?: number;
}

export interface DtoV1CreditValidationPublicRecord {
  /** @format int32 */
  publicRecordId?: number;
  obligationCode?: string | null;
  dispositionCode?: string | null;
  /** @format float */
  legalAmount?: number;
  bankruptcyType?: string | null;
  repositories?: string | null;
  dateFiled?: string | null;
  datePaidOff?: string | null;
}

export interface DtoV1CreditValidationRealEstateLiability {
  /** @format int32 */
  debtId?: number | null;
  /** @format int32 */
  debtLenderdatabaseId?: number | null;
  liabilityType?: string | null;
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format int32 */
  originalTermRemaining?: number;
  lienPosition?: string | null;
  /** @format decimal */
  payment?: number;
  /** @format decimal */
  balance?: number;
  excludePayment?: boolean;
  payoffRequired?: boolean;
  exclusionReason?: string | null;
  associatedRealEstate?: DtoV1RealEstateOwnedRealEstateOwned | null;
  /** @format int64 */
  matchedTradelineId?: number | null;
  matchType?: DtoV1EnumMatchType | null;
  showMortgageSeasoningQuestion?: boolean | null;
  /** @format int32 */
  numberOfLatePayments?: number | null;
  dateLastActive?: string | null;
  isReporting?: boolean;
  minimumSeasoningDate?: string | null;
  isConventionallySeasoned?: boolean;
  dateAccountOpened?: string | null;
  estimatedClosingDate?: string | null;
  isMortgageHistorySectionOneVisible?: boolean;
  isMortgageHistorySectionTwoVisible?: boolean;
  isMortgageHistoryV2Active?: boolean;
}

export interface DtoV1CreditValidationSaveMortgageHistoryDataRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  mortgageHistoryQuestions: Record<string, any>;
  resultQuestionAnswerMetadata: Record<string, number>;
}

export interface DtoV1CreditValidationSaveMortgageHistoryRequest {
  loanQuestionAnswers: Record<string, string | null>;
  liabilityQuestionAnswers: Record<string, Record<string, string>>;
}

export interface DtoV1CreditValidationTaxLienItem {
  date?: string | null;
  /** @format float */
  amount?: number;
  status?: string | null;
  documentationQuestion?: DtoV1ValidationResultQuestion | null;
  lienPayoffQuestion?: DtoV1ValidationResultQuestion | null;
}

export interface DtoV1CreditValidationTradeline {
  /** @format int32 */
  tradelineId?: number;
  creditorName?: string | null;
  dateLastActive?: string | null;
  dateAccountOpened?: string | null;
  accountNumber?: string | null;
  derogatoryKeyword?: string | null;
  accountStatus?: string | null;
  address?: string | null;
  /** @format double */
  monthlyPayment?: number | null;
  /** @format double */
  currentBalance?: number | null;
  accountType?: string | null;
  /** @format int32 */
  numberOfLates?: number;
}

export interface DtoV1CreditValidationUnifiedDerogatoryTerm {
  /** @format int64 */
  derogatoryTermId?: number;
  derogatoryTermText?: string | null;
  source?: UWMCLibraryCommonDomainEnumsDerogatoryTermSource;
  derogatoryTermType?: string | null;
}

export interface DtoV1CreditValidationUpdateCreditValidationDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  saveQuestionAnswerRequest?: DtoV1ValidationResultSaveQuestionAnswersRequest | null;
}

export interface DtoV1CreditValidationUpdateCreditValidationDataResponse {
  success?: boolean;
  liabilitiesUpdated?: boolean;
}

export interface DtoV1DocumentAssociationAssetDocumentAssociation {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
  /** @format int64 */
  assetId?: number;
  /** @format int64 */
  assetLdId?: number;
}

export interface DtoV1DocumentAssociationAssociatedDocument {
  /** @format int64 */
  documentId?: number;
  /** @format int32 */
  documentTypeId?: number;
}

export interface DtoV1DocumentAssociationAssociationDetails {
  /** @format int64 */
  documentID?: number | null;
  /** @format int32 */
  documentTypeID?: number | null;
  /** @format int32 */
  assetLdID?: number | null;
  /** @format int32 */
  assetID?: number | null;
  /** @format int32 */
  debtLdID?: number | null;
  /** @format int32 */
  debtID?: number | null;
  /** @format int32 */
  incomeID?: number | null;
  /** @format int32 */
  addressLdID?: number | null;
  /** @format int32 */
  addressID?: number | null;
  /** @format int32 */
  borrowerLenderDatabaseID?: number | null;
  /** @format int32 */
  borrowerRecordID?: number | null;
  employerName?: string | null;
}

export interface DtoV1DocumentAssociationAssociationOptionsData {
  associationOptions?: string[] | null;
  extractedDocData?: Record<string, Record<string, string>> | null;
}

export interface DtoV1DocumentAssociationBorrowerAssociation {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
}

export interface DtoV1DocumentAssociationDocument {
  /** @format int32 */
  loanDocumentId?: number;
  /** @format int32 */
  documentTypeId?: number;
  /** @format int64 */
  folderId?: number;
  /** @format int64 */
  documentId?: number;
  /** @format date-time */
  extractionDateTime?: string;
  /** @format int32 */
  extractionStatusId?: number;
  useFiscalYear?: boolean;
  fiscalYear?: string | null;
}

export interface DtoV1DocumentAssociationDocumentDetails {
  /** @format int32 */
  documentFieldId?: number;
  documentFieldName?: string | null;
  fieldValue?: string | null;
  /** @format int64 */
  extractedDataResultId?: number;
  /** @format int32 */
  pageNumber?: number | null;
  boundingBox?: string | null;
  confidence?: string | null;
}

export interface DtoV1DocumentAssociationDocumentDetailsResponse {
  document?: DtoV1DocumentAssociationDocument | null;
  details?: DtoV1DocumentAssociationDocumentDetails[] | null;
}

export interface DtoV1DocumentAssociationGetAssetDocumentAssociation {
  /** @format int64 */
  assetId?: number;
  /** @format int64 */
  assetLdId?: number;
}

export interface DtoV1DocumentAssociationGetIncomeDocumentAssociation {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
  /** @format int64 */
  incomeId?: number;
  incomeBorrowerId?: string | null;
}

export interface DtoV1DocumentAssociationGetLiabilityDocumentAssociation {
  /** @format int64 */
  debtLdId?: number;
  /** @format int64 */
  debtId?: number;
}

export interface DtoV1DocumentAssociationGetPropertyDocumentAssociation {
  /** @format int64 */
  addressLdId?: number;
  /** @format int64 */
  addressId?: number;
}

export interface DtoV1DocumentAssociationIncomeDocumentAssociation {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
  /** @format int64 */
  incomeId?: number;
}

export interface DtoV1DocumentAssociationLiabilityDocumentAssociation {
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
  /** @format int64 */
  debtLdId?: number;
  /** @format int64 */
  debtId?: number;
}

export interface DtoV1DocumentAssociationPropertyAssociation {
  /** @format int64 */
  addressLdId?: number;
  /** @format int64 */
  addressId?: number;
  isAddressSubjectProperty?: boolean;
}

export interface DtoV1DocumentAssociationSaveBatchDocumentAssociations {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  quickMatch: Record<
    string,
    DtoV1DocumentAssociationSaveBatchDocumentsCategory
  >;
}

export interface DtoV1DocumentAssociationSaveBatchDocumentsCategory {
  tableData: Record<string, DtoV1DocumentAssociationAssociationOptionsData>;
}

export interface DtoV1DocumentAssociationSaveDocumentAssociationRequest {
  /** @format int64 */
  documentId?: number;
  /** @format int32 */
  documentTypeId?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  borrowerAssociations?: DtoV1DocumentAssociationBorrowerAssociation[] | null;
  assetDocumentAssociations?:
    | DtoV1DocumentAssociationAssetDocumentAssociation[]
    | null;
  liabilityDocumentAssociations?:
    | DtoV1DocumentAssociationLiabilityDocumentAssociation[]
    | null;
  incomeDocumentAssociations?:
    | DtoV1DocumentAssociationIncomeDocumentAssociation[]
    | null;
  propertyAssociations?: DtoV1DocumentAssociationPropertyAssociation[] | null;
}

export interface DtoV1DocumentAssociationSuccessResponse {
  message?: string | null;
}

export interface DtoV1DocumentSelection {
  /** @format int64 */
  id?: number;
  label?: string | null;
}

export interface DtoV1DocumentSnippet {
  /** @format byte */
  image?: string | null;
  message?: string | null;
  errors?: string[] | null;
  /** @format int32 */
  statusCode?: number | null;
  errorId?: string | null;
}

export interface DtoV1DocumentViewerResponse {
  url?: string | null;
}

export interface DtoV1EarlyCheckAppraisalManagementCompany {
  /** @format int32 */
  entityId?: number;
  entityName?: string | null;
}

export interface DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier {
  borrowerEmploymentIdentifier?: DtoV1EmploymentIncomeBorrowerEmploymentIdentifier | null;
  incomeValidationDocumentType?: DtoV1EnumIncomeValidationDocumentType;
  /** @format int64 */
  documentId?: number;
  /** @format int64 */
  documentTypeId?: number;
}

export interface DtoV1EmploymentIncomeBorrowerEmploymentIdentifier {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  employerId?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  incomeDocumentId?: number;
}

export interface DtoV1EmploymentIncomeDocumentDetails {
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  docType?: number | null;
  total?: DtoV1EmploymentIncomeDocumentField | null;
  base?: DtoV1EmploymentIncomeDocumentField | null;
  overtime?: DtoV1EmploymentIncomeDocumentField | null;
  bonus?: DtoV1EmploymentIncomeDocumentField | null;
  commission?: DtoV1EmploymentIncomeDocumentField | null;
  tip?: DtoV1EmploymentIncomeDocumentField | null;
  other?: DtoV1EmploymentIncomeDocumentField | null;
  /** @format int32 */
  fiscalYear?: number | null;
}

export interface DtoV1EmploymentIncomeDocumentField {
  documentValue?: string | null;
  /** @format int32 */
  fieldId?: number;
  /** @format int64 */
  snippetId?: number;
  documentFieldName?: string | null;
}

export interface DtoV1EmploymentIncomeEmploymentExtractedAwardLetter {
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  name?: DtoV1ExtractedDocumentField | null;
  address?: DtoV1ExtractedDocumentField | null;
  date?: DtoV1ExtractedDocumentField | null;
  grossAmount?: DtoV1ExtractedDocumentField | null;
  netAmount?: DtoV1ExtractedDocumentField | null;
  employer?: DtoV1ExtractedDocumentField | null;
}

export interface DtoV1EmploymentIncomeEmploymentExtractedBankStatement {
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  bankName?: DtoV1ExtractedDocumentField | null;
  address?: DtoV1ExtractedDocumentField | null;
  city?: DtoV1ExtractedDocumentField | null;
  state?: DtoV1ExtractedDocumentField | null;
  zipCode?: DtoV1ExtractedDocumentField | null;
  typeOfAccount?: DtoV1ExtractedDocumentField | null;
  endingBalanceOfAccount?: DtoV1ExtractedDocumentField | null;
  accountNumber?: DtoV1ExtractedDocumentField | null;
  accountHolderFirstName?: DtoV1ExtractedDocumentField | null;
  accountHolderMiddleInitial?: DtoV1ExtractedDocumentField | null;
  accountHolderLastname?: DtoV1ExtractedDocumentField | null;
  coaccountHolderFirstName?: DtoV1ExtractedDocumentField | null;
  coaccountHolderMiddleInitial?: DtoV1ExtractedDocumentField | null;
  coaccountHolderLastName?: DtoV1ExtractedDocumentField | null;
  beginningDateOfStatement?: DtoV1ExtractedDocumentField | null;
  endingDateOfStatement?: DtoV1ExtractedDocumentField | null;
}

export interface DtoV1EmploymentIncomeEmploymentExtractedPaystub {
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  employerName?: string | null;
  /** @format int64 */
  employerNameExtractedDataResultId?: number;
  /** @format int32 */
  employerNameDocumentFieldId?: number;
  borrowerAddress?: string | null;
  /** @format int64 */
  borrowerAddressExtractedDataResultId?: number;
  /** @format int32 */
  borrowerAddressDocumentFieldId?: number;
  borrowerCity?: string | null;
  /** @format int64 */
  borrowerCityExtractedDataResultId?: number;
  /** @format int32 */
  borrowerCityDocumentFieldId?: number;
  borrowerState?: string | null;
  /** @format int64 */
  borrowerStateExtractedDataResultId?: number;
  /** @format int32 */
  borrowerStateDocumentFieldId?: number;
  borrowerZipCode?: string | null;
  /** @format int64 */
  borrowerZipCodeExtractedDataResultId?: number;
  /** @format int32 */
  borrowerZipCodeDocumentFieldId?: number;
  paymentDate?: string | null;
  /** @format int64 */
  paymentDateExtractedDataResultId?: number;
  /** @format int32 */
  paymentDateDocumentFieldId?: number;
}

export interface DtoV1EmploymentIncomeEmploymentExtractedScheduleC {
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  taxYearExtracted?: DtoV1TaxYearExtracted | null;
  socialSecurityNumberExtracted?: DtoV1SocialSecurityNumberExtracted | null;
}

export interface DtoV1EmploymentIncomeEmploymentExtractedW2 {
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  employerName?: string | null;
  /** @format int64 */
  employerNameExtractedDataResultId?: number;
  /** @format int32 */
  employerNameDocumentFieldId?: number;
  socialSecurityNumber?: string | null;
  /** @format int64 */
  socialSecurityNumberExtractedDataResultId?: number;
  /** @format int32 */
  socialSecurityNumberDocumentFieldId?: number;
  taxYear?: string | null;
  /** @format int64 */
  taxYearExtractedDataResultId?: number;
  /** @format int32 */
  taxYearDocumentFieldId?: number;
  borrowerAddress?: string | null;
  /** @format int64 */
  borrowerAddressExtractedDataResultId?: number;
  /** @format int32 */
  borrowerAddressDocumentFieldId?: number;
  borrowerCity?: string | null;
  /** @format int64 */
  borrowerCityExtractedDataResultId?: number;
  /** @format int32 */
  borrowerCityDocumentFieldId?: number;
  borrowerState?: string | null;
  /** @format int64 */
  borrowerStateExtractedDataResultId?: number;
  /** @format int32 */
  borrowerStateDocumentFieldId?: number;
  borrowerZipCode?: string | null;
  /** @format int64 */
  borrowerZipCodeExtractedDataResultId?: number;
  /** @format int32 */
  borrowerZipCodeDocumentFieldId?: number;
}

export interface DtoV1EmploymentIncomeEmploymentIncome {
  /** @format int32 */
  employerId?: number;
  employerName?: string | null;
  incomeType?: string | null;
  isCurrentEmployment?: boolean;
  /** @format date-time */
  hireDate?: string | null;
}

export interface DtoV1EmploymentIncomeEmploymentIncomeExtractedData {
  documentField?:
    | DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentField[]
    | null;
}

export interface DtoV1EmploymentIncomeEmploymentIncomeValidationDataAwardLetter {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  employmentExtractedAwardLetter?: DtoV1EmploymentIncomeEmploymentExtractedAwardLetter | null;
  /** @format int32 */
  employerId?: number;
  borrowerSSN?: string | null;
  userInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentIncomeValidationDataBankStatement {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  employmentExtractedBankStatement?: DtoV1EmploymentIncomeEmploymentExtractedBankStatement | null;
  /** @format int32 */
  employerId?: number;
  borrowerSSN?: string | null;
  userInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentIncomeValidationDataPaystub {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  employmentIncome?: DtoV1EmploymentIncomeEmploymentIncome[] | null;
  employmentExtractedPaystub?: DtoV1EmploymentIncomeEmploymentExtractedPaystub | null;
  /** @format int32 */
  employerId?: number;
  borrowerAddresses?: DtoV1BorrowerAddress[] | null;
  userInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentIncomeValidationDataScheduleC {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  employmentExtractedScheduleC?: DtoV1EmploymentIncomeEmploymentExtractedScheduleC | null;
  /** @format int32 */
  employerId?: number;
  borrowerSSN?: string | null;
  userInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentIncomeValidationDataW2 {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  employmentIncome?: DtoV1EmploymentIncomeEmploymentIncome[] | null;
  employmentExtractedW2?: DtoV1EmploymentIncomeEmploymentExtractedW2 | null;
  /** @format int32 */
  employerId?: number;
  borrowerAddresses?: DtoV1BorrowerAddress[] | null;
  borrowerSSN?: string | null;
  userInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentReviewCustomerEmployment {
  /** @format int32 */
  customerRecordId?: number;
  borrowerName?: DtoV1BorrowerName | null;
  /** @format int32 */
  employerId?: number;
  employerName?: string | null;
  jobTitle?: string | null;
  incomeSource?: string | null;
  isCurrent?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  verifiedDate?: string | null;
  monthlyIncome?: string | null;
  associationDetails?: DtoV1DocumentAssociationAssociationDetails[] | null;
  documentDetailsResponses?:
    | DtoV1DocumentAssociationDocumentDetailsResponse[]
    | null;
}

export interface DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewAnswer {
  /** @format int32 */
  questionAnswerId?: number;
  /** @format int32 */
  sortOrder?: number;
  fieldType?: string | null;
  answerText?: string | null;
  detailAnswer?: string | null;
  resolutionMessages?: DtoV1IncomeCalculatorAlert[] | null;
  nextQuestions?:
    | DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewQuestion[]
    | null;
}

export interface DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewQuestion {
  /** @format int32 */
  questionId?: number;
  /** @format int32 */
  ruleResultDetailId?: number | null;
  questionText?: string | null;
  questionSubtext?: string | null;
  questionDisplayFormat?: DtoV1EnumValidationResultQuestionDisplayType;
  answers?:
    | DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewAnswer[]
    | null;
  userProvidedAnswer?: DtoV1ValidationResultQuestionUserResponse | null;
  alertMessages?: DtoV1IncomeCalculatorAlert[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewResponse {
  results?: DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewRule[] | null;
  cpaResults?:
    | DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewRule[]
    | null;
  cpaInformationStrings?: string[] | null;
  alertMessages?: DtoV1IncomeCalculatorAlert[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewRule {
  /** @format int32 */
  ruleId?: number;
  /** @format int32 */
  ruleResultId?: number;
  displayTitle?: string | null;
  /** @format int64 */
  cpaDocumentId?: number | null;
  applicableEmployers?:
    | DtoV1EmploymentIncomeEmploymentReviewCustomerEmployment[]
    | null;
  questions?:
    | DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewQuestion[]
    | null;
  borrowerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  alertMessages?: DtoV1IncomeCalculatorAlert[] | null;
}

export interface DtoV1EmploymentIncomeEmploymentReviewDetail {
  /** @format int32 */
  customerLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  borrowerName?: DtoV1BorrowerData | null;
  /** @format int32 */
  employerId?: number;
  employerName?: string | null;
  employmentType?: DtoV1EnumEmploymentType;
  isCurrent?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  /** @format decimal */
  monthlyAmount?: number;
  monthlyIncomeDetails?: DtoV1EmploymentIncomeMonthlyIncomeDetails[] | null;
  /** @format decimal */
  percentBusinessOwned?: number;
  /** @format int32 */
  empByPartyToTranFlag?: number;
  /** @format int32 */
  yearsOnJob?: number;
  /** @format int32 */
  monthsOnJob?: number;
  title?: string | null;
  excluded?: boolean;
  /** @format int32 */
  totalConditions?: number;
  exclusionStatusChanged?: boolean;
  conditions?: DtoV1Condition[] | null;
}

export interface DtoV1EmploymentIncomeExtractedFieldUpdateData {
  documentFieldName?: string | null;
  /** @format int64 */
  extractedDataResultId?: number;
  value?: string | null;
}

export interface DtoV1EmploymentIncomeMonthlyIncomeDetails {
  /** @format int32 */
  sequenceNumber?: number;
  name?: string | null;
  type?: string | null;
  /** @format decimal */
  amount?: number;
  taxable?: string | null;
  /** @format decimal */
  hoursPerWeek?: number;
  excluded?: boolean;
  /** @format date-time */
  incomeVerifiedDate?: string | null;
  conditions?: DtoV1Condition[] | null;
}

export interface DtoV1EmploymentIncomePaystubValidationMatchTableRow {
  systemValue?: string | null;
  documentValue?: string | null;
  isVisible?: boolean;
  aiResponse?: DtoV1AIResponse | null;
}

export interface DtoV1EmploymentIncomeSaveEmploymentRequest {
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /** @format int32 */
  employerId?: number;
  employerName?: string | null;
  includeEmployerNameForUpdation?: boolean | null;
  /** @format date-time */
  employmentStartDateToSave?: string | null;
  /** @format date-time */
  verifiedDateToSave?: string | null;
  employerAddress?: DtoV1Address | null;
  borrowerSSN?: string | null;
  includeSSNForUpdate?: boolean | null;
  /** @format int64 */
  documentTypeId?: number | null;
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  incomeDocumentId?: number;
  saveUserInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  country?: string | null;
}

export interface DtoV1EmploymentIncomeSaveEmploymentSmartQuestionAnswersRequest {
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /** @format int32 */
  employerId?: number;
  /** @format int64 */
  documentTypeId?: number | null;
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  incomeDocumentId?: number;
  smartUserResponses?: Record<string, any> | null;
}

export interface DtoV1EmploymentIncomeSaveExtractedDataUpdatesRequest {
  isDataChanged?: boolean;
  /** @format int64 */
  receivedMailItemId?: number;
  extractedDataUpdates?: DtoV1EmploymentIncomeExtractedFieldUpdateData[] | null;
}

export interface DtoV1EmploymentIncomeSmartCalculationInitialFormValues {
  /** @format int64 */
  documentId?: number;
  documentFields?: Record<string, DtoV1EmploymentIncomeDocumentField> | null;
  additionalDocumentDetails?: Record<
    string,
    DtoV1EmploymentIncomeDocumentDetails
  > | null;
  complexFields?: DtoV1IncomeCalculatorGenericCalculatorComplexField[] | null;
}

export interface DtoV1EmploymentIncomeSmartCalculationScreenData {
  /** @format int64 */
  documentId?: number;
  aiResponses?: Record<string, DtoV1AIResponse> | null;
}

export interface DtoV1EmploymentIncomeUpdateEmploymentAndQuestionAnswers {
  saveEmploymentRequest: DtoV1EmploymentIncomeSaveEmploymentRequest;
  saveQuestionAnswersRequest: DtoV1ValidationResultSaveQuestionAnswersRequest;
  saveCpaInformationRequest?: DtoV1IncomeSaveCpaInformationRequest | null;
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  saveExtractedDataUpdatesRequest?: DtoV1EmploymentIncomeSaveExtractedDataUpdatesRequest | null;
  userName?: string | null;
}

export interface DtoV1EmploymentIncomeUpdateEmploymentAndQuestionAnswersResults {
  employmentRequestSuccessful?: boolean;
  questionAnswersRequestSuccessful?: boolean;
  saveIncomeTypeRequestSuccessful?: boolean;
  saveCPARequestSuccessful?: boolean;
  mergeDeductionsSuccessful?: boolean;
}

export interface DtoV1EmploymentIncomeUpdateEmploymentDateAnswersRequest {
  saveDateAnswersRequest: DtoV1ValidationResultSaveDateAnswersRequest;
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
}

export interface DtoV1EmploymentIncomeUpdateEmploymentReviewAnswersRequest {
  saveQuestionAnswersRequest: DtoV1ValidationResultSaveQuestionAnswersRequest;
  saveEmploymentRequests?: DtoV1EmploymentIncomeSaveEmploymentRequest[] | null;
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
}

export interface DtoV1EmploymentIncomeUpdateEmploymentSmartQuestionAnswers {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  saveEmploymentRequest: DtoV1EmploymentIncomeSaveEmploymentSmartQuestionAnswersRequest;
  systemValuesWithExtractedIds?:
    | DtoV1DocumentAssociationDocumentDetails[]
    | null;
  deductionDetails?: DtoV1IncomeDeductionDetail[] | null;
}

export interface DtoV1EmploymentIncomeValidateDocumentDetailsWithFieldResolution {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  ausUnderwritingMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod | null;
  employmentIncome?: DtoV1EmploymentIncomeEmploymentIncome[] | null;
  employmentExtractedData?: DtoV1EmploymentIncomeEmploymentIncomeExtractedData | null;
  /** @format int32 */
  employerId?: number;
  /** @format int32 */
  incomeDocumentId?: number;
  /** @format int64 */
  documentTypeId?: number;
  /** @format int64 */
  documentId?: number;
  borrowerAddresses?: DtoV1BorrowerAddress[] | null;
  borrowerSSN?: string | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
  incomeDocumentFieldQuestions?:
    | DtoV1IncomeIncomeDocumentFieldQuestionIncomeDocumentFieldQuestion[]
    | null;
  autoAnswers?: Record<string, string | null>;
}

export interface DtoV1EmploymentIncomeValidateDocumentResponse {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  ausUnderwritingMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod | null;
  employmentIncome?: DtoV1EmploymentIncomeEmploymentIncome[] | null;
  employmentExtractedData?: DtoV1EmploymentIncomeEmploymentIncomeExtractedData | null;
  /** @format int32 */
  employerId?: number;
  borrowerAddresses?: DtoV1BorrowerAddress[] | null;
  borrowerSSN?: string | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
  /** @deprecated */
  incomeDocumentResolutions?:
    | DtoV1IncomeIncomeDocumentFieldValueResolution[]
    | null;
  incomeDocumentFields?: DtoV2IncomeIncomeDocumentField[] | null;
  userInputDocumentData?: DtoV1IncomeUserInputDocumentData | null;
  cpaInformationStrings?: string[] | null;
}

export interface DtoV1EmploymentIncomeValidationInitialFormValues {
  isBorrowerNameAcceptableMatch?: string | null;
  isEmployerNameAcceptableMatch?: string | null;
  isSsnAcceptableMatch?: string | null;
  isBorrowerAddressAcceptableMatch?: string | null;
  hasAppropriateActionBeenTaken?: string | null;
  /** @format date-time */
  documentHireDate?: string | null;
  /** @format date-time */
  startDate?: string | null;
  isDocumentHireDateSelected?: string | null;
  /** @format date-time */
  dateOfPaystub?: string | null;
  deductionDetails?: DtoV1IncomeDeductionDetail[] | null;
  noUndisclosedLiabilitiesChecked?: boolean;
  systemValuesWithExtractedIds?:
    | DtoV1DocumentAssociationDocumentDetails[]
    | null;
}

export interface DtoV1EmploymentIncomeValidationScreenData {
  matchTable?: Record<
    string,
    DtoV1EmploymentIncomePaystubValidationMatchTableRow
  > | null;
  isUnacceptableMatchQuestionVisible?: boolean;
  /** @format date-time */
  systemHireDate?: string | null;
  dateOfPaystubResponse?: DtoV1AIResponse | null;
  documentHireDateResponse?: DtoV1AIResponse | null;
  hasHireDateBoundingBox?: boolean | null;
}

export interface DtoV1ExtractedDocumentField {
  name?: string | null;
  value?: string | null;
  /** @format int64 */
  extractedDataResultId?: number;
  /** @format int32 */
  documentFieldId?: number;
}

export interface DtoV1FeesGetCalculatedAllocatedSellerConcessionsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format decimal */
  sellerConcessions?: number;
}

export interface DtoV1FeesGetCalculatedMaxAllowableSellerConcessionsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format decimal */
  purchasePrice?: number;
}

export interface DtoV1FhaOverviewFhaDetailsFhaDetails {
  caseNumber?: string | null;
  /** @format date-time */
  caseNumberDate?: string | null;
  hudVaLoanPurpose?: DtoV1FhaOverviewHudVaLoanPurpose;
  hudSectionOfAct?: DtoV1FhaOverviewHudSectionOfAct;
  hasSingleUnitApproval?: boolean;
  hasHUDVAAddendumMortgageeSignature?: boolean | null;
  fhaCaseNumber?: string | null;
  /** @format int32 */
  fhaadpCodeId?: number | null;
  doesFhaConnectionMatchBolt?: string | null;
  loanOfficer?: DtoV1LoanOfficerLoanOfficer | null;
}

export interface DtoV1FhaOverviewFhaDetailsGetFhaDetailsResponse {
  caseNumber?: string | null;
  /** @format date-time */
  caseNumberDate?: string | null;
  hudVaLoanPurpose?: DtoV1FhaOverviewHudVaLoanPurpose;
  hudSectionOfAct?: DtoV1FhaOverviewHudSectionOfAct;
  hasSingleUnitApproval?: boolean;
  hasHUDVAAddendumMortgageeSignature?: boolean | null;
  fhaCaseNumber?: string | null;
  /** @format int32 */
  fhaadpCodeId?: number | null;
  doesFhaConnectionMatchBolt?: string | null;
  loanOfficer?: DtoV1LoanOfficerLoanOfficer | null;
  fhaCaseNumberV2Active?: boolean;
  isOTC?: boolean;
}

export interface DtoV1FhaOverviewFhaDetailsSaveFhaDetailsRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier | null;
  fhaDetails?: DtoV1FhaOverviewFhaDetailsFhaDetails | null;
}

export interface DtoV1FhaOverviewSecondaryFinancingGetFhaSecondaryFinancingResponse {
  secondMortgageSource?: string | null;
  /** @format int32 */
  debtSource?: number;
  /** @format int32 */
  fhaSource?: number;
  sourceEIN?: string | null;
  sourceDescription?: string | null;
  isDocumentationNotProvided?: boolean;
  isFhaSourceTypeCorrect?: string | null;
}

export interface DtoV1FhaOverviewSecondaryFinancingSaveFhaSecondaryFinancingRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  secondMortgageSource?: string | null;
  /** @format int32 */
  debtSource?: number;
  sourceEIN?: string | null;
  sourceDescription?: string | null;
  isDocumentationNotProvided?: boolean;
  isFhaSourceTypeCorrect?: string | null;
}

export interface DtoV1FhaOverviewUfmipSaveUfmipRefund {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier | null;
  refinanceAuthorizationNumber?: string | null;
  /** @format date-time */
  dateRefinanceAuthorizationIssued?: string | null;
  /** @format decimal */
  computedPremium?: number | null;
  /** @format decimal */
  premiumRefundFactor?: number | null;
  originalCaseNumberDocumentationProvided?: string | null;
  refundCreditMatchUnearnedRefiAuthorization?: string | null;
  originalFHACaseNumber?: string | null;
  /** @format int32 */
  numberOfMonthsForRefundFactor?: number | null;
  ufmipDebt?: DtoV1FhaOverviewUfmipUfmipDebt | null;
  isFHAToFHARefinance?: string | null;
}

export interface DtoV1FhaOverviewUfmipUfmipDebt {
  originalHUDSectionOfAct?: DtoV1FhaOverviewHudSectionOfAct;
  /** @format date-time */
  dateOfOriginalFirstPayment?: string | null;
  /** @format date-time */
  dateOfOriginalMortgage?: string | null;
  /** @format date-time */
  dateOfEndorsement?: string | null;
  /** @format decimal */
  originalMortgageAmount?: number | null;
  /** @format int32 */
  originalTermOfMortgage?: number | null;
}

export interface DtoV1FhaOverviewUfmipUfmipRefund {
  refinanceAuthorizationNumber?: string | null;
  /** @format date-time */
  dateRefinanceAuthorizationIssued?: string | null;
  originalFHACaseNumber?: string | null;
  /** @format decimal */
  computedPremium?: number | null;
  /** @format decimal */
  premiumRefundFactor?: number | null;
  fhaRefundFactors?: Record<string, number> | null;
  ufmipDebt?: DtoV1FhaOverviewUfmipUfmipDebt | null;
  /** @format date-time */
  closingDate?: string;
  /** @format date-time */
  firstPaymentDate?: string | null;
  /** @format decimal */
  ufmipRefundCredit?: number | null;
  isFHAToFHARefinance?: string | null;
  /** @format int64 */
  refinanceAuthorizationDocumentId?: number | null;
  originalCaseNumberDocumentationProvided?: string | null;
  refundCreditMatchUnearnedRefiAuthorization?: string | null;
  isOriginalCaseNumberQuestionActive?: boolean;
  isUfmipRefundCreditMatchQuestionActive?: boolean;
  isUfmipDebtMissing?: boolean;
}

export interface DtoV1FinalReviewChangeLoanStatusRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  loanStatus?: string | null;
}

export interface DtoV1FinalReviewChecklistCategories {
  categoryName?: string | null;
  categoryDescription?: string | null;
  checklistItems?: DtoV1FinalReviewChecklistItem[] | null;
}

export interface DtoV1FinalReviewChecklistItem {
  /** @format int32 */
  id?: number;
  description?: string | null;
  text?: string | null;
  isChecked?: boolean;
}

export interface DtoV1FinalReviewChecklistItemUserResponse {
  /** @format int32 */
  id?: number;
  isChecked?: boolean;
}

export interface DtoV1FinalReviewCommunicationPreferencesCommunicationPreferences {
  touchPointName?: string | null;
  /** @format int32 */
  timeFrameId?: number;
  emailPreference?: DtoV1FinalReviewCommunicationPreferencesEmailPreference | null;
  phonePreference?: DtoV1FinalReviewCommunicationPreferencesPhonePreference | null;
  textPreference?: DtoV1FinalReviewCommunicationPreferencesTextPreference | null;
}

export interface DtoV1FinalReviewCommunicationPreferencesEmailPreference {
  isPreferred?: boolean;
  emailTemplates?:
    | DtoV1FinalReviewCommunicationPreferencesEmailTemplate[]
    | null;
}

export interface DtoV1FinalReviewCommunicationPreferencesEmailTemplate {
  templateName?: string | null;
  obfuscatedTemplateId?: string | null;
}

export interface DtoV1FinalReviewCommunicationPreferencesPhonePreference {
  isPreferred?: boolean;
  salesForceDialURLs?: string[] | null;
}

export interface DtoV1FinalReviewCommunicationPreferencesTextPreference {
  isPreferred?: boolean;
  salesForceTextURLs?: string[] | null;
}

export interface DtoV1FinalReviewPrepaidResponse {
  prepaidOverrideFlag?: boolean;
  /** @format decimal */
  originalPrepaid?: number | null;
  /** @format decimal */
  paddedPrepaid?: number | null;
  /** @format decimal */
  cashToFromBorrower?: number | null;
  /** @format decimal */
  totalFundsAvailable?: number | null;
  prepaidAlertType?: DtoV1EnumPrepaidAlertType;
}

export interface DtoV1FinalReviewSaveFinalRunValidationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  loanStatus?: string | null;
  isAUSSuccess?: boolean;
  isFraudGuardSuccess?: boolean;
}

export interface DtoV1FinalReviewSaveManualCheckStatusRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  userResponses?: DtoV1FinalReviewChecklistItemUserResponse[] | null;
}

export interface DtoV1FinalReviewSavePrepaidRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format decimal */
  originalPrepaid?: number | null;
  /** @format decimal */
  paddedPrepaid?: number | null;
  prepaidOverrideFlag?: boolean;
  /** @format decimal */
  cashToFromBorrower?: number | null;
  /** @format decimal */
  totalFundsAvailable?: number | null;
}

export interface DtoV1FraudGuardFraudGuardData {
  /** @format int32 */
  requestId?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  communicationId?: number | null;
  overallStatus?: string | null;
  /** @format int32 */
  overallScore?: number | null;
  /** @format int32 */
  borrowerScore?: number | null;
  /** @format int32 */
  borrowerAdjustedScore?: number | null;
  borrowerStatus?: string | null;
  /** @format int32 */
  propertyScore?: number | null;
  propertyStatus?: string | null;
  fraudGuardUrl?: string | null;
  soapStatus?: string | null;
  soapMessage?: string | null;
  /** @format date-time */
  actionDateTime?: string;
  resultsViewedIND?: boolean;
}

export interface DtoV1FraudGuardGetRedFlagsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1FraudGuardInsertFraudGuardRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoV1FraudGuardSaveThirdPartyChecksStatusRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  completionStatus?: boolean;
}

export interface DtoV1GetCalculationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  requestReferenceType?: DtoV1EnumRequestReferenceType;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int32 */
  calculationId?: number | null;
  /** @format int32 */
  rentalAddressId?: number | null;
  /** @format int32 */
  calculationAuditId?: number;
}

export interface DtoV1GetValidationResultsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  ruleSubCategoryId?: number;
}

export interface DtoV1IncomeAlertMessage {
  title?: string | null;
  status?: DtoV1IncomeAlertStatus;
  description?: string | null;
}

export interface DtoV1IncomeBorrowerEmploymentIdentifier {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  employerId?: number;
}

export interface DtoV1IncomeCalculation {
  /** @format uuid */
  id: string;
  type: DtoV1EnumIncomeCalculatorType;
  displayName: string | null;
  inputs: DtoV1IncomeCalculationFormInput[] | null;
  outputs: DtoV1IncomeCalculationFormInput[] | null;
  /** @format decimal */
  monthlyIncome: number;
  calculatedIncomeAmounts: {
    /** @format decimal */
    Base?: number;
    /** @format decimal */
    Seasonal?: number;
    /** @format decimal */
    Overtime?: number;
    /** @format decimal */
    Commission?: number;
    /** @format decimal */
    Bonus?: number;
    /** @format decimal */
    Tip?: number;
    /** @format decimal */
    Other?: number;
    /** @format decimal */
    Pitia?: number;
  } | null;
  formulas: DtoV1IncomeFormula[] | null;
  alerts: DtoV1IncomeAlertMessage[] | null;
  isSelected?: boolean;
  overriddenIncomeAmounts?: {
    /** @format decimal */
    Base?: number;
    /** @format decimal */
    Seasonal?: number;
    /** @format decimal */
    Overtime?: number;
    /** @format decimal */
    Commission?: number;
    /** @format decimal */
    Bonus?: number;
    /** @format decimal */
    Tip?: number;
    /** @format decimal */
    Other?: number;
    /** @format decimal */
    Pitia?: number;
  } | null;
  comments?: string | null;
}

export interface DtoV1IncomeCalculationField {
  name: string | null;
  metadata: DtoV1IncomeCalculationFieldMetadata | null;
  value?: string | null;
  canHide?: boolean | null;
  citation?: DtoV1Snippet | null;
  iconType?: DtoV1EnumIconType;
}

export interface DtoV1IncomeCalculationFieldMetadata {
  label: string | null;
  placeholder?: string | null;
  type?: DtoV1IncomeCalculationFieldType;
  required?: boolean;
  isReadOnly?: boolean;
  tooltip?: string | null;
  options?: DtoV1IncomeRadioOption[] | null;
  range?: DtoV1IncomeRange | null;
}

export interface DtoV1IncomeCalculationForm {
  name: string | null;
  label: string | null;
  /** @format int32 */
  fiscalYear?: number;
  fields: DtoV1IncomeCalculationField[] | null;
  required?: boolean;
  isTaxDocument?: boolean;
  /** @format int64 */
  documentId?: number | null;
}

export interface DtoV1IncomeCalculationFormInput {
  name?: string | null;
  /** @format int32 */
  fiscalYear?: number;
  fields?: Record<string, string | null>;
  /** @format int64 */
  documentId?: number | null;
}

export interface DtoV1IncomeCpaInformation {
  /** @format int32 */
  customerCpaDetailId?: number | null;
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  employerId?: number;
  cpaFirstName?: string | null;
  cpaMiddleName?: string | null;
  cpaLastName?: string | null;
  cpaCompanyName?: string | null;
}

export interface DtoV1IncomeDeductionDetail {
  /** @format int32 */
  deductionId?: number | null;
  /** @format int32 */
  debtLdId?: number | null;
  /** @format int32 */
  debtId?: number | null;
  /** @format int64 */
  additionalReferenceId?: number | null;
  additionalReferenceType?: DtoV1EnumAdditionalReferenceType | null;
  documentType?: DtoV1EnumDocumentType | null;
  deductionSummary?: string | null;
  /** @format decimal */
  deductionAmount?: number | null;
  actionTaken?: DtoV1EnumDeductionAction | null;
}

export interface DtoV1IncomeDocumentField {
  /** @format int32 */
  id?: number;
  name?: string | null;
  value?: string | null;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1IncomeFormula {
  name?: string | null;
  value?: string | null;
}

export interface DtoV1IncomeFutureIncomeGetFutureWageIncomeDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  requestReferenceType?: DtoV1EnumRequestReferenceType;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int32 */
  calculatorTypeId?: number;
}

export interface DtoV1IncomeFutureIncomeGetFutureWageIncomeDataResponse {
  questionAnswers?: DtoV1IncomeQuestionAnswer[] | null;
  /** @format int32 */
  documentTypeId?: number;
  documentTypeDescription?: string | null;
  /** @format int64 */
  documentId?: number;
  /** @format int32 */
  calculationId?: number | null;
  previousEmployersNames?: string | null;
  /** @format decimal */
  previousYtdMonths?: number | null;
  /** @format decimal */
  pitiaReoTiaLiabilities?: number | null;
  /** @format date-time */
  noteDate?: string | null;
}

export interface DtoV1IncomeFutureIncomeSaveFutureIncomeRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int64 */
  documentId?: number;
  /** @format int32 */
  calculatorTypeId?: number;
  hasStartDateChanged?: boolean | null;
  questionAnswers?: DtoV1IncomeQuestionAnswer[] | null;
  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userName?: string | null;
}

export interface DtoV1IncomeFutureIncomeSaveFutureIncomeResponse {
  /** @format int32 */
  calculationId?: number;
}

export interface DtoV1IncomeGetCalculationsAlert {
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  severity?: number;
  scenario?: DtoV1EnumCalculationScenarioType | null;
  /** @format int32 */
  conditionCategory?: number | null;
}

export interface DtoV1IncomeGetCalculationsCalculationData {
  /** @format int32 */
  loanCalculationId?: number;
  comment?: string | null;
  wageEarnerData?: DtoV1IncomeGetCalculationsWageEarnerDataDetail[] | null;
  voeData?: DtoV1IncomeGetCalculationsVoeDataDetail[] | null;
  genericIncomeData?:
    | DtoV1IncomeGetCalculationsGenericIncomeDataDetail[]
    | null;
}

export interface DtoV1IncomeGetCalculationsCalculationField {
  /** @format int32 */
  fieldId?: number;
  fieldValue?: string | null;
  fieldName?: string | null;
  /** @format int32 */
  formId?: number;
  /** @format int32 */
  documentFieldId?: number;
  documentFieldName?: string | null;
  documentFieldDesc?: string | null;
  /** @format int32 */
  fiscalYear?: number | null;
  /** @format int64 */
  documentTypeID?: number;
  /** @format int64 */
  snippetId?: number;
  /** @format int64 */
  documentID?: number;
}

export interface DtoV1IncomeGetCalculationsCalculationFormula {
  /** @format int32 */
  formulaId?: number;
  formulaName?: string | null;
  formula?: string | null;
  /** @format int32 */
  calculationScenarioID?: number | null;
  /** @format int32 */
  sortOrder?: number;
  formulaHours?: string | null;
}

export interface DtoV1IncomeGetCalculationsCalculationOverrides {
  /** @format decimal */
  overriddenBaseIncome?: number | null;
  /** @format decimal */
  overriddenSeasonalIncome?: number | null;
  /** @format decimal */
  overriddenOvertimeIncome?: number | null;
  /** @format decimal */
  overriddenCommissionIncome?: number | null;
  /** @format decimal */
  overriddenBonusIncome?: number | null;
  /** @format decimal */
  overriddenTipIncome?: number | null;
  /** @format decimal */
  overriddenOtherIncome?: number | null;
  /** @format decimal */
  overriddenNetRentalIncome?: number | null;
  overriddenAmountsByIncomeType?: {
    /** @format decimal */
    BaseEmploymentIncome?: number | null;
    /** @format decimal */
    AccessoryUnitIncome?: number | null;
    /** @format decimal */
    Alimony?: number | null;
    /** @format decimal */
    AssetsAsIncome?: number | null;
    /** @format decimal */
    AutomobileOrExpenseAccountIncome?: number | null;
    /** @format decimal */
    BoarderIncome?: number | null;
    /** @format decimal */
    Bonuses?: number | null;
    /** @format decimal */
    CapitalGains?: number | null;
    /** @format decimal */
    ChildSupport?: number | null;
    /** @format decimal */
    Commissions?: number | null;
    /** @format decimal */
    DividendsOrInterest?: number | null;
    /** @format decimal */
    EmploymentRelatedAsset?: number | null;
    /** @format decimal */
    FarmIncome?: number | null;
    /** @format decimal */
    ForeignIncome?: number | null;
    /** @format decimal */
    FosterCare?: number | null;
    /** @format decimal */
    IraDistributions?: number | null;
    /** @format decimal */
    MilitaryBasePay?: number | null;
    /** @format decimal */
    MilitaryCombatPay?: number | null;
    /** @format decimal */
    MilitaryFlightPay?: number | null;
    /** @format decimal */
    MilitaryHazardPay?: number | null;
    /** @format decimal */
    MilitaryOverseasPay?: number | null;
    /** @format decimal */
    MilitaryVariableHousingAllowance?: number | null;
    /** @format decimal */
    MilitaryClothesAllowance?: number | null;
    /** @format decimal */
    MilitaryPropPay?: number | null;
    /** @format decimal */
    MilitaryQuartersAllowance?: number | null;
    /** @format decimal */
    MilitaryRationsAllowance?: number | null;
    /** @format decimal */
    NetRentalIncome?: number | null;
    /** @format decimal */
    NotesReceivableOrInstallment?: number | null;
    /** @format decimal */
    OtherIncome?: number | null;
    /** @format decimal */
    OtherW2Income?: number | null;
    /** @format decimal */
    Overtime?: number | null;
    /** @format decimal */
    PensionOrRetirementIncome?: number | null;
    /** @format decimal */
    RealEstateOrMortgageDifferential?: number | null;
    /** @format decimal */
    RoyaltyPayments?: number | null;
    /** @format decimal */
    SeasonalIncome?: number | null;
    /** @format decimal */
    SocialSecurityOrDisabilityIncome?: number | null;
    /** @format decimal */
    SubjectPropertyNetCashFlow?: number | null;
    /** @format decimal */
    TemporaryLeave?: number | null;
    /** @format decimal */
    TipIncome?: number | null;
    /** @format decimal */
    TrustIncome?: number | null;
    /** @format decimal */
    UnemploymentOrPublicAssistance?: number | null;
    /** @format decimal */
    UnReimbursedExpenses?: number | null;
    /** @format decimal */
    VaBenefits?: number | null;
  } | null;
}

export interface DtoV1IncomeGetCalculationsConsideredFormula {
  formula?: string | null;
  formulaType?: string | null;
  /** @format decimal */
  incomeValue?: number;
  isFormulaUsed?: boolean;
}

export interface DtoV1IncomeGetCalculationsCurrentYearVariableIncome {
  /** @format int32 */
  fiscalYear?: number;
  currentYearIncome?:
    | DtoV1IncomeGetCalculationsWageEarnerIncomeSummary[]
    | null;
}

export interface DtoV1IncomeGetCalculationsGenericIncomeCalculationResponse {
  /** @format int32 */
  scenarioId?: number | null;
  scenarioName?: string | null;
  isSelected?: boolean;
  isSavedToLoan?: boolean;
  /** @format decimal */
  calculationAmount?: number;
  /** @format decimal */
  overriddenBaseIncome?: number;
  comments?: string | null;
  incomeCalculatorType?: string | null;
  /** @format int32 */
  incomeCalculatorTypeId?: number;
  alerts?: DtoV1IncomeGetCalculationsAlert[] | null;
  formulas?: DtoV1IncomeGetCalculationsCalculationFormula[] | null;
  calculationFields?: DtoV1IncomeGetCalculationsCalculationField[] | null;
}

export interface DtoV1IncomeGetCalculationsGenericIncomeDataDetail {
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number;
  overrideAmounts?: DtoV1IncomeGetCalculationsCalculationOverrides | null;
  inputFields?: DtoV1IncomeGetCalculationsCalculationField[] | null;
  calculationItems?:
    | DtoV1IncomeGetCalculationsGenericIncomeCalculationResponse[]
    | null;
}

export interface DtoV1IncomeGetCalculationsPastYearWageEarnerSummary {
  /** @format int32 */
  fiscalYear?: number;
  /** @format decimal */
  annualIncome?: number;
  /** @format decimal */
  monthlyAmount?: number;
  backingIntoVariableIncomeFormula?: string | null;
  totalBackedInVariableIncomeFormula?: string | null;
}

export interface DtoV1IncomeGetCalculationsSingleVariablePay {
  title?: string | null;
  trendTitle?: string | null;
  /** @format decimal */
  calculatedVariableAmount?: number;
  /** @format int32 */
  calculationField?: number;
  formula?: string | null;
  variablePercentageFormula?: string | null;
  calculatedVariableTitle?: string | null;
  consideredFormulas?: DtoV1IncomeGetCalculationsConsideredFormula[] | null;
  w2Items?: DtoV1IncomeGetCalculationsPastYearWageEarnerSummary[] | null;
  currentYearItems?: DtoV1IncomeGetCalculationsCurrentYearVariableIncome | null;
  pastYearsItems?: DtoV1IncomeGetCalculationsPastYearWageEarnerSummary[] | null;
}

export interface DtoV1IncomeGetCalculationsVoeCalculationResult {
  /** @format decimal */
  calculatedMonthlyIncome?: number;
  /** @format decimal */
  calculatedTrendIncome?: number;
  formulaType?: string | null;
  incomeType?: string | null;
  trend?: string | null;
  calculationEquation?: string | null;
  trendCalculationEquation?: string | null;
  payType?: string | null;
  consideredFormulas?: DtoV1IncomeGetCalculationsConsideredFormula[] | null;
  incomeDetails?: DtoV1IncomeGetCalculationsVoeIncomeDetail[] | null;
  monthsUsedForPriorYearCalculation?: string | null;
  additionalCalculationDetails?: DtoV1IncomeRecentRaiseAdditionalCalculationDetail | null;
}

export interface DtoV1IncomeGetCalculationsVoeDataDetail {
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number;
  overrideAmounts?: DtoV1IncomeGetCalculationsCalculationOverrides | null;
  inputFields?: DtoV1IncomeGetCalculationsCalculationField[] | null;
  calculationItems?: DtoV1IncomeGetCalculationsVoeResponse[] | null;
}

export interface DtoV1IncomeGetCalculationsVoeDetailResponse {
  /** @format int32 */
  fiscalYear?: number;
  /** @format decimal */
  annualIncome?: number;
  calculationResults?: DtoV1IncomeGetCalculationsVoeCalculationResult[] | null;
  /** @format decimal */
  monthsWorkedThisYear?: number;
  /** @format decimal */
  monthsWorkedLastYear?: number;
  /** @format decimal */
  monthsWorkedTwoYearsAgo?: number;
  ytdMonthlyAverageEquation?: string | null;
  payType?: DtoV1EnumPaySchedule;
  bonusType?: DtoV1EnumWageBonusType;
  /** @format decimal */
  currentGrossBasePay?: number;
  /** @format date-time */
  dateOfEmployment?: string;
}

export interface DtoV1IncomeGetCalculationsVoeIncomeDetail {
  incomeYear?: string | null;
  /** @format decimal */
  monthlyIncome?: number;
  /** @format decimal */
  totalIncome?: number;
  /** @format int32 */
  fiscalYear?: number;
}

export interface DtoV1IncomeGetCalculationsVoeResponse {
  /** @format int32 */
  scenarioId?: number | null;
  scenarioName?: string | null;
  isSelected?: boolean;
  isSavedToLoan?: boolean;
  incomeCalculatorType?: string | null;
  /** @format decimal */
  calculationAmount?: number;
  annualDetails?: DtoV1IncomeGetCalculationsVoeDetailResponse[] | null;
  alerts?: DtoV1IncomeGetCalculationsAlert[] | null;
  calculationFields?: DtoV1IncomeGetCalculationsCalculationField[] | null;
  isDisabled?: boolean;
  formulaName?: string | null;
  /** @format date-time */
  throughDate?: string | null;
  isVariableIncomePresent?: boolean;
}

export interface DtoV1IncomeGetCalculationsW2DetailResponse {
  /** @format int32 */
  fiscalYear?: number;
  /** @format decimal */
  annualIncome?: number;
  formula?: string | null;
  formulaName?: string | null;
  /** @format decimal */
  monthlyYearToDate?: number;
  /** @format decimal */
  totalMonthsWorked?: number;
}

export interface DtoV1IncomeGetCalculationsWageEarnerDataDetail {
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number;
  overrideAmounts?: DtoV1IncomeGetCalculationsCalculationOverrides | null;
  inputFields?: DtoV1IncomeGetCalculationsCalculationField[] | null;
  calculationItems?: DtoV1IncomeGetCalculationsWageEarnerResponse[] | null;
}

export interface DtoV1IncomeGetCalculationsWageEarnerIncomeSummary {
  incomeType?: string | null;
  /** @format decimal */
  monthlyAmount?: number;
  /** @format decimal */
  annualIncome?: number;
  /** @format decimal */
  totalYearToDateIncome?: number;
}

export interface DtoV1IncomeGetCalculationsWageEarnerResponse {
  /** @format int32 */
  scenarioId?: number | null;
  scenarioName?: string | null;
  isSelected?: boolean;
  isSavedToLoan?: boolean;
  incomeCalculatorType?: string | null;
  /** @format decimal */
  calculationAmount?: number;
  annualDetails?: DtoV1IncomeGetCalculationsW2DetailResponse[] | null;
  alerts?: DtoV1IncomeGetCalculationsAlert[] | null;
  calculationFields?: DtoV1IncomeGetCalculationsCalculationField[] | null;
  isDisabled?: boolean;
  formula?: string | null;
  formulaName?: string | null;
  isYearToDateInstantiated?: boolean;
  /** @format decimal */
  earningRate?: number;
  payType?: string | null;
  /** @format decimal */
  totalIncome?: number;
  isBaseIncomeVariable?: boolean;
  /** @format date-time */
  throughDate?: string | null;
  variableIncomes?: DtoV1IncomeGetCalculationsSingleVariablePay[] | null;
}

export interface DtoV1IncomeGetPropertyRentalIncomeResponse {
  realEstateOwned?: DtoV1IncomeRentalRealEstateOwned[] | null;
  ausMethod?: string | null;
  /** @format decimal */
  pitiaAmount?: number;
  eligibleForDUFlag?: boolean;
  eligibleForLPAFlag?: boolean;
}

export interface DtoV1IncomeGetRentalRealEstateOwnedRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  isSubjectProperty?: boolean | null;
}

export interface DtoV1IncomeHistoryGetCalculationsHistoryRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
}

export interface DtoV1IncomeHistoryGetHistoryCalculationsResponse {
  calculationSummaries?:
    | DtoV1IncomeHistoryHistoricalCalculationSummary[]
    | null;
}

export interface DtoV1IncomeHistoryHistoricalCalculationSummary {
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  changedByUserName?: string | null;
  /** @format decimal */
  calculatedMonthlyAmount?: number;
  requestReferenceType?: DtoV1EnumRequestReferenceType;
  /** @format int32 */
  calculationId?: number | null;
  /** @format int32 */
  calculatorTypeId?: number | null;
  calculatorTypeName?: string | null;
  calculatorTypeDesc?: string | null;
  /** @format int32 */
  rentalAddressId?: number | null;
  /** @format decimal */
  rentalIncomePitia?: number | null;
  /** @format date-time */
  createdDateTime?: string;
  calculationDate?: string | null;
  calculationTime?: string | null;
  /** @format int32 */
  calculationAuditId?: number;
  /** @format date-time */
  modifiedDateTime?: string;
  isOverride?: boolean;
}

export interface DtoV1IncomeIncomeDocumentFieldQuestionAnswerResolution {
  /** @format int32 */
  resolutionTypeId?: number | null;
  resolutionText?: string | null;
  nextIncomeDocumentFieldId?: string | null;
}

export interface DtoV1IncomeIncomeDocumentFieldQuestionIncomeDocumentFieldQuestion {
  /** @format int32 */
  incomeDocumentFieldId?: number;
  incomeDocumentFieldName?: string | null;
  incomeDocumentFieldDesc?: string | null;
  /** @format int32 */
  incomeDocumentFieldSortOrder?: number;
  visibleOnLoad?: boolean;
  posiibleAnswers?:
    | DtoV1IncomeIncomeDocumentFieldQuestionPossibleAnswer[]
    | null;
  userAnswer?: string | null;
}

export interface DtoV1IncomeIncomeDocumentFieldQuestionPossibleAnswer {
  answer?: string | null;
  /** @format int32 */
  sortOrder?: number | null;
  isActive?: boolean | null;
  resolutions?: DtoV1IncomeIncomeDocumentFieldQuestionAnswerResolution[] | null;
}

export interface DtoV1IncomeIncomeDocumentFieldValueResolution {
  /** @format int32 */
  incomeDocumentFieldId?: number;
  incomeDocumentFieldName?: string | null;
  incomeDocumentFieldDesc?: string | null;
  /** @format int64 */
  documentTypeId?: number;
  /** @format int32 */
  documentTypeIncomeDocumentFieldId?: number | null;
  answer?: string | null;
  /** @format int32 */
  resolutionTypeId?: number | null;
  resolutionText?: string | null;
  nextIncomeDocumentFieldId?: string | null;
  /** @format int32 */
  sortOrder?: number | null;
  isActive?: boolean | null;
}

export interface DtoV1IncomeIncomeReconciliationBorrowerName {
  firstName?: string | null;
  lastName?: string | null;
}

export interface DtoV1IncomeIncomeReconciliationCalculateDebtToIncomeRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  debtToIncomeData?: DtoV1IncomeIncomeReconciliationDebtToIncomeData | null;
}

export interface DtoV1IncomeIncomeReconciliationDebtToIncomeData {
  /** @format decimal */
  totalIncome?: number | null;
  /** @format decimal */
  totalObligations?: number | null;
  /** @format decimal */
  housingIncome?: number | null;
  /** @format decimal */
  housingObligations?: number | null;
  /** @format decimal */
  housingToIncomeRatio?: number | null;
  /** @format decimal */
  debtToIncomeRatio?: number | null;
  income?: DtoV1IncomeIncomeReconciliationIncomeCalculations | null;
  obligations?: DtoV1IncomeIncomeReconciliationObligationsCalculations | null;
}

export interface DtoV1IncomeIncomeReconciliationEmploymentIncomeReconciliationData {
  /** @format decimal */
  totalEmploymentIncome?: number;
  employmentIncomeDetails?:
    | DtoV1EmploymentIncomeEmploymentReviewDetail[]
    | null;
}

export interface DtoV1IncomeIncomeReconciliationIncomeCalculations {
  /** @format decimal */
  employmentIncome?: number;
  /** @format decimal */
  rentalIncome?: number;
  /** @format decimal */
  subjectPropertyIncome?: number;
}

export interface DtoV1IncomeIncomeReconciliationIncomeReconciliationData {
  rentalIncome?: DtoV1IncomeIncomeReconciliationRentalIncomeReconciliationData | null;
  employmentIncome?: DtoV1IncomeIncomeReconciliationEmploymentIncomeReconciliationData | null;
  debtToIncome?: DtoV1IncomeIncomeReconciliationDebtToIncomeData | null;
  hasSavedData?: boolean;
  featureFlags?: Record<string, boolean> | null;
}

export interface DtoV1IncomeIncomeReconciliationObligationsCalculations {
  /** @format decimal */
  occupyingBorrowerHousingObligations?: number;
  /** @format decimal */
  nonOccupyingBorrowerHousingObligations?: number;
  /** @format decimal */
  nonRealEstateOwnedObligations?: number;
  /** @format decimal */
  realEstateOwnedObligations?: number;
  /** @format decimal */
  secondaryResidenceObligations?: number;
}

export interface DtoV1IncomeIncomeReconciliationRentalIncomeDetail {
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  /** @format int32 */
  subjectAsReoAddressId?: number | null;
  excluded?: boolean;
  exclusionStatusChanged?: boolean;
  /** @format decimal */
  netRentalIncome?: number;
  /** @format decimal */
  grossMonthlyIncome?: number;
  /** @format decimal */
  propertyExpenses?: number;
  /** @format int32 */
  documentTypeId?: number | null;
  /** @format decimal */
  percentRentalIncome?: number;
  propertyType?: DtoV1EnumPropertyType;
  occupancyType?: DtoV1EnumOccupancyType;
  dtiFlag?: DtoV1EnumDtiFlag;
  conditions?: DtoV1Condition[] | null;
  propertyAddress?: DtoV1PropertyInformationPropertyAddress | null;
  formattedPropertyAddress?: string | null;
  associatedBorrowers?: DtoV1IncomeIncomeReconciliationBorrowerName[] | null;
}

export interface DtoV1IncomeIncomeReconciliationRentalIncomeReconciliationData {
  excluded?: boolean;
  /** @format decimal */
  totalReoNetRentalIncome?: number;
  /** @format decimal */
  totalSubjectPropertyIncome?: number;
  rentalIncomeDetails?:
    | DtoV1IncomeIncomeReconciliationRentalIncomeDetail[]
    | null;
  /** @format decimal */
  totalRentalConditions?: number;
}

export interface DtoV1IncomeIncomeReconciliationSaveIncomeReconciliationData {
  rentalIncome?: DtoV1IncomeIncomeReconciliationRentalIncomeReconciliationData | null;
  employmentIncome?: DtoV1IncomeIncomeReconciliationEmploymentIncomeReconciliationData | null;
  debtToIncome?: DtoV1IncomeIncomeReconciliationDebtToIncomeData | null;
  hasSavedData?: boolean;
  featureFlags?: Record<string, boolean> | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1IncomeIncomeResolutionBaseResolutionQuestion {
  resolutionQuestionDescription?: string | null;
  answer?: string | null;
  possibleAnswers?: DtoV1IncomeIncomeResolutionPossibleAnswer[] | null;
}

export interface DtoV1IncomeIncomeResolutionGetIncomeResolutionDetailRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int32 */
  calculationId?: number;
}

export interface DtoV1IncomeIncomeResolutionGetIncomeResolutionDetailResponse {
  /** @format int32 */
  calculationId?: number;
  topLevelQuestions?:
    | DtoV1IncomeIncomeResolutionBaseResolutionQuestion[]
    | null;
  resolutionItems?: DtoV1IncomeIncomeResolutionResolutionItem[] | null;
}

export interface DtoV1IncomeIncomeResolutionPossibleAnswer {
  questionAnswer?: string | null;
  showQuestionIDs?: number[] | null;
}

export interface DtoV1IncomeIncomeResolutionResolutionItem {
  /** @format int32 */
  resolutionItemId?: number;
  /** @format int32 */
  incomeType?: number;
  resolutionItemName?: string | null;
  resolutionItemDescription?: string | null;
  resolutionOptions?: DtoV1IncomeIncomeResolutionResolutionOption[] | null;
  isLPFluctuationThirtyPercentChange?: boolean;
}

export interface DtoV1IncomeIncomeResolutionResolutionOption {
  /** @format int32 */
  resolutionOptionId?: number;
  /** @format decimal */
  monthlyAmount?: number;
  resolutionOptionName?: string | null;
  resolutionOptionDescription?: string | null;
  isOptionSelected?: boolean;
  resolutionQuestions?: DtoV1IncomeIncomeResolutionResolutionQuestion[] | null;
}

export interface DtoV1IncomeIncomeResolutionResolutionQuestion {
  resolutionQuestionDescription?: string | null;
  answer?: string | null;
  possibleAnswers?: DtoV1IncomeIncomeResolutionPossibleAnswer[] | null;
  /** @format int32 */
  resolutionQuestionId?: number;
  isQuestionAnswerTrue?: boolean | null;
  isShownByDefault?: boolean;
  /** @format int32 */
  questionDisplayTypeId?: number;
  resolutionReasons?: DtoV1IncomeIncomeResolutionResolutionReason[] | null;
}

export interface DtoV1IncomeIncomeResolutionResolutionReason {
  isCommentRequired?: boolean;
  isReasonSelected?: boolean;
  reasonComment?: string | null;
  /** @format int32 */
  resolutionReasonId?: number;
  resolutionReasonDescription?: string | null;
  resolutionReasonCommentPlaceholder?: string | null;
}

export interface DtoV1IncomeIncomeResolutionSaveIncomeResolutionDetailRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  /** @format int32 */
  calculationId?: number;
  resolutionItems?: DtoV1IncomeIncomeResolutionResolutionItem[] | null;
}

export interface DtoV1IncomeIncomeSummaryAnsweredQuestionResponse {
  /** @format int32 */
  incomeTypeFieldID?: number;
  /** @format int32 */
  loanIncomeTypeDetailID?: number;
  incomeTypeFieldName?: string | null;
  incomeTypeFieldQuestion?: string | null;
  incomeTypeFieldValue?: string | null;
}

export interface DtoV1IncomeIncomeSummaryCustomerEmploymentDetail {
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  borrowerName?: DtoV1BorrowerName | null;
  employerName?: string | null;
  source?: string | null;
  isCurrent?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  /** @format decimal */
  monthlyAmount?: number;
  incomeTypes?: string[] | null;
  isPrimary?: boolean;
  businessAddress?: DtoV1Address | null;
}

export interface DtoV1IncomeIncomeSummaryCustomerEmploymentDetailRequest {
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1IncomeIncomeSummaryDocumentSelection {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  incomeDocumentId: number;
  isSelected: boolean;
}

export interface DtoV1IncomeIncomeSummaryDocumentationTypeSelection {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  incomeDocumentationTypeId: number;
  isSelected?: boolean;
}

export interface DtoV1IncomeIncomeSummaryEmploymentQuestionsAndAnswersResponse {
  /** @format int32 */
  incomeTypeFieldId?: number;
  /** @format int32 */
  incomeTypeID?: number;
  incomeTypeFieldName?: string | null;
  incomeTypeFieldQuestion?: string | null;
  resolutions?: DtoV1IncomeIncomeSummaryQuestionResolution[] | null;
  currentAnswer?: string | null;
  isVisibleIND?: boolean;
}

export interface DtoV1IncomeIncomeSummaryGetIncomeSummaryInformation {
  documentTree?: DtoV1IncomeIncomeSummaryIncomeDocumentNode[] | null;
  message?: DtoV1IncomeIncomeSummaryIncomeSummaryMessage | null;
  showExtensionCheckbox?: boolean | null;
  extensionFiledForMostRecentYear?: boolean | null;
  employmentQuestionsAndAnswers?:
    | DtoV1IncomeIncomeSummaryEmploymentQuestionsAndAnswersResponse[]
    | null;
  incomeValidationKeyDates?: DtoV1IncomeIncomeValidationKeyDates | null;
}

export interface DtoV1IncomeIncomeSummaryIncomeDocumentNode {
  /** @format int32 */
  id?: number | null;
  name?: string | null;
  /** @format int32 */
  sortOrder?: number;
  isSelected?: boolean;
  /** @format int32 */
  documentTypeId?: number | null;
  allowMultiple?: boolean;
  hasChildren?: boolean;
  children?: DtoV1IncomeIncomeSummaryIncomeDocumentNode[] | null;
}

export interface DtoV1IncomeIncomeSummaryIncomeSummaryDocumentTree {
  documentTree?: DtoV1IncomeIncomeSummaryIncomeDocumentNode[] | null;
}

export interface DtoV1IncomeIncomeSummaryIncomeSummaryFhaChildSupportQuestionsAndAnswers {
  hasAFinalDivorceDecree?: string | null;
  whatTypeOfAgreementProvided?: string | null;
  hasMostRecentThreeMonths?: string | null;
  hasMostRecentTwelveMonths?: string | null;
}

export interface DtoV1IncomeIncomeSummaryIncomeSummaryMessage {
  messageType?: DtoV1EnumIncomeSummaryMessageType;
  message?: string | null;
}

export interface DtoV1IncomeIncomeSummaryQuestionResolution {
  /** @format int32 */
  incomeTypeFieldValueResolutionID?: number;
  answer?: string | null;
  /** @format int32 */
  resolutionTypeID?: number | null;
  resolutionText?: string | null;
  /** @format int32 */
  nextIncomeTypeFieldID?: number | null;
  /** @format int32 */
  sortOrder?: number | null;
}

export interface DtoV1IncomeIncomeSummaryQuestionResponse {
  /** @format int32 */
  incomeTypeFieldID?: number;
  /** @format int32 */
  incomeTypeID?: number;
  incomeTypeFieldName?: string | null;
  incomeTypeFieldQuestion?: string | null;
  resolutions?: DtoV1IncomeIncomeSummaryQuestionResolution[] | null;
}

export interface DtoV1IncomeIncomeSummarySaveIncomeSummaryFhaChildSupport {
  borrowerEmploymentIdentifier?: DtoV1IncomeBorrowerEmploymentIdentifier | null;
  childSupportQuestionAnswers?: DtoV1IncomeIncomeSummaryIncomeSummaryFhaChildSupportQuestionsAndAnswers | null;
  documentationType?: DtoV1IncomeIncomeSummaryDocumentationTypeSelection | null;
  incomeDocuments: DtoV1IncomeIncomeSummaryDocumentSelection[];
}

export interface DtoV1IncomeIncomeSummarySaveIncomeSummaryRequest {
  borrowerEmploymentIdentifier?: DtoV1IncomeBorrowerEmploymentIdentifier | null;
  documentationType?: DtoV1IncomeIncomeSummaryDocumentationTypeSelection | null;
  incomeDocuments: DtoV1IncomeIncomeSummaryDocumentSelection[];
  extensionFiledForMostRecentYear?: boolean | null;
}

export interface DtoV1IncomeIncomeValidationKeyDates {
  /** @format date-time */
  disbursementDate?: string | null;
  /** @format date-time */
  docHubSubmissionDate?: string | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  /** @format date-time */
  fileImportedDate?: string | null;
  /** @format date-time */
  loanApplicationDate?: string | null;
  /** @format date-time */
  submittedDate?: string | null;
  /** @format date-time */
  boltEnteredDate?: string | null;
  /** @format date-time */
  zapEnteredDate?: string | null;
  /** @format date-time */
  caseNumberDate?: string | null;
}

export interface DtoV1IncomeNoDocumentsProvidedScreenData {
  employerName?: string | null;
  propertyAddress?: string | null;
  borrowerName?: string | null;
  incomeType?: string | null;
  employmentType?: string | null;
  isW2Provided?: boolean;
  /** @format decimal */
  monthlyAmount?: number;
  /** @format int32 */
  currentEmploymentYear?: number;
  /** @format int32 */
  previousEmploymentYear?: number;
  /** @format int32 */
  secondPreviousEmploymentYear?: number;
  /** @format int32 */
  thirdPreviousEmploymentYear?: number;
  endDate?: string | null;
  isCurrent?: boolean;
  hasEmploymentFiveYearsOlder?: boolean;
  isOnlyScheduleEProvided?: boolean;
}

export interface DtoV1IncomePreviousEmploymentEmployer {
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  employerName?: string | null;
  borrowerName?: string | null;
  yearsOfEmployment?: DtoV1IncomePreviousEmploymentYearsOfEmployment[] | null;
  isEndDateBeforeStartDate?: boolean;
}

export interface DtoV1IncomePreviousEmploymentGetPreviousEmploymentRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  incomeIdentifier: DtoIdentitiesIncomeIdentifier;
}

export interface DtoV1IncomePreviousEmploymentIncomeDetails {
  documentDetails?: Record<string, DtoV1EmploymentIncomeDocumentDetails> | null;
  isEvidenceOfBaseVariableIncome?: boolean | null;
  isBaseVariableIncome?: boolean | null;
  isVoe?: boolean | null;
}

export interface DtoV1IncomePreviousEmploymentPreviousEmploymentInitialFormValues {
  employmentDetails?: Record<
    string,
    DtoV1IncomePreviousEmploymentIncomeDetails
  > | null;
}

export interface DtoV1IncomePreviousEmploymentPreviousEmploymentScreenData {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  employers?: DtoV1IncomePreviousEmploymentEmployer[] | null;
  shouldDisplayVariableIncomeQuestion?: boolean;
  isBaseIncomeVariable?: boolean;
  isVoeRequired?: boolean;
  isVisible?: Record<string, boolean> | null;
  /** @format date-time */
  mostRecentDocumentDate?: string;
  loanProductType?: string | null;
  underwritingMethod?: string | null;
  variableBaseQuestionFeatureFlag?: boolean;
}

export interface DtoV1IncomePreviousEmploymentSavePreviousEmploymentDataRequest {
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  employmentDetails?: Record<
    string,
    DtoV1IncomePreviousEmploymentIncomeDetails
  > | null;
  /** @format date-time */
  mostRecentDocumentDate?: string;
}

export interface DtoV1IncomePreviousEmploymentYearsOfEmployment {
  year?: string | null;
  isCurrentYear?: boolean;
  /** @format int64 */
  wageEarnerDocumentId?: number;
  /** @format int64 */
  incomeBreakoutDocumentId?: number;
  displayDocumentationTipMessage?: boolean;
}

export interface DtoV1IncomeQuestionAnswer {
  questionId?: string | null;
  answer?: string | null;
  canHide?: boolean | null;
}

export interface DtoV1IncomeRadioOption {
  label?: string | null;
  value?: string | null;
}

export interface DtoV1IncomeRange {
  /** @format decimal */
  min?: number | null;
  /** @format decimal */
  max?: number | null;
}

export interface DtoV1IncomeRecentRaiseAdditionalCalculationDetail {
  recentRaiseDetailResponsesByIncomeYear?:
    | DtoV1IncomeRecentRaiseRecentRaiseDetailResponse[]
    | null;
  calculatedMonthlyQualifyingAmount?: string | null;
  formulaType?: string | null;
  formula?: string | null;
  formulaDisplayString?: string | null;
  additionalCalculationFormula?:
    | DtoV1IncomeGetCalculationsCalculationFormula[]
    | null;
  dateOfRaise?: string | null;
  priorRate?: string | null;
  currentRate?: string | null;
  throughDateUsedForCalculation?: string | null;
}

export interface DtoV1IncomeRecentRaiseBasicDocumentDetail {
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  documentTypeID?: number | null;
  documentTypeName?: string | null;
}

export interface DtoV1IncomeRecentRaiseGetRecentRaiseIncomeRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
}

export interface DtoV1IncomeRecentRaiseGetRecentRaiseIncomeResponse {
  questionAnswers?: DtoV1IncomeQuestionAnswer[] | null;
  associatedDocumentDetails?:
    | DtoV1IncomeRecentRaiseBasicDocumentDetail[]
    | null;
  /** @format date-time */
  mostRecentDocumentDate?: string | null;
  alerts?: DtoV1IncomeGetCalculationsAlert[] | null;
}

export interface DtoV1IncomeRecentRaiseRecentRaiseDetailResponse {
  /** @format int32 */
  fiscalYear?: number;
  title?: string | null;
  formulaType?: string | null;
  incomeType?: string | null;
  totalHoursWorked?: string | null;
  hoursAtPriorRate?: string | null;
  hoursAtCurrentRate?: string | null;
  monthsAtPriorRate?: string | null;
  monthsAtCurrentRate?: string | null;
  incomeYear?: string | null;
  monthsUsedForCalculation?: string | null;
  calculationFormula?: DtoV1IncomeGetCalculationsCalculationFormula[] | null;
}

export interface DtoV1IncomeRecentRaiseSaveRecentRaiseIncomeRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  questionAnswers?: DtoV1IncomeQuestionAnswer[] | null;
  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userName?: string | null;
}

export interface DtoV1IncomeRecentRaiseSaveRecentRaiseIncomeResponse {
  isSaved?: boolean;
}

export interface DtoV1IncomeRentalIncomeExtracted1040Data {
  year?: DtoV1IncomeRentalIncomeExtractedYear | null;
  propertyAddresses?: DtoV1IncomeRentalIncomeExtractedPropertyAddress[] | null;
}

export interface DtoV1IncomeRentalIncomeExtractedPropertyAddress {
  /** @format int32 */
  loanDocumentID?: number;
  /** @format int32 */
  documentFieldID?: number;
  documentFieldDesc?: string | null;
  propertyAddress?: string | null;
  isMatchingThePropertyAddress?: boolean;
  /** @format int64 */
  extractedAddressResultId?: number;
  documentComplexFieldGroupingID?: string | null;
}

export interface DtoV1IncomeRentalIncomeExtractedYear {
  /** @format int32 */
  loanDocumentID?: number;
  /** @format int32 */
  documentFieldID?: number;
  /** @format int64 */
  documentId?: number;
  documentFieldDesc?: string | null;
  year?: string | null;
  documentTypeName?: string | null;
  /** @format date-time */
  extractionDate?: string;
  alternateYears?: number[] | null;
  /** @format int64 */
  extractedYearResultId?: number;
}

export interface DtoV1IncomeRentalIncomeGetRentalIncomeRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
}

export interface DtoV1IncomeRentalIncomeIncomeDocument {
  /** @format int32 */
  incomeDocumentId?: number;
  /** @format int64 */
  documentId?: number;
  incomeDocumentName?: string | null;
  incomeDocumentDesc?: string | null;
  isSelected?: boolean;
  groupDesc?: string | null;
  /** @format int32 */
  sortOrder?: number;
}

export interface DtoV1IncomeRentalIncomePropertyData {
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  loanRecordId?: number;
  /** @format int32 */
  propertyLenderDatabaseId?: number;
  /** @format int32 */
  propertyRecordId?: number;
  propertyName?: string | null;
  propertyAddress?: DtoV1Address | null;
  /** @format decimal */
  salesPrice?: number;
  /** @format decimal */
  appraisedValue?: number;
  /** @format int32 */
  yearBuilt?: number;
  propertyType?: DtoV1EnumPropertyType;
  occupancyType?: DtoV1EnumOccupancyType | null;
  /** @format decimal */
  rentalIncome?: number;
  /** @format decimal */
  proposedPitia?: number;
}

export interface DtoV1IncomeRentalIncomeRentalIncomeAnswer {
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /** @format int32 */
  questionAnswerId?: number;
  /** @format int32 */
  questionId?: number;
  answer?: string | null;
  repeatedQuestionIND?: boolean;
  hasRedStopWhileValidating?: boolean;
}

export interface DtoV1IncomeRentalIncomeRentalIncomeData {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  propertyType?: DtoV1IncomeRentalIncomeRentalPropertyTypeEnum;
  ausMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  /** @format decimal */
  pitiaAmount?: number | null;
  duEligible?: boolean;
  lpaEligible?: boolean;
  ausTipMessage?: string | null;
  ausIneligibleMessage?: string | null;
  realEstateOwned?: DtoV1IncomeRentalRealEstateOwned | null;
  propertyData?: DtoV1IncomeRentalIncomePropertyData | null;
  isDocumentOptionRadioButton?: boolean;
  shouldCheckDuLpaEligibility?: boolean;
  documentOptions?:
    | DtoV1IncomeRentalIncomeRentalIncomeDocumentAndQuestions[]
    | null;
  topLevelQuestions?:
    | DtoV1IncomeRentalIncomeRentalIncomeQuestionDetail[]
    | null;
  extractedPropertyAddresses?:
    | DtoV1IncomeRentalIncomeExtractedPropertyAddress[]
    | null;
  extractedYear?: DtoV1IncomeRentalIncomeExtractedYear | null;
  extracted1040Datas?: DtoV1IncomeRentalIncomeExtracted1040Data[] | null;
  loanDates?: DtoLoanInformationDates | null;
  isRentalIneligible?: boolean;
}

export interface DtoV1IncomeRentalIncomeRentalIncomeDocumentAndQuestions {
  incomeDocument?: DtoV1IncomeRentalIncomeIncomeDocument | null;
  applicableQuestions?:
    | DtoV1IncomeRentalIncomeRentalIncomeQuestionDetail[]
    | null;
}

export interface DtoV1IncomeRentalIncomeRentalIncomeQuestionAndAnswer {
  questionDescription?: string | null;
  questionAlias?: string | null;
  questionAnswer?: boolean;
  answerDescription?: string | null;
}

export interface DtoV1IncomeRentalIncomeRentalIncomeQuestionDetail {
  /** @format int32 */
  questionId?: number;
  questionDesc?: string | null;
  visibleOnLoad?: boolean;
  repeatedQuestionIND?: boolean;
  /** @format int32 */
  sortOrder?: number;
  questionDisplayTypeDesc?: string | null;
  fieldType?: string | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  userAnswer?: DtoV1IncomeRentalIncomeRentalIncomeAnswer | null;
  possibleAnswers?: DtoV1IncomeRentalIncomeRentalQuestionAnswer[] | null;
}

export interface DtoV1IncomeRentalIncomeRentalQuestionAnswer {
  answerValue?: string | null;
  resolutionTypeDesc?: string | null;
  resolutionText?: string | null;
  alternateResolutionTypeDesc?: string | null;
  alternateResolutiontext?: string | null;
  nextQuestionId?: string[] | null;
}

export interface DtoV1IncomeRentalIncomeSaveRentalIncomeQuestionAnswersRequest {
  willNotBeProvidingDocumentation?: boolean | null;
  /** @format int32 */
  userId?: number;
  /** @format decimal */
  grossMonthlyRent?: number | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  propertyIdentifier?: DtoV1PropertySubjectPropertyIdentifier | null;
  ausMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  userAnswers?: DtoV1IncomeRentalIncomeRentalIncomeAnswer[] | null;
  propertyData?: DtoV1IncomeRentalIncomePropertyData | null;
}

export interface DtoV1IncomeRentalIncomeSaveRentalIncomeRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  documents?: DtoV1IncomeRentalIncomeIncomeDocument[] | null;
  userAnswers?: DtoV1IncomeRentalIncomeRentalIncomeAnswer[] | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoV1IncomeRentalIncomeSaveRentalIncomeResponse {
  saveResponse?: boolean;
}

export interface DtoV1IncomeRentalRealEstateOwned {
  addressId?: DtoIdentitiesAddressIdentifier | null;
  propertyStatus?: DtoV1EnumPropertyStatus | null;
  propertyAddress?: DtoV1Address | null;
  isSubjectProperty?: boolean | null;
  propertyType?: DtoPropertyType | null;
  associatedLiabilities?: DtoV1CreditValidationLiability[] | null;
  /** @format decimal */
  monthlyHazardInsurance?: number | null;
  /** @format decimal */
  monthlyAssociationDues?: number | null;
  /** @format decimal */
  monthlyTaxes?: number | null;
  /** @format decimal */
  reopitiaAmount?: number | null;
  pymtIncludesTaxInsFlag?: boolean;
  results?: DtoV1RuleResult[] | null;
  /** @format decimal */
  rentalIncome?: number | null;
  /** @format decimal */
  netRentalIncome?: number | null;
  ownershipStatus?: DtoV1EnumOwnershipStatus;
  isValidationCompleted?: boolean;
  isReviewBreakdownCompleted?: boolean;
  occupancyType?: DtoV1EnumOccupancyType | null;
}

export interface DtoV1IncomeSaveAnswerRequest {
  borrowerEmploymentIdentifier?: DtoV1IncomeBorrowerEmploymentIdentifier | null;
  answerText?: DtoV1IncomeSaveLoanIncomeDetail[] | null;
  willNotBeProvidingDocumentation?: boolean | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoV1IncomeSaveCpaInformationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  saveCpaInformation?: DtoV1IncomeCpaInformation[] | null;
}

export interface DtoV1IncomeSaveLoanIncomeDetail {
  /** @format int32 */
  incomeTypeFieldID?: number;
  incomeTypeFieldValue?: string | null;
}

export interface DtoV1IncomeUserInputDocumentData {
  /** @format int32 */
  incomeDocumentId?: number;
  documentFields?: DtoV1IncomeDocumentField[] | null;
}

export interface DtoV1IncomeCalculatorAlert {
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  severity?: number;
}

export interface DtoV1IncomeCalculatorCalculationInput {
  /** @format int32 */
  fiscalYear?: number;
  /** @format int32 */
  formId: number;
  /** @minLength 1 */
  fieldName: string;
  /** @minLength 1 */
  fieldValue: string;
  /** @format int32 */
  snippetId?: number;
}

export interface DtoV1IncomeCalculatorCalculationOutcome {
  /** @format decimal */
  calculationResultAmount?: number | null;
  override?: boolean | null;
  /** @format decimal */
  overrideAmount?: number | null;
  /** @format int32 */
  calculationField: number;
}

export interface DtoV1IncomeCalculatorCalculationOutcomeBase {
  /** @format decimal */
  calculationResultAmount?: number | null;
  override?: boolean | null;
  /** @format decimal */
  overrideAmount?: number | null;
}

export interface DtoV1IncomeCalculatorCalculationOutcomeDetail {
  outcomeDetails: Record<string, DtoV1IncomeCalculatorCalculationOutcomeBase>;
}

export interface DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentDetail {
  /** @format int64 */
  documentTypeId?: number;
  /** @format int64 */
  documentId?: number;
  /** @format int64 */
  receivedMailItemId?: number;
  /** @format int32 */
  fiscalYear?: number;
  calculationInputData?:
    | DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentField[]
    | null;
  additionalProperties?: Record<string, string | null>;
}

export interface DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentField {
  /** @format int32 */
  documentFieldId?: number;
  documentFieldName?: string | null;
  documentFieldValue?: string | null;
  /** @format int64 */
  snippetId?: number;
  boundingBoxCoordinates?: DtoV1BoundingBox[] | null;
  extractedValue?: string | null;
  iconType?: string | null;
  isEditable?: boolean;
  /** @format int32 */
  compositeFieldId?: number | null;
  /** @format int32 */
  groupingId?: number | null;
}

export interface DtoV1IncomeCalculatorGenericCalculatorComplexField {
  complexFieldType?: DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentField | null;
  complexFieldAmountYtd?: DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentField | null;
  /** @format int32 */
  compositeFieldId?: number | null;
  /** @format int32 */
  groupingId?: number | null;
  iconType?: string | null;
  citation?: DtoV1Snippet | null;
  include?: boolean;
  isManuallyAdded?: boolean;
}

export interface DtoV1IncomeCalculatorGenericCalculatorGetDataForSelectedCalculatorRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  requestReferenceType?: DtoV1EnumRequestReferenceType;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  rentalAddressId?: DtoIdentitiesAddressIdentifier | null;
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number | null;
}

export interface DtoV1IncomeCalculatorGenericCalculatorGetDataforSelectedCalculatorResponse {
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number | null;
  documentDetails?:
    | DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentDetail[]
    | null;
  tip?: DtoV1IncomeCalculatorAlert | null;
  toolTip?: DtoV1IncomeCalculatorAlert | null;
}

export interface DtoV1IncomeCalculatorRunLeaseAgreementCalculateRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  rentalAddressId?: DtoIdentitiesAddressIdentifier | null;
  ausUnderwritingMethod?: DtoV1EnumUnderwritingMethod;
}

export interface DtoV1IncomeCalculatorSaveCalculationDataToLoanRequest {
  /** @format int32 */
  loanCalculationId?: number;
  /** @format int32 */
  calculationId?: number;
  /** @format int32 */
  scenarioId?: number | null;
  comments?: string | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  calculationDetails?: Record<
    string,
    DtoV1IncomeCalculatorCalculationOutcomeDetail
  > | null;
  employerName?: string | null;
  calculatorType?: string | null;
  isRecentRaiseSelected?: boolean | null;
}

export interface DtoV1IncomeCalculatorSaveCalculationResponse {
  success?: boolean;
}

export interface DtoV1IncomeCalculatorSaveEmploymentIncomeRequest {
  /** @format int32 */
  loanCalculationId?: number;
  /** @format int32 */
  calculationId?: number;
  /** @format int32 */
  scenarioId?: number | null;
  comments?: string | null;
  obfuscatedLoanIdentifierRequest?: DtoObfuscatedLoanIdentifierRequest | null;
  customerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  /** @format int32 */
  employerId?: number;
  calculationOutcomes?: DtoV1IncomeCalculatorCalculationOutcome[] | null;
  employerName?: string | null;
  calculatorType?: string | null;
  isRecentRaiseSelected?: boolean | null;
}

export interface DtoV1IncomeCalculatorSaveRentalIncomeToLoanRequest {
  obfuscatedLoanIdentifierRequest?: DtoObfuscatedLoanIdentifierRequest | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  /** @format int32 */
  calculationId?: number;
  /** @format int32 */
  loanCalculationId?: number;
  /** @format int32 */
  scenarioId?: number | null;
  comments?: string | null;
  /** @format decimal */
  combinedGrossRentalIncome?: number | null;
  /** @format decimal */
  combinedNetRentalIncome?: number | null;
}

export interface DtoV1IncomeCalculatorSaveRentalIncomeToLoanResponse {
  success?: boolean;
}

export interface DtoV1IncomeCalculatorSaveToLoanRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier: DtoIdentitiesIncomeIdentifier;
  /** @format int32 */
  formId: number;
  /** @format int32 */
  calculationTypeId: number;
  /** @minItems 1 */
  calculationInput?: DtoV1IncomeCalculatorCalculationInput[] | null;
  calculationOutcomes?: DtoV1IncomeCalculatorCalculationOutcome[] | null;
  alerts?: DtoV1IncomeCalculatorAlert[] | null;
  comments?: string | null;
  formulas?: number[] | null;
}

export interface DtoV1IncomeCalculatorYmlAlert {
  title?: string | null;
  description?: string | null;
  severity?: string | null;
}

export interface DtoV1IncomeCalculatorYmlCalculationData {
  title?: string | null;
  method?: string | null;
  /** @format decimal */
  total?: number;
  /** @format int32 */
  calculationId?: number;
  /** @format int32 */
  calculationTypeId?: number;
  /** @format date-time */
  throughDate?: string;
  calculations?: DtoV1IncomeCalculatorYmlFormulaCard[] | null;
  alerts?: DtoV1IncomeCalculatorYmlAlert[] | null;
}

export interface DtoV1IncomeCalculatorYmlCardAlert {
  title?: string | null;
  description?: string | null;
  severity?: string | null;
  showAlert?: boolean;
}

export interface DtoV1IncomeCalculatorYmlCardData {
  title?: string | null;
  description?: string | null;
  styling?: DtoV1IncomeCalculatorYmlReviewBreakdownStyling | null;
  grid?: Record<string, DtoV1IncomeCalculatorYmlReviewBreakdownGridRow> | null;
}

export interface DtoV1IncomeCalculatorYmlFormulaCard {
  title?: string | null;
  incomeType?: string | null;
  trend?: string | null;
  value?: string | null;
  alert?: DtoV1IncomeCalculatorYmlCardAlert | null;
  cardData?: DtoV1IncomeCalculatorYmlCardData[] | null;
  additionalCalculationDetails?: DtoV1IncomeRecentRaiseAdditionalCalculationDetail | null;
}

export interface DtoV1IncomeCalculatorYmlGetCalculationsInitialFormValues {
  calculationDetails?: Record<
    string,
    DtoV1IncomeCalculatorCalculationOutcomeDetail
  > | null;
  /** @format int32 */
  calculationId?: number;
  comments?: string | null;
}

export interface DtoV1IncomeCalculatorYmlGetCalculationsScreenData {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  calculationData?: DtoV1IncomeCalculatorYmlCalculationData[] | null;
}

export interface DtoV1IncomeCalculatorYmlReviewBreakdownGridRow {
  /** @format int32 */
  fiscalYear?: number;
  monthlyIncome?: string | null;
  totalIncome?: string | null;
  w2Average?: string | null;
  backedIntoMonthlyIncome?: string | null;
  styling?: DtoV1IncomeCalculatorYmlReviewBreakdownStyling | null;
}

export interface DtoV1IncomeCalculatorYmlReviewBreakdownStyling {
  boldTitle?: boolean;
  underlineTitle?: boolean;
  isVoeGrid?: boolean;
  isPaystubGrid?: boolean;
  isOneW2Grid?: boolean;
  isTwoW2Grid?: boolean;
  boldColumn?: boolean;
  incomeType?: string | null;
}

export interface DtoV1KnowYourLoanAssets {
  /** @format int32 */
  id?: number;
  /** @format decimal */
  cashToFromBorrower?: number;
  /** @format decimal */
  reserves?: number;
  typesOfAssets?: string | null;
  /** @format decimal */
  verifiedTotalBalance?: number;
}

export interface DtoV1KnowYourLoanBrokerComment {
  /** @format int64 */
  id?: number;
  description?: string | null;
  brokerComments?: string | null;
  date?: string | null;
  time?: string | null;
}

export interface DtoV1KnowYourLoanEmployment {
  /** @format int32 */
  id?: number;
  employerOrDescription?: string | null;
  jobDescription?: string | null;
  incomeType?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  /** @format decimal */
  monthlyIncome?: number;
}

export interface DtoV1KnowYourLoanKnowYourLoanScreenData {
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  lastName?: string | null;
  address?: string | null;
  isPrimaryBorrower?: boolean;
  occupancyStatus?: string | null;
  transactionType?: string | null;
  occupancy?: DtoV1KnowYourLoanOccupancy[] | null;
  employment?: DtoV1KnowYourLoanEmployment[] | null;
  reo?: DtoV1KnowYourLoanReo[] | null;
  assets?: DtoV1KnowYourLoanAssets[] | null;
  liabilities?: DtoV1KnowYourLoanLiability[] | null;
  brokerComments?: DtoV1KnowYourLoanBrokerComment[] | null;
  maritalStatus?: string | null;
}

export interface DtoV1KnowYourLoanLiability {
  /** @format int32 */
  id?: number;
  creditor?: string | null;
  type?: string | null;
  /** @format decimal */
  payment?: number;
  exclusionReason?: string | null;
  /** @format decimal */
  balance?: number;
}

export interface DtoV1KnowYourLoanOccupancy {
  /** @format int32 */
  id?: number;
  rentOwn?: string | null;
  primaryResidenceHistory?: string | null;
  current?: string | null;
  timeFrame?: string | null;
}

export interface DtoV1KnowYourLoanReo {
  /** @format int32 */
  id?: number;
  address?: string | null;
  rentalIncome?: string | null;
  intendedOccupancy?: string | null;
  propertyStatus?: string | null;
}

export interface DtoV1KnowYourLoanScreenData {
  borrowers?: DtoV1KnowYourLoanKnowYourLoanScreenData[] | null;
}

export interface DtoV1LiabilitiesGetLiabilitiesAssociateDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1LiabilitiesGetLiabilitiesAssociateDataResponse {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  liabilities?: DtoV1CreditValidationLiability[] | null;
  availableREOAddresses?: DtoV1RealEstateOwnedREOAddress[] | null;
}

export interface DtoV1LiabilitiesGetLiabilitiesVerifyDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1LiabilitiesGetLiabilitiesVerifyDataResponse {
  liabilities?: DtoV1CreditValidationLiability[] | null;
  internalTradelines?: DtoV1CreditValidationInternalTradeline[] | null;
}

export interface DtoV1LiabilitiesLiability {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  debtId?: number | null;
  /** @format int32 */
  debtLenderdatabaseId?: number | null;
  liabilityType?: string | null;
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format int32 */
  originalTermRemaining?: number;
  /** @format decimal */
  payment?: number;
  payoffRequired?: boolean;
  /** @format decimal */
  balance?: number;
  excludePayment?: boolean;
  excludeBalance?: boolean;
  exclusionReason?: string | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  associatedRealEstateAddress?: DtoV1Address | null;
  associatedRealEstate?: DtoIdentitiesAddressIdentifier | null;
  availableREOAddresses?: DtoV1RealEstateOwnedREOAddress[] | null;
  customerIdentifiers?: DtoIdentitiesBorrowerIdentifier[] | null;
  borrowerNames?: DtoV1BorrowerName[] | null;
  availableLiabilityTypes?: KeyValuePairSystemStringSystemString[] | null;
  availableExclusionReasons?: KeyValuePairSystemStringSystemString[] | null;
}

export interface DtoV1LiabilitiesUpdateLiabilitiesAssociateDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  liabilities?: DtoV1CreditValidationLiability[] | null;
}

export interface DtoV1LiabilitiesUpdateLiabilitiesAssociateDataResponse {
  resultFromUpdateBorrowerFin?: boolean;
  resultFromUpdateIntegra?: boolean;
}

export interface DtoV1LiabilitiesUpdateLiabilitiesVerifyDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  liabilities?: DtoV1CreditValidationLiability[] | null;
}

export interface DtoV1LoanCommentsLoanCommentData {
  /** @format int32 */
  commentId?: number;
  commentSubCategory?: UWMCLibraryCommonDomainEnumsLoanCommentSubCategory;
  commentDate?: string | null;
  commentTime?: string | null;
  /** @format date-time */
  commentDateTime?: string;
  commentCreatedByUserName?: string | null;
  commentText?: string | null;
  isServerUser?: boolean;
}

export interface DtoV1LoanCommentsLoanCommentsDataResponse {
  loanCommentDetails?: Record<
    string,
    DtoV1LoanCommentsLoanCommentData[] | null
  >;
  dropDownOptions?: Record<
    string,
    KeyValuePairSystemInt32SystemString[] | null
  >;
}

export interface DtoV1LoanCommentsSaveLoanCommentRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  commentSubCategoryId?: number;
  commentText?: string | null;
  /** @format int32 */
  userId?: number | null;
}

export interface DtoV1LoanInfoAssetInfo {
  /** @format int32 */
  assetId?: number;
  /** @format int32 */
  assetLdId?: number;
  assetDetails?: string | null;
  borrowerIds?: DtoIdentitiesBorrowerIdentifier[] | null;
}

export interface DtoV1LoanInfoBorrowerInfo {
  /** @format int32 */
  borrowerLenderDatabaseId?: number;
  /** @format int32 */
  borrowerRecordId?: number;
  borrowerName?: string | null;
}

export interface DtoV1LoanInfoGetFeatureFlagsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  featureFlags?: Record<string, boolean> | null;
}

export interface DtoV1LoanInfoIncomeInfo {
  /** @format int32 */
  borrowerLenderDatabaseId?: number;
  /** @format int32 */
  borrowerRecordId?: number;
  /** @format int32 */
  incomeId?: number;
  incomeDetails?: string | null;
  incomeBorrowerId?: string | null;
}

export interface DtoV1LoanInfoLiability {
  /** @format int32 */
  debtId?: number | null;
  /** @format int32 */
  debtLdId?: number | null;
  liabilityDetails?: string | null;
  borrowerAssociations?: DtoIdentitiesBorrowerIdentifier[] | null;
}

export interface DtoV1LoanInfoPropertyInfo {
  /** @format int32 */
  addressId?: number;
  /** @format int32 */
  addressLdId?: number;
  addressDetails?: string | null;
  isAddressSubjectProperty?: boolean;
}

export interface DtoV1LoanLockInformation {
  isLoanCurrentlyLocked?: boolean;
  loanLockedBy?: string | null;
}

export interface DtoV1LoanOfficerLoanOfficer {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  nmls?: string | null;
  companyName?: string | null;
  companyNmls?: string | null;
}

export interface DtoV1LoanStatusDenialReason {
  /** @format int32 */
  categoryId?: number;
  /** @format int32 */
  denialId?: number;
  denialName?: string | null;
  categoryName?: string | null;
}

export interface DtoV1LoanStatusDenialReasonResponse {
  denialReasons?: DtoV1LoanStatusDenialReason[] | null;
  appliedDenialReasons?: DtoV1LoanStatusLoanDenialReason[] | null;
  denialReasonNonCRFlag?: boolean;
  denialSecondReview?: boolean;
}

export interface DtoV1LoanStatusLoanDenialReason {
  /** @format int32 */
  categoryId?: number;
  /** @format int32 */
  denialId?: number;
  denialName?: string | null;
  appliedInd?: boolean;
  categoryName?: string | null;
}

export interface DtoV1LoanStatusUpdateDenialReasonsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  appliedDenialReasons?: DtoV1LoanStatusLoanDenialReason[] | null;
  denialReasonNonCRFlag?: boolean;
  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userName?: string | null;
}

export interface DtoV1LoanSummaryLoanSummary {
  /** @format int32 */
  loanNumber?: number;
  primaryBorrowerFirstName?: string | null;
  primaryBorrowerLastName?: string | null;
  propertyAddress?: DtoV1Address | null;
  loanStatus?: string | null;
  /** @format decimal */
  dti?: number;
  /** @format decimal */
  hti?: number;
  /** @format decimal */
  ltv?: number;
  /** @format decimal */
  cltv?: number;
  /** @format decimal */
  tltv?: number;
  /** @format decimal */
  baseLoanAmount?: number;
  /** @format decimal */
  totalLoanAmount?: number;
  loanPurpose?: string | null;
  refiPurpose?: string | null;
  ausMethod?: string | null;
  /** @format decimal */
  principalInterestTaxesInsurance?: number;
  /** @format decimal */
  salesPrice?: number;
  /** @format decimal */
  appraisedvalue?: number;
  occupancyType?: string | null;
  propertyType?: string | null;
  isRefinance?: boolean;
  productType?: string | null;
  loanProductTypeDescription?: string | null;
  /** @format int32 */
  qualifiedIND?: number;
  creditScoreCategory?: string | null;
}

export interface DtoV1NavigationGetNavigationDetailsResponse {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  topNavigationItems?: DtoV1NavigationTopNavigationItem[] | null;
  allRequiredRulesCompleted?: boolean;
  loanLockInformation?: DtoV1LoanLockInformation | null;
}

export interface DtoV1NavigationGutterItem {
  gutterItemId?: string | null;
  ruleName?: string | null;
  /** @format int32 */
  ruleId?: number;
  displayTitle?: string | null;
  displaySubTitle?: string | null;
  displayTitleDesc?: string | null;
  /** @format int32 */
  ruleResultId?: number;
  /** @format int32 */
  ruleCategoryId?: number;
  ruleCategoryName?: string | null;
  /** @format int32 */
  ruleSubCategoryId?: number;
  ruleSubCategoryName?: string | null;
  /** @format int32 */
  parentRuleSortOrder?: number;
  /** @format int32 */
  ruleResultStatusId?: number;
  /** @format int64 */
  ruleReferenceId?: number;
  /** @format int32 */
  ruleReferenceLDId?: number;
  ruleReferenceTypeDesc?: string | null;
  /** @format int32 */
  ruleReferenceTypeId?: number;
  /** @format int32 */
  customerLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  isUnderwriterCheckboxVisible?: boolean;
  isUnderwriterVerified?: boolean;
  additionalReferences?: Record<string, string | null>;
  isReadOnlyPermission?: boolean;
  gutterItemChildren?: DtoV1NavigationGutterItem[] | null;
  workTrackingTitle?: string | null;
}

export interface DtoV1NavigationTopNavigationItem {
  /** @format int32 */
  navigationCategoryId?: number;
  navigationCategoryName?: string | null;
  /** @format int32 */
  navigationOrder?: number;
  allRequiredRulesCompleted?: boolean;
  isReadOnlyPermission?: boolean;
  canWriteUnderwriterCheckbox?: boolean;
  canReadUnderwriterCheckboxes?: boolean;
  canOverrideAMCCheckbox?: boolean;
  navigationGutterItems?: DtoV1NavigationGutterItem[] | null;
}

export interface DtoV1Option {
  label: string | null;
  value: string | null;
}

export interface DtoV1OtherIncomeGetOtherIncomeDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
}

export interface DtoV1OtherIncomeGetOtherIncomeDataResponse {
  /** @format int32 */
  borrowerLenderDatabaseId?: number;
  /** @format int32 */
  borrowerRecordId?: number;
  /** @format int32 */
  employerId?: number;
  incomeType?: DtoV1EnumIncomeType;
  incomeTypeDescription?: string | null;
  isDocumentationProvided?: boolean | null;
  /** @format decimal */
  amount?: number;
  underwritingMessage?: DtoV1UnderwritingMessage | null;
  otherIncomeQuestionsData?: DtoV1IncomeIncomeSummaryQuestionResponse[] | null;
  userProvidedAnswers?:
    | DtoV1IncomeIncomeSummaryAnsweredQuestionResponse[]
    | null;
  otherIncomeAlert?: DtoV1IncomeCalculatorAlert | null;
  otherIncomeTooltip?: string[] | null;
  comment?: string | null;
}

export interface DtoV1OtherIncomeSaveOtherIncomeDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  incomeType?: DtoV1EnumIncomeType;
  /** @format int32 */
  userId?: number;
  isDocumentationProvided?: boolean | null;
  /** @format decimal */
  monthlyNetIncome?: number;
  comment?: string | null;
  saveAnswerRequest?: DtoV1IncomeSaveAnswerRequest | null;
  employerName?: string | null;
  calculatorType?: string | null;
  /** @format int32 */
  calculationId?: number | null;
}

export interface DtoV1ParentAlertsGetUnclassifiedDocumentStatusRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1ParentAlertsGetUnclassifiedDocumentStatusResponse {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  hasUnclassifiedDocuments?: boolean;
}

export interface DtoV1PermissionCheckUserHasPermissionRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  permission?: string | null;
}

export interface DtoV1PermissionCheckUserHasPermissionResponse {
  result?: boolean;
}

export interface DtoV1PermissionGetUserPermissionsByCategoryRequest {
  /** @format int32 */
  loanStatusContext?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1PermissionGetUserPermissionsByCategoryResponse {
  permissions?: string[] | null;
}

export interface DtoV1ProductsGetInvalidProductResponse {
  invalidReasons?: DtoV1ProductsInvalidReason[] | null;
  validLoanProductDescriptions?: string[] | null;
}

export interface DtoV1ProductsInvalidReason {
  reasonHeader?: string | null;
  invalidReasonList?: DtoV1ProductsInvalidReasonData[] | null;
}

export interface DtoV1ProductsInvalidReasonData {
  ruleDescription?: string | null;
  rule?: string | null;
  value?: string | null;
}

export interface DtoV1PropertyGetQuestionAnswersRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  questionCategoryId?: number;
}

export interface DtoV1PropertyGetQuestionAnswersResponse {
  subjectPropertyIdentifier?: DtoV1PropertySubjectPropertyIdentifier | null;
  /** @format int32 */
  questionCategory?: number;
  questionSubCategories?: DtoV1PropertyQuestionSubCategory[] | null;
  /** @format decimal */
  appraisedValue?: number;
  /** @format decimal */
  hazardInsuranceReserves?: number | null;
  /** @format decimal */
  totalTaxes?: number | null;
  /** @format decimal */
  floodInsurance?: number | null;
  isEarlyCDAppraisalVerified?: boolean;
  isEarlyCDHOIVerified?: boolean;
  isEarlyCDTaxesVerified?: boolean;
  isEarlyCDFloodInsuranceVerified?: boolean;
}

export interface DtoV1PropertyNewConstructionRequirementsData {
  isNewConstruction?: boolean | null;
  isConstructionLoan?: boolean | null;
  certificateOfOccupancyReceived?: boolean | null;
  certificateOfOccupancyNotRequired?: boolean | null;
  form92051Provided?: boolean | null;
  moveCertificateOfOccupancyToClosing?: boolean | null;
}

export interface DtoV1PropertyQuestion {
  /** @format int32 */
  questionId?: number;
  questionText?: string | null;
  isVisibleOnLoad?: boolean;
  answerProvided?: string | null;
  /** @format int32 */
  sortOrder?: number;
  questionAnswers?: DtoV1PropertyQuestionAnswer[] | null;
}

export interface DtoV1PropertyQuestionAnswer {
  /** @format int32 */
  questionAnswerId?: number;
  answer?: string | null;
  /** @format int32 */
  nextQuestionId?: number;
  /** @format int32 */
  sortOrder?: number;
  questionAnswerResolutions?: DtoV1PropertyQuestionAnswerResolution[] | null;
}

export interface DtoV1PropertyQuestionAnswerResolution {
  /** @format int32 */
  questionAnswerResolutionId?: number;
  resolutionType?: DtoV1EnumResolutionType;
  resolutionText?: string | null;
  /** @format int32 */
  sortOrder?: number;
}

export interface DtoV1PropertyQuestionSubCategory {
  /** @format int32 */
  questionSubCategoryId?: number;
  title?: string | null;
  /** @format int32 */
  sortOrder?: number;
  questions?: DtoV1PropertyQuestion[] | null;
}

export interface DtoV1PropertySavePropertyQuestionAnswersRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  questionAnswers?: DtoV1PropertySaveQuestionAnswer[] | null;
  underwriterVerifications?: DtoV1PropertyUnderwriterVerifications | null;
}

export interface DtoV1PropertySaveQuestionAnswer {
  /** @format int32 */
  questionId?: number;
  answerProvided?: string | null;
}

export interface DtoV1PropertySubjectPropertyIdentifier {
  /** @format int32 */
  obfuscatedLenderDatabaseId?: number;
  /** @format int32 */
  propertyRecordId?: number;
}

export interface DtoV1PropertyUnderwriterVerifications {
  isEarlyCDAppraisalVerified?: boolean;
  isEarlyCDHOIVerified?: boolean;
  isEarlyCDTaxesVerified?: boolean;
  isEarlyCDFloodInsuranceVerified?: boolean;
}

export interface DtoV1PropertyInformationBorrower {
  customerRecordId?: string | null;
  primaryCustomer?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface DtoV1PropertyInformationBorrowerInfo {
  customerRecordId?: string | null;
  primaryCustomer?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  fullName?: string | null;
}

export interface DtoV1PropertyInformationCreateFhaCaseNumberRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  primaryBorrowerLastName?: string | null;
  /** @format int32 */
  fhaCashOutCaseNumberActions?: number;
}

export interface DtoV1PropertyInformationDocument {
  /** @format int64 */
  documentId?: number;
  /** @format int32 */
  documentTypeId?: number;
  documentTypeKey?: string | null;
}

export interface DtoV1PropertyInformationDropDownOption {
  label: string | null;
  value: string | null;
  bankName: string | null;
  accountName: string | null;
  state: string | null;
  isStateLicensed: boolean;
}

export interface DtoV1PropertyInformationEarnestMoneyDeposit {
  assetRecordIdentifier?: DtoV1AssetsAssetRecordIdentifier | null;
  emdName?: string | null;
  /** @format float */
  emdAmount?: number;
  operation?: string | null;
}

export interface DtoV1PropertyInformationExtractedEmdQuestionAnswer {
  id?: string | null;
  userAction?: string | null;
  previousUserAction?: string | null;
  /** @format decimal */
  extractedValue?: number;
  /** @format decimal */
  value?: number | null;
  /** @format decimal */
  previousValue?: number | null;
  /** @format decimal */
  assetValue?: number | null;
  assetIdValueToReplace?: string | null;
  questionAnswers?: Record<
    string,
    DtoV1PropertyInformationQuestionAnswer
  > | null;
}

export interface DtoV1PropertyInformationFhaCaseNumberReponse {
  caseNumber?: string | null;
  salesforceUrl?: string | null;
  caseNumberDate?: string | null;
}

export interface DtoV1PropertyInformationFirstSavedValues {
  firstSavedDatetime?: string | null;
  firstSavedUser?: string | null;
  firstSavedEmail?: string | null;
}

export interface DtoV1PropertyInformationGetQuestionAnswersRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  context?: DtoV1EnumPropertyInformationContext;
}

export interface DtoV1PropertyInformationMortgageAssociatedWithProperty {
  creditorName?: string | null;
  debtType?: string | null;
  /** @format decimal */
  balance?: number;
  /** @format date-time */
  dateOfEndorsement?: string | null;
  includePayment?: boolean | null;
  /** @format decimal */
  payoffAmount?: number;
  verified?: string | null;
}

export interface DtoV1PropertyInformationPropertyAddress {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  county?: string | null;
}

export interface DtoV1PropertyInformationPropertyInformationScreenData {
  /** @format int64 */
  documentId?: number | null;
  loanPurpose?: DtoV1EnumPurposeType;
  refinancePurposeType?: string | null;
  propertyType?: string | null;
  propertyAddress?: DtoV1PropertyInformationPropertyAddress | null;
  formattedPropertyAddress?: string | null;
  ausMethod?: string | null;
  /** @format date-time */
  applicationDate?: string;
  estimatedClosingDate?: string | null;
  titleCompany?: string | null;
  titleUnderwriterCompany?: DtoV1PropertyInformationTitleUnderwriterCompany | null;
  titleCommitmentNumber?: string | null;
  propertyTypes?: DtoV1PropertyInformationUnderWritingPropertyType[] | null;
  titleUnderwriterCompanies?:
    | DtoV1PropertyInformationTitleUnderwriterCompany[]
    | null;
  questionAnswers?: Record<
    string,
    DtoV1PropertyInformationQuestionAnswer
  > | null;
  firstSavedValues?: DtoV1PropertyInformationFirstSavedValues | null;
  loanStatus?: string | null;
  isTitleUploaded?: boolean | null;
  isCPLUploaded?: boolean | null;
  isWireUploaded?: boolean | null;
  isPurchaseAgreementUploaded?: boolean | null;
  isNewConstruction?: boolean | null;
  /** @format decimal */
  ltv?: number | null;
  tracType?: DtoV1EnumTracType | null;
  isFHACaseNumberInheritanceWorkflowEnabled?: boolean;
}

export interface DtoV1PropertyInformationQuestionAnswer {
  questionId?: string | null;
  questionName?: string | null;
  answer?: string | null;
  iconType?: DtoV1EnumIconType;
  aiResponse?: DtoV1AIResponse | null;
  answerSource?: DtoV1PropertyInformationEnumsAnswerSource;
  canHide?: boolean | null;
}

export interface DtoV1PropertyInformationSavePropertyInformationDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  context?: DtoV1EnumPropertyInformationContext;
  questionAnswers?: Record<string, any> | null;
  vestingCustomers?: DtoV1PropertyInformationVestingCustomer[] | null;
  screenData?: DtoV1PropertyInformationPropertyInformationScreenData | null;
  titleUnderwriterCompanyName?: string | null;
  earnestMoneyDeposits?: DtoV1PropertyInformationEarnestMoneyDeposit[] | null;
  extractedEmdQuestionAnswers?:
    | DtoV1PropertyInformationExtractedEmdQuestionAnswer[]
    | null;
  borrowers?: DtoV1PropertyInformationBorrowerInfo[] | null;
  /** @format date-time */
  fhaCaseNumberDate?: string | null;
  loanProductType?: DtoV1EnumLoanProductType;
  loanPurposeType?: DtoV1EnumLoanPurposeType;
  refinancePurposeTypeDescription?: string | null;
  isCplDateAndSignatureDisabled?: boolean;
  sellerConcessionsDatapoints?: DtoV1PropertyInformationSellerConcessionsDatapoints | null;
  questionsToDelete?: string[] | null;
}

export interface DtoV1PropertyInformationSaveTitleSummaryRequest {
  questionAnswers?: Record<string, string | null>;
}

export interface DtoV1PropertyInformationSearchWireInfoRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  abaNumber?: string | null;
  accountNumber?: string | null;
  subjectPropertyState?: string | null;
}

export interface DtoV1PropertyInformationSeller {
  /** @format int32 */
  sellerNumber?: number | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}

export interface DtoV1PropertyInformationSellerConcessionsDatapoints {
  /** @format decimal */
  loanAmount?: number | null;
  /** @format decimal */
  appraisedValue?: number | null;
  /** @format decimal */
  purchasePrice?: number | null;
  occupancyTypeId?: DtoV1EnumOccupancyType;
}

export interface DtoV1PropertyInformationTitleCommitmentRefinance {
  /** @format date-time */
  dateLotAcquired?: string | null;
  isLoanBeingRefinanced50A6?: boolean;
  cannotCloseBeforeReason?: string | null;
  /** @format date-time */
  cannotCloseBeforeDate?: string | null;
  /** @format date-time */
  mustHoldUntilDate?: string | null;
}

export interface DtoV1PropertyInformationTitleSummaryScreenData {
  /** @format int32 */
  purposeTypeId?: number;
  appraisalParcelId?: string | null;
  hasAppraisalBeenUploaded?: boolean;
  hasAppraisalWaiver?: boolean;
  /** @format date-time */
  effectiveDate?: string | null;
  /** @format date-time */
  firstPaymentDate?: string | null;
  /** @format date-time */
  loanApplicationDate?: string | null;
  /** @format int32 */
  loanProductLoanTermMaximum?: number;
  /** @format int32 */
  loanProductTypeId?: number;
  hasSpecialFeatureCode360?: boolean;
  hasSpecialFeatureCode361?: boolean;
  sellers?: DtoV1PropertyInformationSeller[] | null;
  borrowers?: DtoV1PropertyInformationBorrower[] | null;
  titleUnderwriters?: DtoV1PropertyInformationTitleUnderwriterCompany[] | null;
  underWritingPropertyTypes?: DtoV1Option[] | null;
  propertyType?: string | null;
  /** @format date-time */
  agencyCaseNumberDate?: string | null;
  agencyCaseNumber?: string | null;
  /** @format decimal */
  salesPrice?: number;
  /** @format decimal */
  ltv?: number;
  /** @format date-time */
  purchaseContractEffectiveDate?: string | null;
  /** @format decimal */
  proposedGroundRent?: number;
  /** @format int32 */
  paymentsPerYear?: number;
  /** @format int32 */
  numberOfPayments?: number;
  /** @format int32 */
  monthsRemainingOnResaleRestrictions?: number | null;
  /** @format int32 */
  tracTypeId?: number;
  /** @format int32 */
  ausUnderwritingMethod?: number;
  isPropertyTypeSameAsSystemPropertyType?: boolean | null;
  correspondentLender?: string | null;
  /** @format decimal */
  appraisedValue?: number | null;
  /** @format decimal */
  loanAmount?: number | null;
  isNewConstruction?: boolean | null;
  /** @format decimal */
  acquisitionPrice?: number | null;
  /** @format int32 */
  occupancyTypeId?: number;
  isPropertyTaxesUnderwriterCheckboxVerified?: boolean;
  /** @format int32 */
  businessChannelId?: number | null;
  documents?: DtoV1PropertyInformationDocument[] | null;
  refiPurpose?: string | null;
  refinanceProps?: DtoV1PropertyInformationTitleCommitmentRefinance | null;
  mortgagesAssociatedWithProperties?:
    | DtoV1PropertyInformationMortgageAssociatedWithProperty[]
    | null;
  titleSummaryWorkflow?: DtoV1PropertyInformationEnumsTitleSummaryWorkflow;
  questionAnswers?: Record<
    string,
    DtoV1PropertyInformationQuestionAnswer
  > | null;
}

export interface DtoV1PropertyInformationTitleUnderwriterCompany {
  /** @format int32 */
  selectedTitleUnderwriterId?: number;
  titleUnderwriterName?: string | null;
}

export interface DtoV1PropertyInformationUnderWritingPropertyType {
  id?: string | null;
  displayValue?: string | null;
}

export interface DtoV1PropertyInformationVestingCustomer {
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  email?: string | null;
  isIndividualVerified?: boolean;
  isDeededOffTitle?: boolean | null;
  /** @format int32 */
  typeId?: number;
  isNonBorrowingTrustee?: boolean | null;
  isNonBorrowingSpouse?: boolean;
  /** @format int32 */
  spouseCustomerRecordId?: number;
  customerChangeAction?: DtoV1PropertyInformationEnumsCustomerChangeAction;
}

export interface DtoV1PropertyInsuranceComparisonValues {
  key?: string | null;
  document?: string | null;
  system?: string | null;
}

export interface DtoV1PropertyInsuranceGetInsurancePolicyScreenData {
  documents?: DtoV1PropertyInsurancePropertyInsuranceDocument[] | null;
  questionAnswers?: Record<string, DtoV1QuestionsQuestion> | null;
  masterQuestionAnswers?: Record<string, DtoV1QuestionsQuestion> | null;
  hO6QuestionAnswers?: Record<string, DtoV1QuestionsQuestion> | null;
  comparisonValues?: DtoV1PropertyInsuranceComparisonValues[] | null;
  isPolicyDocumentTypeAutoGenerated?: boolean;
  isCurrentAlreadyProvided?: boolean | null;
  isRenewalAlreadyProvided?: boolean | null;
  hoiHasSupplementalPolicy?: boolean | null;
  supplementalWorkflowHasCorrespondingHoiPolicy?: boolean | null;
  loanProductType?: DtoV1EnumLoanProductType | null;
  loanPurposeType?: DtoV1EnumLoanPurposeType | null;
  propertyType?: string | null;
  occupancyType?: DtoV1EnumOccupancyType | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  /** @format date-time */
  disbursementDate?: string | null;
  /** @format decimal */
  totalLoanAmount?: number | null;
  questionContextKey?: string | null;
  floodZone?: string | null;
  waiveEscrowOption?: string | null;
  isAttached?: boolean | null;
  /** @format int32 */
  businessChannelId?: number | null;
  isMasterPolicyDocumentAttached?: boolean;
  isPerUnitDeductibleEnabled?: boolean;
  isElectiveInsuranceEnabled?: boolean;
  isActualCashValueTextDiffEnabled?: boolean;
  isMasterInsuranceReplacementCostEnhancement?: boolean;
  isHoiInvoiceUpdateEnabled?: boolean;
  currentHoiPolicyEndDate?: string | null;
  highestPerilAmount?: string | null;
  perilsList?: string | null;
  /** @format int32 */
  numberOfCondoUnits?: number | null;
  isHOITrustScoreAutomationEnabled?: boolean;
  isHomeownerResponsibleForExteriorMaintenance?: boolean | null;
  isCondoOrAttachedPud?: boolean | null;
}

export interface DtoV1PropertyInsurancePropertyInsuranceDocument {
  /** @format int32 */
  documentTypeId?: number;
  /** @format int64 */
  id?: number;
  label?: string | null;
}

export interface DtoV1PropertyInsuranceSaveInsurancePolicyRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier | null;
  insuranceQuestionAnswers: Record<string, any> | null;
  /** @format int32 */
  ruleId?: number;
  /** @format int64 */
  documentId?: number | null;
}

export interface DtoV1PropertyTaxAdditionalInstallment {
  /** @format uuid */
  taxId: string;
  /** @format uuid */
  installmentId?: string;
  /** @format decimal */
  installmentAmount?: number;
  paymentNumber?: string | null;
  /** @format decimal */
  amountDue?: number;
  /** @format decimal */
  amountPaid?: number;
  paidBy?: string | null;
  /** @format int32 */
  monthsToCollect?: number;
  /** @format date-time */
  dueDate?: string;
  /** @format date-time */
  discountDate?: string;
  /** @format date-time */
  delinquentDate?: string;
  /** @format date-time */
  distributionDate?: string;
  paidType?: DtoV1EnumTaxPaymentTypes | null;
  taxAnswerSource?: UWMCLibraryCommonDomainEnumsTaxAnswerSource;
  /** @format decimal */
  currentInstallmentAmount?: number | null;
  /** @format int32 */
  userId?: number;
  isPastInstallment?: boolean;
}

export interface DtoV1PropertyTaxEscrowDetails {
  /** @format uuid */
  taxId: string;
  taxType: string | null;
  includeUnequalInstallments: boolean;
  includeMillageRate: boolean;
  taxDocumentType: string | null;
  /** @format date-time */
  taxDocumentYear: string;
  /** @format date-time */
  estimatedClosingDate: string;
  /** @format date-time */
  actualClosingDate?: string | null;
  payeeCode: string | null;
  payeeName: string | null;
  parcel: string | null;
  /** @format decimal */
  totalAmount: number;
  /** @format decimal */
  paddingAmount: number;
  /** @format decimal */
  monthlyAmount: number;
  /** @format decimal */
  escrowAmount: number;
  /** @format decimal */
  millageRate?: number | null;
  /** @format decimal */
  taxRate?: number | null;
  /** @format decimal */
  nonAdValorum?: number | null;
  /** @format int32 */
  numberOfMonths: number;
  isBorrowerExempt: boolean;
  taxCompleteFlag: boolean;
  escrowInstallments: DtoV1PropertyTaxEscrowInstallment[] | null;
  additionalTaxes?: DtoV1PropertyTaxAdditionalInstallment[] | null;
  taxDocuments?: DtoV1PropertyTaxTaxDocument[] | null;
  isCloser?: boolean;
  isCloserTL?: boolean;
  areTaxesBasedOnLandOnlyValue?: boolean | null;
  previouslySavedByUser?: boolean;
  escrowWaiverOption?: UWMCLibraryCommonDomainEnumsWaiveEscrowOption;
  /** @format decimal */
  cashToClose?: number;
  /** @format decimal */
  totalNonRealEstateDebt?: number;
  taxDueDates?: string[] | null;
  /** @format decimal */
  additionalDueAtClosing?: number;
  /** @format decimal */
  delinquentDueAtClosing?: number;
  /** @format decimal */
  supplementalDueAtClosing?: number;
  /** @format uuid */
  supplementalDueAtClosingId?: string;
  includeSupplementals?: boolean;
  supplementalInstallments?: DtoV1PropertyTaxSupplementalInstallment[] | null;
  deletedSupplementalInstallments?: string[] | null;
}

export interface DtoV1PropertyTaxEscrowInstallment {
  /** @format uuid */
  taxId: string;
  /** @format uuid */
  installmentId?: string;
  /** @format decimal */
  installmentAmount?: number;
  paymentNumber?: string | null;
  /** @format decimal */
  amountDue?: number;
  /** @format decimal */
  amountPaid?: number;
  paidBy?: string | null;
  /** @format int32 */
  monthsToCollect?: number;
  /** @format date-time */
  dueDate?: string;
  /** @format date-time */
  discountDate?: string;
  /** @format date-time */
  delinquentDate?: string;
  /** @format date-time */
  distributionDate?: string;
  paidType?: DtoV1EnumTaxPaymentTypes | null;
  taxAnswerSource?: UWMCLibraryCommonDomainEnumsTaxAnswerSource;
  /** @format decimal */
  currentInstallmentAmount?: number | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoV1PropertyTaxGetTaxSummaryDto {
  areTaxesBasedOnLandOnlyValue?: boolean | null;
  calculationMethod?: DtoV1EnumAnnualQualifyingAmountCalcMethod | null;
  /** @format decimal */
  taxRate?: number | null;
  /** @format decimal */
  millageRate?: number | null;
  generateShockLetter?: boolean | null;
  isNewConstruction?: boolean | null;
  taxDocuments?: DtoV1PropertyTaxTaxDocument[] | null;
  /** @format decimal */
  annualQualifyingAmount?: number | null;
}

export interface DtoV1PropertyTaxPropertyTaxAddressData {
  /** @format uuid */
  propertyAddressId: string;
  addressLineOne?: string | null;
  addressLineTwo?: string | null;
  city?: string | null;
  county?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface DtoV1PropertyTaxPropertyTaxData {
  /** @format date-time */
  closingDate: string;
  /** @format decimal */
  sellerToPayAtClosing?: number;
  /** @format decimal */
  delinquentTaxesPaidAtClosing?: number;
  /** @format decimal */
  nonDelinquentTaxesPaidAtClosing?: number;
  /** @format decimal */
  escrowsCollectedAtClosing?: number;
  /** @format decimal */
  taxesPaidAtClosing?: number;
  escrowWaiverOption?: UWMCLibraryCommonDomainEnumsWaiveEscrowOption;
  isTaxVerified: boolean;
  isTaxVerifiedForEarlyCD: boolean;
  escrowDetails?: DtoV1PropertyTaxEscrowDetails[] | null;
  address?: DtoV1PropertyTaxPropertyTaxAddressData | null;
  taxProrations?: DtoV1PropertyTaxTaxProration[] | null;
  /** @format decimal */
  totalDelinquentAmount?: number;
  taxDocuments?: DtoV1PropertyTaxTaxDocument[] | null;
  isCalculationMethodNotProvided?: boolean;
  hasCoreLogicDoc?: boolean;
  /** @format decimal */
  annualTaxAmount?: number;
}

export interface DtoV1PropertyTaxSaveEscrowDetailsRequestDto {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  escrowDetails?: DtoV1PropertyTaxEscrowDetails | null;
  fieldUpdateStatus: boolean;
}

export interface DtoV1PropertyTaxSavePropertyTaxDataRequestDto {
  propertyTaxData?: DtoV1PropertyTaxPropertyTaxData | null;
  fieldUpdateStatus: boolean;
}

export interface DtoV1PropertyTaxSaveTaxSummaryRequestDto {
  areTaxesBasedOnLandOnlyValue?: boolean;
  calculationMethod?: DtoV1EnumAnnualQualifyingAmountCalcMethod | null;
  /** @format decimal */
  taxRate?: number | null;
  /** @format decimal */
  millageRate?: number | null;
  /** @format decimal */
  annualQualifyingAmount?: number | null;
  generateShockLetter?: boolean | null;
  isNewConstruction?: boolean | null;
}

export interface DtoV1PropertyTaxSupplementalInstallment {
  /** @format uuid */
  supplementalId?: string;
  /** @format uuid */
  taxId?: string;
  /** @format decimal */
  supplementalAmount?: number;
  /** @format date-time */
  supplementalDate?: string;
  paidType?: DtoV1EnumTaxPaymentTypes | null;
  /** @format int32 */
  userId?: number | null;
  taxAnswerSource?: UWMCLibraryCommonDomainEnumsTaxAnswerSource | null;
}

export interface DtoV1PropertyTaxTaxDocument {
  /** @format int32 */
  documentTypeId?: number;
  documentTypeKey?: string | null;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1PropertyTaxTaxProration {
  /** @format int32 */
  originalHudNumber?: number;
  taxesPaidFlag?: DtoV1PropertyTaxTaxesPaidFlag | null;
  /** @format decimal */
  amount?: number;
  /** @format decimal */
  sellerPaidAmount?: number;
  /** @format date-time */
  fromDate?: string | null;
  /** @format date-time */
  toDate?: string | null;
  companyName?: string | null;
}

export interface DtoV1PurchaseAgreementFhaRequirements {
  nonBorrowingPartiesSigned?: string | null;
  nonBorrowingFHADefined?: string | null;
  amendatoryClauseSignedByAll?: string | null;
  realEstateCertificateIsValid?: string | null;
  leadPaintDisclosureProvided?: string | null;
  /** @format decimal */
  salesPriceOnAmendatoryClause?: number | null;
  isTBDPurchase?: boolean | null;
  buildBefore1978?: boolean | null;
  isPurchaseContractReviewLoan?: boolean | null;
}

export interface DtoV1PurchaseAgreementUpdateFhaRequirementsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  fhaRequirements?: DtoV1PurchaseAgreementFhaRequirements | null;
  /** @format int32 */
  userId?: number;
}

export interface DtoV1Question {
  /** @format int32 */
  questionId?: number;
  questionText?: string | null;
  questionSubtext?: string | null;
  answers?: DtoV1Answer[] | null;
  userResponse?: DtoV1QuestionUserResponse | null;
  /** @format int32 */
  questionDisplayFormat?: number;
  isVisibleOnLoad?: boolean;
  questionMessage?: string | null;
  /** @format int32 */
  questionMessageActionId?: number | null;
}

export interface DtoV1QuestionUserResponse {
  /** @format int32 */
  questionUserResponseID?: number;
  answerText?: string | null;
  /** @format int32 */
  questionAnswerID?: number;
  /** @format int32 */
  questionId?: number;
}

export interface DtoV1QuestionsQuestion {
  /** @format uuid */
  id?: string | null;
  /** @minLength 1 */
  name?: string | null;
  answerText?: string | null;
  source?: DtoV1PropertyInformationEnumsAnswerSource;
  /** @format int32 */
  createdUserId?: number;
  /** @format date-time */
  savedDateTime?: string | null;
  iconType?: DtoV1EnumIconType;
  canHide?: boolean | null;
  aiResponse?: DtoV1AIResponse | null;
}

export interface DtoV1QuestionsSaveQuestionAnswerRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  conditionCategory?: DtoV1EnumValidationResultConditionCategory;
  /** @minItems 1 */
  responses: DtoV1QuestionUserResponse[];
}

export interface DtoV1QueueFiuReason {
  /** @format int32 */
  id?: number;
  label?: string | null;
}

export interface DtoV1QueueGetFiuResponse {
  sendToFIUFlag?: boolean;
  status?: string | null;
  statusReasonId?: DtoV1QueueEnumStatusReasonType | null;
  underwriterComment?: string | null;
  displayComment?: boolean;
  isFIUEnabled?: boolean;
  isFIUAdditionalDocsEnabled?: boolean;
  statusReasons?: DtoV1QueueFiuReason[] | null;
}

export interface DtoV1QueueGetQueueState {
  queueType?: DtoV1QueueEnumQueueType;
  label?: string | null;
  inQueue?: boolean;
  isDisabled?: boolean;
}

export interface DtoV1QueueGetQueueStateResponse {
  queues?: DtoV1QueueGetQueueState[] | null;
  comment?: string | null;
  isCounterOfferPresent?: boolean;
  isAusExpired?: boolean;
  redStops?: string[] | null;
}

export interface DtoV1QueueQueueAuditData {
  action?: string | null;
  user?: string | null;
  /** @format date-time */
  dateTime?: string;
  email?: string | null;
}

export interface DtoV1QueueQueueState {
  queueType?: DtoV1QueueEnumQueueType;
  inQueue?: boolean;
}

export interface DtoV1QueueSaveFiuRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  statusReasonId?: DtoV1QueueEnumStatusReasonType;
  underwriterComment?: string | null;
  additionalInfoDocReceived?: boolean;
}

export interface DtoV1QueueSaveQueueStatusAndCommentRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  queues?: DtoV1QueueQueueState[] | null;
  comment?: string | null;
}

export interface DtoV1RealEstateOwnedBorrowerAddressForSummary {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  wholeAddressString?: string | null;
  primaryResidence?: boolean;
  addressType?: string | null;
  ownership?: DtoV1EnumOwnershipStatus | null;
}

export interface DtoV1RealEstateOwnedBorrowerForSummary {
  /** @format int32 */
  lenderdatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  socialSecurityNumber?: string | null;
  /** @format int32 */
  borrowerPosition?: number;
  isPrimaryBorrower?: boolean;
  /** @format date-time */
  dateOfBirth?: string | null;
  citizenship?: DtoV1EnumCitizenshipType | null;
  borrowerAddressHistory?:
    | DtoV1RealEstateOwnedBorrowerAddressForSummary[]
    | null;
  isCitizenshipDocumentUploaded?: boolean | null;
}

export interface DtoV1RealEstateOwnedDeleteRealEstateOwnedRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
}

export interface DtoV1RealEstateOwnedGetRealEstateOwnedResponse {
  realEstateOwned?: DtoV1RealEstateOwnedRealEstateOwned[] | null;
}

export interface DtoV1RealEstateOwnedGetRealEstateOwnedSinglePropertyRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
}

export interface DtoV1RealEstateOwnedLiabilityForSummary {
  liabilityId?: DtoV1RealEstateOwnedLiabilityIdentifier | null;
  liabilityType?: string | null;
  creditorName?: string | null;
  accountNumber?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  /** @format decimal */
  balance?: number;
  /** @format decimal */
  payment?: number;
  /** @format int32 */
  originalTermRemaining?: number;
  isStudentLoan?: boolean;
  payoffRequired?: boolean;
  excludePayment?: boolean;
  excludeBalance?: boolean;
  /** @format int32 */
  numberOfPaymentsMade?: number | null;
  /** @format date-time */
  originalFirstPaymentDate?: string | null;
  exclusionReason?: string | null;
  associatedRealEstate?: DtoV1RealEstateOwnedRealEstateOwnedForSummary | null;
  customerIdentifiers?: DtoIdentitiesCustomerIdentifier[] | null;
}

export interface DtoV1RealEstateOwnedLiabilityIdentifier {
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  loanRecordId?: number;
  /** @format int32 */
  debtLenderDatabaseId?: number;
  /** @format int32 */
  debtId?: number;
}

export interface DtoV1RealEstateOwnedPropertyAddressForSummary {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  wholeAddressString?: string | null;
  country?: string | null;
}

export interface DtoV1RealEstateOwnedREOAddress {
  propertyAddress?: DtoV1Address | null;
  addressId?: DtoIdentitiesAddressIdentifier | null;
}

export interface DtoV1RealEstateOwnedRealEstateOwned {
  addressId?: DtoIdentitiesAddressIdentifier | null;
  propertyAddress?: DtoV1Address | null;
  propertyStatus?: DtoV1EnumPropertyStatus | null;
  propertyStatusString?: string | null;
  isSubjectProperty?: boolean | null;
  propertyType?: DtoPropertyType | null;
  /** @format decimal */
  monthlyHazardInsurance?: number | null;
  /** @format decimal */
  monthlyTaxes?: number | null;
  /** @format decimal */
  monthlyAssociationDues?: number | null;
  /** @format decimal */
  reopitiaAmount?: number | null;
  pymtIncludesTaxInsFlag?: boolean;
  associatedLiabilities?: DtoV1CreditValidationLiability[] | null;
  results?: DtoV1ValidationResultRuleResult[] | null;
  isValidationCompleted?: boolean;
  isReviewBreakdownCompleted?: boolean;
  occupancyType?: DtoV1EnumOccupancyType | null;
  occupancyTypeDescription?: string | null;
  taxDocumentIds?: number[] | null;
  mortgageStatementDocumentIds?: number[] | null;
  documents?: DtoV1DocumentSelection[] | null;
}

export interface DtoV1RealEstateOwnedRealEstateOwnedForSummary {
  addressId?: DtoIdentitiesAddressIdentifier | null;
  propertyStatus?: DtoV1EnumPropertyStatus | null;
  propertyAddress?: DtoV1RealEstateOwnedPropertyAddressForSummary | null;
  isSubjectProperty?: boolean | null;
  propertyType?: DtoPropertyType | null;
  associatedLiabilities?: DtoV1RealEstateOwnedLiabilityForSummary[] | null;
  /** @format decimal */
  monthlyHazardInsurance?: number | null;
  /** @format decimal */
  monthlyAssociationDues?: number | null;
  /** @format decimal */
  monthlyTaxes?: number | null;
  pymtIncludesTaxInsFlag?: boolean;
  /** @format decimal */
  netRentalIncome?: number | null;
  occupancyType?: DtoV1EnumOccupancyType | null;
  /** @format decimal */
  rentalIncome?: number | null;
  /** @format decimal */
  reopitiaAmount?: number | null;
  isValidationCompleted?: boolean;
  isReviewBreakdownCompleted?: boolean;
  ownership?: string | null;
  /** @format int32 */
  customerRecordId?: number | null;
  overrideReturnTaxAmount?: boolean | null;
  overrideReturnHOIAmount?: boolean | null;
  overrideReturnHOADuesAmount?: boolean | null;
}

export interface DtoV1RealEstateOwnedRealEstateOwnedSummaryRecord {
  addressId?: DtoIdentitiesAddressIdentifier | null;
  propertyStatus?: DtoV1EnumPropertyStatus | null;
  propertyAddress?: DtoV1RealEstateOwnedPropertyAddressForSummary | null;
  isSubjectProperty?: boolean | null;
  propertyType?: DtoPropertyType | null;
  associatedLiabilities?: DtoV1RealEstateOwnedLiabilityForSummary[] | null;
  /** @format decimal */
  monthlyHazardInsurance?: number | null;
  /** @format decimal */
  monthlyAssociationDues?: number | null;
  /** @format decimal */
  monthlyTaxes?: number | null;
  pymtIncludesTaxInsFlag?: boolean;
  /** @format decimal */
  netRentalIncome?: number | null;
  occupancyType?: DtoV1EnumOccupancyType | null;
  associatedBorrowers?: DtoV1RealEstateOwnedBorrowerForSummary[] | null;
  /** @format decimal */
  marketValue?: number | null;
  /** @format decimal */
  mortgageBalance?: number | null;
  /** @format decimal */
  mortgagePayment?: number | null;
  /** @format decimal */
  monthlyFloodInsurance?: number | null;
  /** @format decimal */
  leaseGroundRents?: number | null;
  /** @format decimal */
  otherExpenses?: number | null;
  /** @format decimal */
  totalMonthlyExpenses?: number | null;
  /** @format decimal */
  grossRentalIncome?: number | null;
  /** @format decimal */
  adjustedGrossRentalIncome?: number | null;
  /** @format int32 */
  vacancyFactor?: number | null;
  reoPitiaVerifiedByUW?: boolean;
  overrideTaxesFromCalculator?: boolean;
  overrideHoiFromCalculator?: boolean;
  overrideHoaFromCalculator?: boolean;
  propertyStatusString?: string | null;
  occupancyTypeDescription?: string | null;
  /** @format int32 */
  escrowedOnProperty?: number;
}

export interface DtoV1RealEstateOwnedRealEstateOwnedSummaryResponse {
  realEstateOwned?: DtoV1RealEstateOwnedRealEstateOwnedSummaryRecord[] | null;
  dropDownOptions?: Record<
    string,
    KeyValuePairSystemInt32SystemString[] | null
  >;
  availableBorrowers?: DtoV1Borrower[] | null;
  hasWritePermission?: boolean;
}

export interface DtoV1RealEstateOwnedSaveRealEstateOwnedMultipleRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  saveRealEstateOwnedRequests?:
    | DtoV1RealEstateOwnedSaveRealEstateOwnedRequest[]
    | null;
}

export interface DtoV1RealEstateOwnedSaveRealEstateOwnedRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  isInsuranceAndTaxesEscrowed?: boolean | null;
  /** @format decimal */
  monthlyInsuranceAmount?: number | null;
  /** @format decimal */
  monthlyTaxesAmount?: number | null;
  /** @format decimal */
  monthlyHOAAmount?: number | null;
}

export interface DtoV1RealEstateOwnedSaveRealEstateOwnedSummaryRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  customerRecordIds?: DtoIdentitiesCustomerIdentifier[] | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  propertyAddress?: DtoV1RealEstateOwnedPropertyAddressForSummary | null;
  propertyTypeId?: DtoV1EnumPropertyType;
  occupancyTypeId?: DtoV1EnumOccupancyType;
  propertyStatusId?: DtoV1EnumPropertyStatus;
  /** @format decimal */
  presentvalue?: number | null;
  /** @format decimal */
  monthlyFloodInsurance?: number | null;
  /** @format decimal */
  monthlyAssociationDues?: number | null;
  /** @format decimal */
  grossRentalIncome?: number | null;
  /** @format decimal */
  monthlyGroundRent?: number | null;
  hasGrossRentalIncomeChanged?: boolean | null;
  isSubjectProperty?: boolean;
}

export interface DtoV1RuleDetails {
  /** @format int32 */
  ruleId?: number;
  ruleDisplayTitle?: string | null;
  ruleDisplayDescription?: string | null;
  /** @format int32 */
  categoryId?: number;
  /** @format int32 */
  subCategoryId?: number;
  /** @format int32 */
  parentRuleId?: number | null;
}

export interface DtoV1RuleResult {
  ruleDetails?: DtoV1RuleDetails | null;
  /** @format int32 */
  status?: number;
  message?: string | null;
  additionalData?: Record<string, string | null>;
  questions?: DtoV1Question[] | null;
}

export interface DtoV1RunAllRulesRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV1RunAllRulesResponse {
  success?: boolean;
}

export interface DtoV1RunCalculationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  requestReferenceType?: DtoV1EnumRequestReferenceType;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  rentalAddressId?: DtoIdentitiesAddressIdentifier | null;
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number;
  isDataChanged?: boolean;
  documentDetails?:
    | DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentDetail[]
    | null;
  userName?: string | null;
}

export interface DtoV1RunSmartCalculationRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  requestReferenceType?: DtoV1EnumRequestReferenceType;
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  rentalAddressId?: DtoIdentitiesAddressIdentifier | null;
  /** @format int32 */
  calculatorTypeId?: number;
  /** @format int32 */
  calculationId?: number;
  isDataChanged?: boolean;
  documentDetails?:
    | DtoV1IncomeCalculatorGenericCalculatorCalculationDocumentDetail[]
    | null;
  userName?: string | null;
  formValues?: DtoV1EmploymentIncomeSmartCalculationInitialFormValues | null;
}

export interface DtoV1SaveQuestionAnswersRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  userResponses?: DtoV1QuestionUserResponse[] | null;
}

export interface DtoV1SaveQuestionAnswersResponse {
  success?: boolean;
}

export interface DtoV1Snippet {
  text?: string | null;
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  boundingBoxes?: DtoV1BoundingBox[] | null;
}

export interface DtoV1SocialSecurityNumberExtracted {
  socialSecurityNumber?: string | null;
  /** @format int64 */
  socialSecurityNumberExtractedDataResultId?: number;
  /** @format int32 */
  socialSecurityNumberDocumentFieldId?: number;
  boundingBoxCoordinates?: DtoV1BoundingBox[] | null;
}

export interface DtoV1StatusAndReviewDenialReasonsToggleResponse {
  isToggleOn?: boolean;
  isSuspense?: boolean;
}

export interface DtoV1StatusAndReviewDenialReasonsToggleSaveRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  isToggleOn?: boolean;
  /** @format int32 */
  userId?: number | null;
  email?: string | null;
}

export interface DtoV1StatusAndReviewSaveInvalidProductOverrideReasonRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  isInvalidProductOverridden?: boolean;
  invalidProductOverrideComment?: string | null;
}

export interface DtoV1StatusAndReviewStatusAndReviewAlert {
  title?: string | null;
  description?: string | null;
  severity?: DtoV1EnumValidationResultAlertStyle;
}

export interface DtoV1StatusAndReviewStatusAndReviewDetails {
  hasNoOutstandingCounteroffer?: boolean;
  hasValidProduct?: boolean;
  isAusValid?: boolean;
  hasFraudGuard?: boolean;
  ausRanOnStatusAndReview?: boolean;
  haveDenialReasonsBeenReviewed?: boolean;
  hasDenialReasons?: boolean;
  outstandingCounterOfferAlertDetails?: DtoV1StatusAndReviewStatusAndReviewAlert | null;
  secondReviewDenialReasonsAlertDetails?: DtoV1StatusAndReviewStatusAndReviewAlert | null;
  noDenialReasonsAlert?: DtoV1StatusAndReviewStatusAndReviewAlert | null;
  ausInvalidAlertDetails?: DtoV1StatusAndReviewStatusAndReviewAlert | null;
  ausOutdatedAlertDetails?: DtoV1StatusAndReviewStatusAndReviewAlert | null;
}

export interface DtoV1StatusAndReviewSuspenseReasons {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  isIncompleteDocuments?: boolean;
  isCreditIssues?: boolean;
}

export interface DtoV1SubjectPropertyPropertyReviewType {
  /** @format int32 */
  formTypeId?: number;
  formNumber: string | null;
  description: string | null;
}

export interface DtoV1SubjectPropertyPropertyUnitInfo {
  unitNumber?: string | null;
  /** @format int32 */
  numberOfBedrooms?: number | null;
  /** @format decimal */
  grossMonthlyRents?: number | null;
}

export interface DtoV1SubjectPropertySaveSubjectPropertyInfoRequest {
  purposeType?: UWMCLibraryCommonDomainEnumsPurposeType;
  occupancyType?: UWMCLibraryCommonDomainEnumsOccupancyType;
  propertyType?: UWMCLibraryCommonDomainEnumsPropertyType;
  attachedPropertyType?: UWMCLibraryCommonDomainEnumsAttachedPropertyType;
  /** @format int32 */
  rentalIncomeDocTypeId?: number | null;
  mixedUseProperty?: boolean | null;
  ruralProperty?: boolean | null;
  /** @format decimal */
  sellerEscrowHoldbackAmount?: number | null;
  propertyAddress?: DtoV1PropertyInformationPropertyAddress | null;
  /** @format decimal */
  appraisedValue?: number | null;
  parcelId?: string | null;
  /** @format int32 */
  currentAddressId?: number | null;
  /** @format int32 */
  yearBuilt?: number | null;
  /** @format int32 */
  numberOfUnits?: number | null;
  /** @format int32 */
  squareFootage?: number | null;
  /** @format decimal */
  numberOfAcres?: number | null;
  /** @format int32 */
  propertyValueFormType?: number | null;
  propertyReviewFormNum?: string | null;
  appraisalFileIdNum?: string | null;
  /** @format decimal */
  percentRentalIncome?: number | null;
  /** @format decimal */
  rentalIncome?: number | null;
  /** @format decimal */
  totalNetRentalIncome?: number | null;
  requiredImprovements?: string | null;
  buildingStatus?: string | null;
  /** @format decimal */
  adjustedRentalIncome?: number | null;
  /** @format decimal */
  assuranceCompletionAmount?: number | null;
  comments?: string | null;
  units?: DtoV1SubjectPropertyPropertyUnitInfo[] | null;
  /** @format decimal */
  monthlyHOADues?: number | null;
  verifiedByUnderwriter?: boolean | null;
  propertyName?: string | null;
  cpmProjectId?: string | null;
  homeownersAssocEin?: string | null;
  /** @format int32 */
  projectDesignTypeId?: number | null;
  /** @format int32 */
  classification?: number | null;
  /** @format int32 */
  classification3?: number | null;
  /** @format int32 */
  condoProjDetachedFlag?: number | null;
  /** @format int32 */
  numberOfCondoUnits?: number | null;
  /** @format int32 */
  numberOfUnitsSold?: number | null;
  warrantable?: boolean;
  /** @format int32 */
  lengthInFeet?: number | null;
  /** @format int32 */
  widthInFeet?: number | null;
  serialNumber?: string | null;
  model?: string | null;
  hudLabelNumber?: string | null;
  make?: string | null;
  /** @format int32 */
  newOrUsedIndicator?: number | null;
  /** @format int32 */
  attachToFoundationFlag?: number | null;
  /** @format date-time */
  questionnaireEffectiveDate?: string | null;
  /** @format date-time */
  questionnaireExpirationDate?: string | null;
  /** @format date-time */
  budgetEffectiveDate?: string | null;
  /** @format date-time */
  budgetExpirationDate?: string | null;
  /** @format int32 */
  isQuestionnaireExpirationDateOverriden?: number | null;
  certOfTitleType?: string | null;
  /** @format int32 */
  mobileHomeParkFlag?: number | null;
  /** @format date-time */
  masterInsuranceEffectiveDate?: string | null;
  /** @format date-time */
  masterInsuranceExpirationDate?: string | null;
  assuranceOfCompletion?: string | null;
  coopMaintenanceFee?: string | null;
  phaseId?: string | null;
  fannieCpmCertificationId?: string | null;
  projectAssessmentsResultsNum?: string | null;
  condoProjectWaiverRequestNum?: string | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  userId?: number | null;
  userEmail?: string | null;
}

export interface DtoV1SubjectPropertySubjectPropertyAssociatedReo {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  county?: string | null;
  /** @format int32 */
  addressId?: number;
  addressLine2?: string | null;
  country?: string | null;
  /** @format int32 */
  currentAddressId?: number;
}

export interface DtoV1SubjectPropertySubjectPropertySummaryResponse {
  purposeType?: UWMCLibraryCommonDomainEnumsPurposeType;
  occupancyType?: UWMCLibraryCommonDomainEnumsOccupancyType;
  propertyType?: UWMCLibraryCommonDomainEnumsPropertyType;
  attachedPropertyType?: UWMCLibraryCommonDomainEnumsAttachedPropertyType;
  /** @format int32 */
  rentalIncomeDocTypeId?: number | null;
  mixedUseProperty?: boolean | null;
  ruralProperty?: boolean | null;
  /** @format decimal */
  sellerEscrowHoldbackAmount?: number | null;
  propertyAddress?: DtoV1PropertyInformationPropertyAddress | null;
  /** @format decimal */
  appraisedValue?: number | null;
  parcelId?: string | null;
  /** @format int32 */
  currentAddressId?: number | null;
  /** @format int32 */
  yearBuilt?: number | null;
  /** @format int32 */
  numberOfUnits?: number | null;
  /** @format int32 */
  squareFootage?: number | null;
  /** @format decimal */
  numberOfAcres?: number | null;
  /** @format int32 */
  propertyValueFormType?: number | null;
  propertyReviewFormNum?: string | null;
  appraisalFileIdNum?: string | null;
  /** @format decimal */
  percentRentalIncome?: number | null;
  /** @format decimal */
  rentalIncome?: number | null;
  /** @format decimal */
  totalNetRentalIncome?: number | null;
  requiredImprovements?: string | null;
  buildingStatus?: string | null;
  /** @format decimal */
  adjustedRentalIncome?: number | null;
  /** @format decimal */
  assuranceCompletionAmount?: number | null;
  comments?: string | null;
  units?: DtoV1SubjectPropertyPropertyUnitInfo[] | null;
  /** @format decimal */
  monthlyHOADues?: number | null;
  verifiedByUnderwriter?: boolean | null;
  propertyName?: string | null;
  cpmProjectId?: string | null;
  homeownersAssocEin?: string | null;
  /** @format int32 */
  projectDesignTypeId?: number | null;
  /** @format int32 */
  classification?: number | null;
  /** @format int32 */
  classification3?: number | null;
  /** @format int32 */
  condoProjDetachedFlag?: number | null;
  /** @format int32 */
  numberOfCondoUnits?: number | null;
  /** @format int32 */
  numberOfUnitsSold?: number | null;
  warrantable?: boolean;
  /** @format int32 */
  lengthInFeet?: number | null;
  /** @format int32 */
  widthInFeet?: number | null;
  serialNumber?: string | null;
  model?: string | null;
  hudLabelNumber?: string | null;
  make?: string | null;
  /** @format int32 */
  newOrUsedIndicator?: number | null;
  /** @format int32 */
  attachToFoundationFlag?: number | null;
  /** @format date-time */
  questionnaireEffectiveDate?: string | null;
  /** @format date-time */
  questionnaireExpirationDate?: string | null;
  /** @format date-time */
  budgetEffectiveDate?: string | null;
  /** @format date-time */
  budgetExpirationDate?: string | null;
  /** @format int32 */
  isQuestionnaireExpirationDateOverriden?: number | null;
  certOfTitleType?: string | null;
  /** @format int32 */
  mobileHomeParkFlag?: number | null;
  /** @format date-time */
  masterInsuranceEffectiveDate?: string | null;
  /** @format date-time */
  masterInsuranceExpirationDate?: string | null;
  assuranceOfCompletion?: string | null;
  coopMaintenanceFee?: string | null;
  phaseId?: string | null;
  fannieCpmCertificationId?: string | null;
  projectAssessmentsResultsNum?: string | null;
  condoProjectWaiverRequestNum?: string | null;
  /** @format int32 */
  propertyRecordId?: number;
  fipsCountyCode?: string | null;
  isAppraisalEditable?: boolean;
  /** @format decimal */
  proposedPrincipalAndInterestPayment?: number | null;
  /** @format decimal */
  proposedOtherFinancing?: number | null;
  /** @format decimal */
  proposedMortgageInsurance?: number | null;
  /** @format decimal */
  proposedRealEstateTaxes?: number | null;
  /** @format decimal */
  proposedHazardInsurance?: number | null;
  /** @format decimal */
  proposedFloodInsurance?: number | null;
  /** @format decimal */
  proposedUtility?: number | null;
  /** @format decimal */
  proposedGroundRent?: number | null;
  /** @format decimal */
  proposedSpecialAssessments?: number | null;
  /** @format decimal */
  proposedMaintenance?: number | null;
  /** @format date-time */
  expectedRepairsCompletionDate?: string | null;
  propertyReviewTypes?: DtoV1SubjectPropertyPropertyReviewType[] | null;
  associatedReos?: DtoV1SubjectPropertySubjectPropertyAssociatedReo[] | null;
  hasPropertyInspectionWaiver?: boolean | null;
  isRentalIncomeCalculatorCompleted?: boolean;
  /** @format decimal */
  proposedAssociationDues?: number | null;
}

export interface DtoV1SubmitToSetupAllowBoltApprovalResponse {
  canSubmitBoltApproval?: boolean;
  canSubmitToSetup?: boolean;
  submissionAlerts?: DtoV1SubmitToSetupSubmissionAlert[] | null;
}

export interface DtoV1SubmitToSetupFinalReviewInitialValidationsResponse {
  canRunAusValidations?: boolean;
  canSubmitToSetup?: boolean;
  skipAusFlag?: boolean;
  submissionAlerts?: DtoV1SubmitToSetupSubmissionAlert[] | null;
}

export interface DtoV1SubmitToSetupSubmissionAlert {
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  severity?: number;
  shouldShowBailoutMessage?: boolean;
}

export interface DtoV1SubmitToSetupSubmitToSetupRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  confirmed?: boolean;
}

export interface DtoV1SubordinateFinancingSaveSubordinateFinancingRequest {
  creditorName?: string | null;
  /** @format decimal */
  subordinateFinancingAmount?: number;
  /** @format decimal */
  noteRate?: number;
  /** @format int32 */
  paymentsPerYear?: number;
  /** @format int32 */
  numberOfPayments?: number;
  /** @format int32 */
  amortizingTerm?: number;
  /** @format decimal */
  paymentAmount?: number | null;
  helocFlag?: boolean;
  /** @format decimal */
  highestBalance?: number;
  interestOnly?: boolean;
  isCommunitySecond?: boolean;
  /** @format int32 */
  selectedCommunitySecondOption?: number | null;
  /** @format decimal */
  undrawnAmount?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  deleteSubordinateFinancing?: boolean | null;
}

export interface DtoV1SubordinateFinancingSubordinateFinancingResponse {
  creditorName?: string | null;
  /** @format decimal */
  subordinateFinancingAmount?: number;
  /** @format decimal */
  noteRate?: number;
  /** @format int32 */
  paymentsPerYear?: number;
  /** @format int32 */
  numberOfPayments?: number;
  /** @format int32 */
  amortizingTerm?: number;
  /** @format decimal */
  paymentAmount?: number | null;
  helocFlag?: boolean;
  /** @format decimal */
  highestBalance?: number;
  interestOnly?: boolean;
  isCommunitySecond?: boolean;
  /** @format int32 */
  selectedCommunitySecondOption?: number | null;
  /** @format decimal */
  undrawnAmount?: number;
  isHomeTownHeroSubordinateFinancingFieldReadOnly?: boolean;
}

export interface DtoV1TaxYearExtracted {
  taxYear?: string | null;
  /** @format int64 */
  taxYearExtractedDataResultId?: number;
  /** @format int32 */
  taxYearDocumentFieldId?: number;
  boundingBoxCoordinates?: DtoV1BoundingBox[] | null;
  iconType?: DtoV1EnumIconType;
}

export interface DtoV1UnderWriterGetUWDateTrackingDataResponse {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  cannotCloseBeforeDateTracking?: DtoV1UnderWriterUWCloseDate[] | null;
  mustCloseByDateTracking?: DtoV1UnderWriterUWCloseDate[] | null;
}

export interface DtoV1UnderWriterSaveUWDateTrackingRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  cannotCloseBeforeDateTracking?: DtoV1UnderWriterUWCloseDate[] | null;
  mustCloseByDateTracking?: DtoV1UnderWriterUWCloseDate[] | null;
}

export interface DtoV1UnderWriterUWCloseDate {
  /** @format int64 */
  id?: number | null;
  /** @format date-time */
  date?: string | null;
  reason?: string | null;
}

export interface DtoV1UnderwriterVerifiedRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int32 */
  ruleResultId?: number;
  isUnderwriterVerified?: boolean;
}

export interface DtoV1UnderwritingMessage {
  underwritingMethod?: DtoV1EnumUnderwritingMethod;
  message?: string | null;
}

export interface DtoV1UnderwritingSummariesIncomeCpaInformation {
  /** @format int32 */
  customerCpaDetailId?: number | null;
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  employerId?: number;
  cpaFirstName?: string | null;
  cpaMiddleName?: string | null;
  cpaLastName?: string | null;
  cpaCompanyName?: string | null;
}

export interface DtoV1UnderwritingSummariesIncomeCustomerEmployment {
  /** @format int32 */
  customerLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  employerId?: number;
  employerName?: string | null;
  currentEmployment?: boolean | null;
  incomeSource?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  verifiedDate?: string | null;
  monthlyIncome?: string | null;
  monthlyIncomeDetails?:
    | DtoV1UnderwritingSummariesIncomeMonthlyIncomeDetails[]
    | null;
  cpaInformation?: DtoV1UnderwritingSummariesIncomeCpaInformation[] | null;
  /** @format decimal */
  percentBusinessOwned?: number;
  /** @format int32 */
  empByPartyToTranFlag?: number;
  /** @format int32 */
  yearsOnJob?: number;
  /** @format int32 */
  monthsOnJob?: number;
  primaryEmployment?: boolean;
  selfEmployed?: boolean;
  employerAddress?: DtoV1Address | null;
  country?: string | null;
  employerPhone?: string | null;
  title?: string | null;
  typeOfBusiness?: string | null;
  /** @format decimal */
  monthlyAmount?: number;
}

export interface DtoV1UnderwritingSummariesIncomeEmploymentDetail {
  incomeIdentifier?: DtoIdentitiesIncomeIdentifier | null;
  incomeType?: DtoV1EnumIncomeType;
  /** @format decimal */
  monthlyNetIncome?: number | null;
  /** @format date-time */
  incomeVerifiedDate?: string | null;
}

export interface DtoV1UnderwritingSummariesIncomeMonthlyIncomeDetails {
  /** @format int32 */
  sequenceNumber?: number;
  name?: string | null;
  type?: string | null;
  /** @format decimal */
  amount?: number;
  /** @format date-time */
  incomeVerifiedDate?: string | null;
}

export interface DtoV1UnderwritingSummariesIncomeSaveEmploymentAndDetailsRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  incomeIdentifier: DtoIdentitiesIncomeIdentifier;
  /** @format int32 */
  customerRecordIdOriginal?: number | null;
  /** @format int32 */
  userId?: number | null;
  employerName?: string | null;
  employmentType?: string | null;
  isW2Employment?: boolean | null;
  /** @format date-time */
  beginDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  employerAddress?: DtoV1AddressExtended | null;
  /** @format decimal */
  percentageOwnership?: number | null;
  /** @format date-time */
  incomeVerifiedDate?: string | null;
  /** @format date-time */
  verifiedDate?: string | null;
  primaryEmployment?: string | null;
  employerPhone?: string | null;
  cpaInformation?: DtoV1UnderwritingSummariesIncomeCpaInformation[] | null;
  isCurrentEmployment?: boolean;
  country?: string | null;
  /** @format int32 */
  empByPartyToTranFlag?: number | null;
  selfEmployed?: boolean | null;
  title?: string | null;
  typeOfBusiness?: string | null;
  employmentDetails?: DtoV1UnderwritingSummariesIncomeEmploymentDetail[] | null;
  shouldInactivateNonApplicableCalculations?: boolean;
  shouldTriggerUwaiEntityMatching?: boolean;
}

export interface DtoV1UnderwritingSummariesIncomeUnderwritingSummaryIncomeData {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  allBorrowers?: DtoV1Borrower[] | null;
  employmentReviewDetail?:
    | DtoV1UnderwritingSummariesIncomeCustomerEmployment[]
    | null;
  hasWritePermission?: boolean;
}

export interface DtoV1UnderwritingSummariesLiabilityDeleteLiabilitiesRequest {
  obfuscatedLoanIdentifier: DtoIdentitiesObfuscatedLoanIdentifier;
  /** @minItems 1 */
  liabilitiesToDelete: DtoIdentitiesLiabilityIdentifier[];
}

export interface DtoV1UnderwritingSummariesLiabilityLiabilityDataOnly {
  liabilityIdentifier?: DtoIdentitiesLiabilityIdentifier | null;
  liabilitySummaryType?: DtoV1UnderwritingSummariesLiabilityLiabilitySummaryType | null;
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number | null;
  /** @format decimal */
  payment?: number | null;
  excludeBalance?: boolean | null;
  excludePayment?: boolean | null;
  exclusionReason?: DtoV1EnumExclusionReason | null;
  payoffRequired?: boolean | null;
  lienPosition?: DtoV1UnderwritingSummariesLiabilityLienPosition | null;
  ownerOfMortgage?: DtoV1EnumOwnerOfMortgage | null;
  isCurrentlyServicedByInstitution?: boolean | null;
  isCurrentlyFHAInsured?: boolean | null;
  /** @format decimal */
  payoffAmount?: number | null;
  /** @format date-time */
  creditReportOpenedDate?: string | null;
  /** @format decimal */
  originalSalesPrice?: number | null;
  /** @format int32 */
  originalTerm?: number | null;
  /** @format date-time */
  originalNextAdjustment?: string | null;
  /** @format decimal */
  mostRecentAppraisedValue?: number | null;
  /** @format date-time */
  originalFirstPaymentDate?: string | null;
  /** @format decimal */
  originalMonthlyMiAmount?: number | null;
  /** @format int32 */
  numberOfPaymentsMade?: number | null;
  /** @format decimal */
  highestBalance?: number | null;
  /** @format decimal */
  originalInterestRate?: number | null;
  /** @format decimal */
  originalApr?: number | null;
  /** @format int32 */
  originalTermRemaining?: number | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  originalMortgageType?: DtoV1EnumOriginalMortgageType | null;
  originalMortgageDesc?: DtoV1EnumOriginalMortgageDescription | null;
  originalSectionAct?: DtoV1EnumOriginalSectionAct | null;
  originalMortgageLoanPurpose?: DtoV1EnumOriginalMortgagePurpose | null;
  /** @format decimal */
  presentPAndI?: number | null;
  customerIdentifiers?: DtoIdentitiesBorrowerIdentifier[] | null;
  /** @format int32 */
  remainingTerm?: number | null;
}

export interface DtoV1UnderwritingSummariesLiabilityLiabilityDropdownOptions {
  availableLiabilityTypes?: DtoV1Option[] | null;
  availableExclusionReasons?: DtoV1Option[] | null;
  availableRealEstateProperties?: DtoV1Option[] | null;
  availableLienPositions?: DtoV1Option[] | null;
  availableOwnersOfMortgage?: DtoV1Option[] | null;
  availableOriginalMortgageType?: DtoV1Option[] | null;
  availableOriginalMortgageDesc?: DtoV1Option[] | null;
  availableOriginalSectionAct?: DtoV1Option[] | null;
  availableOriginalMortgageLoanPurpose?: DtoV1Option[] | null;
}

export interface DtoV1UnderwritingSummariesLiabilityLiabilitySummaryRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  dropdownOptionsNeeded?: boolean;
}

export interface DtoV1UnderwritingSummariesLiabilityLiabilitySummaryResponse {
  liabilities?: DtoV1UnderwritingSummariesLiabilityLiabilityDataOnly[] | null;
  dropdownOptions?: DtoV1UnderwritingSummariesLiabilityLiabilityDropdownOptions | null;
  availableBorrowers?: DtoV1Borrower[] | null;
  vaSummaryData?: DtoV1UnderwritingSummariesLiabilityVaLiabilitySummaryData | null;
  hasWritePermission?: boolean;
}

export interface DtoV1UnderwritingSummariesLiabilitySaveLiabilityRequest {
  liabilityIdentifier?: DtoIdentitiesLiabilityIdentifier | null;
  liabilitySummaryType?: DtoV1UnderwritingSummariesLiabilityLiabilitySummaryType | null;
  creditorName?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number | null;
  /** @format decimal */
  payment?: number | null;
  excludeBalance?: boolean | null;
  excludePayment?: boolean | null;
  exclusionReason?: DtoV1EnumExclusionReason | null;
  payoffRequired?: boolean | null;
  lienPosition?: DtoV1UnderwritingSummariesLiabilityLienPosition | null;
  ownerOfMortgage?: DtoV1EnumOwnerOfMortgage | null;
  isCurrentlyServicedByInstitution?: boolean | null;
  isCurrentlyFHAInsured?: boolean | null;
  /** @format decimal */
  payoffAmount?: number | null;
  /** @format date-time */
  creditReportOpenedDate?: string | null;
  /** @format decimal */
  originalSalesPrice?: number | null;
  /** @format int32 */
  originalTerm?: number | null;
  /** @format date-time */
  originalNextAdjustment?: string | null;
  /** @format decimal */
  mostRecentAppraisedValue?: number | null;
  /** @format date-time */
  originalFirstPaymentDate?: string | null;
  /** @format decimal */
  originalMonthlyMiAmount?: number | null;
  /** @format int32 */
  numberOfPaymentsMade?: number | null;
  /** @format decimal */
  highestBalance?: number | null;
  /** @format decimal */
  originalInterestRate?: number | null;
  /** @format decimal */
  originalApr?: number | null;
  /** @format int32 */
  originalTermRemaining?: number | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  originalMortgageType?: DtoV1EnumOriginalMortgageType | null;
  originalMortgageDesc?: DtoV1EnumOriginalMortgageDescription | null;
  originalSectionAct?: DtoV1EnumOriginalSectionAct | null;
  originalMortgageLoanPurpose?: DtoV1EnumOriginalMortgagePurpose | null;
  /** @format decimal */
  presentPAndI?: number | null;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  remainingTerm?: number | null;
  customerIdentifiers?: DtoIdentitiesCustomerIdentifier[] | null;
}

export interface DtoV1UnderwritingSummariesLiabilityVaLiabilitySummaryData {
  isUwmToUwm?: boolean;
  loanProduct?: UWMCLibraryCommonDomainEnumsLoanProductType;
  loanPurpose?: UWMCLibraryCommonDomainEnumsLoanPurposeType;
  refinancePurpose?: UWMCLibraryCommonDomainEnumsRefiPurposeType;
}

export interface DtoV1VACaivrsAuthorizationDetails {
  authorizationNumber?: string | null;
  debtInformation?: DtoV1VADebtInformation[] | null;
}

export interface DtoV1VAChangeInObligorFormValues {
  originalLoanBorrowers?: DtoV1BorrowerData[] | null;
  currentLoanBorrowers?: DtoV1BorrowerData[] | null;
  doesBorrowerMatchLin?: string | null;
  purchaserNameListed?: string | null;
  changeInObligor?: string | null;
  changeInMaritalStatus?: string | null;
  veteranDeceasedOrSurvivingSpouse?: string | null;
  survivingSpouseObligated?: string | null;
  certificateOfEligibilityProvided?: string | null;
  substitutionOfEntitlementProvided?: string | null;
  letterOfExplanationProvided?: string | null;
}

export interface DtoV1VAChangeInObligorSaveRequest {
  originalLoanBorrowers?: DtoV1BorrowerData[] | null;
  currentLoanBorrowers?: DtoV1BorrowerData[] | null;
  doesBorrowerMatchLin?: string | null;
  purchaserNameListed?: string | null;
  changeInObligor?: string | null;
  changeInMaritalStatus?: string | null;
  veteranDeceasedOrSurvivingSpouse?: string | null;
  survivingSpouseObligated?: string | null;
  certificateOfEligibilityProvided?: string | null;
  substitutionOfEntitlementProvided?: string | null;
  letterOfExplanationProvided?: string | null;
  changeInObligorScenario?: string | null;
}

export interface DtoV1VAChangeInObligorScreenData {
  verbiages?: DtoV1VAChangeInObligorVerbiage[] | null;
  isUwmToUwm?: boolean;
  borrowerSsnMatch?: boolean;
  changeInObligorScenario?: string | null;
}

export interface DtoV1VAChangeInObligorVerbiage {
  questionName?: string | null;
  verbiage?: string | null;
}

export interface DtoV1VADebtInformation {
  agencyName?: string | null;
  caseNumber?: string | null;
  caseType?: string | null;
  phoneReferral?: string | null;
  debtResolution?: DtoV1VADebtResolution;
}

export interface DtoV1VADocumentDetailResponse {
  /** @format int64 */
  documentId?: number;
  documentTypeKeyName?: string | null;
  /** @format int64 */
  documentTypeId?: number;
  documentDetails?: DtoV1VADocumentDetails[] | null;
}

export interface DtoV1VADocumentDetails {
  /** @format int32 */
  documentFieldId?: number;
  documentFieldName?: string | null;
  fieldValue?: string | null;
  /** @format int64 */
  extractedDataResultId?: number;
  /** @format int64 */
  actualExtractedDataResultId?: number;
  /** @format int32 */
  pageNumber?: number | null;
  boundingBox?: string | null;
  confidence?: string | null;
  vibe?: string | null;
  answerSource?: UWMCLibraryCommonDomainEnumsAnswerSource | null;
}

export interface DtoV1VADocumentReviewLoanModificationDocumentData {
  /** @format int64 */
  documentId?: number | null;
  borrowerNames?: string[] | null;
  /** @format date */
  effectiveDate?: string | null;
  /** @format decimal */
  interestRate?: number | null;
  /** @format decimal */
  originalLoanAmount?: number | null;
  mortgageDescription?: string | null;
  /** @format decimal */
  monthlyPayment?: number | null;
  /** @format date */
  firstPaymentDueDate?: string | null;
  /** @format date */
  maturityDate?: string | null;
  /** @format int32 */
  term?: number | null;
  loanModificationNoDocsAlert?: DtoV1VADocumentReviewLoanModificationNoDocsAlert | null;
}

export interface DtoV1VADocumentReviewLoanModificationNoDocsAlert {
  alertTriggers?: string[] | null;
  creditorName?: string | null;
}

export interface DtoV1VADocumentReviewMortgageStatementFormValues {
  /** @format int64 */
  documentId?: number | null;
  /** @format date */
  statementDate?: string | null;
  isMostRecentStatement?: boolean | null;
  wasFullPaymentMade?: boolean | null;
  /** @format decimal */
  outstandingPrincipalBalance?: number | null;
  /** @format decimal */
  interestRate?: number | null;
  mortgageDescription?: string | null;
  hasDeferredBalance?: boolean | null;
  /** @format decimal */
  principal?: number | null;
  /** @format decimal */
  interest?: number | null;
  /** @format decimal */
  escrow?: number | null;
  escrowType?: UWMCLibraryCommonDomainEnumsEscrowedOnProperty | null;
  /** @format decimal */
  monthlyPayment?: number | null;
  isPITIAtOrAbove20Percent?: boolean | null;
}

export interface DtoV1VADocumentReviewMortgageStatementResponse {
  formValues?: DtoV1VADocumentReviewMortgageStatementFormValues | null;
}

export interface DtoV1VADocumentReviewMortgageStatementSaveRequest {
  /** @format int64 */
  documentId?: number | null;
  /** @format date-time */
  statementDate?: string | null;
  isMostRecentStatement?: boolean | null;
  wasFullPaymentMade?: boolean | null;
  /** @format decimal */
  outstandingPrincipalBalance?: number | null;
  /** @format decimal */
  interestRate?: number | null;
  mortgageDescription?: string | null;
  hasDeferredBalance?: boolean | null;
  /** @format decimal */
  principal?: number | null;
  /** @format decimal */
  interest?: number | null;
  /** @format decimal */
  escrow?: number | null;
  escrowType?: UWMCLibraryCommonDomainEnumsEscrowedOnProperty | null;
  /** @format decimal */
  monthlyPayment?: number | null;
}

export interface DtoV1VADocumentReviewNoteDocumentData {
  formValues?: DtoV1VADocumentReviewNoteFormValues | null;
  documents?: DtoV1VAVADocument[] | null;
}

export interface DtoV1VADocumentReviewNoteFormValues {
  /** @format date */
  noteDate?: string | null;
  /** @format decimal */
  originalLoanAmount?: number | null;
  /** @format decimal */
  interestRate?: number | null;
  mortgageDescription?: string | null;
  /** @format date */
  firstPaymentDueDate?: string | null;
  /** @format date */
  maturityDate?: string | null;
  /** @format decimal */
  monthlyPrincipalAndInterest?: number | null;
  borrowerNames?: string[] | null;
  isConstructionLoanRiderAttached?: boolean | null;
  /** @format int32 */
  mortgageTerm?: number | null;
}

export interface DtoV1VADocumentReviewPayoffSaveRequest {
  /** @format int64 */
  documentId?: number | null;
  /** @format date-time */
  statementDate?: string | null;
  /** @format date-time */
  nextPaymentDueDate?: string | null;
  /** @format decimal */
  interestRate?: number | null;
  mortgageDescription?: string | null;
  hasDeferredBalance?: boolean | null;
  /** @format date-time */
  interestFromDate?: string | null;
  /** @format date-time */
  interestGoodThroughDate?: string | null;
  interestDatesNotPresent?: boolean | null;
  delinquencyCheckNotPresent?: boolean | null;
  interestRateNotPresent?: boolean | null;
  /** @format decimal */
  interestAmountPerDiem?: number | null;
  /** @format decimal */
  totalInterestCollected?: number | null;
}

export interface DtoV1VAForbearanceFormValues {
  /** @format date */
  forbearanceExitDate?: string | null;
  /** @format date */
  datePaymentsResumed?: string | null;
  noForbearanceExitDocumentationProvided?: boolean | null;
  noForbearancePaymentsResumedDocumentationProvided?: boolean | null;
}

export interface DtoV1VAForbearanceReviewRequest {
  /** @format date */
  forbearanceExitDate?: string | null;
  /** @format date */
  datePaymentsResumed?: string | null;
  noForbearanceExitDocumentationProvided?: boolean | null;
  noForbearancePaymentsResumedDocumentationProvided?: boolean | null;
}

export interface DtoV1VAForbearanceReviewResponse {
  formValues?: DtoV1VAForbearanceFormValues | null;
  screenData?: DtoV1VAForbearanceScreenData | null;
}

export interface DtoV1VAForbearanceScreenData {
  creditorName?: string | null;
  activeForbearance?: boolean | null;
  forbearanceInFirstSixMonths?: boolean | null;
}

export interface DtoV1VAGetVAMortgageHistoryResponse {
  /** @format date-time */
  nextPaymentDueDate?: string | null;
  /** @format int32 */
  delinquencyDays?: number | null;
  paymentHistory?: string | null;
  hasRestructureBeenAdded?: boolean | null;
  restructureQuestion?: string | null;
  hasCurrentlyDelinquent?: boolean | null;
  showConvertToCreditQualifying?: boolean;
  deliquencyAlert?: DtoV2ValidationResultAlertMessage | null;
  staticAlerts?: DtoV2ValidationResultAlertMessage[] | null;
}

export interface DtoV1VAMortgageInsurancePlan {
  /** @format int32 */
  mortgageInsuranceId?: number;
  mortgageInsuranceDescription?: string | null;
}

export interface DtoV1VAMortgageSeasoningData {
  /** @format date-time */
  firstPaymentDueDate?: string | null;
  /** @format date-time */
  firstPayment210Days?: string | null;
  /** @format date-time */
  lastPaymentMadeDate?: string | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  /** @format date-time */
  creditReportExpirationDate?: string | null;
  /** @format date-time */
  forbearanceFirstPaymentDate?: string | null;
  /** @format date-time */
  modifiedFirstPaymentDueDate?: string | null;
  /** @format date-time */
  nextPaymentDueDate?: string | null;
  isSeasoningMet?: boolean;
  forbearanceBeforeSixPayments?: boolean;
  leaderOverride?: boolean | null;
  evidenceOfMissedPaymentQuestion?: string | null;
  evidenceOfMissedPayment?: boolean | null;
  /** @format int32 */
  ruleId?: number;
  noDocProvided?: boolean | null;
  isOtcLoan?: boolean | null;
  isUserTeamLead?: boolean;
  creditorName?: string | null;
  accountNumber?: string | null;
  alertToShow?: DtoV1ValidationResultAlertMessage[] | null;
  noDocumentationAlert?: DtoV1ValidationResultAlertMessage | null;
  paymentRequirementAlert?: DtoV1ValidationResultAlertMessage | null;
  dayRequirementAlert?: DtoV1ValidationResultAlertMessage | null;
  redStopAlert?: DtoV1ValidationResultAlertMessage[] | null;
}

export interface DtoV1VAMortgageSeasoningSaveRequest {
  /** @format date-time */
  firstPaymentDate?: string | null;
  /** @format date-time */
  firstPayment210DaysDate?: string | null;
  /** @format date-time */
  lastPaymentRecordedDate?: string | null;
  /** @format date-time */
  forbearanceFirstPaymentDate?: string | null;
  /** @format date-time */
  loanModificationDate?: string | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  /** @format date-time */
  nextPaymentDueDate?: string | null;
  leaderOverride?: boolean | null;
  evidenceOfMissedPayments?: boolean | null;
  noDocumentProvided?: boolean | null;
  /** @format int32 */
  numberOfPaymentsMade?: number | null;
  /** @format int32 */
  daysCountedForSeasoning?: number | null;
}

export interface DtoV1VANetTangibleBenefitsData {
  oldMortgageTypeDesc?: string | null;
  /** @format decimal */
  oldInterestRate?: number | null;
  newMortgageTypeDesc?: string | null;
  /** @format decimal */
  newInterestRate?: number | null;
  interestRateLocked?: boolean | null;
  /** @format decimal */
  interestRateReductionAmount?: number | null;
  isRestructureProcessInitiated?: boolean | null;
  isUWMToUWMLoan?: boolean | null;
  isArmToFixed?: boolean | null;
  isLowerInterestRate?: boolean | null;
  loanStatus?: UWMCLibraryCommonDomainEnumsLoanStatus | null;
  alertToShow?: DtoV1ValidationResultAlertMessage | null;
  ruleResult?: DtoV1ValidationResultRuleResult | null;
}

export interface DtoV1VANetTangibleBenefitsSaveRequest {
  isRestructureProcessInitiated?: boolean | null;
}

export interface DtoV1VAPayoffFormValues {
  /** @format int64 */
  documentId?: number | null;
  /** @format date */
  nextPaymentDueDate?: string | null;
  /** @format decimal */
  interestRate?: number | null;
  mortgageDescription?: string | null;
  hasDeferredBalance?: boolean | null;
  /** @format date */
  interestFromDate?: string | null;
  /** @format date */
  interestGoodThroughDate?: string | null;
  interestDatesNotPresent?: boolean | null;
  delinquencyCheckNotPresent?: boolean | null;
  interestRateNotPresent?: boolean | null;
  /** @format decimal */
  interestAmountPerDiem?: number | null;
  /** @format decimal */
  totalInterestCollected?: number | null;
  /** @format date */
  statementDate?: string | null;
  noDocs?: DtoV1VAPayoffNoDocs | null;
}

export interface DtoV1VAPayoffNoDocs {
  isProcessorAssist?: boolean | null;
  creditorName?: string | null;
}

export interface DtoV1VAPayoffResponse {
  formValues?: DtoV1VAPayoffFormValues | null;
}

export interface DtoV1VAPresentPayment {
  /** @format int32 */
  year?: number;
  /** @format int32 */
  month?: number;
  isSelected?: boolean;
  isDisabled?: boolean;
}

export interface DtoV1VAQuestionAnswer {
  questionId?: string | null;
  questionName?: string | null;
  answer?: string | null;
  iconType?: DtoV1EnumIconType;
  answerSource?: UWMCLibraryCommonDomainEnumsAnswerSource;
  aiResponse?: DtoV1AIResponse | null;
}

export interface DtoV1VASaveVANoteRequest {
  /** @format int64 */
  documentId?: number | null;
  /** @format date-time */
  noteDate?: string | null;
  /** @format decimal */
  originalLoanAmount?: number | null;
  /** @format decimal */
  interestRate?: number | null;
  mortgageDescription?: string | null;
  /** @format date-time */
  firstPaymentDueDate?: string | null;
  /** @format date-time */
  maturityDate?: string | null;
  /** @format decimal */
  monthlyPrincipalAndInterest?: number | null;
  borrowerNames?: string[] | null;
  isConstructionLoanRiderAttached?: boolean | null;
  /** @format int32 */
  mortgageTerm?: number | null;
}

export interface DtoV1VAVACaivrsBorrower {
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  socialSecurityNumber?: string | null;
  /** @format int32 */
  borrowerPosition?: number;
  caivrsAuthorizationDetails?: DtoV1VACaivrsAuthorizationDetails | null;
}

export interface DtoV1VAVACaivrsFormValues {
  borrowers?: DtoV1VAVACaivrsBorrower[] | null;
}

export interface DtoV1VAVACaivrsRequest {
  borrowers?: DtoV1VAVACaivrsBorrower[] | null;
}

export interface DtoV1VAVACaivrsResponse {
  formValues?: DtoV1VAVACaivrsFormValues | null;
  documents?: DtoV1VAVADocument[] | null;
  smartAnswers?: Record<string, DtoV1VAQuestionAnswer> | null;
}

export interface DtoV1VAVACaseNumberRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  caseNumber?: string | null;
  originalLIN?: string | null;
  isUwmTitleSponsor?: string | null;
  hasUpdatedIRRRLsCaseNumberAssigned?: string | null;
  isPropertyAddressMatchingCaseNumberAddress?: string | null;
  isFundingFeeExempt?: string | null;
  isLoanIdentificationNumberHasMultipleBorrower?: string | null;
  /** @format int32 */
  mortgageInsuranceId?: number | null;
  mortgageInsuranceDescription?: string | null;
}

export interface DtoV1VAVACaseNumberResponse {
  formValues?: DtoV1VAVAFormValues | null;
  vaDocuments?: DtoV1VAVADocument[] | null;
  questionAnswers?: Record<string, DtoV1VAQuestionAnswer> | null;
}

export interface DtoV1VAVAChangeInObligorResponse {
  screenData?: DtoV1VAChangeInObligorScreenData | null;
  formValues?: DtoV1VAChangeInObligorFormValues | null;
  vaDocuments?: DtoV1VAVADocument[] | null;
  questionAnswers?: Record<string, DtoV1VAQuestionAnswer> | null;
}

export interface DtoV1VAVACreditReportFormValues {
  creditorName?: string | null;
  creditReportOpenDate?: string | null;
  dateLastActivity?: string | null;
  /** @format decimal */
  highCreditAmount?: number | null;
  /** @format decimal */
  balance?: number | null;
  /** @format decimal */
  monthlyPayment?: number | null;
  /** @format int32 */
  term?: number | null;
  paymentsPresent?: boolean | null;
  selectedPresentPayments?: DtoV1VAPresentPayment[] | null;
  isEvidenceOfLoanModification?: boolean | null;
  isEvidenceOfActiveForbearance?: boolean | null;
  isEvidenceOfForbearanceInterruptingFirst6Payments?: boolean | null;
  estimatedClosingDate?: string | null;
  creditReportType?: DtoV1VACreditReportType | null;
  isMortgageTransferred?: boolean | null;
  previousTradelinePresentPayments?: DtoV1VAPresentPayment[] | null;
  previousTradelineCreditReportOpenDate?: string | null;
}

export interface DtoV1VAVACreditReportRequest {
  /** @format int64 */
  documentId?: number | null;
  creditReportOpenDate?: string | null;
  dateLastActivity?: string | null;
  /** @format decimal */
  highCreditAmount?: number | null;
  /** @format decimal */
  balance?: number | null;
  /** @format decimal */
  monthlyPayment?: number | null;
  /** @format int32 */
  term?: number | null;
  paymentsPresent?: boolean | null;
  selectedPresentPayments?: DtoV1VAPresentPayment[] | null;
  isEvidenceOfLoanModification?: boolean | null;
  isEvidenceOfActiveForbearance?: boolean | null;
  isEvidenceOfForbearanceInterruptingFirst6Payments?: boolean | null;
  creditorName?: string | null;
  creditReportType?: DtoV1VACreditReportType | null;
  isMortgageTransferred?: boolean | null;
  previousTradelinePresentPayments?: DtoV1VAPresentPayment[] | null;
  previousTradelineCreditReportOpenDate?: string | null;
}

export interface DtoV1VAVACreditReportResponse {
  formValues?: DtoV1VAVACreditReportFormValues | null;
  vaDocuments?: DtoV1VAVADocument[] | null;
}

export interface DtoV1VAVACreditSupplementFormValues {
  creditorName?: string | null;
  creditReportOpenDate?: string | null;
  dateLastActivity?: string | null;
  /** @format decimal */
  highCreditAmount?: number | null;
  /** @format decimal */
  balance?: number | null;
  /** @format decimal */
  monthlyPayment?: number | null;
  /** @format int32 */
  term?: number | null;
  paymentsPresent?: boolean | null;
  selectedPresentPayments?: DtoV1VAPresentPayment[] | null;
  isEvidenceOfLoanModification?: boolean | null;
  isEvidenceOfActiveForbearance?: boolean | null;
  isEvidenceOfForbearanceInterruptingFirst6Payments?: boolean | null;
  estimatedClosingDate?: string | null;
}

export interface DtoV1VAVACreditSupplementRequest {
  /** @format int64 */
  documentId?: number | null;
  creditReportOpenDate?: string | null;
  dateLastActivity?: string | null;
  /** @format decimal */
  highCreditAmount?: number | null;
  /** @format decimal */
  balance?: number | null;
  /** @format decimal */
  monthlyPayment?: number | null;
  /** @format int32 */
  term?: number | null;
  paymentsPresent?: boolean | null;
  selectedPresentPayments?: DtoV1VAPresentPayment[] | null;
  isEvidenceOfLoanModification?: boolean | null;
  isEvidenceOfActiveForbearance?: boolean | null;
  isEvidenceOfForbearanceInterruptingFirst6Payments?: boolean | null;
}

export interface DtoV1VAVACreditSupplementResponse {
  formValues?: DtoV1VAVACreditSupplementFormValues | null;
  vaDocuments?: DtoV1VAVADocument[] | null;
}

export interface DtoV1VAVADocument {
  documentTypeId?: string | null;
  /** @format int64 */
  documentId?: number;
}

export interface DtoV1VAVAFormValues {
  caseNumber?: string | null;
  originalLIN?: string | null;
  isPropertyAddressMatchingCaseNumberAddress?: string | null;
  isUwmTitleSponsor?: string | null;
  hasUpdatedIRRRLsCaseNumberAssigned?: string | null;
  subjectPropertyAddress?: string | null;
  isFundingFeeExempt?: string | null;
  isLoanIdentificationNumberHasMultipleBorrower?: boolean | null;
  mortgageInsurancePlans?: DtoV1VAMortgageInsurancePlan[] | null;
  currentMortgageInsurancePlan?: DtoV1VAMortgageInsurancePlan | null;
  isUwmToUwm?: boolean;
  extractedDocuments?: DtoV1VADocumentDetailResponse[] | null;
}

export interface DtoV1VAVAMortgageHistorySaveRequest {
  hasRestructureBeenAdded?: boolean | null;
  /** @format date-time */
  nextPaymentDueDate?: string | null;
  /** @format int32 */
  daysDelinquent?: number | null;
  paymentHistory?: string | null;
}

export interface DtoV1VAVAPitiResponse {
  /** @format decimal */
  pitiPercentageIncrease?: number | null;
  isInsAndTaxesVerified?: boolean;
  interestRateLocked?: boolean | null;
  /** @format decimal */
  proposedMonthlyPiti?: number;
  /** @format decimal */
  presentMonthlyPiti?: number;
}

export interface DtoV1ValidationResultAlertMessage {
  alertText?: string | null;
  alertStyle?: DtoV1EnumValidationResultAlertStyle;
}

export interface DtoV1ValidationResultAnswer {
  /** @format int32 */
  questionAnswerId?: number;
  answerText?: string | null;
  resolutionMessages?: DtoV1ValidationResultAlertMessage[] | null;
  nextQuestionIds?: number[] | null;
  /** @format int32 */
  sortOrder?: number | null;
  /** @format int32 */
  answerGroupSeq?: number | null;
  fieldType?: string | null;
  detailAnswer?: string | null;
}

export interface DtoV1ValidationResultDateResponse {
  /** @format int32 */
  customerId?: number;
  dateTime?: string | null;
  /** @format int32 */
  employerId?: number;
}

export interface DtoV1ValidationResultGetValidationResultsResponse {
  results?: DtoV1ValidationResultRuleResult[] | null;
}

export interface DtoV1ValidationResultQuestion {
  /** @format int32 */
  questionId?: number;
  /** @format int32 */
  ruleResultDetailId?: number | null;
  questionText?: string | null;
  questionSubtext?: string | null;
  tooltip?: string | null;
  answers?: DtoV1ValidationResultAnswer[] | null;
  userResponse?: DtoV1ValidationResultQuestionUserResponse | null;
  questionDisplayFormat?: DtoV1EnumValidationResultQuestionDisplayType;
  isVisibleOnLoad?: boolean;
  questionAlertMessages?: DtoV1ValidationResultAlertMessage[] | null;
}

export interface DtoV1ValidationResultQuestionUserResponse {
  /** @format int32 */
  questionUserResponseID?: number;
  currentAnswerText?: string | null;
  /** @format int32 */
  questionAnswerId?: number | null;
  /** @format int32 */
  ruleResultDetailId?: number | null;
  /** @format int32 */
  questionId?: number;
}

export interface DtoV1ValidationResultRuleMetadata {
  /** @format int32 */
  ruleId?: number;
  ruleName?: string | null;
  vendorRuleName?: string | null;
  vendorConditionCategory?: DtoV1EnumValidationResultConditionCategory | null;
  ruleDisplayTitle?: string | null;
  ruleDisplayDescription?: string | null;
  categoryId?: DtoV1EnumValidationResultRuleCategory;
  subCategoryId?: DtoV1EnumValidationResultRuleSubCategory;
  /** @format int32 */
  parentRuleId?: number | null;
}

export interface DtoV1ValidationResultRuleReferenceIdentifier {
  ruleReferenceType?: DtoV1EnumValidationResultRuleReferenceType;
  /** @format int32 */
  lenderDatabaseId?: number;
  ruleReferenceValue?: string | null;
  /** @format int64 */
  ruleReferenceId?: number | null;
}

export interface DtoV1ValidationResultRuleResult {
  /** @format int32 */
  ruleResultId?: number | null;
  ruleMetadata?: DtoV1ValidationResultRuleMetadata | null;
  borrowerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  ruleReferenceIdentifiers?:
    | DtoV1ValidationResultRuleReferenceIdentifier[]
    | null;
  details?: DtoV1ValidationResultRuleResultDetail[] | null;
  conditionText?: string | null;
  status?: DtoV1EnumValidationResultRuleResultStatus;
  csid?: DtoV1EnumValidationResultCSID | null;
  questions?: DtoV1ValidationResultQuestion[] | null;
  /** @format date-time */
  ruleRunDateTime?: string;
  isVisible?: boolean;
  ruleAlertMessages?: DtoV1ValidationResultAlertMessage[] | null;
}

export interface DtoV1ValidationResultRuleResultDetail {
  /** @format int32 */
  ruleResultDetailId?: number | null;
  ruleResultDetailText?: string | null;
  ruleReferenceIdentifier?: DtoV1ValidationResultRuleReferenceIdentifier | null;
}

export interface DtoV1ValidationResultSaveDateAnswersRequest {
  dateAnswers?: DtoV1ValidationResultDateResponse[] | null;
}

export interface DtoV1ValidationResultSaveQuestionAnswersRequest {
  userResponses?: DtoV1ValidationResultQuestionUserResponse[] | null;
}

export interface DtoV2ClassifyDocumentsDocumentTypesAndCategories {
  /** @format int32 */
  documentCategoryId?: number;
  documentCategory?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  documentClassification?: string | null;
  dropDownOptions?: DtoV2ClassifyDocumentsDropDownOption[] | null;
}

export interface DtoV2ClassifyDocumentsDropDownOption {
  /** @format int32 */
  priority?: number;
  dropDownName?: string | null;
  dropDownKey?: string | null;
  defaultValue?: string | null;
  includeNA?: boolean;
  isMulti?: boolean;
}

export interface DtoV2ClassifyDocumentsGetDocumentTypeAssociationsResponse {
  borrowerArray?: DtoV1LoanInfoBorrowerInfo[] | null;
  incomeArray?: DtoV1LoanInfoIncomeInfo[] | null;
  assetArray?: DtoV1LoanInfoAssetInfo[] | null;
  liabilityArray?: DtoV1LoanInfoLiability[] | null;
  propertyArray?: DtoV1LoanInfoPropertyInfo[] | null;
  documentTypesAndCategories?:
    | DtoV2ClassifyDocumentsDocumentTypesAndCategories[]
    | null;
}

export interface DtoV2FraudGuardGetRedFlagsResponse {
  results?: DtoV2ValidationResultRuleResult[] | null;
  alertSections?: DtoV2FraudGuardRedFlagAlertSection[] | null;
}

export interface DtoV2FraudGuardRedFlagAlert {
  clientFacingAlert?: string | null;
}

export interface DtoV2FraudGuardRedFlagAlertSection {
  title?: string | null;
  alerts?: DtoV2FraudGuardRedFlagAlert[] | null;
}

export interface DtoV2IncomeIncomeDocumentField {
  /** @format int64 */
  documentTypeId?: number;
  /** @format int32 */
  incomeDocumentFieldId?: number;
  incomeDocumentFieldName?: string | null;
  incomeDocumentFieldDesc?: string | null;
  incomeDocumentFieldValueResolutions?:
    | DtoV2IncomeIncomeDocumentFieldValueResolution[]
    | null;
}

export interface DtoV2IncomeIncomeDocumentFieldValueResolution {
  /** @format int32 */
  documentTypeIncomeDocumentFieldId?: number | null;
  answer?: string | null;
  /** @format int32 */
  resolutionTypeId?: number | null;
  resolutionText?: string | null;
  nextIncomeDocumentFieldId?: string | null;
  /** @format int32 */
  sortOrder?: number | null;
  isActive?: boolean | null;
}

export interface DtoV2ValidationResultAlertMessage {
  alertText?: string | null;
  alertStyle?: DtoV1EnumValidationResultAlertStyle;
}

export interface DtoV2ValidationResultAnswer {
  /** @format int32 */
  questionAnswerId?: number;
  answerText?: string | null;
  resolutionMessages?: DtoV2ValidationResultAlertMessage[] | null;
  nextQuestionIds?: number[] | null;
  /** @format int32 */
  sortOrder?: number | null;
  /** @format int32 */
  answerGroupSeq?: number | null;
  fieldType?: string | null;
  detailAnswer?: string | null;
}

export interface DtoV2ValidationResultQuestion {
  /** @format int32 */
  questionId?: number;
  /** @format int32 */
  ruleResultDetailId?: number | null;
  questionText?: string | null;
  questionSubtext?: string | null;
  tooltip?: string | null;
  answers?: DtoV2ValidationResultAnswer[] | null;
  userResponse?: DtoV2ValidationResultQuestionUserResponse | null;
  questionDisplayFormat?: DtoV1EnumValidationResultQuestionDisplayType;
  isVisibleOnLoad?: boolean;
  questionAlertMessages?: DtoV2ValidationResultAlertMessage[] | null;
}

export interface DtoV2ValidationResultQuestionUserResponse {
  /** @format int32 */
  questionUserResponseID?: number;
  currentAnswerText?: string | null;
  /** @format int32 */
  questionAnswerId?: number | null;
  /** @format int32 */
  ruleResultDetailId?: number | null;
  /** @format int32 */
  questionId?: number;
}

export interface DtoV2ValidationResultRuleMetadata {
  /** @format int32 */
  ruleId?: number;
  ruleName?: string | null;
  vendorRuleName?: string | null;
  vendorConditionCategory?: DtoV1EnumValidationResultConditionCategory | null;
  ruleDisplayTitle?: string | null;
  ruleDisplayDescription?: string | null;
  categoryId?: DtoV1EnumValidationResultRuleCategory;
  subCategoryId?: DtoV1EnumValidationResultRuleSubCategory;
  /** @format int32 */
  parentRuleId?: number | null;
}

export interface DtoV2ValidationResultRuleReferenceIdentifier {
  ruleReferenceType?: DtoV1EnumValidationResultRuleReferenceType;
  /** @format int32 */
  lenderDatabaseId?: number;
  ruleReferenceValue?: string | null;
  /** @format int64 */
  ruleReferenceId?: number | null;
}

export interface DtoV2ValidationResultRuleResult {
  /** @format int32 */
  ruleResultId?: number | null;
  ruleMetadata?: DtoV2ValidationResultRuleMetadata | null;
  borrowerIdentifier?: DtoIdentitiesCustomerIdentifier | null;
  ruleReferenceIdentifiers?:
    | DtoV2ValidationResultRuleReferenceIdentifier[]
    | null;
  details?: DtoV2ValidationResultRuleResultDetail[] | null;
  conditionText?: string | null;
  status?: DtoV1EnumValidationResultRuleResultStatus;
  csid?: DtoV1EnumValidationResultCSID | null;
  questions?: DtoV2ValidationResultQuestion[] | null;
  /** @format date-time */
  ruleRunDateTime?: string;
  isVisible?: boolean;
  ruleAlertMessages?: DtoV2ValidationResultAlertMessage[] | null;
}

export interface DtoV2ValidationResultRuleResultDetail {
  /** @format int32 */
  ruleResultDetailId?: number | null;
  ruleResultDetailText?: string | null;
  ruleReferenceIdentifier?: DtoV2ValidationResultRuleReferenceIdentifier | null;
}

export interface ModelsAIResponse {
  answer?: string | null;
  formattedAnswer?: string | null;
  detailedAnswer?: string | null;
  /** @format double */
  confidence?: number;
  confidenceLevel?: ModelsEnumConfidenceLevel;
  snippets?: ModelsSnippet[] | null;
}

export interface ModelsAssetsAccountDisplayData {
  assetRecordIdentifier?: ModelsAssetsAssetRecordIdentifier | null;
  /** @format int32 */
  customerRecordId?: number;
  assetType?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number | null;
  bankName?: string | null;
}

export interface ModelsAssetsAssetAccountInitialFormValues {
  statementDetails?: Record<string, Record<string, any>> | null;
  assetDetails?: Record<string, any> | null;
}

export interface ModelsAssetsAssetAccountScreenData {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  assets?: ModelsAssetsAssetDisplayModel | null;
  borrowers?: DtoV1AssetsAssetBorrower[] | null;
  statements?: ModelsAssetsAssetStatement[] | null;
  pdfViewerDocumentDropdownOptions?: DtoV1DocumentSelection[] | null;
  giftDepositedAccounts?: ModelsAssetsGiftDepositedAccounts[] | null;
  assetsCalculationInformation?: ModelsAssetsAssetsCalculationInformation | null;
  hasMultipleGiftsOfEquity?: boolean;
  giftRelationshipDropdown?: ModelsAssetsDropdownFormValues[] | null;
  giftSourceDropdown?: ModelsAssetsDropdownFormValues[] | null;
  giftDonorDropdown?: ModelsAssetsDropdownFormValues[] | null;
  grantDefaultData?: ModelsAssetsGrantDefaultData | null;
  loanAssetInformation?: ModelsAssetsLoanAssetInformation | null;
  emdSourceDropdownOptions?: ModelsAssetsSourceDropdownOptions[] | null;
  assetsFeatureFlags?: DtoV1AssetsAssetsFeatureFlags | null;
  sellerNamesQuestion?: string | null;
  netProceedsRealEstateOwnedDropdownOptions?:
    | ModelsAssetsNetProceedsRealEstateOwnedDropdownOption[]
    | null;
  cashDepositSourceDropdownOptions?: ModelsAssetsSourceDropdownOptions[] | null;
  hasNewDocument?: boolean;
  fullPageShouldWaitForExtraction?: boolean;
  actionTypesForHousingDeductionDropdown?:
    | ModelsAssetsDropdownFormValues[]
    | null;
  transactionTypesDropDown?: ModelsAssetsDropdownFormValues[] | null;
}

export interface ModelsAssetsAssetAlertMessages {
  willProvideDocumentAlertMessage?: string | null;
  businessAssetHasMultipleIncomes?: string | null;
  extractionIsPendingAlertMessage?: string | null;
}

export interface ModelsAssetsAssetAssociationDetails {
  /** @format int32 */
  incomeID?: number | null;
  /** @format int32 */
  addressLdID?: number | null;
  /** @format int32 */
  addressID?: number | null;
  /** @format int32 */
  borrowerLenderDatabaseID?: number | null;
  /** @format int32 */
  borrowerRecordID?: number | null;
  /** @format int64 */
  documentID?: number | null;
  /** @format int32 */
  documentTypeID?: number | null;
  /** @format int32 */
  assetLdID?: number | null;
  /** @format int32 */
  assetID?: number | null;
  /** @format int32 */
  debtLdID?: number | null;
  /** @format int32 */
  debtID?: number | null;
  employerName?: string | null;
  documentDetails?: ModelsDocumentDocumentDetails[] | null;
  assetTransactions?: ModelsAssetsAssetTransaction[] | null;
  deletedAssetTransactions?: ModelsAssetsAssetTransaction[] | null;
  userResponses?: Record<string, any> | null;
  documentAlertMessages?: ModelsAssetsDocumentAlertMessages | null;
  largeDepositStatus?: ModelsEnumTransactionExtractionStatus;
  debtsAndDeductionsStatus?: ModelsEnumTransactionExtractionStatus;
  hasMissingTransactions?: boolean;
  /** @format decimal */
  totalDeposits?: number;
  documentExtractionStatus?: ModelsEnumDocumentExtractionStatus;
}

export interface ModelsAssetsAssetCondition {
  relatedTransactionIds?: number[] | null;
  conditionGroup?: ModelsEnumAssetConditionGroup;
  conditionName?: string | null;
  conditionText?: string | null;
}

export interface ModelsAssetsAssetCustomerData {
  /** @format int32 */
  customerLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  assetId?: number;
  /** @format int32 */
  assetLdId?: number;
  assetType?: string | null;
  bankName?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  country?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number | null;
  includeBalance?: string | null;
  sendToAus?: string | null;
  verified?: string | null;
  /** @format date-time */
  verifiedDate?: string | null;
  /** @format decimal */
  faceValue?: number | null;
  /** @format int32 */
  fhaSource?: number | null;
  sellerFundDap?: string | null;
  sourceEin?: string | null;
  sourceDesc?: string | null;
  /** @format int32 */
  giftDepositedDuFlag?: number | null;
  grantAssetAutomationStatus?: ModelsEnumGrantAssetAutomationStatus | null;
  /** @format int32 */
  giftSourceId?: number | null;
  isLiquid?: boolean;
  isDeleted?: boolean;
  /** @format decimal */
  nextLargestDeposit?: number | null;
  giftInformation?: ModelsAssetsGiftInformation | null;
  srUWReviewRequired?: boolean | null;
  comment?: string | null;
  canBeUsedForEmdOrCashDepositBackout?: boolean;
  /** @format int32 */
  lenderDatabaseId?: number;
  customerRecordIds?: number[] | null;
}

export interface ModelsAssetsAssetDisplayModel {
  /** @format int32 */
  assetLdId?: number;
  /** @format int32 */
  assetId?: number;
  assetType?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number | null;
  bankName?: string | null;
  primaryAddress?: string | null;
  isDocumentProvided?: boolean;
  alertMessages?: ModelsAssetsAssetAlertMessages | null;
  /** @format decimal */
  largeDepositThreshold?: number | null;
  giftInformation?: ModelsAssetsGiftInformation | null;
  srUWReviewRequired?: boolean | null;
}

export interface ModelsAssetsAssetDisplayRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  /** @format int32 */
  assetId?: number;
}

export interface ModelsAssetsAssetExtractedData {
  /** @format int32 */
  accountNumberSuffix?: number;
  financialInstitution?: ModelsExtractedDocumentField | null;
  accountNumber?: ModelsExtractedDocumentField | null;
  balance?: ModelsExtractedDocumentField | null;
  assetType?: ModelsExtractedDocumentField | null;
  startDate?: ModelsExtractedDocumentField | null;
  endDate?: ModelsExtractedDocumentField | null;
  giftAmount?: ModelsExtractedDocumentField | null;
  donorFirstName?: ModelsExtractedDocumentField | null;
  donorMiddleInitial?: ModelsExtractedDocumentField | null;
  donorLastName?: ModelsExtractedDocumentField | null;
  donorRelationship?: ModelsExtractedDocumentField | null;
  donorAddress?: ModelsExtractedDocumentField | null;
  donorCity?: ModelsExtractedDocumentField | null;
  donorState?: ModelsExtractedDocumentField | null;
  donorZipCode?: ModelsExtractedDocumentField | null;
}

export interface ModelsAssetsAssetInformationModel {
  asset?: ModelsAssetsAssetModel | null;
  borrowers?: ModelsBorrower[] | null;
  documentAssociationDetails?: ModelsAssetsAssetAssociationDetails[] | null;
  userResponses?: Record<string, any> | null;
  alertMessages?: ModelsAssetsAssetAlertMessages | null;
}

export interface ModelsAssetsAssetModel {
  /** @format int32 */
  customerLenderDatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  /** @format int32 */
  assetId?: number;
  /** @format int32 */
  assetLdId?: number;
  assetType?: string | null;
  bankName?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  country?: string | null;
  accountNumber?: string | null;
  /** @format decimal */
  balance?: number | null;
  includeBalance?: string | null;
  sendToAus?: string | null;
  verified?: string | null;
  /** @format date-time */
  verifiedDate?: string | null;
  /** @format decimal */
  faceValue?: number | null;
  /** @format int32 */
  fhaSource?: number | null;
  sellerFundDap?: string | null;
  sourceEin?: string | null;
  sourceDesc?: string | null;
  /** @format int32 */
  giftDepositedDuFlag?: number | null;
  grantAssetAutomationStatus?: ModelsEnumGrantAssetAutomationStatus | null;
  /** @format int32 */
  giftSourceId?: number | null;
  isLiquid?: boolean;
  isDeleted?: boolean;
  /** @format decimal */
  nextLargestDeposit?: number | null;
  giftInformation?: ModelsAssetsGiftInformation | null;
  srUWReviewRequired?: boolean | null;
  comment?: string | null;
  canBeUsedForEmdOrCashDepositBackout?: boolean;
}

export interface ModelsAssetsAssetReconciliationInformationModel {
  asset?: ModelsAssetsAssetModel | null;
  accountConditions?: ModelsAssetsAssetCondition[] | null;
  assetTransactions?: ModelsAssetsReconciliationAssetTransaction[] | null;
  includeAsset?: boolean;
  excludeFromBackOut?: boolean;
  excludeFromVerifiedFunds?: boolean;
  excludeFromVerifiedFundsForGiftTransferType?: boolean;
  assetAssociation?: ModelsAssetsAssetRecordIdentifier[] | null;
}

export interface ModelsAssetsAssetReconciliationResponse {
  assetsLoanInformation?: ModelsAssetsAssetsLoanInformation | null;
  assets?: ModelsAssetsAssetReconciliationInformationModel[] | null;
  suggestion?: ModelsAssetsSmartSuggestion | null;
  featureFlags?: DtoV1AssetsAssetsFeatureFlags | null;
  wereExpectedAssetsEverPresent?: boolean;
}

export interface ModelsAssetsAssetRecordIdentifier {
  /** @format int32 */
  assetDatabaseId?: number;
  /** @format int32 */
  assetRecordId?: number;
}

export interface ModelsAssetsAssetStatement {
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  documentTypeId?: number | null;
  borrowers?: DtoV1AssetsAssetBorrower[] | null;
  extractedData?: ModelsAssetsAssetExtractedData | null;
  isBankNameHidden?: boolean;
  isAssetTypeHidden?: boolean;
  largeDepositThresholdIncreasedMessage?: string | null;
  deductionsExtractionStatus?: string | null;
  largeDepositsExtractionStatus?: string | null;
  isMissingTransactions?: boolean;
  employerName?: string | null;
  /** @format decimal */
  totalDeposits?: number;
  questionAnswers?: Record<string, ModelsAssetsBoltQuestionAnswer> | null;
  extractedTransactionSnippets?: ModelsAssetsSnippet[] | null;
  isExtractionPending?: boolean;
}

export interface ModelsAssetsAssetTransaction {
  /** @format int32 */
  assetldID?: number;
  /** @format int32 */
  assetID?: number;
  /** @format int64 */
  documentAssetTransactionID?: number | null;
  assetTransactionType?: ModelsEnumAssetTransactionType;
  assetTransactionSource?: ModelsEnumAssetTransactionSource | null;
  assetTransactionAction?: ModelsEnumAssetTransactionAction | null;
  extractedTransactionID?: string | null;
  /** @format decimal */
  amount?: number | null;
  accountID?: string | null;
  description?: string | null;
  /** @format date-time */
  postedDate?: string | null;
  /** @format date-time */
  transactionDate?: string | null;
  /** @format int32 */
  pageNumber?: number | null;
  boundingBox?: string | null;
  confidence?: string | null;
  answerDetail?: string | null;
  /** @format int32 */
  debtID?: number | null;
  originalExtractedData?: string | null;
  transactionGuid?: string | null;
  /** @format int64 */
  documentId?: number;
  isBackedOut?: boolean;
  userResponses?: Record<string, any> | null;
}

export interface ModelsAssetsAssetsBorrowerInformation {
  assetsSummaryInformation?: ModelsAssetsAssetsCalculationInformation | null;
  borrowers?: ModelsBorrowersBorrowerResponse | null;
  assets?: ModelsAssetsAssetInformationModel[] | null;
  hasWritePermission?: boolean;
  excludedAssets?: ModelsAssetsAssetModel[] | null;
  loanProductType?: ModelsEnumLoanProductType;
  displayAuditHistory?: boolean;
  assetsFeatureFlags?: Record<string, boolean> | null;
  reservesComment?: string | null;
}

export interface ModelsAssetsAssetsCalculationInformation {
  /** @format decimal */
  cashToFromBorrower?: number;
  /** @format decimal */
  largeDepositThreshold?: number;
  /** @format decimal */
  totalFundsAvailable?: number;
  /** @format decimal */
  totalFundsRequired?: number;
  /** @format decimal */
  totalReservesRequired?: number;
  /** @format decimal */
  minimumInvestment?: number;
  /** @format decimal */
  actualBorrowerInvestment?: number;
  /** @format decimal */
  totalFundsAvailableFHA?: number;
  /** @format decimal */
  additionalReserves?: number;
  /** @format decimal */
  totalVerifiedFunds?: number;
  /** @format decimal */
  subordinateFinancingAmount?: number | null;
}

export interface ModelsAssetsAssetsFeatureFlagData {
  businessAssetEligibility?: boolean;
  assetReconciliationEligibility?: boolean;
  giftAssetEligibility?: boolean;
  eligibilityForEmd?: boolean;
  eligibilityForEmdGiftWorkflow?: boolean;
  eligibilityForGiftPurchaseAssets?: boolean;
  eligibilityForGiftRefinanceAssets?: boolean;
  eligibilityForGiftOfEquityAssets?: boolean;
  eligibilityForNewRetirementWorkFlow?: boolean;
  eligibilityForAssetNetProceedsWorkFlow?: boolean;
  eligibilityForAssetCashDepositWorkFlow?: boolean;
  assetFeatureFlags?: Record<string, boolean> | null;
}

export interface ModelsAssetsAssetsLoanInformation {
  isDU?: boolean;
  isRefinance?: boolean;
  isSuperCorrespondent?: boolean;
  /** @format decimal */
  cashToFromBorrower?: number;
  /** @format decimal */
  totalFundsRequired?: number;
  /** @format decimal */
  totalReservesRequired?: number;
  /** @format decimal */
  minumumRequiredInvestment?: number;
}

export interface ModelsAssetsAssociatedIncome {
  isSelfEmployed?: boolean;
  employerName?: string | null;
  /** @format int32 */
  employerId?: number | null;
  /** @format int32 */
  customerRecordId?: number | null;
}

export interface ModelsAssetsAssociatedLiability {
  creditorName?: string | null;
  excludeBalance?: boolean;
  liabilityType?: string | null;
}

export interface ModelsAssetsBoltQuestionAnswer {
  questionId?: string | null;
  questionName?: string | null;
  answer?: string | null;
  iconType?: ModelsEnumIconType;
  aiResponse?: ModelsAssetsBoltResponse | null;
}

export interface ModelsAssetsBoltResponse {
  answer?: string | null;
  snippets?: ModelsAssetsSnippet[] | null;
}

export interface ModelsAssetsDepositSourceInformation {
  assetTransactions?: Record<string, ModelsAssetsAssetTransaction[] | null>;
  assetFeatureFlags?: Record<string, boolean> | null;
  dropdowns?: Record<string, ModelsAssetsSourceDropdownOptions[] | null>;
  bankName?: string | null;
  assetType?: string | null;
  productType?: ModelsEnumLoanProductType;
  ausUnderwritingMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod;
  assetsCalculationInformation?: ModelsAssetsAssetsCalculationInformation | null;
}

export interface ModelsAssetsDepositSourceRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  assetRecordIdentifier?: ModelsAssetsAssetRecordIdentifier | null;
}

export interface ModelsAssetsDepositoryAccountReviewScreenData {
  asset?: ModelsAssetsAssetModel | null;
  assetsFeatureFlags?: ModelsAssetsAssetsFeatureFlagData | null;
  assetsCalculationInformation?: ModelsAssetsAssetsCalculationInformation | null;
  documentInformation?: ModelsAssetsMostRecentStatementDetails | null;
  productType?: string | null;
  employerName?: string | null;
  accountConditions?: ModelsAssetsAssetCondition[] | null;
}

export interface ModelsAssetsDepositoryAccountScreenData {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  asset?: ModelsAssetsAssetDisplayModel | null;
  borrowers?: DtoV1AssetsAssetBorrower[] | null;
  extractedData?: ModelsAssetsAssetExtractedData | null;
  tableData?: Record<string, ModelsAssetsGridRow[] | null>;
  pdfViewerDocumentDropdownOptions?: DtoV1DocumentSelection[] | null;
  assetsCalculationInformation?: ModelsAssetsAssetsCalculationInformation | null;
  assetsFeatureFlags?: ModelsAssetsAssetsFeatureFlagData | null;
  isBankNameHidden?: boolean;
  isAssetTypeHidden?: boolean;
  hasDocumentPendingExtraction?: boolean;
  associatedIncomes?: ModelsAssetsAssociatedIncome[] | null;
}

export interface ModelsAssetsDepositoryStatementScreenData {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  account?: ModelsAssetsAccountDisplayData | null;
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  documentTypeId?: number | null;
  extractedData?: ModelsAssetsStatementExtractedData | null;
  largeDepositThresholdIncreasedMessage?: string | null;
  hasMissingTransactions?: boolean;
  deductionsExtractionStatus?: string | null;
  largeDepositsExtractionStatus?: string | null;
  assetsCalculationInformation?: ModelsAssetsAssetsCalculationInformation | null;
  loanAssetInformation?: ModelsAssetsLoanInformationModel | null;
  assetFeatureFlags?: Record<string, boolean> | null;
  actionTypesForHousingDeductionDropdown?:
    | ModelsAssetsDropdownFormValues[]
    | null;
  transactionTypesDropDown?: ModelsAssetsDropdownFormValues[] | null;
  llmPendingMessage?: string | null;
  isEmployeeSponsoredRetirementAccount?: boolean;
}

export interface ModelsAssetsDocumentAlertMessages {
  largeDepositThresholdIncreasedAlertMessage?: string | null;
  llmPendingResponseAlertMessage?: string | null;
}

export interface ModelsAssetsDropdownFormValues {
  label?: string | null;
  value?: string | null;
}

export interface ModelsAssetsGiftDepositedAccounts {
  accounts?: string | null;
}

export interface ModelsAssetsGiftInformation {
  donorName?: string | null;
  donorRelationship?: string | null;
  giftAmount?: string | null;
  isGiftDepositedVerified?: boolean | null;
  isGiftTransferAtCloseVerified?: boolean | null;
  isGiftTransferAtClose?: boolean | null;
  isEarnestMoneyDepositAGift?: boolean | null;
  /** @format int32 */
  giftSourceId?: number | null;
  /** @format int32 */
  fhaSource?: number | null;
}

export interface ModelsAssetsGrantDefaultData {
  giftSourceDropdownSelection?: string | null;
  howGiftIsBeingTransferred?: string | null;
}

export interface ModelsAssetsGridRow {
  label?: string | null;
  value?: string | null;
  snippet?: ModelsAssetsSnippet | null;
}

export interface ModelsAssetsLoanAssetInformation {
  occupancyType?: DtoV1EnumOccupancyType | null;
  productType?: string | null;
  isDU?: boolean | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  state?: string | null;
  hasAppraisalWaiver?: boolean;
  appraisalWaiverData?: DtoV1AssetsAppraisalWaiverData | null;
  isRefinance?: boolean;
  isDryState?: boolean;
  businessChannel?: DtoV1EnumBusinessChannel;
  /** @format int32 */
  loanStatusId?: number;
  isCorrespondent?: boolean;
}

export interface ModelsAssetsLoanInformationModel {
  productType?: string | null;
  isDu?: boolean;
  isRefinance?: boolean;
}

export interface ModelsAssetsMostRecentStatementDetails {
  /** @format int64 */
  documentId?: number;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  extractedBalance?: ModelsDocumentDocumentDetails | null;
}

export interface ModelsAssetsNetProceedsRealEstateOwnedDropdownOption {
  addressId?: string | null;
  addressDropDownOption?: ModelsAssetsDropdownFormValues | null;
  associatedLiabilities?: ModelsAssetsAssociatedLiability[] | null;
  propertyStatus?: string | null;
}

export interface ModelsAssetsReconciliationAssetTransaction {
  /** @format int64 */
  documentAssetTransactionID?: number;
  /** @format decimal */
  amount?: number | null;
  /** @format date-time */
  transactionDate?: string | null;
  includeTransaction?: boolean;
  type?: ModelsEnumAssetTransactionType;
  additionalConditionsOnBackOut?: string[] | null;
}

export interface ModelsAssetsSaveAccountReviewInformationRequest {
  loanIdentifier?: ModelsLoanIdentifier | null;
  /** @format int32 */
  userId?: number;
  assetRecordIdentifier?: ModelsAssetsAssetRecordIdentifier | null;
  assetDetails?: Record<string, any> | null;
  statementEndDate?: string | null;
  extractedBalance?: ModelsDocumentDocumentDetails | null;
  productType?: string | null;
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
}

export interface ModelsAssetsSaveAccountSummaryInformationRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  /** @format int32 */
  userId?: number;
  assetRecordIdentifier?: ModelsAssetsAssetRecordIdentifier | null;
  extractedBankName?: ModelsExtractedDocumentField | null;
  extractedAssetType?: ModelsExtractedDocumentField | null;
  assetDetails?: Record<string, any> | null;
  isDocumentProvided?: boolean;
}

export interface ModelsAssetsSaveAssetQuestionAnswersRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  /** @format int32 */
  userId?: number;
  borrowers?: DtoV1AssetsAssetBorrower[] | null;
  assetRecordIdentifier?: ModelsAssetsAssetRecordIdentifier | null;
  assetDetails?: Record<string, any> | null;
  statementDetails?: Record<string, Record<string, any>> | null;
  statements?: ModelsAssetsAssetStatement[] | null;
  giftInformation?: ModelsAssetsGiftInformation | null;
  loanAssetInformation?: ModelsAssetsLoanAssetInformation | null;
  hasNewDocument?: boolean;
  assetType?: string | null;
  assetsFeatureFlags?: Record<string, boolean> | null;
}

export interface ModelsAssetsSaveAssetSummaryRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  assetCustomerData?: ModelsAssetsAssetCustomerData | null;
  assetsFeatureFlags?: Record<string, boolean> | null;
  productType?: string | null;
}

export interface ModelsAssetsSaveStatementQuestionAnswersRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  /** @format int32 */
  userId?: number;
  assetRecordIdentifier?: ModelsAssetsAssetRecordIdentifier | null;
  statementDetails?: Record<string, any> | null;
  /** @format int64 */
  documentId?: number;
  /** @format int32 */
  documentTypeId?: number;
  /** @format int32 */
  customerRecordId?: number;
}

export interface ModelsAssetsSmartSuggestion {
  isSuggestionProvided?: boolean;
  /** @format decimal */
  totalFunds?: number;
  /** @format int32 */
  totalActionItems?: number;
  assetsToBackOut?: ModelsAssetsAssetRecordIdentifier[] | null;
  largeDepositsToBackOut?: number[] | null;
}

export interface ModelsAssetsSnippet {
  /** @format int64 */
  documentId?: number;
  boundingBoxes?: DtoV1BoundingBox[] | null;
}

export interface ModelsAssetsSourceDropdownOptions {
  /** @format int32 */
  assetLdId?: number | null;
  /** @format int32 */
  assetId?: number | null;
  assetType?: string | null;
  displayName?: string | null;
}

export interface ModelsAssetsStatementExtractedData {
  startDate?: ModelsExtractedDocumentField | null;
  endDate?: ModelsExtractedDocumentField | null;
}

export interface ModelsAssetsStatementInformationRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
  /** @format int32 */
  assetId?: number;
  /** @format int64 */
  documentId?: number;
}

export interface ModelsAssetsUpdateAdditionalReservesResponse {
  isSuccessful?: boolean;
  assetsSummaryInformation?: ModelsAssetsAssetsCalculationInformation | null;
}

export interface ModelsBoltApprovalIntegraLoanCondition {
  /** @format int32 */
  csid?: number;
  condName?: string | null;
  /** @format date-time */
  dateCompleted?: string | null;
  /** @format date-time */
  dateFirstEntered?: string | null;
  /** @format int32 */
  categoryID?: number;
  /** @format int32 */
  lcOrder?: number;
  approvedFlag?: string | null;
  /** @format int32 */
  condID?: number;
  printCondition?: string | null;
  condEnum?: string | null;
  state?: string | null;
  /** @format int32 */
  sourceID?: number;
  condAlias?: string | null;
}

export interface ModelsBoltApprovalLoanConditionData {
  preapprovalLoanConditions?: ModelsBoltApprovalIntegraLoanCondition[] | null;
}

export interface ModelsBorrower {
  /** @format int32 */
  lenderdatabaseId?: number;
  /** @format int32 */
  customerRecordId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  socialSecurityNumber?: string | null;
  /** @format int32 */
  borrowerPosition?: number;
  isPrimaryBorrower?: boolean;
  /** @format date-time */
  dateOfBirth?: string | null;
  citizenship?: ModelsEnumCitizenshipType | null;
  borrowerAddressHistory?: ModelsBorrowerAddress[] | null;
}

export interface ModelsBorrowerAddress {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  primaryResidence?: boolean;
  addressType?: string | null;
}

export interface ModelsBorrowersBorrowerResponse {
  /** @format int32 */
  customerGroupId?: number;
  borrowers?: ModelsBorrower[] | null;
}

export interface ModelsConditionsBoltApprovalRunResponse {
  legacyConditionsSuccess?: boolean | null;
  rulesSuccess?: boolean | null;
}

export interface ModelsDocumentDocumentDetails {
  /** @format int32 */
  documentFieldId?: number;
  documentFieldName?: string | null;
  fieldValue?: string | null;
  /** @format int64 */
  extractedDataResultId?: number;
  /** @format int64 */
  actualExtractedDataResultId?: number;
  /** @format int32 */
  pageNumber?: number | null;
  boundingBox?: string | null;
  confidence?: string | null;
  vibe?: string | null;
}

export interface ModelsExtractedDocumentField {
  name?: string | null;
  value?: string | null;
  /** @format int64 */
  extractedDataResultId?: number;
  /** @format int32 */
  documentFieldId?: number;
}

export interface ModelsFinalReviewLoanStatusFlipEligibilityData {
  loanStatus?: string | null;
  isFinalRunValidationsCompleted?: boolean;
  isProductValid?: boolean;
  isValidCreditExpirationDate?: boolean;
}

export interface ModelsLoanIdentifier {
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  loanRecordId?: number;
}

export interface ModelsObfuscatedLoanIdentifier {
  /** @format int32 */
  obfuscatedLenderDatabaseId?: number;
  /** @format int32 */
  obfuscatedLoanRecordId?: number;
}

export interface ModelsPropertyInformationBorrowerInfo {
  customerRecordId?: string | null;
  primaryCustomer?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
}

export interface ModelsPropertyInformationPropertyAddress {
  addressLine1?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  county?: string | null;
}

export interface ModelsPropertyInformationPropertyInformationScreenData {
  loanProductType?: ModelsEnumLoanProductType;
  loanPurpose?: ModelsEnumPurposeType;
  refinancePurposeTypeDescription?: string | null;
  propertyType?: string | null;
  propertyAddress?: ModelsPropertyInformationPropertyAddress | null;
  ausMethod?: string | null;
  occupancyType?: ModelsEnumOccupancyType;
  /** @format date-time */
  applicationDate?: string;
  estimatedClosingDate?: string | null;
  titleCompany?: string | null;
  titleUnderwriterCompany?: ModelsPropertyInformationTitleUnderwriterCompany | null;
  titleCommitmentNumber?: string | null;
  propertyTypes?: ModelsPropertyInformationUnderWritingPropertyType[] | null;
  titleUnderwriterCompanies?:
    | ModelsPropertyInformationTitleUnderwriterCompany[]
    | null;
  questionAnswers?: Record<
    string,
    ModelsPropertyInformationQuestionAnswer
  > | null;
  titleDocuments?: Record<
    string,
    ModelsPropertyInformationTitleDocument
  > | null;
  borrowers?: ModelsPropertyInformationBorrowerInfo[] | null;
  isNewConstruction?: boolean;
  /** @format decimal */
  ltv?: number | null;
  tracType?: ModelsEnumTracType | null;
}

export interface ModelsPropertyInformationPropertyValidationResponse {
  loanIdentifier?: ModelsLoanIdentifier | null;
  screenData?: ModelsPropertyInformationPropertyInformationScreenData | null;
  questionAnswers?: Record<string, string | null>;
  questionAnswersV2?: Record<string, ModelsPropertyInformationQuestion> | null;
  extractedQuestionAnswers?: ModelsPropertyInformationQuestion[] | null;
}

export interface ModelsPropertyInformationQuestion {
  /** @format uuid */
  questionId?: string;
  questionName?: string | null;
  answer?: string | null;
  data?: Record<string, any> | null;
  formattedAnswer?: string | null;
  detailedAnswer?: string | null;
  /** @format double */
  confidence?: number;
  answerSource?: DtoV1PropertyInformationEnumsAnswerSource;
  snippets?: ModelsSnippet[] | null;
  /** @format uuid */
  runId?: string;
  /** @format date-time */
  runDate?: string;
  /** @format date-time */
  updateDateTime?: string;
  canHide?: boolean | null;
}

export interface ModelsPropertyInformationQuestionAnswer {
  /** @format uuid */
  questionId?: string;
  questionName?: string | null;
  userAnswer?: string | null;
  iconType?: ModelsEnumIconType;
  aiResponse?: ModelsAIResponse | null;
  answerSource?: DtoV1PropertyInformationEnumsAnswerSource;
  canHide?: boolean | null;
  correlationId?: string | null;
}

export interface ModelsPropertyInformationTitleDocument {
  /** @format int64 */
  documentId?: number | null;
  isUploaded?: boolean;
}

export interface ModelsPropertyInformationTitleUnderwriterCompany {
  /** @format int32 */
  selectedTitleUnderwriterId?: number;
  titleUnderwriterName?: string | null;
}

export interface ModelsPropertyInformationUnderWritingPropertyType {
  id?: string | null;
  displayValue?: string | null;
}

export interface ModelsPropertyInsuranceOrderFloodCertRequest {
  obfuscatedLoanIdentifier?: ModelsObfuscatedLoanIdentifier | null;
}

export interface ModelsSnippet {
  text?: string | null;
  documentType?: string | null;
  /** @format int64 */
  documentId?: number;
  /** @format double */
  confidence?: number;
  boundingBoxes?: DtoV1BoundingBox[] | null;
}

export interface ModelsV1UnderwriterVerifiedInformation {
  isUnderwriterCheckboxVisible?: boolean;
  isUnderwriterVerified?: boolean;
  /** @format int32 */
  ruleResultID?: number;
  ruleResultStatus?: ModelsEnumRuleResultStatus;
}

export interface ModelsV2UWAIQuestion {
  /** @format uuid */
  questionId?: string;
  questionName?: string | null;
  key?: string | null;
  answerType?: string | null;
  data?: Record<string, string | null>;
  snippets?: ModelsSnippet[] | null;
  /** @format uuid */
  runId?: string;
  /** @format date-time */
  runDate?: string;
  /** @format date-time */
  updateDateTime?: string;
  /** @format double */
  elapsedTime?: number;
  /** @format int32 */
  statusCode?: number | null;
  source?: DtoV1PropertyInformationEnumsAnswerSource;
}

export interface ModelsV2UWAIUwaiQuestionAnswerResponse {
  /** @format int32 */
  lenderDatabaseId?: number;
  /** @format int32 */
  loanRecordId?: number;
  id?: string | null;
  context?: ModelsEnumQuestionContext;
  subContext?: ModelsEnumQuestionSubContext;
  associations?: Record<string, string | null>;
  questions?: ModelsV2UWAIQuestion[] | null;
}

export interface UWMCApplicationUWMUDSDtoSDUICondition {
  when?: string | null;
  is?: string | null;
  all?: any | null;
  any?: any | null;
  and?: UWMCApplicationUWMUDSDtoSDUICondition[] | null;
  or?: UWMCApplicationUWMUDSDtoSDUICondition[] | null;
  not?: UWMCApplicationUWMUDSDtoSDUICondition[] | null;
  sequence?: UWMCApplicationUWMUDSDtoSDUICondition[] | null;
  isEmpty?: boolean | null;
  isNotEmpty?: boolean | null;
  notMatch?: boolean | null;
  pattern?: string | null;
  flags?: string | null;
  /** @format decimal */
  lessThan?: number | null;
  /** @format decimal */
  lessThanOrEqual?: number | null;
  /** @format decimal */
  greaterThan?: number | null;
  /** @format decimal */
  greaterThanOrEqual?: number | null;
  then?: UWMCApplicationUWMUDSDtoSDUIThen | null;
  else?: UWMCApplicationUWMUDSDtoSDUIThen | null;
  useRelative?: boolean | null;
  useData?: boolean | null;
  func?: UWMCApplicationUWMUDSDtoSDUIFunction | null;
}

export interface UWMCApplicationUWMUDSDtoSDUIContainersPage {
  sx?: Record<string, string> | null;
  isRequired?: boolean | null;
  name?: string | null;
  condition?: UWMCApplicationUWMUDSDtoSDUICondition | null;
  validate?: UWMCApplicationUWMUDSDtoSDUIIValidate | null;
  actions?: Record<string, string[]> | null;
  context?: string | null;
  contextPattern?: Record<string, string> | null;
  useData?: boolean | null;
  children?: UWMCApplicationUWMUDSDtoSDUIWidget[] | null;
  title?: string | null;
  action?: Record<string, any>[] | null;
}

export interface UWMCApplicationUWMUDSDtoSDUIFunction {
  name?: string | null;
}

export interface UWMCApplicationUWMUDSDtoSDUIIValidate {
  type?: string | null;
  required?: boolean | null;
  message?: string | null;
}

export interface UWMCApplicationUWMUDSDtoSDUILayout {
  page?: UWMCApplicationUWMUDSDtoSDUIContainersPage | null;
}

export interface UWMCApplicationUWMUDSDtoSDUISet {
  key?: string | null;
  value?: any | null;
}

export interface UWMCApplicationUWMUDSDtoSDUIThen {
  set?: UWMCApplicationUWMUDSDtoSDUISet[] | null;
  isChecked?: boolean | null;
  visible?: boolean | null;
}

export interface UWMCApplicationUWMUDSDtoSDUIWidget {
  sx?: Record<string, string> | null;
  isRequired?: boolean | null;
  name?: string | null;
  condition?: UWMCApplicationUWMUDSDtoSDUICondition | null;
  validate?: UWMCApplicationUWMUDSDtoSDUIIValidate | null;
  actions?: Record<string, string[]> | null;
  context?: string | null;
  contextPattern?: Record<string, string> | null;
  useData?: boolean | null;
}

export interface DtoV1BoltResponseDtoV1IncomeNoDocumentsProvidedScreenDataWithPreviousIDictionarySystemStringSystemString {
  screenData?: DtoV1IncomeNoDocumentsProvidedScreenDataWithPrevious | null;
  initialFormValues?: Record<string, string | null>;
}

export interface DtoV1BoltResponseDtoV2RealEstateOwnedGetRealEstateOwnedScreenDataDictionarySystemStringSystemString {
  screenData?: DtoV2RealEstateOwnedGetRealEstateOwnedScreenData | null;
  initialFormValues?: Record<string, string | null>;
}

export interface DtoV1IncomeNoDocumentsProvidedScreenDataWithPrevious {
  employerName?: string | null;
  propertyAddress?: string | null;
  borrowerName?: string | null;
  incomeType?: string | null;
  employmentType?: string | null;
  isW2Provided?: boolean;
  /** @format decimal */
  monthlyAmount?: number;
  /** @format int32 */
  currentEmploymentYear?: number;
  /** @format int32 */
  previousEmploymentYear?: number;
  /** @format int32 */
  secondPreviousEmploymentYear?: number;
  /** @format int32 */
  thirdPreviousEmploymentYear?: number;
  endDate?: string | null;
  isCurrent?: boolean;
  hasEmploymentFiveYearsOlder?: boolean;
  isOnlyScheduleEProvided?: boolean;
  previousEmployersNames?: string | null;
}

export interface DtoV2ClassifyDocumentsAssociation {
  /** @format int64 */
  associationId?: number;
  /** @format int64 */
  associationLdId?: number;
  associationDetails?: string | null;
  /** @format int64 */
  borrowerLenderDatabaseId?: number;
  /** @format int64 */
  borrowerRecordId?: number;
  isAddressSubjectProperty?: boolean | null;
  isTBDPurchaseProperty?: boolean | null;
}

export interface DtoV2ClassifyDocumentsClassifyDocumentsDetails {
  /** @format int32 */
  categoryId?: number;
  categoryName?: string | null;
  /** @format int64 */
  documentId?: number;
  documentTypeId?: string | null;
  documentTypeName?: string | null;
  documentTypeKey?: string | null;
  /** @format int64 */
  receivedMailItemId?: number;
  brokerActionRequired?: boolean;
  groupCategoryName?: string | null;
}

export interface DtoV2ClassifyDocumentsDocumentTypesAndCategoryV2 {
  documentCategory?: string | null;
  /** @format int32 */
  documentCategoryId?: number;
  documentClassification?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  dropDownFields?: DtoV2ClassifyDocumentsDropDownField[] | null;
}

export interface DtoV2ClassifyDocumentsDropDownField {
  dropDownName?: string | null;
  isDefaultNa?: boolean;
  options?: DtoV2ClassifyDocumentsAssociation[] | null;
  isMulti?: boolean;
}

export interface DtoV2ClassifyDocumentsGetClassifiedDocumentsRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
}

export interface DtoV2ClassifyDocumentsGetClassifiedDocumentsResponse {
  documentItems?: DtoV2ClassifyDocumentsClassifyDocumentsDetails[] | null;
}

export interface DtoV2ClassifyDocumentsGetDocumentTypeAssociationsResponseV2 {
  documentTypesAndCategories?:
    | DtoV2ClassifyDocumentsDocumentTypesAndCategoryV2[]
    | null;
}

export interface DtoV2DocumentAssociationGetDocumentAssociationsRequestV2 {
  /** @format int64 */
  documentId?: number;
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int64 */
  documentTypeId?: number;
}

export interface DtoV2DocumentAssociationGetDocumentAssociationsResponseV2 {
  /** @format int64 */
  documentId?: number;
  borrowerAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  assetDocumentAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  incomeDocumentAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  liabilityDocumentAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  propertyAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
}

export interface DtoV2DocumentAssociationSaveDocumentAssociationsRequestV2 {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  /** @format int64 */
  receivedMailItemId?: number;
  /** @format int64 */
  documentId?: number;
  /** @format int64 */
  documentTypeId?: number;
  /** @format int64 */
  previousDocumentTypeId?: number;
  /** @format int64 */
  userId?: number;
  classificationChanged?: boolean;
  borrowerAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  assetDocumentAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  incomeDocumentAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  liabilityDocumentAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
  propertyAssociations?: DtoV2ClassifyDocumentsAssociation[] | null;
}

export interface DtoV2LoanSummaryLoanSummaryBorrower {
  firstName?: string | null;
  lastName?: string | null;
  ssNumber?: string | null;
  fullName?: string | null;
}

export interface DtoV2LoanSummaryLoanSummaryData {
  borrower?: DtoV2LoanSummaryLoanSummaryBorrower | null;
  propertyData?: DtoV2LoanSummaryLoanSummaryPropertyData | null;
  loanInfo?: DtoV2LoanSummaryLoanSummaryLoanInfo | null;
  loanSummaryDates?: DtoV2LoanSummaryLoanSummaryDates | null;
  miscellaneousInfo?: DtoV2LoanSummaryLoanSummaryMiscellaneousInfo | null;
}

export interface DtoV2LoanSummaryLoanSummaryDates {
  /** @format date-time */
  fileImportedDate?: string | null;
  /** @format date-time */
  boltEnteredDate?: string | null;
  /** @format date-time */
  estimatedClosingDate?: string | null;
  /** @format date-time */
  loanApplicationDate?: string | null;
  /** @format date-time */
  underwritingSubmittedDate?: string | null;
  /** @format date-time */
  disbursementDate?: string | null;
  /** @format date-time */
  firstPaymentDate?: string | null;
  /** @format date-time */
  zapEnteredDate?: string | null;
  /** @format date-time */
  cannotCloseBeforeDate?: string | null;
  /** @format date-time */
  actualClosingDate?: string | null;
  /** @format date-time */
  caseNumberDate?: string | null;
  /** @format date-time */
  creditReportExpirationDate?: string | null;
  /** @format date-time */
  approvalExpirationDate?: string | null;
  /** @format date-time */
  lockExpirationDate?: string | null;
  /** @format date-time */
  maturityDate?: string | null;
}

export interface DtoV2LoanSummaryLoanSummaryLoanInfo {
  loanNumber?: string | null;
  /** @format float */
  totalLoanAmount?: number | null;
  /** @format float */
  baseLoanAmount?: number | null;
  /** @format float */
  salesPrice?: number | null;
  /** @format float */
  appraisedValue?: number | null;
  /** @format float */
  dti?: number | null;
  /** @format float */
  hti?: number | null;
  /** @format float */
  ltv?: number | null;
  /** @format float */
  cltv?: number | null;
  /** @format float */
  hcltv?: number | null;
  /** @format float */
  tltv?: number | null;
  /** @format int32 */
  fico?: number | null;
  /** @format int32 */
  loanStatusId?: number | null;
  loanStatus?: string | null;
  loanProductType?: DtoV1EnumLoanProductType;
  loanProductTypeDescription?: string | null;
  isNonAgency?: boolean;
  underwritingMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod | null;
  /** @format float */
  interestRate?: number | null;
  agencyCaseNumber?: string | null;
  tracTypeDescription?: string | null;
  creditScoreCategory?: string | null;
  lastAusRecommendation?: string | null;
  lastAusRunMethod?: UWMCLibraryCommonDomainEnumsAusUnderwritingMethod | null;
  isLastAusRunSuccessful?: boolean;
  /** @format decimal */
  cashToFromBorrower?: number | null;
}

export interface DtoV2LoanSummaryLoanSummaryMiscellaneousInfo {
  closingType?: DtoV1EnumClosingType | null;
  businessChannel?: DtoV1EnumBusinessChannel | null;
  documentGenerationProvider?: DtoV1EnumDocumentGenerationProvider | null;
  urlaVersion?: DtoV1EnumUrlaFormVersion | null;
  amcName?: string | null;
  /** @format decimal */
  piti?: number;
  propertyReviewLevel?: DtoV1EnumPropertyReviewLevel | null;
  qualifiedIND?: boolean | null;
}

export interface DtoV2LoanSummaryLoanSummaryPropertyData {
  propertyAddress?: DtoV1PropertyInformationPropertyAddress | null;
  purposeType?: DtoV1EnumLoanPurposeType | null;
  refiPurpose?: string | null;
  occupancyType?: DtoV1EnumOccupancyType | null;
  propertyType?: DtoV1EnumPropertyType;
  isAttachedProperty?: boolean;
  isRefi?: boolean;
  /** @format int32 */
  yearBuilt?: number | null;
}

export interface DtoV2RealEstateOwnedGetRealEstateOwnedScreenData {
  addressId?: DtoIdentitiesAddressIdentifier | null;
  propertyAddress?: DtoV1Address | null;
  propertyStatus?: DtoV1EnumPropertyStatus | null;
  propertyStatusString?: string | null;
  isSubjectProperty?: boolean | null;
  propertyType?: DtoPropertyType | null;
  /** @format decimal */
  monthlyHazardInsurance?: number | null;
  /** @format decimal */
  monthlyTaxes?: number | null;
  /** @format decimal */
  monthlyAssociationDues?: number | null;
  /** @format decimal */
  reopitiaAmount?: number | null;
  pymtIncludesTaxInsFlag?: boolean;
  associatedLiabilities?: DtoV1CreditValidationLiability[] | null;
  isValidationCompleted?: boolean;
  isReviewBreakdownCompleted?: boolean;
  occupancyType?: DtoV1EnumOccupancyType | null;
  occupancyTypeDescription?: string | null;
  documents?: DtoV1DocumentSelection[] | null;
  /** @format int64 */
  documentId?: number | null;
  /** @format int32 */
  ruleResultId?: number | null;
  ruleMetadata?: DtoV1ValidationResultRuleMetadata | null;
  ruleReferenceIdentifiers?:
    | DtoV1ValidationResultRuleReferenceIdentifier[]
    | null;
  questionAnswers?: Record<
    string,
    DtoV2RealEstateOwnedREOQuestionAnswerMetadata
  > | null;
}

export interface DtoV2RealEstateOwnedREOQuestionAnswerMetadata {
  /** @format int32 */
  questionAnswerId?: number | null;
  /** @format int32 */
  questionUserResponseID?: number;
}

export interface DtoV2RealEstateOwnedSaveRealEstateOwnedMultipleRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  saveRealEstateOwnedRequests?:
    | DtoV2RealEstateOwnedSaveRealEstateOwnedRequest[]
    | null;
  saveQuestionAnswerRequest?: DtoV1ValidationResultSaveQuestionAnswersRequest | null;
}

export interface DtoV2RealEstateOwnedSaveRealEstateOwnedRequest {
  isInsuranceOrTaxesOrBothEscrowed?: string | null;
  providedInsuranceDocs?: boolean | null;
  providedTaxDocs?: boolean | null;
  /** @format decimal */
  monthlyInsuranceAmount?: number | null;
  /** @format decimal */
  monthlyTaxesAmount?: number | null;
  /** @format decimal */
  monthlyHOAAmount?: number | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  occupancyType?: DtoV1EnumOccupancyType | null;
  expectedTransactionCompletionQuestionAnswer?: string | null;
}

export interface DtoV2RealEstateOwnedSaveRealEstateOwnedScreenDataRequest {
  obfuscatedLoanIdentifier?: DtoIdentitiesObfuscatedLoanIdentifier | null;
  addressIdentifier?: DtoIdentitiesAddressIdentifier | null;
  formValues?: Record<string, string | null>;
  questionAnswers?: Record<
    string,
    DtoV2RealEstateOwnedREOQuestionAnswerMetadata
  > | null;
  occupancyType?: DtoV1EnumOccupancyType | null;
  /** @format int32 */
  userId?: number;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === "multipart/form-data" &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === "text/plain" &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title UWMUDS API
 * @version 1.0
 *
 * UWMUDS API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    accountInformationGetAccountSummaryInformation: Object.assign(
      (data: ModelsAssetsAssetDisplayRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1BoltResponseModelsAssetsDepositoryAccountScreenDataDictionarySystemStringSystemObject,
          any
        >({
          path: `/v1/AccountInformation/GetAccountSummaryInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AccountInformation/GetAccountSummaryInformation",
        method: "post",
      } as unknown,
    ),

    accountReviewGetAccountReviewInformation: Object.assign(
      (data: ModelsAssetsAssetDisplayRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1BoltResponseModelsAssetsDepositoryAccountReviewScreenDataDictionarySystemStringSystemObject,
          any
        >({
          path: `/v1/AccountReview/GetAccountReviewInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AccountReview/GetAccountReviewInformation",
        method: "post",
      } as unknown,
    ),

    accountReviewSaveSaveAccountReviewInformation: Object.assign(
      (
        data: ModelsAssetsSaveAccountReviewInformationRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/AccountReviewSave/SaveAccountReviewInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/AccountReviewSave/SaveAccountReviewInformation",
        method: "post",
      } as unknown,
    ),

    accountSummarySaveSaveAccountSummaryInformation: Object.assign(
      (
        data: ModelsAssetsSaveAccountSummaryInformationRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/AccountSummarySave/SaveAccountSummaryInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/AccountSummarySave/SaveAccountSummaryInformation",
        method: "post",
      } as unknown,
    ),

    actionBarIconDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1ActionBarIconResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/ActionBar/icon/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ActionBar/icon/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    actionBarCounterOfferModalDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1CounterOfferCounterOfferModalResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/ActionBar/counter-offer-modal/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ActionBar/counter-offer-modal/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    actionBarCounterOffer: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1CounterOfferSaveCounterOfferRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/ActionBar/counter-offer/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/ActionBar/counter-offer/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "post",
      } as unknown,
    ),

    actionBarAutoCofcDifferencesDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1CaptureEventFieldDifference[],
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/ActionBar/auto-cofc-differences/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ActionBar/auto-cofc-differences/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    actionBarChangeOfCircumstanceRequest: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/ActionBar/change-of-circumstance-request`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/ActionBar/change-of-circumstance-request",
        method: "post",
      } as unknown,
    ),

    appraisalsDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AppraisalAppraisalData, any>({
          path: `/v1/Appraisals/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Appraisals/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    appraisals: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1AppraisalSaveAppraisalRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Appraisals/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Appraisals/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "post",
      } as unknown,
    ),

    appraisalsAppraiserLicenseDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        appraiserLicenseNumber: string,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1AppraisalAppraisalData,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/Appraisals/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/appraiser-license/${appraiserLicenseNumber}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Appraisals/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/appraiser-license/{appraiserLicenseNumber}",
        method: "get",
      } as unknown,
    ),

    appraisalsSubmissionSummaryReportList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AppraisalSubmissionSummaryReport, any>({
          path: `/v1/Appraisals/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/submission-summary-report`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Appraisals/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/submission-summary-report",
        method: "get",
      } as unknown,
    ),

    appraisalsSubmissionSummaryReport: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1AppraisalSaveSubmissionSummaryReportDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Appraisals/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/submission-summary-report`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Appraisals/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/submission-summary-report",
        method: "post",
      } as unknown,
    ),

    appraisalsAppraisalXml: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        appraisalXmlId: number,
        data: DtoV1AppraisalSaveAppraisalRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Appraisals/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/appraisal-xml/${appraisalXmlId}`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Appraisals/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/appraisal-xml/{appraisalXmlId}",
        method: "post",
      } as unknown,
    ),

    appraisersSearchList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        query?: {
          searchText?: string;
          /** @format date-time */
          appraisalEffectiveDate?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AppraisalAppraiserSearchResult[], any>({
          path: `/v1/Appraisers/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/search`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Appraisers/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/search",
        method: "get",
      } as unknown,
    ),

    appraisersEmailQcApprovals: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1AppraisalEmailQcApprovalsRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AppraisalEmailQcApprovalsResponse, any>({
          path: `/v1/Appraisers/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/email-qc-approvals`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Appraisers/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/email-qc-approvals",
        method: "post",
      } as unknown,
    ),

    assetsInformationGetAssetsInformation: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<ModelsAssetsAssetInformationModel[], any>({
          path: `/v1/AssetsInformation/GetAssetsInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/GetAssetsInformation",
        method: "post",
      } as unknown,
    ),

    assetsInformationGetAssetsInformationForAssetSummary: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<ModelsAssetsAssetsBorrowerInformation, any>({
          path: `/v1/AssetsInformation/GetAssetsInformationForAssetSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/GetAssetsInformationForAssetSummary",
        method: "post",
      } as unknown,
    ),

    assetsInformationGetSingleAssetInformation: Object.assign(
      (data: ModelsAssetsAssetDisplayRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1BoltResponseModelsAssetsAssetAccountScreenDataModelsAssetsAssetAccountInitialFormValues,
          any
        >({
          path: `/v1/AssetsInformation/GetSingleAssetInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/GetSingleAssetInformation",
        method: "post",
      } as unknown,
    ),

    assetsInformationDeleteAsset: Object.assign(
      (data: DtoV1AssetsDeleteAssetRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/AssetsInformation/DeleteAsset`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/DeleteAsset",
        method: "post",
      } as unknown,
    ),

    assetsInformationBatchDeleteAssets: Object.assign(
      (
        data: DtoV1AssetsBatchAssetRecordIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/AssetsInformation/BatchDeleteAssets`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/BatchDeleteAssets",
        method: "post",
      } as unknown,
    ),

    assetsInformationGetAssetReconciliationInformation: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<ModelsAssetsAssetReconciliationResponse, any>({
          path: `/v1/AssetsInformation/GetAssetReconciliationInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/GetAssetReconciliationInformation",
        method: "post",
      } as unknown,
    ),

    assetsInformationUpdateAdditionalReserves: Object.assign(
      (
        data: DtoV1AssetsUpdateAdditionalReservesRequest,
        params: RequestParams = {},
      ) =>
        this.request<ModelsAssetsUpdateAdditionalReservesResponse, any>({
          path: `/v1/AssetsInformation/UpdateAdditionalReserves`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AssetsInformation/UpdateAdditionalReserves",
        method: "post",
      } as unknown,
    ),

    ausRunAus: Object.assign(
      (data: DtoV1AUSAUSRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/AUS/RunAUS`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AUS/RunAUS",
        method: "post",
      } as unknown,
    ),

    ausRunAusWithReissue: Object.assign(
      (data: DtoV1AUSRunAusWithReissueRequest, params: RequestParams = {}) =>
        this.request<DtoV1AUSAusResponse, MicrosoftAspNetCoreMvcProblemDetails>(
          {
            path: `/v1/AUS/run-aus-with-reissue`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          },
        ),
      {
        path: "/v1/AUS/run-aus-with-reissue",
        method: "post",
      } as unknown,
    ),

    ausSkipAus: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/AUS/SkipAUS`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/AUS/SkipAUS",
        method: "post",
      } as unknown,
    ),

    ausGetAusRecommendation: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1AUSGetAUSRecommendationResponse, any>({
          path: `/v1/AUS/GetAUSRecommendation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AUS/GetAUSRecommendation",
        method: "post",
      } as unknown,
    ),

    ausRequestHistoryList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AUSGetAusRequestHistoryResponse, any>({
          path: `/v1/AUS/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/RequestHistory`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AUS/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/RequestHistory",
        method: "get",
      } as unknown,
    ),

    ausCreditReport: Object.assign(
      (data: DtoV1AUSAusDocumentRequest, params: RequestParams = {}) =>
        this.request<DtoV1AUSAusDocumentResponse, any>({
          path: `/v1/AUS/credit-report`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AUS/credit-report",
        method: "post",
      } as unknown,
    ),

    ausFindings: Object.assign(
      (data: DtoV1AUSAusDocumentRequest, params: RequestParams = {}) =>
        this.request<DtoV1AUSAusDocumentResponse, any>({
          path: `/v1/AUS/findings`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AUS/findings",
        method: "post",
      } as unknown,
    ),

    ausAusDetailsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AUSGetAusDetailsResponse, any>({
          path: `/v1/AUS/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/aus-details`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/AUS/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/aus-details",
        method: "get",
      } as unknown,
    ),

    ausPositiveRentalPayment: Object.assign(
      (
        data: DtoV1AUSUpdatePositiveRentalHistoryPaymentRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/AUS/positive-rental-payment`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/AUS/positive-rental-payment",
        method: "post",
      } as unknown,
    ),

    boltApprovalGetBoltApprovalData: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltApprovalBoltApprovalData, any>({
          path: `/v1/BoltApproval/GetBoltApprovalData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltApproval/GetBoltApprovalData",
        method: "post",
      } as unknown,
    ),

    boltAuditGetBoltAudit: Object.assign(
      (data: DtoV1BoltAuditBoltAuditRequest, params: RequestParams = {}) =>
        this.request<DtoV1BoltAuditBoltAuditResponse, any>({
          path: `/v1/BoltAudit/GetBoltAudit`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetBoltAudit",
        method: "post",
      } as unknown,
    ),

    boltAuditGetSectionedBoltAudit: Object.assign(
      (data: DtoV1BoltAuditBoltAuditRequest, params: RequestParams = {}) =>
        this.request<DtoV1BoltAuditSectionedAuditPage, any>({
          path: `/v1/BoltAudit/GetSectionedBoltAudit`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetSectionedBoltAudit",
        method: "post",
      } as unknown,
    ),

    boltAuditGetBoltAuditSummaryScreen: Object.assign(
      (data: DtoV1BoltAuditBoltAuditRequest, params: RequestParams = {}) =>
        this.request<DtoV1BoltAuditBoltAuditSummaryScreenResponse, any>({
          path: `/v1/BoltAudit/GetBoltAuditSummaryScreen`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetBoltAuditSummaryScreen",
        method: "post",
      } as unknown,
    ),

    boltAuditGetAssetDepositoryAudit: Object.assign(
      (data: DtoV1BoltAuditAssetAuditRequest, params: RequestParams = {}) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/GetAssetDepositoryAudit`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetAssetDepositoryAudit",
        method: "post",
      } as unknown,
    ),

    boltAuditGetTransferReconciliationAudit: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/GetTransferReconciliationAudit`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetTransferReconciliationAudit",
        method: "post",
      } as unknown,
    ),

    boltAuditAssetReconciliationList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/asset-reconciliation`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/asset-reconciliation",
        method: "get",
      } as unknown,
    ),

    boltAuditGetValidateDocumentAudit: Object.assign(
      (
        data: DtoV1BoltAuditValidateDocumentAuditRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/GetValidateDocumentAudit`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetValidateDocumentAudit",
        method: "post",
      } as unknown,
    ),

    boltAuditGetIncomeCalculatorAudit: Object.assign(
      (
        data: DtoV1BoltAuditIncomeCalculateAuditRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/GetIncomeCalculatorAudit`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetIncomeCalculatorAudit",
        method: "post",
      } as unknown,
    ),

    boltAuditGetIncomeAuditHistory: Object.assign(
      (data: DtoV1BoltAuditBoltAuditRequest, params: RequestParams = {}) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/GetIncomeAuditHistory`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/GetIncomeAuditHistory",
        method: "post",
      } as unknown,
    ),

    boltAuditIncomeReconciliationList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltAuditIncomeReconSectionedBoltAuditResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/BoltAudit/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/income-reconciliation`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/income-reconciliation",
        method: "get",
      } as unknown,
    ),

    boltAuditDepositSourcingList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        assetId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/${assetId}/deposit-sourcing`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/{assetId}/deposit-sourcing",
        method: "get",
      } as unknown,
    ),

    boltAuditStatusAndReviewList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltAuditBoltAuditResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/BoltAudit/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/status-and-review`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/status-and-review",
        method: "get",
      } as unknown,
    ),

    boltAuditBorrower1003List: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltAuditBorrower1003AuditPageResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/BoltAudit/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/borrower1003`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/borrower1003",
        method: "get",
      } as unknown,
    ),

    boltAuditAccountStatementDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        assetId: number,
        documentId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditSectionedBoltAuditResponse, any>({
          path: `/v1/BoltAudit/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/account-statement/${assetId}/${documentId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltAudit/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/account-statement/{assetId}/{documentId}",
        method: "get",
      } as unknown,
    ),

    boltHistoryGetBoltAuditHistory: Object.assign(
      (
        data: DtoV1BoltHistoryBoltAuditHistoryRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltHistoryBoltAuditHistoryResponse, any>({
          path: `/v1/BoltHistory/GetBoltAuditHistory`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltHistory/GetBoltAuditHistory",
        method: "post",
      } as unknown,
    ),

    boltStatusGetBoltStatus: Object.assign(
      (data: DtoV1BoltStatusBoltStatusRequest, params: RequestParams = {}) =>
        this.request<DtoV1BoltStatusBoltStatusResponse, any>({
          path: `/v1/BoltStatus/GetBoltStatus`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/BoltStatus/GetBoltStatus",
        method: "post",
      } as unknown,
    ),

    borrowerVaNetTangibleBenefitsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VANetTangibleBenefitsData, any>({
          path: `/v1/Borrower/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/va-net-tangible-benefits`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/va-net-tangible-benefits",
        method: "get",
      } as unknown,
    ),

    borrowerVaNetTangibleBenefits: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VANetTangibleBenefitsSaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Borrower/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/va-net-tangible-benefits`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Borrower/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/va-net-tangible-benefits",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationGetCitizenship: Object.assign(
      (
        data: DtoV1Borrower1003GetCitizenshipRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1Borrower1003GetCitizenshipResponse, any>({
          path: `/v1/Borrower1003Validation/GetCitizenship`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/GetCitizenship",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationSaveCitizenship: Object.assign(
      (
        data: DtoV1Borrower1003SaveCitizenshipRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Borrower1003Validation/SaveCitizenship`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/SaveCitizenship",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationGetFirstTimeHomeBuyer: Object.assign(
      (
        data: DtoV1Borrower1003GetFirstTimeHomeBuyerRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1Borrower1003GetFirstTimeHomeBuyerResponse, any>({
          path: `/v1/Borrower1003Validation/GetFirstTimeHomeBuyer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/GetFirstTimeHomeBuyer",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationSaveFirstTimeHomeBuyer: Object.assign(
      (
        data: DtoV1Borrower1003SaveFirstTimeHomeBuyerRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Borrower1003Validation/SaveFirstTimeHomeBuyer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/SaveFirstTimeHomeBuyer",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationGetNonOccupyingCoBorrowerInfo: Object.assign(
      (
        data: DtoV1Borrower1003GetNonOccupyingCoBorrowersRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1Borrower1003GetNonOccupyingCoBorrowersResponse, any>({
          path: `/v1/Borrower1003Validation/GetNonOccupyingCoBorrowerInfo`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/GetNonOccupyingCoBorrowerInfo",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationSaveNonOccupyingCoBorrowerInfo: Object.assign(
      (
        data: DtoV1Borrower1003SaveNonOccupyingCoBorrowersRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Borrower1003Validation/SaveNonOccupyingCoBorrowerInfo`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/SaveNonOccupyingCoBorrowerInfo",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationGetSubjectPropertyOccupancy: Object.assign(
      (
        data: DtoV1Borrower1003GetSubjectPropertyOccupancyRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1Borrower1003SubjectPropertyOccupancyDto, any>({
          path: `/v1/Borrower1003Validation/GetSubjectPropertyOccupancy`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/GetSubjectPropertyOccupancy",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationSaveSubjectPropertyOccupancy: Object.assign(
      (
        data: DtoV1Borrower1003SaveSubjectPropertyOccupancyRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Borrower1003Validation/SaveSubjectPropertyOccupancy`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/SaveSubjectPropertyOccupancy",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationBorrowersList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1Borrower1003GetBorrowerSummaryDataResponse, any>({
          path: `/v1/Borrower1003Validation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/borrowers`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/borrowers",
        method: "get",
      } as unknown,
    ),

    borrower1003ValidationBorrowerSummary: Object.assign(
      (
        data: DtoV1Borrower1003UpdateBorrowerSummaryRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Borrower1003Validation/BorrowerSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/BorrowerSummary",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationUpdateBorrowerResidenceHistoryDetails: Object.assign(
      (
        data: DtoV1Borrower1003UpdateBorrowerResidenceInformationRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Borrower1003Validation/UpdateBorrowerResidenceHistoryDetails`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/UpdateBorrowerResidenceHistoryDetails",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationDeleteBorrowerSummary: Object.assign(
      (
        data: DtoV1Borrower1003DeleteBorrowerRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Borrower1003Validation/DeleteBorrowerSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/DeleteBorrowerSummary",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationUpdateBorrowerDeclarations: Object.assign(
      (
        data: DtoV1Borrower1003UpdateBorrowerDeclarationsRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Borrower1003Validation/UpdateBorrowerDeclarations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/UpdateBorrowerDeclarations",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationFirstTimeHomeBuyerDetailsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1Borrower1003BorrowerFirstTimeHomeBuyerScreenDataDtoV1Borrower1003BorrowerFirstTimeHomeBuyerInitialFormValues,
          any
        >({
          path: `/v1/Borrower1003Validation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/FirstTimeHomeBuyerDetails`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/FirstTimeHomeBuyerDetails",
        method: "get",
      } as unknown,
    ),

    borrower1003ValidationSaveBorrowerFirstTimeHomeBuyer: Object.assign(
      (
        data: DtoV1Borrower1003SaveBorrowerFirstTimeHomeBuyerRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Borrower1003Validation/SaveBorrowerFirstTimeHomeBuyer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Borrower1003Validation/SaveBorrowerFirstTimeHomeBuyer",
        method: "post",
      } as unknown,
    ),

    borrower1003ValidationFirstTimeHomeBuyerHousingCounselingDetailsList:
      Object.assign(
        (
          obfuscatedLenderDatabaseId: number,
          obfuscatedLoanRecordId: number,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1BoltResponseDtoV1Borrower1003BorrowerHousingCounselingScreenDataDtoV1Borrower1003BorrowerHousingCounselingInitialFormValues,
            any
          >({
            path: `/v1/Borrower1003Validation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/FirstTimeHomeBuyerHousingCounselingDetails`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
          }),
        {
          path: "/v1/Borrower1003Validation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/FirstTimeHomeBuyerHousingCounselingDetails",
          method: "get",
        } as unknown,
      ),

    borrower1003ValidationSaveBorrowerFirstTimeHomeBuyerHousingCounseling:
      Object.assign(
        (
          data: DtoV1Borrower1003SaveBorrowerFirstTimeHomeBuyerHousingCounselingRequest,
          params: RequestParams = {},
        ) =>
          this.request<any, any>({
            path: `/v1/Borrower1003Validation/SaveBorrowerFirstTimeHomeBuyerHousingCounseling`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            ...params,
          }),
        {
          path: "/v1/Borrower1003Validation/SaveBorrowerFirstTimeHomeBuyerHousingCounseling",
          method: "post",
        } as unknown,
      ),

    checkpointSendCheckpoint: Object.assign(
      (data: DtoV1CheckpointRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/Checkpoint/SendCheckpoint`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Checkpoint/SendCheckpoint",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsGetDocumentPdfDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        documentId: number,
        params: RequestParams = {},
      ) =>
        this.request<File, any>({
          path: `/v1/ClassifyDocuments/GetDocumentPdf/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/${documentId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/GetDocumentPdf/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/{documentId}",
        method: "get",
      } as unknown,
    ),

    classifyDocumentsUpdateDocumentClassification: Object.assign(
      (
        data: DtoV1ClassifyDocumentsUpdateDocumentClassificationRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1ClassifyDocumentsUpdateDocumentClassificationResponse,
          any
        >({
          path: `/v1/ClassifyDocuments/UpdateDocumentClassification`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/UpdateDocumentClassification",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsHideDocument: Object.assign(
      (
        data: DtoV1ClassifyDocumentsHideDocumentRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1ClassifyDocumentsUpdateDocumentClassificationResponse,
          any
        >({
          path: `/v1/ClassifyDocuments/HideDocument`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/HideDocument",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsAdrPendingList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/ClassifyDocuments/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/adr-pending`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/adr-pending",
        method: "get",
      } as unknown,
    ),

    classifyDocumentsGetDocumentTypesAndCategoriesDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1ClassifyDocumentsGetDocumentTypesAndCategoriesResponse,
          any
        >({
          path: `/v1/ClassifyDocuments/GetDocumentTypesAndCategories/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/GetDocumentTypesAndCategories/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    classifyDocumentsUploadBoltApprovalLetter: Object.assign(
      (
        data: DtoV1ClassifyDocumentsUploadBoltApprovalLetterRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/ClassifyDocuments/UploadBoltApprovalLetter`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/UploadBoltApprovalLetter",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsGetDocumentTypeAssociations: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV2ClassifyDocumentsGetDocumentTypeAssociationsResponse,
          any
        >({
          path: `/v1/ClassifyDocuments/GetDocumentTypeAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/GetDocumentTypeAssociations",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsGetClassifiedDocumentsForBatchProcessing: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1BoltResponseDtoV1ClassifyDocumentsClassifyDocumentsScreenDataDtoV1ClassifyDocumentsClassifyDocumentsInitialFormValues,
          any
        >({
          path: `/v1/ClassifyDocuments/GetClassifiedDocumentsForBatchProcessing`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/GetClassifiedDocumentsForBatchProcessing",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsNavigationList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1NavigationTopNavigationItem, any>({
          path: `/v1/ClassifyDocuments/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/navigation`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/ClassifyDocuments/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/navigation",
        method: "get",
      } as unknown,
    ),

    communicationPreferencesGetCommunicationPreferences: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1FinalReviewCommunicationPreferencesCommunicationPreferences[],
          any
        >({
          path: `/v1/CommunicationPreferences/GetCommunicationPreferences`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CommunicationPreferences/GetCommunicationPreferences",
        method: "post",
      } as unknown,
    ),

    conditionsGetLoanConditions: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<ModelsBoltApprovalLoanConditionData, any>({
          path: `/v1/Conditions/GetLoanConditions`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Conditions/GetLoanConditions",
        method: "post",
      } as unknown,
    ),

    internalLoanContacts: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        query?: {
          contactCategories?: DtoV1EnumContactCategoryType[];
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1ContactContactOptions[], any>({
          path: `/v1/Contact/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/InternalLoanContacts`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Contact/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/InternalLoanContacts",
        method: "get",
      } as unknown,
    ),

    contactSaveInternalLoanContact: Object.assign(
      (
        data: DtoV1ContactSaveInternalLoanContactsRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Contact/SaveInternalLoanContact`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Contact/SaveInternalLoanContact",
        method: "post",
      } as unknown,
    ),

    underwriterAssignments: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1ContactSaveLoanContactsAndQueueCommentRequest,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/UnderwriterAssignments/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwriterAssignments/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "post",
      } as unknown,
    ),

    underwriterAssignmentsDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoGetMultipackResponse, string>({
          path: `/v1/UnderwriterAssignments/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwriterAssignments/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    internalLoanContactsAndQueueComment: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        query?: {
          contactCategories?: DtoV1EnumContactCategoryType[];
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1ContactGetLoanContactsAndQueueCommentResponse, any>({
          path: `/v1/Contact/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/InternalLoanContactsAndQueueComment`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Contact/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/InternalLoanContactsAndQueueComment",
        method: "get",
      } as unknown,
    ),

    creditCreditReportLatestList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1CreditCreditReportDocumentResponse, string>({
          path: `/v1/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/credit/credit-report/latest`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/credit/credit-report/latest",
        method: "get",
      } as unknown,
    ),

    creditCreditReportDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        requestId: string,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1CreditCreditReportDocumentResponse, string>({
          path: `/v1/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/credit/credit-report/${requestId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/credit/credit-report/{requestId}",
        method: "get",
      } as unknown,
    ),

    creditValidationGetCreditValidationInfo: Object.assign(
      (
        data: DtoV1CreditValidationGetCreditValidationDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1CreditValidationGetCreditValidationDataResponse, any>(
          {
            path: `/v1/CreditValidation/GetCreditValidationInfo`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          },
        ),
      {
        path: "/v1/CreditValidation/GetCreditValidationInfo",
        method: "post",
      } as unknown,
    ),

    creditValidationUpdateCreditValidationData: Object.assign(
      (
        data: DtoV1CreditValidationUpdateCreditValidationDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1CreditValidationUpdateCreditValidationDataResponse,
          any
        >({
          path: `/v1/CreditValidation/UpdateCreditValidationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/UpdateCreditValidationData",
        method: "post",
      } as unknown,
    ),

    creditValidationGetCreditValidationResults: Object.assign(
      (data: DtoV1GetValidationResultsRequest, params: RequestParams = {}) =>
        this.request<DtoV1ValidationResultGetValidationResultsResponse, any>({
          path: `/v1/CreditValidation/GetCreditValidationResults`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/GetCreditValidationResults",
        method: "post",
      } as unknown,
    ),

    creditValidationGetLatestCreditDocument: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1CreditValidationCreditReportDocument, any>({
          path: `/v1/CreditValidation/GetLatestCreditDocument`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/GetLatestCreditDocument",
        method: "post",
      } as unknown,
    ),

    creditValidationGetMortgageHistoryQuestionAnswers: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1CreditValidationGetMortgageHistoryScreenDataIDictionarySystemStringSystemObject,
          any
        >({
          path: `/v1/CreditValidation/GetMortgageHistoryQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/GetMortgageHistoryQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    creditValidationSaveMortgageHistoryAnswerData: Object.assign(
      (
        data: DtoV1CreditValidationSaveMortgageHistoryDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1CreditValidationUpdateCreditValidationDataResponse,
          any
        >({
          path: `/v1/CreditValidation/SaveMortgageHistoryAnswerData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/SaveMortgageHistoryAnswerData",
        method: "post",
      } as unknown,
    ),

    creditValidationGetDerogatoryEventsDataDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1CreditValidationDerogatoryEventsDataResponse, any>({
          path: `/v1/CreditValidation/GetDerogatoryEventsData/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/GetDerogatoryEventsData/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    getMortgageHistory: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1CreditValidationMortgageHistoryScreenDataDtoV1CreditValidationMortgageHistoryInitialFormValues,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/CreditValidation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-history`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-history",
        method: "get",
      } as unknown,
    ),

    saveMortgageHistory: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1CreditValidationSaveMortgageHistoryRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/CreditValidation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-history`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/CreditValidation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-history",
        method: "post",
      } as unknown,
    ),

    depositSourceGetDepositSourceInformation: Object.assign(
      (data: ModelsAssetsDepositSourceRequest, params: RequestParams = {}) =>
        this.request<ModelsAssetsDepositSourceInformation, any>({
          path: `/v1/DepositSource/GetDepositSourceInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DepositSource/GetDepositSourceInformation",
        method: "post",
      } as unknown,
    ),

    depositSourceSaveDepositSourceInformation: Object.assign(
      (
        data: DtoV1AssetsSaveDepositSourceInformationRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/DepositSource/SaveDepositSourceInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/DepositSource/SaveDepositSourceInformation",
        method: "post",
      } as unknown,
    ),

    documentAssociationSaveDocumentAssociations: Object.assign(
      (
        data: DtoV1DocumentAssociationSaveDocumentAssociationRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1DocumentAssociationSuccessResponse, any>({
          path: `/v1/DocumentAssociation/SaveDocumentAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DocumentAssociation/SaveDocumentAssociations",
        method: "post",
      } as unknown,
    ),

    documentAssociationSaveBatchDocumentAssociations: Object.assign(
      (
        data: DtoV1DocumentAssociationSaveBatchDocumentAssociations,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1DocumentAssociationSuccessResponse, any>({
          path: `/v1/DocumentAssociation/SaveBatchDocumentAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DocumentAssociation/SaveBatchDocumentAssociations",
        method: "post",
      } as unknown,
    ),

    documentAssociationGetDocumentAssociations: Object.assign(
      (
        data: DtoV1ClassifyDocumentsGetDocumentAssociationsRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1ClassifyDocumentsGetDocumentAssociationsResponse,
          any
        >({
          path: `/v1/DocumentAssociation/GetDocumentAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DocumentAssociation/GetDocumentAssociations",
        method: "post",
      } as unknown,
    ),

    documentAssociationGetAssociatedDocumentsByIncome: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1DocumentAssociationAssociatedDocument[], any>({
          path: `/v1/DocumentAssociation/GetAssociatedDocumentsByIncome`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DocumentAssociation/GetAssociatedDocumentsByIncome",
        method: "post",
      } as unknown,
    ),

    documentExtractionSnippetDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        snippetId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1DocumentSnippet, string>({
          path: `/v1/DocumentExtraction/Snippet/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/${snippetId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DocumentExtraction/Snippet/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/{snippetId}",
        method: "get",
      } as unknown,
    ),

    documentViewerDochubFolderUrlList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1DocumentViewerResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/DocumentViewer/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/dochub-folder-url`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/DocumentViewer/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/dochub-folder-url",
        method: "get",
      } as unknown,
    ),

    earlyCheckRun: Object.assign(
      (
        obfuscatedLenderDatabaseId: string,
        obfuscatedLoanRecordId: string,
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<string, any>({
          path: `/v1/EarlyCheck/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/run`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EarlyCheck/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/run",
        method: "post",
      } as unknown,
    ),

    earlyCheckAppraisalManagementCompanyList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1EarlyCheckAppraisalManagementCompany, any>({
          path: `/v1/EarlyCheck/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/appraisal-management-company`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EarlyCheck/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/appraisal-management-company",
        method: "get",
      } as unknown,
    ),

    employmentIncomeGetEmploymentQuestions: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeIncomeSummaryQuestionResponse[], any>({
          path: `/v1/EmploymentIncome/GetEmploymentQuestions`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/GetEmploymentQuestions",
        method: "post",
      } as unknown,
    ),

    employmentIncomeSaveEmploymentAnswer: Object.assign(
      (data: DtoV1IncomeSaveAnswerRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/EmploymentIncome/SaveEmploymentAnswer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/SaveEmploymentAnswer",
        method: "post",
      } as unknown,
    ),

    employmentIncomeGetAnsweredQuestions: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeIncomeSummaryAnsweredQuestionResponse[], any>({
          path: `/v1/EmploymentIncome/GetAnsweredQuestions`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/GetAnsweredQuestions",
        method: "post",
      } as unknown,
    ),

    employmentIncomeGetCustomerEmploymentDetail: Object.assign(
      (
        data: DtoV1IncomeIncomeSummaryCustomerEmploymentDetailRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeIncomeSummaryCustomerEmploymentDetail, any>({
          path: `/v1/EmploymentIncome/GetCustomerEmploymentDetail`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/GetCustomerEmploymentDetail",
        method: "post",
      } as unknown,
    ),

    employmentIncomeGetEmploymentQuestionsAndAnswers: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeIncomeSummaryEmploymentQuestionsAndAnswersResponse[],
          any
        >({
          path: `/v1/EmploymentIncome/GetEmploymentQuestionsAndAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/GetEmploymentQuestionsAndAnswers",
        method: "post",
      } as unknown,
    ),

    employmentIncomeRemoveIncomeAndEmploymentInfo: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/EmploymentIncome/RemoveIncomeAndEmploymentInfo`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/RemoveIncomeAndEmploymentInfo",
        method: "post",
      } as unknown,
    ),

    employmentIncomeGetNoDocumentsProvidedQuestionAnswers: Object.assign(
      (
        data: DtoV1IncomeIncomeSummaryCustomerEmploymentDetailRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1IncomeNoDocumentsProvidedScreenDataIDictionarySystemStringSystemString,
          any
        >({
          path: `/v1/EmploymentIncome/GetNoDocumentsProvidedQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncome/GetNoDocumentsProvidedQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationGetEmploymentIncomeValidationData: Object.assign(
      (
        data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1EmploymentIncomeValidateDocumentResponse, any>({
          path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationData",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationGetEmploymentIncomeValidationDataWithFieldResolution:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeValidateDocumentDetailsWithFieldResolution,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataWithFieldResolution`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataWithFieldResolution",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationGetEmploymentIncomeValidationDataW2:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeEmploymentIncomeValidationDataW2,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataW2`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataW2",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationGetEmploymentIncomeValidationDataPaystub:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeEmploymentIncomeValidationDataPaystub,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataPaystub`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataPaystub",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationGetEmploymentIncomeValidationDataScheduleC:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeEmploymentIncomeValidationDataScheduleC,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataScheduleC`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataScheduleC",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationGetEmploymentIncomeValidationDataBankStatement:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeEmploymentIncomeValidationDataBankStatement,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataBankStatement`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataBankStatement",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationGetEmploymentIncomeValidationDataAwardLetter:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeEmploymentIncomeValidationDataAwardLetter,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataAwardLetter`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataAwardLetter",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationGetEmploymentReviewData: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1EmploymentIncomeEmploymentReviewEmploymentReviewResponse,
          any
        >({
          path: `/v1/EmploymentIncomeValidation/GetEmploymentReviewData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/GetEmploymentReviewData",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationUpdateEmploymentAndQuestionAnswers: Object.assign(
      (
        data: DtoV1EmploymentIncomeUpdateEmploymentAndQuestionAnswers,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1EmploymentIncomeUpdateEmploymentAndQuestionAnswersResults,
          any
        >({
          path: `/v1/EmploymentIncomeValidation/UpdateEmploymentAndQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/UpdateEmploymentAndQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationUpdateEmploymentSmartQuestionAnswers:
      Object.assign(
        (
          data: DtoV1EmploymentIncomeUpdateEmploymentSmartQuestionAnswers,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1EmploymentIncomeUpdateEmploymentAndQuestionAnswersResults,
            any
          >({
            path: `/v1/EmploymentIncomeValidation/UpdateEmploymentSmartQuestionAnswers`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/EmploymentIncomeValidation/UpdateEmploymentSmartQuestionAnswers",
          method: "post",
        } as unknown,
      ),

    employmentIncomeValidationUpdateEmploymentReviewAnswers: Object.assign(
      (
        data: DtoV1EmploymentIncomeUpdateEmploymentReviewAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/EmploymentIncomeValidation/UpdateEmploymentReviewAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/UpdateEmploymentReviewAnswers",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationInsertCpaInformation: Object.assign(
      (
        data: DtoV1IncomeSaveCpaInformationRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/EmploymentIncomeValidation/InsertCpaInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/InsertCpaInformation",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationUpdateEmploymentReviewDateAnswers: Object.assign(
      (
        data: DtoV1EmploymentIncomeUpdateEmploymentDateAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/EmploymentIncomeValidation/UpdateEmploymentReviewDateAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/UpdateEmploymentReviewDateAnswers",
        method: "post",
      } as unknown,
    ),

    employmentIncomeValidationGetValidateSmartQuestionAnswers: Object.assign(
      (
        data: DtoV1EmploymentIncomeBorrowerEmploymentDocumentTypeIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1EmploymentIncomeValidationScreenDataDtoV1EmploymentIncomeValidationInitialFormValues,
          any
        >({
          path: `/v1/EmploymentIncomeValidation/GetValidateSmartQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/EmploymentIncomeValidation/GetValidateSmartQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    feesCalculateAllocatedSellerConcessions: Object.assign(
      (
        data: DtoV1FeesGetCalculatedAllocatedSellerConcessionsRequest,
        params: RequestParams = {},
      ) =>
        this.request<number, any>({
          path: `/v1/Fees/CalculateAllocatedSellerConcessions`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Fees/CalculateAllocatedSellerConcessions",
        method: "post",
      } as unknown,
    ),

    feesCalculateMaxAllowableSellerConcessions: Object.assign(
      (
        data: DtoV1FeesGetCalculatedMaxAllowableSellerConcessionsRequest,
        params: RequestParams = {},
      ) =>
        this.request<number, any>({
          path: `/v1/Fees/CalculateMaxAllowableSellerConcessions`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Fees/CalculateMaxAllowableSellerConcessions",
        method: "post",
      } as unknown,
    ),

    fhaOverviewDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1FhaOverviewFhaDetailsGetFhaDetailsResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/FhaOverview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FhaOverview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    fhaOverviewFhaDetails: Object.assign(
      (
        data: DtoV1FhaOverviewFhaDetailsSaveFhaDetailsRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/FhaOverview/fha-details`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FhaOverview/fha-details",
        method: "post",
      } as unknown,
    ),

    fhaOverviewUfmipRefundList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1FhaOverviewUfmipUfmipRefund,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/FhaOverview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/ufmip-refund`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FhaOverview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/ufmip-refund",
        method: "get",
      } as unknown,
    ),

    fhaOverviewUfmipRefund: Object.assign(
      (
        data: DtoV1FhaOverviewUfmipSaveUfmipRefund,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1FhaOverviewUfmipUfmipRefund,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/FhaOverview/ufmip-refund`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FhaOverview/ufmip-refund",
        method: "post",
      } as unknown,
    ),

    fhaOverviewSecondaryFinancingList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1FhaOverviewSecondaryFinancingGetFhaSecondaryFinancingResponse,
          any
        >({
          path: `/v1/FhaOverview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/secondary-financing`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FhaOverview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/secondary-financing",
        method: "get",
      } as unknown,
    ),

    fhaOverviewSecondaryFinancing: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1FhaOverviewSecondaryFinancingSaveFhaSecondaryFinancingRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/FhaOverview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/secondary-financing`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FhaOverview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/secondary-financing",
        method: "post",
      } as unknown,
    ),

    finalReviewGetManualCheckStatus: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1FinalReviewChecklistCategories[], any>({
          path: `/v1/FinalReview/GetManualCheckStatus`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/GetManualCheckStatus",
        method: "post",
      } as unknown,
    ),

    finalReviewSaveManualCheckStatus: Object.assign(
      (
        data: DtoV1FinalReviewSaveManualCheckStatusRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/FinalReview/SaveManualCheckStatus`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/SaveManualCheckStatus",
        method: "post",
      } as unknown,
    ),

    finalReviewGetLoanStatusFlipEligibilityData: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<ModelsFinalReviewLoanStatusFlipEligibilityData, any>({
          path: `/v1/FinalReview/GetLoanStatusFlipEligibilityData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/GetLoanStatusFlipEligibilityData",
        method: "post",
      } as unknown,
    ),

    finalReviewSaveFinalRunValidationResult: Object.assign(
      (
        data: DtoV1FinalReviewSaveFinalRunValidationRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/FinalReview/SaveFinalRunValidationResult`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/SaveFinalRunValidationResult",
        method: "post",
      } as unknown,
    ),

    finalReviewFlipLoanStatus: Object.assign(
      (
        data: DtoV1FinalReviewChangeLoanStatusRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/FinalReview/FlipLoanStatus`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/FlipLoanStatus",
        method: "post",
      } as unknown,
    ),

    finalReviewRunClearToCloseValidations: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/FinalReview/RunClearToCloseValidations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/RunClearToCloseValidations",
        method: "post",
      } as unknown,
    ),

    finalReviewDenialReasonsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1LoanStatusDenialReasonResponse, any>({
          path: `/v1/FinalReview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/denial-reasons`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/denial-reasons",
        method: "get",
      } as unknown,
    ),

    finalReviewDenialReasons: Object.assign(
      (
        data: DtoV1LoanStatusUpdateDenialReasonsRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/FinalReview/denial-reasons`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/denial-reasons",
        method: "post",
      } as unknown,
    ),

    finalReviewPrepaidList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1FinalReviewPrepaidResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/FinalReview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/Prepaid`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/Prepaid",
        method: "get",
      } as unknown,
    ),

    finalReviewPrepaid: Object.assign(
      (data: DtoV1FinalReviewSavePrepaidRequest, params: RequestParams = {}) =>
        this.request<any, any>({
          path: `/v1/FinalReview/Prepaid`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FinalReview/Prepaid",
        method: "post",
      } as unknown,
    ),

    fraudGuardInsertFraudGuardRequest: Object.assign(
      (
        data: DtoV1FraudGuardInsertFraudGuardRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/FraudGuard/InsertFraudGuardRequest`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FraudGuard/InsertFraudGuardRequest",
        method: "post",
      } as unknown,
    ),

    fraudGuardGetRedFlags: Object.assign(
      (data: DtoV1FraudGuardGetRedFlagsRequest, params: RequestParams = {}) =>
        this.request<DtoV2FraudGuardGetRedFlagsResponse, any>({
          path: `/v1/FraudGuard/GetRedFlags`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FraudGuard/GetRedFlags",
        method: "post",
      } as unknown,
    ),

    fraudGuardSaveThirdPartyChecksStatus: Object.assign(
      (
        data: DtoV1FraudGuardSaveThirdPartyChecksStatusRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/FraudGuard/SaveThirdPartyChecksStatus`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FraudGuard/SaveThirdPartyChecksStatus",
        method: "post",
      } as unknown,
    ),

    fraudGuardGetLatestFraudGuardData: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1FraudGuardFraudGuardData, any>({
          path: `/v1/FraudGuard/GetLatestFraudGuardData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/FraudGuard/GetLatestFraudGuardData",
        method: "post",
      } as unknown,
    ),

    fraudGuardUpdateFraudGuardViewedIndicator: Object.assign(
      (data: DtoV1FraudGuardFraudGuardData, params: RequestParams = {}) =>
        this.request<any, any>({
          path: `/v1/FraudGuard/UpdateFraudGuardViewedIndicator`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/FraudGuard/UpdateFraudGuardViewedIndicator",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorEmployersCalculatorsDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        customerRecordId: number,
        employerId: number,
        calculatorType: DtoV1EnumIncomeCalculatorType,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculationForm[], any>({
          path: `/v1/income-calculator/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/employers/${customerRecordId}/${employerId}/calculators/${calculatorType}`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/income-calculator/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/employers/{CustomerRecordId}/{EmployerId}/calculators/{CalculatorType}",
        method: "get",
      } as unknown,
    ),

    incomeCalculatorPropertiesCalculatorsDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        addressId: number,
        calculatorType: DtoV1EnumIncomeCalculatorType,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculationForm[], any>({
          path: `/v1/income-calculator/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/properties/${addressId}/calculators/${calculatorType}`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/income-calculator/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/properties/{AddressId}/calculators/{CalculatorType}",
        method: "get",
      } as unknown,
    ),

    incomeCalculatorEmployersCalculations: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        customerRecordId: number,
        employerId: number,
        calculatorType: DtoV1EnumIncomeCalculatorType,
        data: DtoV1IncomeCalculationFormInput[],
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeCalculation,
          MicrosoftAspNetCoreHttpHttpValidationProblemDetails
        >({
          path: `/v1/income-calculator/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/employers/${customerRecordId}/${employerId}/calculations/${calculatorType}`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/income-calculator/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/employers/{CustomerRecordId}/{EmployerId}/calculations/{CalculatorType}",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorEmployersCalculationsAuditList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        customerRecordId: number,
        employerId: number,
        calculatorType: DtoV1EnumIncomeCalculatorType,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditFieldAuditHeader[], any>({
          path: `/v1/income-calculator/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/employers/${customerRecordId}/${employerId}/calculations/${calculatorType}/audit`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/income-calculator/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/employers/{CustomerRecordId}/{EmployerId}/calculations/{CalculatorType}/audit",
        method: "get",
      } as unknown,
    ),

    incomeCalculatorPropertiesCalculations: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        addressId: number,
        calculatorType: DtoV1EnumIncomeCalculatorType,
        data: DtoV1IncomeCalculationFormInput[],
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeCalculation,
          MicrosoftAspNetCoreHttpHttpValidationProblemDetails
        >({
          path: `/v1/income-calculator/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/properties/${addressId}/calculations/${calculatorType}`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/income-calculator/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/properties/{AddressId}/calculations/{CalculatorType}",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorPropertiesCalculationsAuditList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        addressId: number,
        calculatorType: DtoV1EnumIncomeCalculatorType,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<DtoV1BoltAuditFieldAuditHeader[], any>({
          path: `/v1/income-calculator/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/properties/${addressId}/calculations/${calculatorType}/audit`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/income-calculator/{ObfuscatedLenderDatabaseId}/{ObfuscatedLoanRecordId}/properties/{AddressId}/calculations/{CalculatorType}/audit",
        method: "get",
      } as unknown,
    ),

    incomeCalculatorSave: Object.assign(
      (
        data: DtoV1IncomeCalculatorSaveToLoanRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/IncomeCalculator/Save`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/Save",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetCalculations: Object.assign(
      (data: DtoV1GetCalculationRequest, params: RequestParams = {}) =>
        this.request<DtoV1IncomeGetCalculationsCalculationData, any>({
          path: `/v1/IncomeCalculator/GetCalculations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetCalculations",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetCalculationData: Object.assign(
      (data: DtoV1GetCalculationRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1BoltResponseDtoV1IncomeCalculatorYmlGetCalculationsScreenDataDtoV1IncomeCalculatorYmlGetCalculationsInitialFormValues,
          any
        >({
          path: `/v1/IncomeCalculator/GetCalculationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetCalculationData",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetDataForSelectedCalculator: Object.assign(
      (
        data: DtoV1IncomeCalculatorGenericCalculatorGetDataForSelectedCalculatorRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeCalculatorGenericCalculatorGetDataforSelectedCalculatorResponse,
          any
        >({
          path: `/v1/IncomeCalculator/GetDataForSelectedCalculator`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetDataForSelectedCalculator",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetSmartDataForSelectedCalculator: Object.assign(
      (
        data: DtoV1IncomeCalculatorGenericCalculatorGetDataForSelectedCalculatorRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1EmploymentIncomeSmartCalculationScreenDataDtoV1EmploymentIncomeSmartCalculationInitialFormValues,
          any
        >({
          path: `/v1/IncomeCalculator/GetSmartDataForSelectedCalculator`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetSmartDataForSelectedCalculator",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorSaveEmploymentIncomeToLoan: Object.assign(
      (
        data: DtoV1IncomeCalculatorSaveEmploymentIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculatorSaveCalculationResponse, any>({
          path: `/v1/IncomeCalculator/SaveEmploymentIncomeToLoan`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/SaveEmploymentIncomeToLoan",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorSaveCalculationDataToLoan: Object.assign(
      (
        data: DtoV1IncomeCalculatorSaveCalculationDataToLoanRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculatorSaveCalculationResponse, any>({
          path: `/v1/IncomeCalculator/SaveCalculationDataToLoan`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/SaveCalculationDataToLoan",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorRunCalculations: Object.assign(
      (data: DtoV1RunCalculationRequest, params: RequestParams = {}) =>
        this.request<number, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/IncomeCalculator/RunCalculations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/RunCalculations",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorRunSmartCalculations: Object.assign(
      (data: DtoV1RunSmartCalculationRequest, params: RequestParams = {}) =>
        this.request<number, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/IncomeCalculator/RunSmartCalculations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/RunSmartCalculations",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetCalculationsHistory: Object.assign(
      (
        data: DtoV1IncomeHistoryGetCalculationsHistoryRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeHistoryGetHistoryCalculationsResponse, any>({
          path: `/v1/IncomeCalculator/GetCalculationsHistory`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetCalculationsHistory",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetOtherIncomeData: Object.assign(
      (
        data: DtoV1OtherIncomeGetOtherIncomeDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1OtherIncomeGetOtherIncomeDataResponse, any>({
          path: `/v1/IncomeCalculator/GetOtherIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetOtherIncomeData",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorSaveOtherIncomeData: Object.assign(
      (
        data: DtoV1OtherIncomeSaveOtherIncomeDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/IncomeCalculator/SaveOtherIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/SaveOtherIncomeData",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorSaveRentalIncomeToLoan: Object.assign(
      (
        data: DtoV1IncomeCalculatorSaveRentalIncomeToLoanRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculatorSaveRentalIncomeToLoanResponse, any>({
          path: `/v1/IncomeCalculator/SaveRentalIncomeToLoan`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/SaveRentalIncomeToLoan",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorCanRunLeaseAgreementCalculator: Object.assign(
      (
        data: DtoV1IncomeCalculatorRunLeaseAgreementCalculateRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/IncomeCalculator/CanRunLeaseAgreementCalculator`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/CanRunLeaseAgreementCalculator",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorSaveFutureEmploymentData: Object.assign(
      (
        data: DtoV1IncomeFutureIncomeSaveFutureIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeFutureIncomeSaveFutureIncomeResponse, any>({
          path: `/v1/IncomeCalculator/SaveFutureEmploymentData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/SaveFutureEmploymentData",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetFutureWageIncomeData: Object.assign(
      (
        data: DtoV1IncomeFutureIncomeGetFutureWageIncomeDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeFutureIncomeGetFutureWageIncomeDataResponse,
          any
        >({
          path: `/v1/IncomeCalculator/GetFutureWageIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetFutureWageIncomeData",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorGetRecentRaiseIncomeData: Object.assign(
      (
        data: DtoV1IncomeRecentRaiseGetRecentRaiseIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeRecentRaiseGetRecentRaiseIncomeResponse, any>({
          path: `/v1/IncomeCalculator/GetRecentRaiseIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/GetRecentRaiseIncomeData",
        method: "post",
      } as unknown,
    ),

    incomeCalculatorSaveRecentRaiseIncomeData: Object.assign(
      (
        data: DtoV1IncomeRecentRaiseSaveRecentRaiseIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeRecentRaiseSaveRecentRaiseIncomeResponse, any>({
          path: `/v1/IncomeCalculator/SaveRecentRaiseIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeCalculator/SaveRecentRaiseIncomeData",
        method: "post",
      } as unknown,
    ),

    incomeReconciliationGetIncomeReconciliationData: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1IncomeIncomeReconciliationIncomeReconciliationData,
          any
        >({
          path: `/v1/IncomeReconciliation/GetIncomeReconciliationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeReconciliation/GetIncomeReconciliationData",
        method: "post",
      } as unknown,
    ),

    incomeReconciliationSaveIncomeReconciliationData: Object.assign(
      (
        data: DtoV1IncomeIncomeReconciliationSaveIncomeReconciliationData,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/IncomeReconciliation/SaveIncomeReconciliationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/IncomeReconciliation/SaveIncomeReconciliationData",
        method: "post",
      } as unknown,
    ),

    incomeReconciliationCalculateDebtToIncome: Object.assign(
      (
        data: DtoV1IncomeIncomeReconciliationCalculateDebtToIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeIncomeReconciliationDebtToIncomeData, any>({
          path: `/v1/IncomeReconciliation/CalculateDebtToIncome`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeReconciliation/CalculateDebtToIncome",
        method: "post",
      } as unknown,
    ),

    incomeReconciliationCalculateDisplayDataForRentalExclusionChange:
      Object.assign(
        (
          data: DtoV1IncomeIncomeReconciliationSaveIncomeReconciliationData,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1IncomeIncomeReconciliationIncomeReconciliationData,
            MicrosoftAspNetCoreMvcProblemDetails
          >({
            path: `/v1/IncomeReconciliation/CalculateDisplayDataForRentalExclusionChange`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/IncomeReconciliation/CalculateDisplayDataForRentalExclusionChange",
          method: "post",
        } as unknown,
      ),

    incomeResolutionGetIncomeResolutionDetails: Object.assign(
      (
        data: DtoV1IncomeIncomeResolutionGetIncomeResolutionDetailRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeIncomeResolutionGetIncomeResolutionDetailResponse,
          any
        >({
          path: `/v1/IncomeResolution/GetIncomeResolutionDetails`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeResolution/GetIncomeResolutionDetails",
        method: "post",
      } as unknown,
    ),

    incomeResolutionSaveIncomeResolutionDetails: Object.assign(
      (
        data: DtoV1IncomeIncomeResolutionSaveIncomeResolutionDetailRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculatorSaveCalculationResponse, any>({
          path: `/v1/IncomeResolution/SaveIncomeResolutionDetails`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeResolution/SaveIncomeResolutionDetails",
        method: "post",
      } as unknown,
    ),

    incomeSummarySave: Object.assign(
      (
        data: DtoV1IncomeIncomeSummarySaveIncomeSummaryRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/IncomeSummary/Save`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/IncomeSummary/Save",
        method: "post",
      } as unknown,
    ),

    incomeSummaryGet: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeIncomeSummaryGetIncomeSummaryInformation, any>({
          path: `/v1/IncomeSummary/Get`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/IncomeSummary/Get",
        method: "post",
      } as unknown,
    ),

    incomeSummaryGetIncomeSummaryAndQuestionAnswerChildSupportFha:
      Object.assign(
        (
          data: DtoV1IncomeBorrowerEmploymentIdentifier,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1BoltResponseDtoV1IncomeIncomeSummaryIncomeSummaryDocumentTreeDtoV1IncomeIncomeSummaryIncomeSummaryFhaChildSupportQuestionsAndAnswers,
            any
          >({
            path: `/v1/IncomeSummary/GetIncomeSummaryAndQuestionAnswerChildSupportFha`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/IncomeSummary/GetIncomeSummaryAndQuestionAnswerChildSupportFha",
          method: "post",
        } as unknown,
      ),

    incomeSummarySaveIncomeSummaryAndQuestionAnswerChildSupportFha:
      Object.assign(
        (
          data: DtoV1IncomeIncomeSummarySaveIncomeSummaryFhaChildSupport,
          params: RequestParams = {},
        ) =>
          this.request<boolean, any>({
            path: `/v1/IncomeSummary/SaveIncomeSummaryAndQuestionAnswerChildSupportFha`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/IncomeSummary/SaveIncomeSummaryAndQuestionAnswerChildSupportFha",
          method: "post",
        } as unknown,
      ),

    knowYourLoanGetKnowYourLoanSummary: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1KnowYourLoanScreenDataDictionarySystemStringSystemString,
          any
        >({
          path: `/v1/KnowYourLoan/GetKnowYourLoanSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/KnowYourLoan/GetKnowYourLoanSummary",
        method: "post",
      } as unknown,
    ),

    liabilityGetLiabilities: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1LiabilitiesLiability[], any>({
          path: `/v1/Liability/GetLiabilities`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Liability/GetLiabilities",
        method: "post",
      } as unknown,
    ),

    liabilityGetLiabilitiesVerifyData: Object.assign(
      (
        data: DtoV1LiabilitiesGetLiabilitiesVerifyDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1LiabilitiesGetLiabilitiesVerifyDataResponse, any>({
          path: `/v1/Liability/GetLiabilitiesVerifyData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Liability/GetLiabilitiesVerifyData",
        method: "post",
      } as unknown,
    ),

    liabilityUpdateLiabilitiesVerifyData: Object.assign(
      (
        data: DtoV1LiabilitiesUpdateLiabilitiesVerifyDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Liability/UpdateLiabilitiesVerifyData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Liability/UpdateLiabilitiesVerifyData",
        method: "post",
      } as unknown,
    ),

    liabilityGetLiabilitiesAssociateData: Object.assign(
      (
        data: DtoV1LiabilitiesGetLiabilitiesAssociateDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1LiabilitiesGetLiabilitiesAssociateDataResponse, any>({
          path: `/v1/Liability/GetLiabilitiesAssociateData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Liability/GetLiabilitiesAssociateData",
        method: "post",
      } as unknown,
    ),

    liabilityUpdateLiabilitiesAssociateData: Object.assign(
      (
        data: DtoV1LiabilitiesUpdateLiabilitiesAssociateDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1LiabilitiesUpdateLiabilitiesAssociateDataResponse,
          any
        >({
          path: `/v1/Liability/UpdateLiabilitiesAssociateData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Liability/UpdateLiabilitiesAssociateData",
        method: "post",
      } as unknown,
    ),

    liabilityVaMortgageSeasoningList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAMortgageSeasoningData, any>({
          path: `/v1/Liability/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/va-mortgage-seasoning`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Liability/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/va-mortgage-seasoning",
        method: "get",
      } as unknown,
    ),

    loanGetNavigationDetails: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1NavigationGetNavigationDetailsResponse, any>({
          path: `/v1/Loan/GetNavigationDetails`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Loan/GetNavigationDetails",
        method: "post",
      } as unknown,
    ),

    loanGetLoanSummary: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1LoanSummaryLoanSummary, any>({
          path: `/v1/Loan/GetLoanSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Loan/GetLoanSummary",
        method: "post",
      } as unknown,
    ),

    loanGetBoltNavFeatureFlags: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1LoanInfoGetFeatureFlagsRequest, any>({
          path: `/v1/Loan/GetBoltNavFeatureFlags`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Loan/GetBoltNavFeatureFlags",
        method: "post",
      } as unknown,
    ),

    loanCommentsCommentsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1LoanCommentsLoanCommentsDataResponse, any>({
          path: `/v1/LoanComments/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/comments`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/LoanComments/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/comments",
        method: "get",
      } as unknown,
    ),

    loanCommentsComments: Object.assign(
      (
        data: DtoV1LoanCommentsSaveLoanCommentRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/LoanComments/comments`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/LoanComments/comments",
        method: "post",
      } as unknown,
    ),

    permissionCheckUserHasPermission: Object.assign(
      (
        data: DtoV1PermissionCheckUserHasPermissionRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PermissionCheckUserHasPermissionResponse, any>({
          path: `/v1/Permission/CheckUserHasPermission`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Permission/CheckUserHasPermission",
        method: "post",
      } as unknown,
    ),

    permissionGetAllUserPermissions: Object.assign(
      (
        data: DtoV1PermissionGetUserPermissionsByCategoryRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PermissionGetUserPermissionsByCategoryResponse, any>({
          path: `/v1/Permission/GetAllUserPermissions`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Permission/GetAllUserPermissions",
        method: "post",
      } as unknown,
    ),

    previousEmploymentGetPreviousEmploymentData: Object.assign(
      (
        data: DtoV1IncomePreviousEmploymentGetPreviousEmploymentRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1IncomePreviousEmploymentPreviousEmploymentScreenDataDtoV1IncomePreviousEmploymentPreviousEmploymentInitialFormValues,
          any
        >({
          path: `/v1/PreviousEmployment/GetPreviousEmploymentData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PreviousEmployment/GetPreviousEmploymentData",
        method: "post",
      } as unknown,
    ),

    previousEmploymentSavePreviousEmploymentData: Object.assign(
      (
        data: DtoV1IncomePreviousEmploymentSavePreviousEmploymentDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/PreviousEmployment/SavePreviousEmploymentData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PreviousEmployment/SavePreviousEmploymentData",
        method: "post",
      } as unknown,
    ),

    productsInvalidList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1ProductsGetInvalidProductResponse, any>({
          path: `/v1/Products/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/invalid`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Products/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/invalid",
        method: "get",
      } as unknown,
    ),

    propertyGetQuestionAnswersDataAsync: Object.assign(
      (
        data: DtoV1PropertyGetQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyGetQuestionAnswersResponse, any>({
          path: `/v1/Property/GetQuestionAnswersDataAsync`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Property/GetQuestionAnswersDataAsync",
        method: "post",
      } as unknown,
    ),

    propertySaveQuestionAnswersDataAsync: Object.assign(
      (
        data: DtoV1PropertySavePropertyQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/Property/SaveQuestionAnswersDataAsync`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Property/SaveQuestionAnswersDataAsync",
        method: "post",
      } as unknown,
    ),

    propertyNewConstructionRequirementsDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyNewConstructionRequirementsData, any>({
          path: `/v1/Property/new-construction-requirements/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Property/new-construction-requirements/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    propertyNewConstructionRequirements: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1PropertyNewConstructionRequirementsData,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Property/new-construction-requirements/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Property/new-construction-requirements/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "post",
      } as unknown,
    ),

    propertyInformationGetPropertyValidationQuestionAnswer: Object.assign(
      (
        data: DtoV1PropertyInformationGetQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<ModelsPropertyInformationPropertyValidationResponse, any>({
          path: `/v1/PropertyInformation/GetPropertyValidationQuestionAnswer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/GetPropertyValidationQuestionAnswer",
        method: "post",
      } as unknown,
    ),

    propertyInformationGetUwaiQuestionAnswer: Object.assign(
      (
        data: DtoV1PropertyInformationGetQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<ModelsV2UWAIUwaiQuestionAnswerResponse[], any>({
          path: `/v1/PropertyInformation/GetUwaiQuestionAnswer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/GetUwaiQuestionAnswer",
        method: "post",
      } as unknown,
    ),

    propertyInformationGetQuestionAnswersDataAsync: Object.assign(
      (
        data: DtoV1PropertyInformationGetQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1PropertyInformationPropertyInformationScreenDataIDictionarySystemStringSystemObject,
          any
        >({
          path: `/v1/PropertyInformation/GetQuestionAnswersDataAsync`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/GetQuestionAnswersDataAsync",
        method: "post",
      } as unknown,
    ),

    propertyInformationSavePropertyInformationQuestionAnswersData:
      Object.assign(
        (
          data: DtoV1PropertyInformationSavePropertyInformationDataRequest,
          params: RequestParams = {},
        ) =>
          this.request<boolean, any>({
            path: `/v1/PropertyInformation/SavePropertyInformationQuestionAnswersData`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/PropertyInformation/SavePropertyInformationQuestionAnswersData",
          method: "post",
        } as unknown,
      ),

    propertyInformationTitleSummaryList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1PropertyInformationTitleSummaryScreenDataIDictionarySystemStringSystemObject,
          any
        >({
          path: `/v1/PropertyInformation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/title-summary`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/title-summary",
        method: "get",
      } as unknown,
    ),

    propertyInformationTitleSummary: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1PropertyInformationSaveTitleSummaryRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/PropertyInformation/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/title-summary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/title-summary",
        method: "post",
      } as unknown,
    ),

    propertyInformationFhaCaseNumberRequestCreate: Object.assign(
      (
        data: DtoV1PropertyInformationCreateFhaCaseNumberRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyInformationFhaCaseNumberReponse, any>({
          path: `/v1/PropertyInformation/CreateFhaCaseNumberRequest`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/CreateFhaCaseNumberRequest",
        method: "post",
      } as unknown,
    ),

    propertyInformationSearchByWireInfo: Object.assign(
      (
        data: DtoV1PropertyInformationSearchWireInfoRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyInformationDropDownOption[], any>({
          path: `/v1/PropertyInformation/SearchByWireInfo`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/SearchByWireInfo",
        method: "post",
      } as unknown,
    ),

    propertyInformationGetUwaiV2QuestionAnswer: Object.assign(
      (
        data: DtoV1PropertyInformationGetQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<ModelsV2UWAIUwaiQuestionAnswerResponse[], any>({
          path: `/v1/PropertyInformation/GetUwaiV2QuestionAnswer`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInformation/GetUwaiV2QuestionAnswer",
        method: "post",
      } as unknown,
    ),

    propertyInsuranceTryOrderFloodCertAsync: Object.assign(
      (
        data: ModelsPropertyInsuranceOrderFloodCertRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/PropertyInsurance/TryOrderFloodCertAsync`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInsurance/TryOrderFloodCertAsync",
        method: "post",
      } as unknown,
    ),

    propertyInsuranceSaveInsurancePolicyAsync: Object.assign(
      (
        data: DtoV1PropertyInsuranceSaveInsurancePolicyRequest,
        params: RequestParams = {},
      ) =>
        this.request<MicrosoftAspNetCoreMvcIActionResult, any>({
          path: `/v1/PropertyInsurance/SaveInsurancePolicyAsync`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInsurance/SaveInsurancePolicyAsync",
        method: "post",
      } as unknown,
    ),

    propertyInsuranceGetInsurancePolicyAsyncDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        query?: {
          /** @format int64 */
          documentId?: number;
        },
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1PropertyInsuranceGetInsurancePolicyScreenDataIDictionarySystemStringSystemObject,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/PropertyInsurance/GetInsurancePolicyAsync/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyInsurance/GetInsurancePolicyAsync/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    propertyTaxesEscrowDetailsDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        taxId: string,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyTaxEscrowDetails, any>({
          path: `/v1/PropertyTaxes/EscrowDetails/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/${taxId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyTaxes/EscrowDetails/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/{taxId}",
        method: "get",
      } as unknown,
    ),

    propertyTaxesEscrowDetails: Object.assign(
      (
        data: DtoV1PropertyTaxSaveEscrowDetailsRequestDto,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/PropertyTaxes/EscrowDetails`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/PropertyTaxes/EscrowDetails",
        method: "post",
      } as unknown,
    ),

    propertyTaxesTaxBreakdownDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyTaxPropertyTaxData, any>({
          path: `/v1/PropertyTaxes/TaxBreakdown/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyTaxes/TaxBreakdown/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    propertyTaxesTaxBreakdown: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1PropertyTaxSavePropertyTaxDataRequestDto,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/PropertyTaxes/TaxBreakdown/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/PropertyTaxes/TaxBreakdown/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "post",
      } as unknown,
    ),

    propertyTaxesTaxSummaryDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1PropertyTaxGetTaxSummaryDto, any>({
          path: `/v1/PropertyTaxes/TaxSummary/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PropertyTaxes/TaxSummary/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    propertyTaxesTaxSummary: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1PropertyTaxSaveTaxSummaryRequestDto,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/PropertyTaxes/TaxSummary/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/PropertyTaxes/TaxSummary/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "post",
      } as unknown,
    ),

    purchaseAgreementGetFhaRequirements: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1PurchaseAgreementFhaRequirements, any>({
          path: `/v1/PurchaseAgreement/GetFhaRequirements`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/PurchaseAgreement/GetFhaRequirements",
        method: "post",
      } as unknown,
    ),

    purchaseAgreementUpdateFhaRequirements: Object.assign(
      (
        data: DtoV1PurchaseAgreementUpdateFhaRequirementsRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/PurchaseAgreement/UpdateFhaRequirements`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/PurchaseAgreement/UpdateFhaRequirements",
        method: "post",
      } as unknown,
    ),

    questionsAnswers: Object.assign(
      (
        data: DtoV1QuestionsSaveQuestionAnswerRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Questions/Answers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Questions/Answers",
        method: "post",
      } as unknown,
    ),

    queueStatusAndComment: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1QueueSaveQueueStatusAndCommentRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/Queue/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/status-and-comment`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Queue/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/status-and-comment",
        method: "post",
      } as unknown,
    ),

    queueStatusAndCommentList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        query?: {
          /** An array of queue types to retrieve the status and queue comment for. Queue Types: 4 New Condition Received, 6 Management Review, 14 Senior Underwriter Review, 64 Project Review. */
          queueTypes?: DtoV1QueueEnumQueueType[];
        },
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1QueueGetQueueStateResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/Queue/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/status-and-comment`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Queue/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/status-and-comment",
        method: "get",
      } as unknown,
    ),

    queueFiu: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1QueueSaveFiuRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/Queue/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/FIU`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/Queue/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/FIU",
        method: "post",
      } as unknown,
    ),

    queueFiuList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1QueueGetFiuResponse, any>({
          path: `/v1/Queue/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/FIU`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Queue/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/FIU",
        method: "get",
      } as unknown,
    ),

    queueQueueAuditList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<Record<string, DtoV1QueueQueueAuditData[]>, any>({
          path: `/v1/Queue/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/QueueAudit`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Queue/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/QueueAudit",
        method: "get",
      } as unknown,
    ),

    realEstateOwnedGetRealEstateOwned: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1RealEstateOwnedGetRealEstateOwnedResponse, any>({
          path: `/v1/RealEstateOwned/GetRealEstateOwned`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RealEstateOwned/GetRealEstateOwned",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedSaveRealEstateOwned: Object.assign(
      (
        data: DtoV1RealEstateOwnedSaveRealEstateOwnedMultipleRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/RealEstateOwned/SaveRealEstateOwned`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RealEstateOwned/SaveRealEstateOwned",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedGetRealEstateOwnedSingleProperty: Object.assign(
      (
        data: DtoV1RealEstateOwnedGetRealEstateOwnedSinglePropertyRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1RealEstateOwnedGetRealEstateOwnedResponse, any>({
          path: `/v1/RealEstateOwned/GetRealEstateOwnedSingleProperty`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RealEstateOwned/GetRealEstateOwnedSingleProperty",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedGetRealEstateOwnedSummary: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1RealEstateOwnedRealEstateOwnedSummaryResponse, any>({
          path: `/v1/RealEstateOwned/GetRealEstateOwnedSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RealEstateOwned/GetRealEstateOwnedSummary",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedDeleteRealEstateOwned: Object.assign(
      (
        data: DtoV1RealEstateOwnedDeleteRealEstateOwnedRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/RealEstateOwned/DeleteRealEstateOwned`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RealEstateOwned/DeleteRealEstateOwned",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedSaveRealEstateOwnedSummary: Object.assign(
      (
        data: DtoV1RealEstateOwnedSaveRealEstateOwnedSummaryRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/RealEstateOwned/SaveRealEstateOwnedSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RealEstateOwned/SaveRealEstateOwnedSummary",
        method: "post",
      } as unknown,
    ),

    rentalIncomeValidationGetRentalIncomeValidationData: Object.assign(
      (
        data: DtoV1IncomeGetRentalRealEstateOwnedRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeGetPropertyRentalIncomeResponse, any>({
          path: `/v1/RentalIncomeValidation/GetRentalIncomeValidationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RentalIncomeValidation/GetRentalIncomeValidationData",
        method: "post",
      } as unknown,
    ),

    rentalIncomeValidationSaveRentalIncomeDocumentSelectionAndQuestionAnswer:
      Object.assign(
        (
          data: DtoV1IncomeRentalIncomeSaveRentalIncomeRequest,
          params: RequestParams = {},
        ) =>
          this.request<DtoV1IncomeRentalIncomeSaveRentalIncomeResponse, any>({
            path: `/v1/RentalIncomeValidation/SaveRentalIncomeDocumentSelectionAndQuestionAnswer`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/RentalIncomeValidation/SaveRentalIncomeDocumentSelectionAndQuestionAnswer",
          method: "post",
        } as unknown,
      ),

    rentalIncomeValidationGetRentalIncomeData: Object.assign(
      (
        data: DtoV1IncomeRentalIncomeGetRentalIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeRentalIncomeRentalIncomeData, any>({
          path: `/v1/RentalIncomeValidation/GetRentalIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RentalIncomeValidation/GetRentalIncomeData",
        method: "post",
      } as unknown,
    ),

    rentalIncomeValidationGetRentalIncomeQuestionsAndAnswersByAddressId:
      Object.assign(
        (
          data: DtoV1IncomeRentalIncomeGetRentalIncomeRequest,
          params: RequestParams = {},
        ) =>
          this.request<
            DtoV1IncomeRentalIncomeRentalIncomeQuestionAndAnswer[],
            any
          >({
            path: `/v1/RentalIncomeValidation/GetRentalIncomeQuestionsAndAnswersByAddressId`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          }),
        {
          path: "/v1/RentalIncomeValidation/GetRentalIncomeQuestionsAndAnswersByAddressId",
          method: "post",
        } as unknown,
      ),

    rentalIncomeValidationGetNoDocumentsProvidedQuestionAnswers: Object.assign(
      (
        data: DtoV1IncomeRentalIncomeGetRentalIncomeRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1IncomeNoDocumentsProvidedScreenDataIDictionarySystemStringSystemString,
          any
        >({
          path: `/v1/RentalIncomeValidation/GetNoDocumentsProvidedQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RentalIncomeValidation/GetNoDocumentsProvidedQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    rentalIncomeValidationSaveRentalIncomeQuestionAnswers: Object.assign(
      (
        data: DtoV1IncomeRentalIncomeSaveRentalIncomeQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/RentalIncomeValidation/SaveRentalIncomeQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/RentalIncomeValidation/SaveRentalIncomeQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    ruleTriggerAllRules: Object.assign(
      (data: DtoV1RunAllRulesRequest, params: RequestParams = {}) =>
        this.request<DtoV1RunAllRulesResponse, any>({
          path: `/v1/Rule/TriggerAllRules`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Rule/TriggerAllRules",
        method: "post",
      } as unknown,
    ),

    ruleGetClassifyFlag: Object.assign(
      (
        data: DtoV1ParentAlertsGetUnclassifiedDocumentStatusRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1ParentAlertsGetUnclassifiedDocumentStatusResponse,
          any
        >({
          path: `/v1/Rule/GetClassifyFlag`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Rule/GetClassifyFlag",
        method: "post",
      } as unknown,
    ),

    saveAssetsReconcileAssets: Object.assign(
      (data: DtoV1AssetsReconcileAssetRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/SaveAssets/ReconcileAssets`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/SaveAssets/ReconcileAssets",
        method: "post",
      } as unknown,
    ),

    saveAssetsSaveAssetSummary: Object.assign(
      (data: ModelsAssetsSaveAssetSummaryRequest, params: RequestParams = {}) =>
        this.request<boolean, any>({
          path: `/v1/SaveAssets/SaveAssetSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/SaveAssets/SaveAssetSummary",
        method: "post",
      } as unknown,
    ),

    saveAssetsSaveAssetQuestionAnswers: Object.assign(
      (
        data: ModelsAssetsSaveAssetQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/SaveAssets/SaveAssetQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/SaveAssets/SaveAssetQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    statementGetStatementInformation: Object.assign(
      (
        data: ModelsAssetsStatementInformationRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseModelsAssetsDepositoryStatementScreenDataDictionarySystemStringSystemObject,
          any
        >({
          path: `/v1/Statement/GetStatementInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Statement/GetStatementInformation",
        method: "post",
      } as unknown,
    ),

    statementSaveSaveStatementInformation: Object.assign(
      (
        data: ModelsAssetsSaveStatementQuestionAnswersRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/StatementSave/SaveStatementInformation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/StatementSave/SaveStatementInformation",
        method: "post",
      } as unknown,
    ),

    statusAndReviewInvalidProductOverrideReason: Object.assign(
      (
        data: DtoV1StatusAndReviewSaveInvalidProductOverrideReasonRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/StatusAndReview/invalid-product-override-reason`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/invalid-product-override-reason",
        method: "post",
      } as unknown,
    ),

    statusAndReviewSuspenseReasonsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1StatusAndReviewSuspenseReasons, any>({
          path: `/v1/StatusAndReview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/suspense-reasons`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/suspense-reasons",
        method: "get",
      } as unknown,
    ),

    statusAndReviewSuspenseReasons: Object.assign(
      (data: DtoV1StatusAndReviewSuspenseReasons, params: RequestParams = {}) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/StatusAndReview/suspense-reasons`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/suspense-reasons",
        method: "post",
      } as unknown,
    ),

    statusAndReviewStatusReviewDetailsList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1StatusAndReviewStatusAndReviewDetails, any>({
          path: `/v1/StatusAndReview/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/status-review-details`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/status-review-details",
        method: "get",
      } as unknown,
    ),

    statusAndReviewDenialReasonsToggleDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1StatusAndReviewDenialReasonsToggleResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/StatusAndReview/denial-reasons-toggle/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/denial-reasons-toggle/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    statusAndReviewDenialReasonsToggle: Object.assign(
      (
        data: DtoV1StatusAndReviewDenialReasonsToggleSaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/StatusAndReview/denial-reasons-toggle`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/denial-reasons-toggle",
        method: "post",
      } as unknown,
    ),

    statusAndReviewAusRan: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/StatusAndReview/aus-ran`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/StatusAndReview/aus-ran",
        method: "post",
      } as unknown,
    ),

    subjectPropertyGetSubjectPropertySummary: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1SubjectPropertySubjectPropertySummaryResponse, any>({
          path: `/v1/SubjectProperty/GetSubjectPropertySummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/SubjectProperty/GetSubjectPropertySummary",
        method: "post",
      } as unknown,
    ),

    subjectPropertySaveSubjectPropertyInfo: Object.assign(
      (
        data: DtoV1SubjectPropertySaveSubjectPropertyInfoRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/SubjectProperty/SaveSubjectPropertyInfo`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/SubjectProperty/SaveSubjectPropertyInfo",
        method: "post",
      } as unknown,
    ),

    submissionSubmitLoanToSetup: Object.assign(
      (
        data: DtoV1SubmitToSetupSubmitToSetupRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1IncomeCalculatorAlert,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/Submission/SubmitLoanToSetup`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Submission/SubmitLoanToSetup",
        method: "post",
      } as unknown,
    ),

    submissionBailOutAndSubmitLoanToSetup: Object.assign(
      (
        data: DtoV1SubmitToSetupSubmitToSetupRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1IncomeCalculatorAlert, DtoV1IncomeCalculatorAlert>({
          path: `/v1/Submission/BailOutAndSubmitLoanToSetup`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Submission/BailOutAndSubmitLoanToSetup",
        method: "post",
      } as unknown,
    ),

    submissionRunBoltApprovalProcess: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<ModelsConditionsBoltApprovalRunResponse, any>({
          path: `/v1/Submission/RunBoltApprovalProcess`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Submission/RunBoltApprovalProcess",
        method: "post",
      } as unknown,
    ),

    submissionGetFinalReviewValidationAfterAusRun: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<DtoV1SubmitToSetupAllowBoltApprovalResponse, any>({
          path: `/v1/Submission/GetFinalReviewValidationAfterAUSRun`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Submission/GetFinalReviewValidationAfterAUSRun",
        method: "post",
      } as unknown,
    ),

    submissionGetInitialFinalReviewValidation: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1SubmitToSetupFinalReviewInitialValidationsResponse,
          any
        >({
          path: `/v1/Submission/GetInitialFinalReviewValidation`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Submission/GetInitialFinalReviewValidation",
        method: "post",
      } as unknown,
    ),

    subordinateFinancingDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1SubordinateFinancingSubordinateFinancingResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/SubordinateFinancing/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/SubordinateFinancing/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    subordinateFinancing: Object.assign(
      (
        data: DtoV1SubordinateFinancingSaveSubordinateFinancingRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/SubordinateFinancing`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/SubordinateFinancing",
        method: "post",
      } as unknown,
    ),

    transferReconciliationGetTransferReconciliationData: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1AssetsTransferReconciliationDisplayData, any>({
          path: `/v1/TransferReconciliation/GetTransferReconciliationData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/TransferReconciliation/GetTransferReconciliationData",
        method: "post",
      } as unknown,
    ),

    transferReconciliationSaveReconcileAccountTransfers: Object.assign(
      (
        data: DtoV1AssetsReconcileAccountTransfersRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/TransferReconciliationSave/ReconcileAccountTransfers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/TransferReconciliationSave/ReconcileAccountTransfers",
        method: "post",
      } as unknown,
    ),

    underwriterVerifiedSaveUnderwriterVerified: Object.assign(
      (data: DtoV1UnderwriterVerifiedRequest, params: RequestParams = {}) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/UnderwriterVerified/SaveUnderwriterVerified`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/UnderwriterVerified/SaveUnderwriterVerified",
        method: "post",
      } as unknown,
    ),

    underwriterVerifiedGetUnderwriterVerified: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<ModelsV1UnderwriterVerifiedInformation[], any>({
          path: `/v1/UnderwriterVerified/GetUnderwriterVerified`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwriterVerified/GetUnderwriterVerified",
        method: "post",
      } as unknown,
    ),

    underwritingDateTrackingDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1UnderWriterGetUWDateTrackingDataResponseDtoV1UnderWriterGetUWDateTrackingDataResponse,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v1/UnderwritingDateTracking/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingDateTracking/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    underwritingDateTracking: Object.assign(
      (
        data: DtoV1UnderWriterSaveUWDateTrackingRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/UnderwritingDateTracking`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingDateTracking",
        method: "post",
      } as unknown,
    ),

    underwritingSummaryIncomeGetUnderwritingSummaryIncomeData: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV1UnderwritingSummariesIncomeUnderwritingSummaryIncomeData,
          any
        >({
          path: `/v1/UnderwritingSummaryIncome/GetUnderwritingSummaryIncomeData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingSummaryIncome/GetUnderwritingSummaryIncomeData",
        method: "post",
      } as unknown,
    ),

    underwritingSummaryIncomeUpsertUnderwritingSummaryIncome: Object.assign(
      (
        data: DtoV1UnderwritingSummariesIncomeSaveEmploymentAndDetailsRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/UnderwritingSummaryIncome/UpsertUnderwritingSummaryIncome`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingSummaryIncome/UpsertUnderwritingSummaryIncome",
        method: "post",
      } as unknown,
    ),

    underwritingSummaryIncomeDeleteUnderwritingSummaryIncome: Object.assign(
      (
        data: DtoV1IncomeBorrowerEmploymentIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/UnderwritingSummaryIncome/DeleteUnderwritingSummaryIncome`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingSummaryIncome/DeleteUnderwritingSummaryIncome",
        method: "post",
      } as unknown,
    ),

    underwritingSummaryLiabilitiesGetLiabilitiesSummaryData: Object.assign(
      (
        data: DtoV1UnderwritingSummariesLiabilityLiabilitySummaryRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1UnderwritingSummariesLiabilityLiabilitySummaryResponse,
          any
        >({
          path: `/v1/UnderwritingSummaryLiabilities/GetLiabilitiesSummaryData`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingSummaryLiabilities/GetLiabilitiesSummaryData",
        method: "post",
      } as unknown,
    ),

    underwritingSummaryLiabilitiesUpsertLiability: Object.assign(
      (
        data: DtoV1UnderwritingSummariesLiabilitySaveLiabilityRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v1/UnderwritingSummaryLiabilities/UpsertLiability`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingSummaryLiabilities/UpsertLiability",
        method: "post",
      } as unknown,
    ),

    underwritingSummaryLiabilitiesDeleteLiabilities: Object.assign(
      (
        data: DtoV1UnderwritingSummariesLiabilityDeleteLiabilitiesRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v1/UnderwritingSummaryLiabilities/DeleteLiabilities`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/UnderwritingSummaryLiabilities/DeleteLiabilities",
        method: "post",
      } as unknown,
    ),

    vaCaseNumberList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAVACaseNumberResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/case-number`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/case-number",
        method: "get",
      } as unknown,
    ),

    vaCaseNumber: Object.assign(
      (data: DtoV1VAVACaseNumberRequest, params: RequestParams = {}) =>
        this.request<any, any>({
          path: `/v1/VA/case-number`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/case-number",
        method: "post",
      } as unknown,
    ),

    vaRecoupmentTest: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<any, any>({
          path: `/v1/VA/recoupment-test`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/recoupment-test",
        method: "post",
      } as unknown,
    ),

    vaMortgageSeasoning: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAMortgageSeasoningSaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-seasoning`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-seasoning",
        method: "post",
      } as unknown,
    ),

    vaMortgageHistoryQuestion: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAVAMortgageHistorySaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-history-question`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-history-question",
        method: "post",
      } as unknown,
    ),

    vaPitiDataList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAVAPitiResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/Piti-data`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/Piti-data",
        method: "get",
      } as unknown,
    ),

    vaMortgageHistoryList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAGetVAMortgageHistoryResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-history`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-history",
        method: "get",
      } as unknown,
    ),

    vaSaveCreditQualifying: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/save-credit-qualifying`,
          method: "POST",
          secure: true,
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/save-credit-qualifying",
        method: "post",
      } as unknown,
    ),

    vaChangeInObligorList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAVAChangeInObligorResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/change-in-obligor`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/change-in-obligor",
        method: "get",
      } as unknown,
    ),

    vaObligorData: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAChangeInObligorSaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/obligor-data`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/obligor-data",
        method: "post",
      } as unknown,
    ),

    vaNoteList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VADocumentReviewNoteDocumentData, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/note`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/note",
        method: "get",
      } as unknown,
    ),

    vaNote: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VASaveVANoteRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/note`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/note",
        method: "post",
      } as unknown,
    ),

    vaPayoffDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        documentId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAPayoffResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/payoff/${documentId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/payoff/{documentId}",
        method: "get",
      } as unknown,
    ),

    vaPayoff: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VADocumentReviewPayoffSaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/payoff`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/payoff",
        method: "post",
      } as unknown,
    ),

    vaCaivrsDataList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAVACaivrsResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/caivrs-data`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/caivrs-data",
        method: "get",
      } as unknown,
    ),

    vaCaivrsData: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAVACaivrsRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/caivrs-data`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/caivrs-data",
        method: "post",
      } as unknown,
    ),

    vaCreditReportList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAVACreditReportResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/credit-report`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/credit-report",
        method: "get",
      } as unknown,
    ),

    vaCreditReportData: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAVACreditReportRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/credit-report-data`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/credit-report-data",
        method: "post",
      } as unknown,
    ),

    vaCreditSupplementList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAVACreditSupplementResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/credit-supplement`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/credit-supplement",
        method: "get",
      } as unknown,
    ),

    vaCreditSupplementData: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAVACreditSupplementRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/credit-supplement-data`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/credit-supplement-data",
        method: "post",
      } as unknown,
    ),

    vaMortgageStatementDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        documentId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VADocumentReviewMortgageStatementResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-statement/${documentId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-statement/{documentId}",
        method: "get",
      } as unknown,
    ),

    vaMortgageStatement: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VADocumentReviewMortgageStatementSaveRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/mortgage-statement`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/mortgage-statement",
        method: "post",
      } as unknown,
    ),

    vaForbearanceReviewList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VAForbearanceReviewResponse, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/forbearance-review`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/forbearance-review",
        method: "get",
      } as unknown,
    ),

    vaForbearanceReviewData: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VAForbearanceReviewRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/forbearance-review-data`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/forbearance-review-data",
        method: "post",
      } as unknown,
    ),

    vaLoanModificationAgreementList: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1VADocumentReviewLoanModificationDocumentData, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/loan-modification-agreement`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/loan-modification-agreement",
        method: "get",
      } as unknown,
    ),

    vaLoanModificationAgreement: Object.assign(
      (
        obfuscatedLenderDatabaseId: number,
        obfuscatedLoanRecordId: number,
        data: DtoV1VADocumentReviewLoanModificationDocumentData,
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/v1/VA/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}/loan-modification-agreement`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v1/VA/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}/loan-modification-agreement",
        method: "post",
      } as unknown,
    ),

    validationSaveQuestionAnswers: Object.assign(
      (data: DtoV1SaveQuestionAnswersRequest, params: RequestParams = {}) =>
        this.request<DtoV1SaveQuestionAnswersResponse, any>({
          path: `/v1/Validation/SaveQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v1/Validation/SaveQuestionAnswers",
        method: "post",
      } as unknown,
    ),
  };
  account = {
    loginList: Object.assign(
      (
        query?: {
          /** @default "" */
          returnUrl?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/Account/Login`,
          method: "GET",
          query: query,
          secure: true,
          ...params,
        }),
      {
        path: "/Account/Login",
        method: "get",
      } as unknown,
    ),

    userinfoList: Object.assign(
      (params: RequestParams = {}) =>
        this.request<Record<string, any>, any>({
          path: `/Account/Userinfo`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/Account/Userinfo",
        method: "get",
      } as unknown,
    ),

    logoutList: Object.assign(
      (
        query?: {
          /** @default "" */
          returnUrl?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/Account/Logout`,
          method: "GET",
          query: query,
          secure: true,
          ...params,
        }),
      {
        path: "/Account/Logout",
        method: "get",
      } as unknown,
    ),
  };
  passport = {
    passportList: Object.assign(
      (params: RequestParams = {}) =>
        this.request<any, any>({
          path: `/passport`,
          method: "GET",
          secure: true,
          ...params,
        }),
      {
        path: "/passport",
        method: "get",
      } as unknown,
    ),
  };
  login = {
    loginList: Object.assign(
      (
        query?: {
          /** @default "" */
          redirectUrl?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, any>({
          path: `/login`,
          method: "GET",
          query: query,
          secure: true,
          ...params,
        }),
      {
        path: "/login",
        method: "get",
      } as unknown,
    ),
  };
  sdui = {
    sdui: Object.assign(
      (
        data: DtoServerDrivenUIRequest,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<
          UWMCApplicationUWMUDSDtoSDUILayout,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/sdui`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/sdui",
        method: "post",
      } as unknown,
    ),

    data: Object.assign(
      (
        data: DtoServerDrivenUIRequest,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/sdui/data`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/sdui/data",
        method: "post",
      } as unknown,
    ),

    answers: Object.assign(
      (
        data: DtoServerDrivenUIAnswerRequest,
        query?: {
          /**
           * The requested API version
           * @default "1.0"
           */
          "api-version"?: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/sdui/answers`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/sdui/answers",
        method: "post",
      } as unknown,
    ),
  };
  v2 = {
    classifyDocumentsGetClassifiedDocuments: Object.assign(
      (
        data: DtoV2ClassifyDocumentsGetClassifiedDocumentsRequest,
        params: RequestParams = {},
      ) =>
        this.request<DtoV2ClassifyDocumentsGetClassifiedDocumentsResponse, any>(
          {
            path: `/v2/ClassifyDocuments/GetClassifiedDocuments`,
            method: "POST",
            body: data,
            secure: true,
            type: "application/json",
            format: "json",
            ...params,
          },
        ),
      {
        path: "/v2/ClassifyDocuments/GetClassifiedDocuments",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsGetDocumentTypeAssociations: Object.assign(
      (data: DtoObfuscatedLoanIdentifierRequest, params: RequestParams = {}) =>
        this.request<
          DtoV2ClassifyDocumentsGetDocumentTypeAssociationsResponseV2,
          any
        >({
          path: `/v2/ClassifyDocuments/GetDocumentTypeAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v2/ClassifyDocuments/GetDocumentTypeAssociations",
        method: "post",
      } as unknown,
    ),

    classifyDocumentsGetClassifyDocumentsV2FeatureFlagDetail: Object.assign(
      (
        obfuscatedLenderDatabaseId: string,
        obfuscatedLoanRecordId: string,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v2/ClassifyDocuments/GetClassifyDocumentsV2FeatureFlag/${obfuscatedLenderDatabaseId}/${obfuscatedLoanRecordId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v2/ClassifyDocuments/GetClassifyDocumentsV2FeatureFlag/{obfuscatedLenderDatabaseId}/{obfuscatedLoanRecordId}",
        method: "get",
      } as unknown,
    ),

    documentAssociationGetDocumentAssociations: Object.assign(
      (
        data: DtoV2DocumentAssociationGetDocumentAssociationsRequestV2,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV2DocumentAssociationGetDocumentAssociationsResponseV2,
          any
        >({
          path: `/v2/DocumentAssociation/GetDocumentAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v2/DocumentAssociation/GetDocumentAssociations",
        method: "post",
      } as unknown,
    ),

    documentAssociationSaveDocumentAssociations: Object.assign(
      (
        data: DtoV2DocumentAssociationSaveDocumentAssociationsRequestV2,
        params: RequestParams = {},
      ) =>
        this.request<DtoV1DocumentAssociationSuccessResponse, any>({
          path: `/v2/DocumentAssociation/SaveDocumentAssociations`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v2/DocumentAssociation/SaveDocumentAssociations",
        method: "post",
      } as unknown,
    ),

    employmentIncomeGetNoDocumentsProvidedQuestionAnswers: Object.assign(
      (
        data: DtoV1IncomeIncomeSummaryCustomerEmploymentDetailRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV1IncomeNoDocumentsProvidedScreenDataWithPreviousIDictionarySystemStringSystemString,
          any
        >({
          path: `/v2/EmploymentIncome/GetNoDocumentsProvidedQuestionAnswers`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v2/EmploymentIncome/GetNoDocumentsProvidedQuestionAnswers",
        method: "post",
      } as unknown,
    ),

    loanGetLoanSummary: Object.assign(
      (
        data: DtoIdentitiesObfuscatedLoanIdentifier,
        params: RequestParams = {},
      ) =>
        this.request<DtoV2LoanSummaryLoanSummaryData, any>({
          path: `/v2/Loan/GetLoanSummary`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v2/Loan/GetLoanSummary",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedSaveRealEstateOwned: Object.assign(
      (
        data: DtoV2RealEstateOwnedSaveRealEstateOwnedMultipleRequest,
        params: RequestParams = {},
      ) =>
        this.request<boolean, any>({
          path: `/v2/RealEstateOwned/SaveRealEstateOwned`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        }),
      {
        path: "/v2/RealEstateOwned/SaveRealEstateOwned",
        method: "post",
      } as unknown,
    ),

    realEstateOwnedSinglePropertyDetail: Object.assign(
      (
        obfuscatedlenderdatabaseid: number,
        obfuscatedloanrecordid: number,
        addresslenderdatabaseid: number,
        addressrecordid: number,
        params: RequestParams = {},
      ) =>
        this.request<
          DtoV1BoltResponseDtoV2RealEstateOwnedGetRealEstateOwnedScreenDataDictionarySystemStringSystemString,
          MicrosoftAspNetCoreMvcProblemDetails
        >({
          path: `/v2/RealEstateOwned/${obfuscatedlenderdatabaseid}/${obfuscatedloanrecordid}/single-property/${addresslenderdatabaseid}/${addressrecordid}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),
      {
        path: "/v2/RealEstateOwned/{obfuscatedlenderdatabaseid}/{obfuscatedloanrecordid}/single-property/{addresslenderdatabaseid}/{addressrecordid}",
        method: "get",
      } as unknown,
    ),
  };
  v3 = {
    realEstateOwned: Object.assign(
      (
        data: DtoV2RealEstateOwnedSaveRealEstateOwnedScreenDataRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, MicrosoftAspNetCoreMvcProblemDetails>({
          path: `/v3/RealEstateOwned`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          ...params,
        }),
      {
        path: "/v3/RealEstateOwned",
        method: "post",
      } as unknown,
    ),
  };
}
